(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.f2.lz === region.ha.lz)
	{
		return 'on line ' + region.f2.lz;
	}
	return 'on lines ' + region.f2.lz + ' through ' + region.ha.lz;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (Object.prototype.hasOwnProperty.call(value, key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	var unwrapped = _Json_unwrap(value);
	if (!(key === 'toJSON' && typeof unwrapped === 'function'))
	{
		object[key] = unwrapped;
	}
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lp,
		impl.m5,
		impl.mW,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		hR: func(record.hR),
		jb: record.jb,
		it: record.it
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.hR;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.jb;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.it) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lp,
		impl.m5,
		impl.mW,
		function(sendToApp, initialModel) {
			var view = impl.nd;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lp,
		impl.m5,
		impl.mW,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.f1 && impl.f1(sendToApp)
			var view = impl.nd;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.j7);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.eQ) && (_VirtualDom_doc.title = title = doc.eQ);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.l2;
	var onUrlRequest = impl.l3;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		f1: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.iz === next.iz
							&& curr.hr === next.hr
							&& curr.io.a === next.io.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		lp: function(flags)
		{
			return A3(impl.lp, flags, _Browser_getUrl(), key);
		},
		nd: impl.nd,
		m5: impl.m5,
		mW: impl.mW
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { lb: 'hidden', kg: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { lb: 'mozHidden', kg: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { lb: 'msHidden', kg: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { lb: 'webkitHidden', kg: 'webkitvisibilitychange' }
		: { lb: 'hidden', kg: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		iU: _Browser_getScene(),
		jM: {
			jR: _Browser_window.pageXOffset,
			jS: _Browser_window.pageYOffset,
			jQ: _Browser_doc.documentElement.clientWidth,
			hq: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		jQ: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		hq: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			iU: {
				jQ: node.scrollWidth,
				hq: node.scrollHeight
			},
			jM: {
				jR: node.scrollLeft,
				jS: node.scrollTop,
				jQ: node.clientWidth,
				hq: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			iU: _Browser_getScene(),
			jM: {
				jR: x,
				jS: y,
				jQ: _Browser_doc.documentElement.clientWidth,
				hq: _Browser_doc.documentElement.clientHeight
			},
			kS: {
				jR: x + rect.left,
				jS: y + rect.top,
				jQ: rect.width,
				hq: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.lM) { flags += 'm'; }
	if (options.ke) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.k2.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.k2.b, xhr)); });
		$elm$core$Maybe$isJust(request.jz) && _Http_track(router, xhr, request.jz.a);

		try {
			xhr.open(request.aI, request.jJ, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.jJ));
		}

		_Http_configureRequest(xhr, request);

		request.j7.a && xhr.setRequestHeader('Content-Type', request.j7.a);
		xhr.send(request.j7.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.D; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.K.a || 0;
	xhr.responseType = request.k2.d;
	xhr.withCredentials = request.j0;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		jJ: xhr.responseURL,
		f3: xhr.status,
		mQ: xhr.statusText,
		D: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			mH: event.loaded,
			i6: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			ml: event.loaded,
			i6: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}var $author$project$Main$ChangedUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$ClickedLink = function (a) {
	return {$: 0, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.q) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.t),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.t);
		} else {
			var treeLen = builder.q * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.u) : builder.u;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.q);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.t) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.t);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{u: nodeList, q: (len / $elm$core$Array$branchFactor) | 0, t: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {hk: fragment, hr: host, ik: path, io: port_, iz: protocol, iA: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Main$NotFound = {$: 14};
var $author$project$Language$Language$english = {
	ge: {X: 'Back to main', gF: 'Confirm deletion', Z: 'Delete', gY: 'Account deletion successful!', aC: 'Email', aa: 'Main page', R: 'Nickname'},
	gE: {gf: 'Account recovery', aa: 'Main page', dS: 'New password', dT: 'New password repetition', ji: 'Successfully updated password.', eV: 'Update password'},
	gG: {gD: 'Confirm', du: 'Display name (optional)', aC: 'Email', bA: 'Confirm registration', aa: 'Main Page', R: 'Nickname', ec: 'Password', ij: 'Password repetition', jh: 'User creation successful'},
	gO: {bi: 'Add', X: 'Cancel', aw: 'Clear', ay: 'Delete?', $7: 'Entries', Z: 'Delete', dq: 'Description', aB: 'Edit', bA: 'Name', hY: 'New dashboard', aO: 'Save', jN: 'Visibility'},
	$7: {bi: 'Add', gg: 'Added', X: 'Cancel', aw: 'Clear', ay: 'Delete?', br: 'Create', gP: 'Dashboard entries', gQ: 'Description', gR: 'Name', Z: 'Delete', aB: 'Edit', hZ: 'New dashboard entry', eh: 'Projects', aO: 'Save', i_: 'Select', bS: 'Project'},
	hc: {hd: 'An error occurred:', bH: 'Login', iR: 'Retry', jj: 'Try the following:'},
	bH: {gK: 'Create account', hE: 'Keep me logged in', bH: 'Log in', R: 'User name', ec: 'Password', iE: 'Recover account', eQ: 'Londo'},
	hM: {h7: 'Page not found', eQ: 'Londo'},
	id: {gS: 'Dashboards', eh: 'Projects', i0: 'Settings'},
	ix: {bi: 'Add', X: 'Cancel', aw: 'Clear', ay: 'Delete?', Z: 'Delete', dq: 'Description', aB: 'Edit', hV: 'Name', h0: 'New project', aO: 'Save', bS: 'Tasks'},
	iN: {hi: 'Find', hu: 'Nickname or email', aa: 'Main page', hU: 'Multiple matching accounts found', h5: 'No matching account found', iF: 'Recovery', iP: 'Requested user recovery. Please check your email.'},
	iO: {aC: 'Email for registration', bA: 'Registration', aa: 'Main page', R: 'Nickname', iG: 'Request registration', iH: 'There was an error requesting the token. Please try again!', iI: 'Successfully requested token! Check your email to proceed!'},
	eG: {dk: 'Counting', gJ: 'Counting', gZ: 'Δ completion (counting)', g_: 'Δ completion (total)', g$: 'Δ 1 (counting)', g0: 'Δ 1 (total)', g1: 'Δ simulation (counting)', g2: 'Δ simulation (total)', hO: 'Mean', hP: 'Mean (absolute)', hQ: 'Mean (relative)', iC: 'Reachable (all)', iD: 'Reached (all)', i3: 'Simulated (counting)', i4: 'Simulated (total)', i5: 'Simulation', eG: 'Statistics', jx: 'Total', jy: 'Total'},
	bS: {X: 'Cancel', aw: 'Clear', ay: 'Delete?', dk: 'Counting?', br: 'Create', Z: 'Delete', g4: 'Discrete', aB: 'Edit', hj: 'Fraction', h3: 'Create new task', il: 'Percent', iw: 'Progress', iy: 'Project name', aO: 'Save', jl: 'Kind', jm: 'Name', jn: 'Tasks', jF: 'Unit'},
	jL: {br: 'Create', gL: 'Create user', hf: 'User creation failed', hJ: 'Go to login page', R: 'User name', ih: 'Password', ii: 'Password repetition', jg: 'User created successfully', jD: 'Try again'},
	eY: {gu: 'Change password', gv: 'Update settings', gN: 'Danger zone', gW: 'Delete account', gX: 'Account deletion requested. Please check your email to continue.', du: 'Display name', aC: 'Email', hK: 'Logout all devices', hL: 'Logout this device', h_: 'New display name', dS: 'New password', dT: 'New password repetition', R: 'Nickname', eV: 'Update password', jH: 'Update settings', eY: 'User settings'}
};
var $author$project$Language$Language$default = $author$project$Language$Language$english;
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$doFetchToken = _Platform_outgoingPort(
	'doFetchToken',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {a$: frag, a5: params, aR: unvisited, nc: value, bf: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.aR;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.nc);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.nc);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.ik),
					$elm$url$Url$Parser$prepareQuery(url.iA),
					url.hk,
					$elm$core$Basics$identity)));
	});
var $author$project$Main$ConfirmDeletionRoute = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Main$ConfirmRecoveryRoute = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Main$ConfirmRegistrationRoute = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Main$DashboardEntriesRoute = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$DashboardsRoute = {$: 6};
var $author$project$Main$LoginRoute = {$: 2};
var $author$project$Main$OverviewRoute = {$: 3};
var $author$project$Main$ProjectsRoute = {$: 4};
var $author$project$Main$PublicStatisticsRoute = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$RequestRecoveryRoute = {$: 12};
var $author$project$Main$RequestRegistrationRoute = {$: 0};
var $author$project$Main$SettingsRoute = {$: 10};
var $author$project$Main$StatisticsRoute = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$TasksRoute = function (a) {
	return {$: 5, a: a};
};
var $author$project$Types$Auxiliary$UserIdentifier = F2(
	function (nickname, email) {
		return {aC: email, R: nickname};
	});
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.bf;
		var unvisited = _v0.aR;
		var params = _v0.a5;
		var frag = _v0.a$;
		var value = _v0.nc;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.bf;
			var unvisited = _v1.aR;
			var params = _v1.a5;
			var frag = _v1.a$;
			var value = _v1.nc;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.bf;
			var unvisited = _v0.aR;
			var params = _v0.a5;
			var frag = _v0.a$;
			var value = _v0.nc;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.bf;
		var unvisited = _v0.aR;
		var params = _v0.a5;
		var frag = _v0.a$;
		var value = _v0.nc;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $author$project$Addresses$ParserUtil$with2 = function (ps) {
	return {
		gh: function (_v0) {
			var param1 = _v0.a;
			var param2 = _v0.b;
			return _Utils_ap(
				$elm$core$List$singleton(ps.cF),
				_Utils_ap(
					ps.m1(param1),
					_Utils_ap(
						$elm$core$List$singleton(ps.mR),
						ps.m2(param2))));
		},
		ig: A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s(ps.cF),
			A2(
				$elm$url$Url$Parser$slash,
				ps.mc,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s(ps.mR),
					ps.md)))
	};
};
var $author$project$Addresses$ParserUtil$nicknameEmailParser = $author$project$Addresses$ParserUtil$with2(
	{mc: $elm$url$Url$Parser$string, md: $elm$url$Url$Parser$string, cF: 'nickname', mR: 'email', m1: $elm$core$List$singleton, m2: $elm$core$List$singleton});
var $author$project$Addresses$Frontend$confirm = function (step1) {
	return $author$project$Addresses$ParserUtil$with2(
		{
			mc: A2($elm$url$Url$Parser$map, $author$project$Types$Auxiliary$UserIdentifier, $author$project$Addresses$ParserUtil$nicknameEmailParser.ig),
			md: $elm$url$Url$Parser$string,
			cF: step1,
			mR: 'token',
			m1: $author$project$Addresses$ParserUtil$nicknameEmailParser.gh,
			m2: $elm$core$List$singleton
		});
};
var $author$project$Addresses$Frontend$confirmRecovery = $author$project$Addresses$Frontend$confirm('recover-account');
var $author$project$Addresses$Frontend$confirmRegistration = $author$project$Addresses$Frontend$confirm('confirm-registration');
var $author$project$Types$Dashboard$Id$Id = $elm$core$Basics$identity;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$Types$Dashboard$Id$uuid = function (_v0) {
	var u = _v0;
	return u;
};
var $author$project$LondoGQL$Scalar$Uuid = $elm$core$Basics$identity;
var $danyx23$elm_uuid$Uuid$Uuid = $elm$core$Basics$identity;
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {ln: index, lE: match, l_: number, mV: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{ke: false, lM: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $danyx23$elm_uuid$Uuid$Barebones$uuidRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$'));
var $danyx23$elm_uuid$Uuid$Barebones$isValidUuid = function (uuidAsString) {
	return A2($elm$regex$Regex$contains, $danyx23$elm_uuid$Uuid$Barebones$uuidRegex, uuidAsString);
};
var $elm$core$String$toLower = _String_toLower;
var $danyx23$elm_uuid$Uuid$fromString = function (text) {
	return $danyx23$elm_uuid$Uuid$Barebones$isValidUuid(text) ? $elm$core$Maybe$Just(
		$elm$core$String$toLower(text)) : $elm$core$Maybe$Nothing;
};
var $danyx23$elm_uuid$Uuid$toString = function (_v0) {
	var internalString = _v0;
	return internalString;
};
var $author$project$Addresses$ParserUtil$uuidParser = A2(
	$elm$url$Url$Parser$map,
	$elm$core$Basics$identity,
	A2(
		$elm$url$Url$Parser$map,
		$danyx23$elm_uuid$Uuid$toString,
		A2($elm$url$Url$Parser$custom, 'UUID', $danyx23$elm_uuid$Uuid$fromString)));
var $author$project$Pages$Util$ScalarUtil$uuidToString = function (_v0) {
	var uuid = _v0;
	return uuid;
};
var $author$project$Addresses$ParserUtil$with1 = function (ps) {
	return {
		gh: function (param) {
			return A2(
				$elm$core$List$cons,
				ps.cF,
				ps.eR(param));
		},
		ig: A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s(ps.cF),
			ps.ea)
	};
};
var $author$project$Addresses$Frontend$dashboardEntries = $author$project$Addresses$ParserUtil$with1(
	{
		ea: A2($elm$url$Url$Parser$map, $elm$core$Basics$identity, $author$project$Addresses$ParserUtil$uuidParser),
		cF: 'dashboard-entry-editor',
		eR: A2(
			$elm$core$Basics$composeR,
			$author$project$Types$Dashboard$Id$uuid,
			A2($elm$core$Basics$composeR, $author$project$Pages$Util$ScalarUtil$uuidToString, $elm$core$List$singleton))
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$Addresses$Frontend$plain = function (string) {
	return {
		gh: $elm$core$Basics$always(
			_List_fromArray(
				[string])),
		ig: $elm$url$Url$Parser$s(string)
	};
};
var $author$project$Addresses$Frontend$dashboards = $author$project$Addresses$Frontend$plain('dashboards');
var $author$project$Addresses$Frontend$deleteAccount = $author$project$Addresses$Frontend$confirm('delete-account');
var $author$project$Addresses$Frontend$login = $author$project$Addresses$Frontend$plain('login');
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Addresses$Frontend$overview = $author$project$Addresses$Frontend$plain('overview');
var $author$project$Addresses$Frontend$projects = $author$project$Addresses$Frontend$plain('projects');
var $author$project$Addresses$Frontend$publicStatistics = $author$project$Addresses$ParserUtil$with1(
	{
		ea: A2($elm$url$Url$Parser$map, $elm$core$Basics$identity, $author$project$Addresses$ParserUtil$uuidParser),
		cF: 'public-statistics',
		eR: A2(
			$elm$core$Basics$composeR,
			$author$project$Types$Dashboard$Id$uuid,
			A2($elm$core$Basics$composeR, $author$project$Pages$Util$ScalarUtil$uuidToString, $elm$core$List$singleton))
	});
var $author$project$Addresses$Frontend$requestRecovery = $author$project$Addresses$Frontend$plain('request-recovery');
var $author$project$Addresses$Frontend$requestRegistration = $author$project$Addresses$Frontend$plain('request-registration');
var $elm_community$basics_extra$Basics$Extra$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var $author$project$Main$route = $elm_community$basics_extra$Basics$Extra$flip($elm$url$Url$Parser$map);
var $author$project$Addresses$Frontend$settings = $author$project$Addresses$Frontend$plain('settings');
var $author$project$Addresses$Frontend$statistics = $author$project$Addresses$ParserUtil$with1(
	{
		ea: A2($elm$url$Url$Parser$map, $elm$core$Basics$identity, $author$project$Addresses$ParserUtil$uuidParser),
		cF: 'statistics',
		eR: A2(
			$elm$core$Basics$composeR,
			$author$project$Types$Dashboard$Id$uuid,
			A2($elm$core$Basics$composeR, $author$project$Pages$Util$ScalarUtil$uuidToString, $elm$core$List$singleton))
	});
var $author$project$Types$Project$Id$Id = $elm$core$Basics$identity;
var $author$project$Types$Project$Id$uuid = function (_v0) {
	var u = _v0;
	return u;
};
var $author$project$Addresses$Frontend$tasks = $author$project$Addresses$ParserUtil$with1(
	{
		ea: A2($elm$url$Url$Parser$map, $elm$core$Basics$identity, $author$project$Addresses$ParserUtil$uuidParser),
		cF: 'task-editor',
		eR: A2(
			$elm$core$Basics$composeR,
			$author$project$Types$Project$Id$uuid,
			A2($elm$core$Basics$composeR, $author$project$Pages$Util$ScalarUtil$uuidToString, $elm$core$List$singleton))
	});
var $author$project$Main$plainRouteParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($author$project$Main$route, $author$project$Addresses$Frontend$requestRegistration.ig, $author$project$Main$RequestRegistrationRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$confirmRegistration.ig, $author$project$Main$ConfirmRegistrationRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$login.ig, $author$project$Main$LoginRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$overview.ig, $author$project$Main$OverviewRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$projects.ig, $author$project$Main$ProjectsRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$tasks.ig, $author$project$Main$TasksRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$dashboards.ig, $author$project$Main$DashboardsRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$dashboardEntries.ig, $author$project$Main$DashboardEntriesRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$statistics.ig, $author$project$Main$StatisticsRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$publicStatistics.ig, $author$project$Main$PublicStatisticsRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$settings.ig, $author$project$Main$SettingsRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$deleteAccount.ig, $author$project$Main$ConfirmDeletionRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$requestRecovery.ig, $author$project$Main$RequestRecoveryRoute),
			A2($author$project$Main$route, $author$project$Addresses$Frontend$confirmRecovery.ig, $author$project$Main$ConfirmRecoveryRoute)
		]));
var $author$project$Main$parsePage = $elm$url$Url$Parser$parse($author$project$Main$plainRouteParser);
var $author$project$Main$init = F3(
	function (configuration, url, key) {
		return _Utils_Tuple2(
			{
				m: configuration,
				aZ: $author$project$Main$parsePage(url),
				am: $elm$core$Maybe$Nothing,
				fz: key,
				dL: $author$project$Language$Language$default.hM,
				V: $author$project$Main$NotFound
			},
			$author$project$Ports$doFetchToken(0));
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Main$DeleteToken = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$FetchToken = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $author$project$Ports$deleteToken = _Platform_incomingPort(
	'deleteToken',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$fetchToken = _Platform_incomingPort('fetchToken', $elm$json$Json$Decode$string);
var $author$project$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$fetchToken($author$project$Main$FetchToken),
				$author$project$Ports$deleteToken($author$project$Main$DeleteToken)
			]));
};
var $author$project$Main$titleFor = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.dL;
	},
	function ($) {
		return $.eQ;
	});
var $elm_community$maybe_extra$Maybe$Extra$filter = F2(
	function (f, m) {
		if (!m.$) {
			var a = m.a;
			return f(a) ? m : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Pages$DashboardEntries$Page$EntriesMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$DashboardEntries$Page$GotFetchResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$View$Tristate$Logic = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$LondoGQL$Scalar$BigDecimal = $elm$core$Basics$identity;
var $author$project$LondoGQL$Scalar$BigInt = $elm$core$Basics$identity;
var $author$project$LondoGQL$Scalar$Unit = $elm$core$Basics$identity;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$string,
			A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int),
			A2(
			$elm$json$Json$Decode$map,
			function (bool) {
				return bool ? 'true' : 'false';
			},
			$elm$json$Json$Decode$bool)
		]));
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$LondoGQL$Scalar$defaultCodecs = {
	e9: {
		fg: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		ce: function (_v0) {
			var raw = _v0;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	fa: {
		fg: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		ce: function (_v1) {
			var raw = _v1;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	fb: {
		fg: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		ce: function (_v2) {
			var raw = _v2;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	dj: {
		fg: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		ce: function (_v3) {
			var raw = _v3;
			return $elm$json$Json$Encode$string(raw);
		}
	}
};
var $author$project$LondoGQL$Scalar$Codecs = $elm$core$Basics$identity;
var $author$project$LondoGQL$Scalar$defineCodecs = function (definitions) {
	return definitions;
};
var $author$project$LondoGQL$ScalarCodecs$codecs = $author$project$LondoGQL$Scalar$defineCodecs(
	{e9: $author$project$LondoGQL$Scalar$defaultCodecs.e9, fa: $author$project$LondoGQL$Scalar$defaultCodecs.fa, fb: $author$project$LondoGQL$Scalar$defaultCodecs.fb, dj: $author$project$LondoGQL$Scalar$defaultCodecs.dj});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject = function (maybeValues) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object(
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var key = _v0.a;
				var value = _v0.b;
				return A2(
					$elm$core$Maybe$andThen,
					function (actualValue) {
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(key, actualValue));
					},
					value);
			},
			maybeValues));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson = function (jsonValue) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(jsonValue);
};
var $author$project$LondoGQL$Scalar$unwrapEncoder = F2(
	function (getter, _v0) {
		var unwrappedCodecs = _v0;
		return A2(
			$elm$core$Basics$composeR,
			getter(unwrappedCodecs).ce,
			$dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
	});
var $author$project$LondoGQL$InputObject$encodeDashboardIdInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'uuid',
				$elm$core$Maybe$Just(
					A2(
						$author$project$LondoGQL$Scalar$unwrapEncoder,
						function ($) {
							return $.dj;
						},
						$author$project$LondoGQL$ScalarCodecs$codecs)(input____.o)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeFetchResolvedDashboardInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dashboardId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeDashboardIdInput(input____.c)))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required = F3(
	function (fieldName, raw, encode) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument,
			fieldName,
			encode(raw));
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$RawField$Composite = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite = F3(
	function (fieldName, args, fields) {
		return A3($dillonkearns$elm_graphql$Graphql$RawField$Composite, fieldName, args, fields);
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $dillonkearns$elm_graphql$Graphql$Document$Hash$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {bp: charsProcessed, bz: hash, ba: seed, bQ: shift};
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$c1 = 3432918353;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$c2 = 461845907;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$Bitwise$or = _Bitwise_or;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize = function (data) {
	var acc = (!(!data.bz)) ? (data.ba ^ A2(
		$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
		$dillonkearns$elm_graphql$Graphql$Document$Hash$c2,
		A2(
			$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
			15,
			A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, data.bz)))) : data.ba;
	var h0 = acc ^ data.bp;
	var h1 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$mix = F2(
	function (h1, k1) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
			5,
			A2(
				$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
				13,
				h1 ^ A2(
					$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
					$dillonkearns$elm_graphql$Graphql$Document$Hash$c2,
					A2(
						$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
						15,
						A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, k1))))) + 3864292196;
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold = F2(
	function (c, data) {
		var res = data.bz | ((255 & $elm$core$Char$toCode(c)) << data.bQ);
		var _v0 = data.bQ;
		if (_v0 === 24) {
			return {
				bp: data.bp + 1,
				bz: 0,
				ba: A2($dillonkearns$elm_graphql$Graphql$Document$Hash$mix, data.ba, res),
				bQ: 0
			};
		} else {
			return {bp: data.bp + 1, bz: res, ba: data.ba, bQ: data.bQ + 8};
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashString = F2(
	function (seed, str) {
		return $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize(
			A3(
				$elm$core$String$foldl,
				$dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold,
				A4($dillonkearns$elm_graphql$Graphql$Document$Hash$HashData, 0, seed, 0, 0),
				str));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$List = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize = function (value) {
	var serializeJson = function (json) {
		var decoder = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$List,
						$elm$core$List$map($dillonkearns$elm_graphql$Graphql$Internal$Encode$Json)),
					$elm$json$Json$Decode$list($elm$json$Json$Decode$value)),
					A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$Object,
						$elm$core$List$map(
							$elm$core$Tuple$mapSecond($dillonkearns$elm_graphql$Graphql$Internal$Encode$Json))),
					$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value))
				]));
		var _v2 = A2($elm$json$Json$Decode$decodeValue, decoder, json);
		if (!_v2.$) {
			var v = _v2.a;
			return $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(v);
		} else {
			return A2($elm$json$Json$Encode$encode, 0, json);
		}
	};
	switch (value.$) {
		case 0:
			var enumValue = value.a;
			return enumValue;
		case 1:
			var json = value.a;
			return serializeJson(json);
		case 2:
			var values = value.a;
			return '[' + (A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize, values)) + ']');
		default:
			var keyValuePairs = value.a;
			return '{' + (A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var objectValue = _v1.b;
						return key + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(objectValue));
					},
					keyValuePairs)) + '}');
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return name + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(value));
};
var $dillonkearns$elm_graphql$Graphql$Document$Argument$serialize = function (args) {
	if (!args.b) {
		return '';
	} else {
		var nonemptyArgs = args;
		return '(' + (A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString, nonemptyArgs)) + ')');
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash = function (field) {
	return A2(
		$elm$core$Maybe$map,
		$dillonkearns$elm_graphql$Graphql$Document$Hash$hashString(0),
		function () {
			if (!field.$) {
				var name = field.a;
				var _arguments = field.b;
				var children = field.c;
				return $elm$core$List$isEmpty(_arguments) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments));
			} else {
				var typeString = field.a.jE;
				var fieldName = field.a.hh;
				var _arguments = field.b;
				return (fieldName === '__typename') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$elm$core$String$concat(
						A2(
							$elm$core$List$append,
							_List_fromArray(
								[typeString]),
							$elm$core$List$singleton(
								$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments)))));
			}
		}());
};
var $dillonkearns$elm_graphql$Graphql$RawField$name = function (field) {
	if (!field.$) {
		var fieldName = field.a;
		var argumentList = field.b;
		var fieldList = field.c;
		return fieldName;
	} else {
		var typeString = field.a.jE;
		var fieldName = field.a.hh;
		var argumentList = field.b;
		return fieldName;
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$alias = function (field) {
	return A2(
		$elm$core$Maybe$map,
		function (aliasHash) {
			return _Utils_ap(
				$dillonkearns$elm_graphql$Graphql$RawField$name(field),
				$elm$core$String$fromInt(aliasHash));
		},
		$dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash(field));
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName = function (field) {
	return A2(
		$elm$core$Maybe$withDefault,
		$dillonkearns$elm_graphql$Graphql$RawField$name(field),
		$dillonkearns$elm_graphql$Graphql$Document$Field$alias(field));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField = F4(
	function (fieldName, args, _v0, decoderTransform) {
		var fields = _v0.a;
		var decoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)
				]),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$field,
						fieldName,
						decoderTransform(decoder)),
						A2(
						$elm$json$Json$Decode$field,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(
							A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)),
						decoderTransform(decoder))
					])));
	});
var $author$project$LondoGQL$Query$fetchResolvedDashboard = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'fetchResolvedDashboard',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeFetchResolvedDashboardInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $dillonkearns$elm_graphql$Graphql$Http$Query = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$Request = $elm$core$Basics$identity;
var $dillonkearns$elm_graphql$Graphql$Document$decoder = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($elm$json$Json$Decode$field, 'data', decoder_);
};
var $dillonkearns$elm_graphql$Graphql$Http$queryRequest = F2(
	function (baseUrl, query) {
		return {
			b3: baseUrl,
			ds: A2($dillonkearns$elm_graphql$Graphql$Http$Query, $elm$core$Maybe$Nothing, query),
			k2: $dillonkearns$elm_graphql$Graphql$Document$decoder(query),
			D: _List_Nil,
			a4: $elm$core$Maybe$Nothing,
			a7: _List_Nil,
			K: $elm$core$Maybe$Nothing,
			bh: false
		};
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {iL: reqs, jf: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.jz;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.iL));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.jf)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					j0: r.j0,
					j7: r.j7,
					k2: A2(_Http_mapExpect, func, r.k2),
					D: r.D,
					aI: r.aI,
					K: r.K,
					jz: r.jz,
					jJ: r.jJ
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{j0: false, j7: r.j7, k2: r.k2, D: r.D, aI: r.aI, K: r.K, jz: r.jz, jJ: r.jJ}));
};
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{j0: true, j7: r.j7, k2: r.k2, D: r.D, aI: r.aI, K: r.K, jz: r.jz, jJ: r.jJ}));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$HttpError = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$convertResult = function (httpResult) {
	if (!httpResult.$) {
		var successOrError = httpResult.a;
		if (!successOrError.$) {
			var value = successOrError.a;
			return $elm$core$Result$Ok(value);
		} else {
			var _v2 = successOrError.a;
			var possiblyParsedData = _v2.a;
			var error = _v2.b;
			return $elm$core$Result$Err(
				A2($dillonkearns$elm_graphql$Graphql$Http$GraphqlError, possiblyParsedData, error));
		}
	} else {
		var httpError = httpResult.a;
		return $elm$core$Result$Err(
			$dillonkearns$elm_graphql$Graphql$Http$HttpError(httpError));
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$BadPayload = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$NetworkError = {$: 2};
var $dillonkearns$elm_graphql$Graphql$Http$Timeout = {$: 1};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $dillonkearns$elm_graphql$Graphql$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 0:
						var url = response.a;
						return $elm$core$Result$Err(
							$dillonkearns$elm_graphql$Graphql$Http$BadUrl(url));
					case 1:
						return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$Timeout);
					case 2:
						return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$NetworkError);
					case 3:
						var metadata = response.a;
						var body = response.b;
						return $elm$core$Result$Err(
							A2($dillonkearns$elm_graphql$Graphql$Http$BadStatus, metadata, body));
					default:
						var metadata = response.a;
						var body = response.b;
						var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
						if (!_v1.$) {
							var value = _v1.a;
							return $elm$core$Result$Ok(value);
						} else {
							var err = _v1.a;
							return $elm$core$Result$Err(
								$dillonkearns$elm_graphql$Graphql$Http$BadPayload(err));
						}
				}
			});
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Get = 0;
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Post = 1;
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$core$Basics$ge = _Utils_ge;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength = 2000;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation = F2(
	function (replacements, _v0) {
		var match = _v0.lE;
		var ordinalString = A2(
			$elm$core$Basics$composeL,
			$elm$core$String$dropLeft(1),
			$elm$core$String$dropRight(1))(match);
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (value) {
					return A2($elm$core$Array$get, value, replacements);
				},
				$elm$core$String$toInt(ordinalString)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{u: nodeList, q: nodeListSize, t: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\\{\\d+\\}'));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolate = F2(
	function (string, args) {
		var asArray = $elm$core$Array$fromList(args);
		return A3(
			$elm$regex$Regex$replace,
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex,
			$lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation(asArray),
			string);
	});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $j_maas$elm_ordered_containers$OrderedDict$OrderedDict = $elm$core$Basics$identity;
var $j_maas$elm_ordered_containers$OrderedDict$empty = {n: $elm$core$Dict$empty, v: _List_Nil};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $elm$core$Set$singleton = function (key) {
	return A2($elm$core$Dict$singleton, key, 0);
};
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$findConflictingTypeFields = function (rawFields) {
	var compositeCount = $elm$core$List$length(
		A2(
			$elm$core$List$filterMap,
			function (field) {
				if (!field.$) {
					return $elm$core$Maybe$Just(0);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			rawFields));
	if (compositeCount <= 1) {
		return $elm$core$Set$empty;
	} else {
		var levelBelowNodes = A2(
			$elm$core$List$concatMap,
			function (field) {
				if (field.$ === 1) {
					return _List_Nil;
				} else {
					var children = field.c;
					return children;
				}
			},
			rawFields);
		var fieldTypes = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, acc) {
					var fieldName = _v1.a;
					var fieldType = _v1.b;
					return A3(
						$elm$core$Dict$update,
						fieldName,
						function (maybeFieldTypes) {
							if (maybeFieldTypes.$ === 1) {
								return $elm$core$Maybe$Just(
									$elm$core$Set$singleton(fieldType));
							} else {
								var fieldTypes_ = maybeFieldTypes.a;
								return $elm$core$Maybe$Just(
									A2($elm$core$Set$insert, fieldType, fieldTypes_));
							}
						},
						acc);
				}),
			$elm$core$Dict$empty,
			A2(
				$elm$core$List$filterMap,
				function (field) {
					if (field.$ === 1) {
						var typeString = field.a.jE;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$dillonkearns$elm_graphql$Graphql$RawField$name(field),
								typeString));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				levelBelowNodes));
		return $elm$core$Set$fromList(
			$elm$core$Dict$keys(
				A2(
					$elm$core$Dict$filter,
					F2(
						function (fieldType, fields) {
							return function (size) {
								return size > 1;
							}(
								$elm$core$Set$size(fields));
						}),
					fieldTypes)));
	}
};
var $j_maas$elm_ordered_containers$OrderedDict$get = F2(
	function (key, _v0) {
		var orderedDict = _v0;
		return A2($elm$core$Dict$get, key, orderedDict.n);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $j_maas$elm_ordered_containers$OrderedDict$insert = F3(
	function (key, value, _v0) {
		var orderedDict = _v0;
		var filteredOrder = A2($elm$core$Dict$member, key, orderedDict.n) ? A2(
			$elm$core$List$filter,
			function (k) {
				return !_Utils_eq(k, key);
			},
			orderedDict.v) : orderedDict.v;
		var newOrder = _Utils_ap(
			filteredOrder,
			_List_fromArray(
				[key]));
		return {
			n: A3($elm$core$Dict$insert, key, value, orderedDict.n),
			v: newOrder
		};
	});
var $j_maas$elm_ordered_containers$OrderedDict$remove = F2(
	function (key, _v0) {
		var orderedDict = _v0;
		return {
			n: A2($elm$core$Dict$remove, key, orderedDict.n),
			v: A2($elm$core$Dict$member, key, orderedDict.n) ? A2(
				$elm$core$List$filter,
				function (k) {
					return !_Utils_eq(k, key);
				},
				orderedDict.v) : orderedDict.v
		};
	});
var $j_maas$elm_ordered_containers$OrderedDict$update = F3(
	function (key, alter, original) {
		var orderedDict = original;
		var _v0 = A2($elm$core$Dict$get, key, orderedDict.n);
		if (!_v0.$) {
			var oldItem = _v0.a;
			var _v1 = alter(
				$elm$core$Maybe$Just(oldItem));
			if (!_v1.$) {
				var newItem = _v1.a;
				return {
					n: A3(
						$elm$core$Dict$update,
						key,
						$elm$core$Basics$always(
							$elm$core$Maybe$Just(newItem)),
						orderedDict.n),
					v: orderedDict.v
				};
			} else {
				return A2($j_maas$elm_ordered_containers$OrderedDict$remove, key, original);
			}
		} else {
			var _v2 = alter($elm$core$Maybe$Nothing);
			if (!_v2.$) {
				var newItem = _v2.a;
				return A3($j_maas$elm_ordered_containers$OrderedDict$insert, key, newItem, original);
			} else {
				return original;
			}
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$canAllowHashing = F2(
	function (forceHashing, rawFields) {
		var fieldCounts = A3(
			$elm$core$List$foldl,
			F2(
				function (fld, acc) {
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						fld,
						function (val) {
							return $elm$core$Maybe$Just(
								function () {
									if (val.$ === 1) {
										return 0;
									} else {
										var count = val.a;
										return count + 1;
									}
								}());
						},
						acc);
				}),
			$j_maas$elm_ordered_containers$OrderedDict$empty,
			A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$RawField$name, rawFields));
		var conflictingTypeFields = $dillonkearns$elm_graphql$Graphql$Document$Field$findConflictingTypeFields(rawFields);
		return A2(
			$elm$core$List$map,
			function (field) {
				return _Utils_Tuple3(
					field,
					A2(
						$elm$core$Set$member,
						$dillonkearns$elm_graphql$Graphql$RawField$name(field),
						forceHashing) ? $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field) : ((!A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$j_maas$elm_ordered_containers$OrderedDict$get,
							$dillonkearns$elm_graphql$Graphql$RawField$name(field),
							fieldCounts))) ? $elm$core$Maybe$Nothing : $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field)),
					conflictingTypeFields);
			},
			rawFields);
	});
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $dillonkearns$elm_graphql$Graphql$Document$Indent$generate = function (indentationLevel) {
	return A2($elm$core$String$repeat, indentationLevel, '  ');
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$mergeFields = function (rawFields) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (field, mergedSoFar) {
				if (!field.$) {
					var newChildren = field.c;
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(field),
						function (maybeChildrenSoFar) {
							if (maybeChildrenSoFar.$ === 1) {
								return $elm$core$Maybe$Just(field);
							} else {
								if (!maybeChildrenSoFar.a.$) {
									var _v2 = maybeChildrenSoFar.a;
									var existingFieldName = _v2.a;
									var existingArgs = _v2.b;
									var existingChildren = _v2.c;
									return $elm$core$Maybe$Just(
										A3(
											$dillonkearns$elm_graphql$Graphql$RawField$Composite,
											existingFieldName,
											existingArgs,
											_Utils_ap(existingChildren, newChildren)));
								} else {
									return $elm$core$Maybe$Just(field);
								}
							}
						},
						mergedSoFar);
				} else {
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(field),
						function (maybeChildrenSoFar) {
							return $elm$core$Maybe$Just(
								A2($elm$core$Maybe$withDefault, field, maybeChildrenSoFar));
						},
						mergedSoFar);
				}
			}),
		$j_maas$elm_ordered_containers$OrderedDict$empty,
		rawFields);
};
var $j_maas$elm_ordered_containers$OrderedDict$values = function (_v0) {
	var orderedDict = _v0;
	return A2(
		$elm$core$List$filterMap,
		function (key) {
			return A2($elm$core$Dict$get, key, orderedDict.n);
		},
		orderedDict.v);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$mergedFields = function (children) {
	return $j_maas$elm_ordered_containers$OrderedDict$values(
		$dillonkearns$elm_graphql$Graphql$Document$Field$mergeFields(children));
};
var $dillonkearns$elm_graphql$Graphql$RawField$Leaf = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$RawField$typename = A2(
	$dillonkearns$elm_graphql$Graphql$RawField$Leaf,
	{hh: '__typename', jE: ''},
	_List_Nil);
var $dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren = function (children) {
	return $elm$core$List$isEmpty(children) ? A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, children) : children;
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$serialize = F4(
	function (forceHashing, aliasName, mIndentationLevel, field) {
		var prefix = function () {
			if (!aliasName.$) {
				var aliasName_ = aliasName.a;
				return _Utils_ap(
					aliasName_,
					function () {
						if (!mIndentationLevel.$) {
							return ': ';
						} else {
							return ':';
						}
					}());
			} else {
				return '';
			}
		}();
		return A2(
			$elm$core$Maybe$map,
			function (string) {
				return _Utils_ap(
					$dillonkearns$elm_graphql$Graphql$Document$Indent$generate(
						A2($elm$core$Maybe$withDefault, 0, mIndentationLevel)),
					_Utils_ap(prefix, string));
			},
			function () {
				if (!field.$) {
					var fieldName = field.a;
					var args = field.b;
					var children = field.c;
					if (mIndentationLevel.$ === 1) {
						return $elm$core$Maybe$Just(
							(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + ('{' + A3($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp, forceHashing, $elm$core$Maybe$Nothing, children)))) + '}');
					} else {
						var indentationLevel = mIndentationLevel.a;
						return $elm$core$Maybe$Just(
							(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + (' {\n' + A3(
								$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp,
								forceHashing,
								$elm$core$Maybe$Just(indentationLevel),
								children)))) + ('\n' + ($dillonkearns$elm_graphql$Graphql$Document$Indent$generate(indentationLevel) + '}')));
					}
				} else {
					var fieldName = field.a.hh;
					var args = field.b;
					return $elm$core$Maybe$Just(
						_Utils_ap(
							fieldName,
							$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args)));
				}
			}());
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp = F3(
	function (forceHashing, indentationLevel, children) {
		return A2(
			$elm$core$String$join,
			function () {
				if (!indentationLevel.$) {
					return '\n';
				} else {
					return ' ';
				}
			}(),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					function (_v0) {
						var field = _v0.a;
						var maybeAlias = _v0.b;
						var conflictingTypeFields = _v0.c;
						return A4(
							$dillonkearns$elm_graphql$Graphql$Document$Field$serialize,
							conflictingTypeFields,
							maybeAlias,
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$add(1),
								indentationLevel),
							field);
					},
					A2(
						$dillonkearns$elm_graphql$Graphql$Document$Field$canAllowHashing,
						forceHashing,
						$dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren(
							$dillonkearns$elm_graphql$Graphql$Document$Field$mergedFields(children))))));
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren = F2(
	function (indentationLevel, children) {
		return A3($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp, $elm$core$Set$empty, indentationLevel, children);
	});
var $dillonkearns$elm_graphql$Graphql$Document$serialize = F2(
	function (operationType, queries) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {\n{1}\n}',
			_List_fromArray(
				[
					operationType,
					A2(
					$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
					$elm$core$Maybe$Just(0),
					queries)
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeQuery = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'query', fields);
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return '{' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}');
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return 'query ' + (operationName + (' {' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}')));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName = F3(
	function (operationType, operationName, queries) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {1} {\n{2}\n}',
			_List_fromArray(
				[
					operationType,
					operationName,
					A2(
					$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
					$elm$core$Maybe$Just(0),
					queries)
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'query', operationName, fields);
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace = F2(
	function (old, _new) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split(old),
			$elm$core$String$join(_new));
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace, '%20', '+'));
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(key) + ('=' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(value));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded = function (args) {
	return A2(
		$elm$core$String$join,
		'&',
		A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair, args));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams = F2(
	function (queryParams, url) {
		return $elm$core$List$isEmpty(queryParams) ? url : (url + ('?' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded(queryParams)));
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build = F5(
	function (forceMethod, url, queryParams, maybeOperationName, queryDocument) {
		var _v0 = function () {
			if (!maybeOperationName.$) {
				var operationName = maybeOperationName.a;
				return _Utils_Tuple2(
					A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName, operationName, queryDocument),
					_List_fromArray(
						[
							_Utils_Tuple2('operationName', operationName)
						]));
			} else {
				return _Utils_Tuple2(
					$dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl(queryDocument),
					_List_Nil);
			}
		}();
		var serializedQueryForGetRequest = _v0.a;
		var operationNameParamForGetRequest = _v0.b;
		var urlForGetRequest = A2(
			$dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams,
			_Utils_ap(
				queryParams,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2('query', serializedQueryForGetRequest),
					operationNameParamForGetRequest)),
			url);
		if (_Utils_eq(
			forceMethod,
			$elm$core$Maybe$Just(1)) || ((_Utils_cmp(
			$elm$core$String$length(urlForGetRequest),
			$dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength) > -1) && (!_Utils_eq(
			forceMethod,
			$elm$core$Maybe$Just(0))))) {
			var _v2 = function () {
				if (!maybeOperationName.$) {
					var operationName = maybeOperationName.a;
					return _Utils_Tuple2(
						A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName, operationName, queryDocument),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'operationName',
								$elm$json$Json$Encode$string(operationName))
							]));
				} else {
					return _Utils_Tuple2(
						$dillonkearns$elm_graphql$Graphql$Document$serializeQuery(queryDocument),
						_List_Nil);
				}
			}();
			var serializedQuery = _v2.a;
			var operationNameParamForPostRequest = _v2.b;
			return {
				j7: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(serializedQuery)),
							operationNameParamForPostRequest))),
				aI: 1,
				jJ: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, queryParams, url)
			};
		} else {
			return {j7: $elm$http$Http$emptyBody, aI: 0, jJ: urlForGetRequest};
		}
	});
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError = F3(
	function (message, locations, details) {
		return {ds: details, lC: locations, hR: message};
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location = F2(
	function (line, column) {
		return {kq: column, lz: line};
	});
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder = A3(
	$elm$json$Json$Decode$map2,
	$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location,
	A2($elm$json$Json$Decode$field, 'line', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'column', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder = A2(
	$elm$json$Json$Decode$field,
	'errors',
	$elm$json$Json$Decode$list(
		A4(
			$elm$json$Json$Decode$map3,
			$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError,
			A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					'locations',
					$elm$json$Json$Decode$list($dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder))),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Dict$remove('locations'),
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Dict$remove('message'),
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$value))))));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData = function (data) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Result$Err,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Tuple$pair(data),
			$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder));
};
var $dillonkearns$elm_graphql$Graphql$Http$nullJsonValue = function (a) {
	nullJsonValue:
	while (true) {
		var _v0 = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, 'null');
		if (!_v0.$) {
			var value = _v0.a;
			return value;
		} else {
			var $temp$a = 0;
			a = $temp$a;
			continue nullJsonValue;
		}
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$errorDecoder = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				A2($elm$json$Json$Decode$map, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData, decoder)),
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				A2(
					$elm$json$Json$Decode$map,
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value))),
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				$elm$json$Json$Decode$succeed(
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData(
						$dillonkearns$elm_graphql$Graphql$Http$nullJsonValue(0))))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Http$decoderOrError = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_graphql$Graphql$Http$errorDecoder(decoder),
				A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, decoder)
			]));
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeMutation = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'mutation', fields);
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'mutation', operationName, fields);
	});
var $dillonkearns$elm_graphql$Graphql$Http$toReadyRequest = function (_v0) {
	var request = _v0;
	var _v1 = request.ds;
	if (!_v1.$) {
		var forcedRequestMethod = _v1.a;
		var querySelectionSet = _v1.b;
		var queryRequestDetails = A5(
			$dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build,
			function () {
				if (!forcedRequestMethod.$) {
					if (!forcedRequestMethod.a) {
						var _v4 = forcedRequestMethod.a;
						return $elm$core$Maybe$Just(0);
					} else {
						var _v5 = forcedRequestMethod.a;
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Just(1);
				}
			}(),
			request.b3,
			request.a7,
			request.a4,
			querySelectionSet);
		return {
			j7: queryRequestDetails.j7,
			fg: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.k2),
			D: request.D,
			aI: function () {
				var _v2 = queryRequestDetails.aI;
				if (!_v2) {
					return 'GET';
				} else {
					return 'Post';
				}
			}(),
			K: request.K,
			jJ: queryRequestDetails.jJ
		};
	} else {
		var mutationSelectionSet = _v1.a;
		var serializedMutation = function () {
			var _v7 = request.a4;
			if (!_v7.$) {
				var operationName = _v7.a;
				return A2($dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName, operationName, mutationSelectionSet);
			} else {
				return $dillonkearns$elm_graphql$Graphql$Document$serializeMutation(mutationSelectionSet);
			}
		}();
		return {
			j7: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(serializedMutation))
							]),
						function () {
							var _v6 = request.a4;
							if (!_v6.$) {
								var operationName = _v6.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'operationName',
										$elm$json$Json$Encode$string(operationName))
									]);
							} else {
								return _List_Nil;
							}
						}()))),
			fg: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.k2),
			D: request.D,
			aI: 'POST',
			K: request.K,
			jJ: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, request.a7, request.b3)
		};
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$toHttpRequestRecord = F2(
	function (resultToMessage, fullRequest) {
		var request = fullRequest;
		return function (readyRequest) {
			return {
				j7: readyRequest.j7,
				k2: A2(
					$dillonkearns$elm_graphql$Graphql$Http$expectJson,
					A2($elm$core$Basics$composeR, $dillonkearns$elm_graphql$Graphql$Http$convertResult, resultToMessage),
					readyRequest.fg),
				D: readyRequest.D,
				aI: readyRequest.aI,
				K: readyRequest.K,
				jz: $elm$core$Maybe$Nothing,
				jJ: readyRequest.jJ
			};
		}(
			$dillonkearns$elm_graphql$Graphql$Http$toReadyRequest(fullRequest));
	});
var $dillonkearns$elm_graphql$Graphql$Http$send = F2(
	function (resultToMessage, fullRequest) {
		var request = fullRequest;
		return (request.bh ? $elm$http$Http$riskyRequest : $elm$http$Http$request)(
			A2($dillonkearns$elm_graphql$Graphql$Http$toHttpRequestRecord, resultToMessage, fullRequest));
	});
var $author$project$Util$HttpUtil$userTokenHeader = 'User-Token';
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $dillonkearns$elm_graphql$Graphql$Http$withHeader = F3(
	function (key, value, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				D: A2(
					$elm$core$List$cons,
					A2($elm$http$Http$header, key, value),
					request.D)
			});
	});
var $author$project$Util$HttpUtil$sendWithJWT = function (ps) {
	return A2(
		$elm$core$Basics$composeR,
		A2($dillonkearns$elm_graphql$Graphql$Http$withHeader, $author$project$Util$HttpUtil$userTokenHeader, ps.am),
		$dillonkearns$elm_graphql$Graphql$Http$send(ps.k2));
};
var $author$project$Util$HttpUtil$queryWith = F2(
	function (expect, authorizedAccess) {
		return A2(
			$elm$core$Basics$composeR,
			$dillonkearns$elm_graphql$Graphql$Http$queryRequest(authorizedAccess.m.k8),
			$author$project$Util$HttpUtil$sendWithJWT(
				{k2: expect, am: authorizedAccess.am}));
	});
var $author$project$Types$Dashboard$Resolved$Resolved = F2(
	function (dashboard, entries) {
		return {ff: dashboard, fk: entries};
	});
var $author$project$LondoGQL$Object$ResolvedDashboard$dashboard = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'dashboard', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$ResolvedDashboard$entries = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'entries',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map2 = F3(
	function (combine, _v0, _v1) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_Utils_ap(selectionFields1, selectionFields2),
			A3($elm$json$Json$Decode$map2, combine, selectionDecoder1, selectionDecoder2));
	});
var $author$project$Types$Dashboard$Dashboard$Dashboard = F4(
	function (id, header, description, visibility) {
		return {dq: description, bA: header, lf: id, jN: visibility};
	});
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf = F2(
	function (details, args) {
		return A2($dillonkearns$elm_graphql$Graphql$RawField$Leaf, details, args);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField = F4(
	function (typeString, fieldName, args, decoder) {
		var newLeaf = A2(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf,
			{hh: fieldName, jE: typeString},
			args);
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_List_fromArray(
				[newLeaf]),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, fieldName, decoder),
						A2(
						$elm$json$Json$Decode$field,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(newLeaf),
						decoder)
					])));
	});
var $author$project$LondoGQL$Object$Dashboard$description = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'description',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$LondoGQL$Object$Dashboard$header = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'header', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$LondoGQL$Object$Dashboard$id = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'id', _List_Nil, object____, $elm$core$Basics$identity);
};
var $elm$json$Json$Decode$map4 = _Json_map4;
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map4 = F5(
	function (combine, _v0, _v1, _v2, _v3) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		var selectionFields3 = _v2.a;
		var selectionDecoder3 = _v2.b;
		var selectionFields4 = _v3.a;
		var selectionDecoder4 = _v3.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			$elm$core$List$concat(
				_List_fromArray(
					[selectionFields1, selectionFields2, selectionFields3, selectionFields4])),
			A5($elm$json$Json$Decode$map4, combine, selectionDecoder1, selectionDecoder2, selectionDecoder3, selectionDecoder4));
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map = F2(
	function (mapFunction, _v0) {
		var selectionFields = _v0.a;
		var selectionDecoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			selectionFields,
			A2($elm$json$Json$Decode$map, mapFunction, selectionDecoder));
	});
var $author$project$LondoGQL$Scalar$unwrapCodecs = function (_v0) {
	var unwrappedCodecs = _v0;
	return unwrappedCodecs;
};
var $author$project$LondoGQL$Object$DashboardId$uuid = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'uuid',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).dj.fg);
var $author$project$Types$Dashboard$Id$selection = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$LondoGQL$Object$DashboardId$uuid);
var $author$project$LondoGQL$Enum$Visibility$Private = 0;
var $author$project$LondoGQL$Enum$Visibility$Public = 1;
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$LondoGQL$Enum$Visibility$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'Private':
				return $elm$json$Json$Decode$succeed(0);
			case 'Public':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid Visibility type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$LondoGQL$Object$Dashboard$visibility = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Visibility.Visibility', 'visibility', _List_Nil, $author$project$LondoGQL$Enum$Visibility$decoder);
var $author$project$Types$Dashboard$Dashboard$selection = A5(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map4,
	$author$project$Types$Dashboard$Dashboard$Dashboard,
	$author$project$LondoGQL$Object$Dashboard$id($author$project$Types$Dashboard$Id$selection),
	$author$project$LondoGQL$Object$Dashboard$header,
	$author$project$LondoGQL$Object$Dashboard$description,
	$author$project$LondoGQL$Object$Dashboard$visibility);
var $author$project$Types$DashboardEntry$Entry$Entry = function (projectId) {
	return {f: projectId};
};
var $author$project$LondoGQL$Object$DashboardEntry$projectId = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'projectId', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$ProjectId$uuid = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'uuid',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).dj.fg);
var $author$project$Types$Project$Id$selection = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$LondoGQL$Object$ProjectId$uuid);
var $author$project$Types$DashboardEntry$Entry$selection = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$author$project$Types$DashboardEntry$Entry$Entry,
	$author$project$LondoGQL$Object$DashboardEntry$projectId($author$project$Types$Project$Id$selection));
var $author$project$Types$Dashboard$Resolved$selection = A3(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map2,
	$author$project$Types$Dashboard$Resolved$Resolved,
	$author$project$LondoGQL$Object$ResolvedDashboard$dashboard($author$project$Types$Dashboard$Dashboard$selection),
	$author$project$LondoGQL$Object$ResolvedDashboard$entries($author$project$Types$DashboardEntry$Entry$selection));
var $author$project$LondoGQL$InputObject$DashboardIdInput = function (uuid) {
	return {o: uuid};
};
var $author$project$Types$Dashboard$Id$toGraphQLInput = A2($elm$core$Basics$composeR, $author$project$Types$Dashboard$Id$uuid, $author$project$LondoGQL$InputObject$DashboardIdInput);
var $author$project$Types$Dashboard$Resolved$fetchWith = F3(
	function (expect, authorizedAccess, dashboardId) {
		return A3(
			$author$project$Util$HttpUtil$queryWith,
			expect,
			authorizedAccess,
			A2(
				$author$project$LondoGQL$Query$fetchResolvedDashboard,
				{
					b: {
						c: $author$project$Types$Dashboard$Id$toGraphQLInput(dashboardId)
					}
				},
				$author$project$Types$Dashboard$Resolved$selection));
	});
var $author$project$Pages$View$Tristate$Initial = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$View$Tristate$Model = F3(
	function (configuration, errorLanguage, status) {
		return {m: configuration, z: errorLanguage, as: status};
	});
var $author$project$Pages$View$Tristate$createInitial = F2(
	function (configuration, language) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Pages$View$Tristate$Initial,
			A2($author$project$Pages$View$Tristate$Model, configuration, language));
	});
var $author$project$Pages$Util$Choice$Page$initialWith = F3(
	function (jwt, parentId, language) {
		return {kl: $elm$core$Maybe$Nothing, g9: $elm$core$Maybe$Nothing, am: jwt, dL: language, eb: parentId};
	});
var $author$project$Pages$Util$Parent$Page$initialWith = F2(
	function (jwt, language) {
		return {am: jwt, dL: language, me: $elm$core$Maybe$Nothing};
	});
var $author$project$Pages$DashboardEntries$Page$initial = F2(
	function (authorizedAccess, dashboardId) {
		return A3(
			$author$project$Pages$View$Tristate$createInitial,
			authorizedAccess.m,
			$author$project$Language$Language$default.hc,
			{
				ff: A2($author$project$Pages$Util$Parent$Page$initialWith, authorizedAccess.am, $author$project$Language$Language$default.gO),
				fk: A3($author$project$Pages$Util$Choice$Page$initialWith, authorizedAccess.am, dashboardId, $author$project$Language$Language$default.$7)
			});
	});
var $author$project$Pages$Util$Choice$Page$GotFetchChoicesResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$LondoGQL$Query$fetchAllProjects = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'fetchAllProjects',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Types$Project$Project$Project = F3(
	function (id, name, description) {
		return {dq: description, lf: id, hV: name};
	});
var $author$project$LondoGQL$Object$Project$description = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'description',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$LondoGQL$Object$Project$id = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'id', _List_Nil, object____, $elm$core$Basics$identity);
};
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map3 = F4(
	function (combine, _v0, _v1, _v2) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		var selectionFields3 = _v2.a;
		var selectionDecoder3 = _v2.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			$elm$core$List$concat(
				_List_fromArray(
					[selectionFields1, selectionFields2, selectionFields3])),
			A4($elm$json$Json$Decode$map3, combine, selectionDecoder1, selectionDecoder2, selectionDecoder3));
	});
var $author$project$LondoGQL$Object$Project$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Types$Project$Project$selection = A4(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map3,
	$author$project$Types$Project$Project$Project,
	$author$project$LondoGQL$Object$Project$id($author$project$Types$Project$Id$selection),
	$author$project$LondoGQL$Object$Project$name,
	$author$project$LondoGQL$Object$Project$description);
var $author$project$Types$Project$Project$fetchAllWith = F2(
	function (expect, authorizedAccess) {
		return A3(
			$author$project$Util$HttpUtil$queryWith,
			expect,
			authorizedAccess,
			$author$project$LondoGQL$Query$fetchAllProjects($author$project$Types$Project$Project$selection));
	});
var $author$project$Pages$DashboardEntries$Entries$Handler$initialFetch = $author$project$Types$Project$Project$fetchAllWith($author$project$Pages$Util$Choice$Page$GotFetchChoicesResponse);
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Pages$DashboardEntries$Handler$init = function (flags) {
	return _Utils_Tuple2(
		A2($author$project$Pages$DashboardEntries$Page$initial, flags.bm, flags.c),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Types$Dashboard$Resolved$fetchWith, $author$project$Pages$DashboardEntries$Page$GotFetchResponse, flags.bm, flags.c),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Pages$DashboardEntries$Page$EntriesMsg,
						$author$project$Pages$DashboardEntries$Entries$Handler$initialFetch(flags.bm))
					]))));
};
var $author$project$Pages$Util$ParentEditor$Page$GotFetchResponse = function (a) {
	return {$: 13, a: a};
};
var $author$project$LondoGQL$Query$fetchAllDashboards = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'fetchAllDashboards',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Types$Dashboard$Dashboard$fetchAllWith = F2(
	function (expect, authorizedAccess) {
		return A3(
			$author$project$Util$HttpUtil$queryWith,
			expect,
			authorizedAccess,
			$author$project$LondoGQL$Query$fetchAllDashboards($author$project$Types$Dashboard$Dashboard$selection));
	});
var $author$project$Pages$Util$ParentEditor$Page$defaultInitial = F2(
	function (jwt, language) {
		return {am: jwt, dL: language, mg: $elm$core$Maybe$Nothing};
	});
var $author$project$Pages$Util$ParentEditor$Page$initial = F3(
	function (authorizedAccess, language, errorLanguage) {
		return A3(
			$author$project$Pages$View$Tristate$createInitial,
			authorizedAccess.m,
			errorLanguage,
			A2($author$project$Pages$Util$ParentEditor$Page$defaultInitial, authorizedAccess.am, language));
	});
var $author$project$Pages$Dashboards$Handler$init = function (flags) {
	return _Utils_Tuple2(
		A3($author$project$Pages$Util$ParentEditor$Page$initial, flags.bm, $author$project$Language$Language$default.gO, $author$project$Language$Language$default.hc),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			A2($author$project$Types$Dashboard$Dashboard$fetchAllWith, $author$project$Pages$Util$ParentEditor$Page$GotFetchResponse, flags.bm)));
};
var $author$project$Pages$Deletion$Page$Checking = 0;
var $author$project$Pages$View$Tristate$Main = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$View$Tristate$createMain = F2(
	function (configuration, language) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Pages$View$Tristate$Main,
			A2($author$project$Pages$View$Tristate$Model, configuration, language));
	});
var $author$project$Pages$Deletion$Page$initial = function (flags) {
	return A3(
		$author$project$Pages$View$Tristate$createMain,
		flags.m,
		$author$project$Language$Language$default.hc,
		{kK: flags.kK, dL: $author$project$Language$Language$default.ge, lL: 0, cO: flags.cO});
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Pages$Deletion$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Deletion$Page$initial(flags),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Types$User$Login$initial = {cl: false, R: '', ec: ''};
var $author$project$Pages$Login$Page$initial = function (flags) {
	return A3(
		$author$project$Pages$View$Tristate$createMain,
		flags.m,
		$author$project$Language$Language$default.hc,
		{gM: $author$project$Types$User$Login$initial, dL: $author$project$Language$Language$default.bH});
};
var $author$project$Pages$Login$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Login$Page$initial(flags),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Overview$Page$initial = function (configuration) {
	return A3(
		$author$project$Pages$View$Tristate$createMain,
		configuration,
		$author$project$Language$Language$default.hc,
		{dL: $author$project$Language$Language$default.id});
};
var $author$project$Pages$Overview$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Overview$Page$initial(flags.m),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Projects$Handler$init = function (flags) {
	return _Utils_Tuple2(
		A3($author$project$Pages$Util$ParentEditor$Page$initial, flags.bm, $author$project$Language$Language$default.ix, $author$project$Language$Language$default.hc),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			A2($author$project$Types$Project$Project$fetchAllWith, $author$project$Pages$Util$ParentEditor$Page$GotFetchResponse, flags.bm)));
};
var $author$project$Pages$Recovery$Confirm$Page$Resetting = 0;
var $author$project$Pages$Util$PasswordInput$initial = {ih: '', ii: ''};
var $author$project$Pages$Recovery$Confirm$Page$initial = function (flags) {
	return A3(
		$author$project$Pages$View$Tristate$createMain,
		flags.m,
		$author$project$Language$Language$default.hc,
		{dL: $author$project$Language$Language$default.gE, lL: 0, fR: $author$project$Pages$Util$PasswordInput$initial, mm: flags.mm, cO: flags.cO});
};
var $author$project$Pages$Recovery$Confirm$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Recovery$Confirm$Page$initial(flags),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Recovery$Request$Page$Initial = 0;
var $author$project$Pages$Recovery$Request$Page$initial = function (configuration) {
	return A3(
		$author$project$Pages$View$Tristate$createMain,
		configuration,
		$author$project$Language$Language$default.hc,
		{dL: $author$project$Language$Language$default.iN, lL: 0, cD: '', na: _List_Nil});
};
var $author$project$Pages$Recovery$Request$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Recovery$Request$Page$initial(flags.m),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Registration$Confirm$Page$Editing = 0;
var $author$project$Pages$Util$ComplementInput$initial = {du: $elm$core$Maybe$Nothing, fR: $author$project$Pages$Util$PasswordInput$initial};
var $author$project$Pages$Registration$Confirm$Page$initial = function (flags) {
	return A3(
		$author$project$Pages$View$Tristate$createMain,
		flags.m,
		$author$project$Language$Language$default.hc,
		{fc: $author$project$Pages$Util$ComplementInput$initial, dL: $author$project$Language$Language$default.gG, lL: 0, mo: flags.mo, cO: flags.cO});
};
var $author$project$Pages$Registration$Confirm$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Registration$Confirm$Page$initial(flags),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Registration$Request$Page$Editing = 0;
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$core$Basics$not = _Basics_not;
var $author$project$Util$ValidatedInput$nonEmptyString = {
	ci: '',
	a6: A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$Just,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$maybe_extra$Maybe$Extra$filter(
				A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
			$elm$core$Result$fromMaybe('Error: Empty string'))),
	bP: $elm$core$Basics$always(true),
	jp: '',
	nc: ''
};
var $author$project$Pages$Registration$Request$Page$initial = function (configuration) {
	return A3(
		$author$project$Pages$View$Tristate$createMain,
		configuration,
		$author$project$Language$Language$default.hc,
		{aC: $author$project$Util$ValidatedInput$nonEmptyString, dL: $author$project$Language$Language$default.iO, lL: 0, R: $author$project$Util$ValidatedInput$nonEmptyString});
};
var $author$project$Pages$Registration$Request$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Registration$Request$Page$initial(flags.m),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Settings$Page$GotFetchUserResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$LondoGQL$Query$fetchUser = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'fetchUser', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Types$User$User$User = F4(
	function (id, nickname, displayName, email) {
		return {du: displayName, aC: email, lf: id, R: nickname};
	});
var $author$project$LondoGQL$Object$User$displayName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'displayName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$LondoGQL$Object$User$email = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'email', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$LondoGQL$Object$User$id = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'id', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$User$nickname = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'nickname', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Types$User$Id$Id = $elm$core$Basics$identity;
var $author$project$LondoGQL$Object$UserId$uuid = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'uuid',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).dj.fg);
var $author$project$Types$User$Id$selection = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$LondoGQL$Object$UserId$uuid);
var $author$project$Types$User$User$selection = A5(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map4,
	$author$project$Types$User$User$User,
	$author$project$LondoGQL$Object$User$id($author$project$Types$User$Id$selection),
	$author$project$LondoGQL$Object$User$nickname,
	$author$project$LondoGQL$Object$User$displayName,
	$author$project$LondoGQL$Object$User$email);
var $author$project$Types$User$User$fetchWith = F2(
	function (expect, authorizedAccess) {
		return A3(
			$author$project$Util$HttpUtil$queryWith,
			expect,
			authorizedAccess,
			$author$project$LondoGQL$Query$fetchUser($author$project$Types$User$User$selection));
	});
var $author$project$Pages$Settings$Page$initial = function (authorizedAccess) {
	return A3(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.m,
		$author$project$Language$Language$default.hc,
		{am: authorizedAccess.am, jK: $elm$core$Maybe$Nothing});
};
var $author$project$Pages$Settings$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Settings$Page$initial(flags.bm),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			A2($author$project$Types$User$User$fetchWith, $author$project$Pages$Settings$Page$GotFetchUserResponse, flags.bm)));
};
var $author$project$Pages$Statistics$Page$GotFetchDashboardAnalysisResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$LondoGQL$InputObject$encodePositiveInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'positive',
				$elm$core$Maybe$Just(
					A2(
						$author$project$LondoGQL$Scalar$unwrapEncoder,
						function ($) {
							return $.fa;
						},
						$author$project$LondoGQL$ScalarCodecs$codecs)(input____.cz)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeFetchDashboardAnalysisInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dashboardId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeDashboardIdInput(input____.c))),
				_Utils_Tuple2(
				'numberOfDecimalPlaces',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodePositiveInput(input____.ae)))
			]));
};
var $author$project$LondoGQL$Query$fetchDashboardAnalysis = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'fetchDashboardAnalysis',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeFetchDashboardAnalysisInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$LondoGQL$InputObject$PositiveInput = function (positive) {
	return {cz: positive};
};
var $author$project$Math$Positive$integerValue = function (_v0) {
	var _int = _v0;
	return _int;
};
var $cmditch$elm_bigint$Constants$maxDigitMagnitude = 7;
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $cmditch$elm_bigint$BigInt$fillZeroes = function (x) {
	return A3(
		$elm$core$String$padLeft,
		$cmditch$elm_bigint$Constants$maxDigitMagnitude,
		'0',
		$elm$core$String$fromInt(x));
};
var $cmditch$elm_bigint$BigInt$revMagnitudeToString = function (_v0) {
	var digits = _v0;
	var _v1 = $elm$core$List$reverse(digits);
	if (!_v1.b) {
		return '0';
	} else {
		var x = _v1.a;
		var xs = _v1.b;
		return $elm$core$String$concat(
			A2(
				$elm$core$List$cons,
				$elm$core$String$fromInt(x),
				A2($elm$core$List$map, $cmditch$elm_bigint$BigInt$fillZeroes, xs)));
	}
};
var $cmditch$elm_bigint$BigInt$toString = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return '0';
		case 0:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$revMagnitudeToString(mag);
		default:
			var mag = bigInt.a;
			return '-' + $cmditch$elm_bigint$BigInt$revMagnitudeToString(mag);
	}
};
var $author$project$Math$Positive$toString = A2($elm$core$Basics$composeR, $author$project$Math$Positive$integerValue, $cmditch$elm_bigint$BigInt$toString);
var $author$project$Math$Positive$toGraphQLInput = A2(
	$elm$core$Basics$composeR,
	$author$project$Math$Positive$toString,
	A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$LondoGQL$InputObject$PositiveInput));
var $author$project$Types$Dashboard$Analysis$fetchWithSelection = F4(
	function (ps, authorizedAccess, dashboardId, numberOfDecimalPlaces) {
		return A3(
			$author$project$Util$HttpUtil$queryWith,
			ps.k2,
			authorizedAccess,
			A2(
				$author$project$LondoGQL$Query$fetchDashboardAnalysis,
				{
					b: {
						c: $author$project$Types$Dashboard$Id$toGraphQLInput(dashboardId),
						ae: $author$project$Math$Positive$toGraphQLInput(numberOfDecimalPlaces)
					}
				},
				ps.mG));
	});
var $author$project$Types$Dashboard$Analysis$Analysis = F3(
	function (dashboard, projectAnalyses, dashboardStatistics) {
		return {ff: dashboard, kC: dashboardStatistics, mj: projectAnalyses};
	});
var $author$project$LondoGQL$Object$DashboardAnalysis$dashboard = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'dashboard', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$DashboardAnalysis$projectAnalyses = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'projectAnalyses',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Types$Project$Analysis$Analysis = F2(
	function (project, tasks) {
		return {eg: project, jn: tasks};
	});
var $author$project$LondoGQL$Object$ProjectAnalysis$project = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'project', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Types$Task$Analysis$Analysis = F3(
	function (task, simulation, incompleteTaskStatistics) {
		return {hw: incompleteTaskStatistics, i5: simulation, eM: task};
	});
var $author$project$LondoGQL$Object$TaskAnalysis$incompleteStatistics = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'incompleteStatistics',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Types$Simulation$Simulation$Simulation = function (reachedModifier) {
	return {cB: reachedModifier};
};
var $cmditch$elm_bigint$BigInt$Negative = 1;
var $cmditch$elm_bigint$BigInt$Positive = 0;
var $cmditch$elm_bigint$BigInt$Magnitude = $elm$core$Basics$identity;
var $elm_community$list_extra$List$Extra$dropWhileRight = function (p) {
	return A2(
		$elm$core$List$foldr,
		F2(
			function (x, xs) {
				return (p(x) && $elm$core$List$isEmpty(xs)) ? _List_Nil : A2($elm$core$List$cons, x, xs);
			}),
		_List_Nil);
};
var $cmditch$elm_bigint$BigInt$emptyZero = function (_v0) {
	var xs = _v0;
	var _v1 = A2(
		$elm_community$list_extra$List$Extra$dropWhileRight,
		$elm$core$Basics$eq(0),
		xs);
	if (!_v1.b) {
		return _List_Nil;
	} else {
		var d = _v1;
		return d;
	}
};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, list) {
		if ((size <= 0) || (step <= 0)) {
			return _List_Nil;
		} else {
			var go = F2(
				function (xs, acc) {
					go:
					while (true) {
						if ($elm$core$List$isEmpty(xs)) {
							return $elm$core$List$reverse(acc);
						} else {
							var $temp$xs = A2($elm$core$List$drop, step, xs),
								$temp$acc = A2(
								$elm$core$List$cons,
								A2($elm$core$List$take, size, xs),
								acc);
							xs = $temp$xs;
							acc = $temp$acc;
							continue go;
						}
					}
				});
			return A2(go, list, _List_Nil);
		}
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $elm_community$maybe_extra$Maybe$Extra$traverseHelp = F3(
	function (f, list, acc) {
		traverseHelp:
		while (true) {
			if (list.b) {
				var head = list.a;
				var tail = list.b;
				var _v1 = f(head);
				if (!_v1.$) {
					var a = _v1.a;
					var $temp$f = f,
						$temp$list = tail,
						$temp$acc = A2($elm$core$List$cons, a, acc);
					f = $temp$f;
					list = $temp$list;
					acc = $temp$acc;
					continue traverseHelp;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Just(
					$elm$core$List$reverse(acc));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$traverse = F2(
	function (f, list) {
		return A3($elm_community$maybe_extra$Maybe$Extra$traverseHelp, f, list, _List_Nil);
	});
var $cmditch$elm_bigint$BigInt$fromString_ = function (x) {
	return A2(
		$elm$core$Maybe$map,
		function (digitList) {
			return $cmditch$elm_bigint$BigInt$emptyZero(
				A2(
					$elm$core$List$map,
					function (group) {
						return A3(
							$elm$core$List$foldr,
							F2(
								function (e, a) {
									return (a * 10) + e;
								}),
							0,
							group);
					},
					A2(
						$elm_community$list_extra$List$Extra$greedyGroupsOf,
						$cmditch$elm_bigint$Constants$maxDigitMagnitude,
						$elm$core$List$reverse(digitList))));
		},
		A2(
			$elm_community$maybe_extra$Maybe$Extra$traverse,
			function (d) {
				var r = $elm$core$Char$toCode(d);
				return ((r >= 48) && (r <= 57)) ? $elm$core$Maybe$Just(r - 48) : $elm$core$Maybe$Nothing;
			},
			x));
};
var $cmditch$elm_bigint$BigInt$Neg = function (a) {
	return {$: 1, a: a};
};
var $cmditch$elm_bigint$BigInt$Pos = function (a) {
	return {$: 0, a: a};
};
var $cmditch$elm_bigint$BigInt$Zer = {$: 2};
var $cmditch$elm_bigint$BigInt$mkBigInt = F2(
	function (s, mag) {
		var digits = mag;
		if ($elm$core$List$isEmpty(digits)) {
			return $cmditch$elm_bigint$BigInt$Zer;
		} else {
			switch (s) {
				case 2:
					return $cmditch$elm_bigint$BigInt$Zer;
				case 0:
					return $cmditch$elm_bigint$BigInt$Pos(mag);
				default:
					return $cmditch$elm_bigint$BigInt$Neg(mag);
			}
		}
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $cmditch$elm_bigint$BigInt$fromIntString = function (x) {
	var _v0 = $elm$core$String$toList(x);
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		switch (_v0.a) {
			case '-':
				if (!_v0.b.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var xs = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						$cmditch$elm_bigint$BigInt$mkBigInt(1),
						$cmditch$elm_bigint$BigInt$fromString_(xs));
				}
			case '+':
				if (!_v0.b.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var xs = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						$cmditch$elm_bigint$BigInt$mkBigInt(0),
						$cmditch$elm_bigint$BigInt$fromString_(xs));
				}
			default:
				var xs = _v0;
				return A2(
					$elm$core$Maybe$map,
					$cmditch$elm_bigint$BigInt$mkBigInt(0),
					$cmditch$elm_bigint$BigInt$fromString_(xs));
		}
	}
};
var $author$project$Util$GraphQLUtil$bigIntFromGraphQL = function (_v0) {
	var x = _v0;
	return $cmditch$elm_bigint$BigInt$fromIntString(x);
};
var $author$project$LondoGQL$Object$Simulation$reachedModifier = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.BigInt',
	'reachedModifier',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).fa.fg);
var $cmditch$elm_bigint$BigInt$BigIntNotNormalised = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $cmditch$elm_bigint$BigInt$MagnitudeNotNormalised = $elm$core$Basics$identity;
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $cmditch$elm_bigint$BigInt$isNegativeMagnitude = function (digits) {
	var _v0 = $elm_community$list_extra$List$Extra$last(digits);
	if (_v0.$ === 1) {
		return false;
	} else {
		var x = _v0.a;
		return x < 0;
	}
};
var $cmditch$elm_bigint$BigInt$dropZeroes = function (ls) {
	return A2(
		$elm_community$list_extra$List$Extra$dropWhileRight,
		$elm$core$Basics$eq(0),
		ls);
};
var $elm$core$Basics$pow = _Basics_pow;
var $cmditch$elm_bigint$Constants$maxDigitValue = (-1) + A2($elm$core$Basics$pow, 10, $cmditch$elm_bigint$Constants$maxDigitMagnitude);
var $cmditch$elm_bigint$BigInt$baseDigit = $cmditch$elm_bigint$Constants$maxDigitValue + 1;
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $cmditch$elm_bigint$BigInt$normaliseDigit = function (x) {
	return (x < 0) ? A2(
		$elm$core$Tuple$mapFirst,
		$elm$core$Basics$add(-1),
		$cmditch$elm_bigint$BigInt$normaliseDigit(x + $cmditch$elm_bigint$BigInt$baseDigit)) : _Utils_Tuple2((x / $cmditch$elm_bigint$BigInt$baseDigit) | 0, x % $cmditch$elm_bigint$BigInt$baseDigit);
};
var $cmditch$elm_bigint$BigInt$normaliseDigitList = F2(
	function (carry, xs) {
		normaliseDigitList:
		while (true) {
			if (!xs.b) {
				if (_Utils_cmp(carry, $cmditch$elm_bigint$BigInt$baseDigit) > 0) {
					var $temp$carry = 0,
						$temp$xs = _List_fromArray(
						[carry]);
					carry = $temp$carry;
					xs = $temp$xs;
					continue normaliseDigitList;
				} else {
					return _List_fromArray(
						[carry]);
				}
			} else {
				var x = xs.a;
				var xs_ = xs.b;
				var _v1 = $cmditch$elm_bigint$BigInt$normaliseDigit(x + carry);
				var newCarry = _v1.a;
				var x_ = _v1.b;
				return A2(
					$elm$core$List$cons,
					x_,
					A2($cmditch$elm_bigint$BigInt$normaliseDigitList, newCarry, xs_));
			}
		}
	});
var $cmditch$elm_bigint$BigInt$normaliseMagnitude = function (_v0) {
	var xs = _v0;
	return $cmditch$elm_bigint$BigInt$dropZeroes(
		A2($cmditch$elm_bigint$BigInt$normaliseDigitList, 0, xs));
};
var $cmditch$elm_bigint$BigInt$Zero = 2;
var $cmditch$elm_bigint$BigInt$signNegate = function (sign_) {
	switch (sign_) {
		case 0:
			return 1;
		case 1:
			return 0;
		default:
			return 2;
	}
};
var $cmditch$elm_bigint$BigInt$normalise = function (_v0) {
	var s = _v0.a;
	var digits = _v0.b;
	var _v1 = $cmditch$elm_bigint$BigInt$normaliseMagnitude(digits);
	var normalisedMag = _v1;
	if ($cmditch$elm_bigint$BigInt$isNegativeMagnitude(normalisedMag)) {
		var _v2 = $cmditch$elm_bigint$BigInt$normaliseMagnitude(
			A2($elm$core$List$map, $elm$core$Basics$negate, normalisedMag));
		var normalisedMag2 = _v2;
		return A2(
			$cmditch$elm_bigint$BigInt$mkBigInt,
			$cmditch$elm_bigint$BigInt$signNegate(s),
			normalisedMag2);
	} else {
		return A2($cmditch$elm_bigint$BigInt$mkBigInt, s, normalisedMag);
	}
};
var $cmditch$elm_bigint$BigInt$signFromInt = function (x) {
	var _v0 = A2($elm$core$Basics$compare, x, 0);
	switch (_v0) {
		case 0:
			return 1;
		case 2:
			return 0;
		default:
			return 2;
	}
};
var $cmditch$elm_bigint$BigInt$fromInt = function (x) {
	return $cmditch$elm_bigint$BigInt$normalise(
		A2(
			$cmditch$elm_bigint$BigInt$BigIntNotNormalised,
			$cmditch$elm_bigint$BigInt$signFromInt(x),
			_List_fromArray(
				[
					$elm$core$Basics$abs(x)
				])));
};
var $author$project$Math$Constants$zeroBigInt = $cmditch$elm_bigint$BigInt$fromInt(0);
var $author$project$Types$Simulation$Simulation$selection = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Util$GraphQLUtil$bigIntFromGraphQL,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault($author$project$Math$Constants$zeroBigInt),
			$author$project$Types$Simulation$Simulation$Simulation)),
	$author$project$LondoGQL$Object$Simulation$reachedModifier);
var $author$project$Types$Task$IncompleteTaskStatistics$IncompleteTaskStatistics = F3(
	function (mean, total, counting) {
		return {dk: counting, hO: mean, jx: total};
	});
var $author$project$LondoGQL$Object$IncompleteTaskStatistics$counting = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'counting', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$IncompleteTaskStatistics$mean = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.BigDecimal',
	'mean',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).e9.fg);
var $author$project$Types$Task$After$After = F3(
	function (one, completion, simulation) {
		return {ks: completion, l5: one, i5: simulation};
	});
var $author$project$LondoGQL$Object$After$completion = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.BigDecimal',
	'completion',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).e9.fg);
var $author$project$LondoGQL$Object$After$one = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.BigDecimal',
	'one',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).e9.fg);
var $author$project$LondoGQL$Object$After$simulation = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.BigDecimal)',
	'simulation',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).e9.fg));
var $author$project$Types$Task$After$selection = A4($dillonkearns$elm_graphql$Graphql$SelectionSet$map3, $author$project$Types$Task$After$After, $author$project$LondoGQL$Object$After$one, $author$project$LondoGQL$Object$After$completion, $author$project$LondoGQL$Object$After$simulation);
var $author$project$LondoGQL$Object$IncompleteTaskStatistics$total = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'total', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Types$Task$IncompleteTaskStatistics$selection = A4(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map3,
	$author$project$Types$Task$IncompleteTaskStatistics$IncompleteTaskStatistics,
	$author$project$LondoGQL$Object$IncompleteTaskStatistics$mean,
	$author$project$LondoGQL$Object$IncompleteTaskStatistics$total($author$project$Types$Task$After$selection),
	$author$project$LondoGQL$Object$IncompleteTaskStatistics$counting($author$project$Types$Task$After$selection));
var $author$project$Types$Task$Task$Task = F6(
	function (id, name, taskKind, unit, progress, counting) {
		return {dk: counting, lf: id, hV: name, iw: progress, jl: taskKind, jF: unit};
	});
var $author$project$LondoGQL$Object$Task$counting = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'counting', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$LondoGQL$Object$Task$id = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'id', _List_Nil, object____, $elm$core$Basics$identity);
};
var $elm$json$Json$Decode$map6 = _Json_map6;
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map6 = F7(
	function (combine, _v0, _v1, _v2, _v3, _v4, _v5) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		var selectionFields3 = _v2.a;
		var selectionDecoder3 = _v2.b;
		var selectionFields4 = _v3.a;
		var selectionDecoder4 = _v3.b;
		var selectionFields5 = _v4.a;
		var selectionDecoder5 = _v4.b;
		var selectionFields6 = _v5.a;
		var selectionDecoder6 = _v5.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			$elm$core$List$concat(
				_List_fromArray(
					[selectionFields1, selectionFields2, selectionFields3, selectionFields4, selectionFields5, selectionFields6])),
			A7($elm$json$Json$Decode$map6, combine, selectionDecoder1, selectionDecoder2, selectionDecoder3, selectionDecoder4, selectionDecoder5, selectionDecoder6));
	});
var $author$project$LondoGQL$Object$Task$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$LondoGQL$Object$Task$progress = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'progress', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Types$Progress$Progress$Progress = F2(
	function (reachable, reached) {
		return {ah: reachable, ai: reached};
	});
var $author$project$LondoGQL$Object$Progress$reachable = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'reachable', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$Progress$reached = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'reached', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Math$Natural$NonNegative = $elm$core$Basics$identity;
var $author$project$LondoGQL$Object$Natural$nonNegative = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.BigInt',
	'nonNegative',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).fa.fg);
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Math$Natural$zero = $author$project$Math$Constants$zeroBigInt;
var $author$project$Math$Natural$selection = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Util$GraphQLUtil$bigIntFromGraphQL,
		A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Math$Natural$zero, $elm$core$Basics$identity)),
	$author$project$LondoGQL$Object$Natural$nonNegative);
var $author$project$Math$Positive$Positive = $elm$core$Basics$identity;
var $author$project$Math$Constants$oneBigInt = $cmditch$elm_bigint$BigInt$fromInt(1);
var $author$project$Math$Positive$one = $author$project$Math$Constants$oneBigInt;
var $author$project$LondoGQL$Object$Positive$positive = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.BigInt',
	'positive',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).fa.fg);
var $author$project$Math$Positive$selection = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Util$GraphQLUtil$bigIntFromGraphQL,
		A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Math$Positive$one, $elm$core$Basics$identity)),
	$author$project$LondoGQL$Object$Positive$positive);
var $author$project$Types$Progress$Progress$selection = A3(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map2,
	$author$project$Types$Progress$Progress$Progress,
	$author$project$LondoGQL$Object$Progress$reachable($author$project$Math$Positive$selection),
	$author$project$LondoGQL$Object$Progress$reached($author$project$Math$Natural$selection));
var $author$project$Types$Task$Id$Id = $elm$core$Basics$identity;
var $author$project$LondoGQL$Object$TaskId$uuid = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'uuid',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).dj.fg);
var $author$project$Types$Task$Id$selection = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$LondoGQL$Object$TaskId$uuid);
var $author$project$LondoGQL$Enum$TaskKind$Discrete = 0;
var $author$project$LondoGQL$Enum$TaskKind$Fraction = 1;
var $author$project$LondoGQL$Enum$TaskKind$Percent = 2;
var $author$project$LondoGQL$Enum$TaskKind$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'Discrete':
				return $elm$json$Json$Decode$succeed(0);
			case 'Fraction':
				return $elm$json$Json$Decode$succeed(1);
			case 'Percent':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid TaskKind type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$LondoGQL$Object$Task$taskKind = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.TaskKind.TaskKind', 'taskKind', _List_Nil, $author$project$LondoGQL$Enum$TaskKind$decoder);
var $author$project$LondoGQL$Object$Task$unit = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'unit',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Types$Task$Task$selection = A7(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map6,
	$author$project$Types$Task$Task$Task,
	$author$project$LondoGQL$Object$Task$id($author$project$Types$Task$Id$selection),
	$author$project$LondoGQL$Object$Task$name,
	$author$project$LondoGQL$Object$Task$taskKind,
	$author$project$LondoGQL$Object$Task$unit,
	$author$project$LondoGQL$Object$Task$progress($author$project$Types$Progress$Progress$selection),
	$author$project$LondoGQL$Object$Task$counting);
var $author$project$LondoGQL$Object$TaskAnalysis$simulation = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'simulation',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$LondoGQL$Object$TaskAnalysis$task = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'task', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Types$Task$Analysis$selection = A4(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map3,
	$author$project$Types$Task$Analysis$Analysis,
	$author$project$LondoGQL$Object$TaskAnalysis$task($author$project$Types$Task$Task$selection),
	$author$project$LondoGQL$Object$TaskAnalysis$simulation($author$project$Types$Simulation$Simulation$selection),
	$author$project$LondoGQL$Object$TaskAnalysis$incompleteStatistics($author$project$Types$Task$IncompleteTaskStatistics$selection));
var $author$project$LondoGQL$Object$ProjectAnalysis$tasks = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'tasks',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Types$Project$Analysis$selection = A3(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map2,
	$author$project$Types$Project$Analysis$Analysis,
	$author$project$LondoGQL$Object$ProjectAnalysis$project($author$project$Types$Project$Project$selection),
	$author$project$LondoGQL$Object$ProjectAnalysis$tasks($author$project$Types$Task$Analysis$selection));
var $author$project$LondoGQL$Object$DashboardAnalysis$dashboardStatistics = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'dashboardStatistics', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Types$Dashboard$Statistics$Statistics = F7(
	function (reached, reachable, absoluteMeans, relativeMeans, buckets, tasks, differenceTotalCounting) {
		return {gd: absoluteMeans, db: buckets, kM: differenceTotalCounting, ah: reachable, ai: reached, iJ: relativeMeans, jn: tasks};
	});
var $author$project$LondoGQL$Object$DashboardStatistics$absoluteMeans = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'absoluteMeans', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$DashboardStatistics$buckets = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'buckets', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$DashboardStatistics$differenceTotalCounting = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'differenceTotalCounting', _List_Nil, $elm$json$Json$Decode$int);
var $elm$json$Json$Decode$map7 = _Json_map7;
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map7 = F8(
	function (combine, _v0, _v1, _v2, _v3, _v4, _v5, _v6) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		var selectionFields3 = _v2.a;
		var selectionDecoder3 = _v2.b;
		var selectionFields4 = _v3.a;
		var selectionDecoder4 = _v3.b;
		var selectionFields5 = _v4.a;
		var selectionDecoder5 = _v4.b;
		var selectionFields6 = _v5.a;
		var selectionDecoder6 = _v5.b;
		var selectionFields7 = _v6.a;
		var selectionDecoder7 = _v6.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			$elm$core$List$concat(
				_List_fromArray(
					[selectionFields1, selectionFields2, selectionFields3, selectionFields4, selectionFields5, selectionFields6, selectionFields7])),
			A8($elm$json$Json$Decode$map7, combine, selectionDecoder1, selectionDecoder2, selectionDecoder3, selectionDecoder4, selectionDecoder5, selectionDecoder6, selectionDecoder7));
	});
var $author$project$LondoGQL$Object$DashboardStatistics$reachable = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'reachable', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$DashboardStatistics$reached = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'reached', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$DashboardStatistics$relativeMeans = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'relativeMeans', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Types$Dashboard$Buckets$Buckets = F2(
	function (total, counting) {
		return {dk: counting, jx: total};
	});
var $author$project$LondoGQL$Object$Buckets$counting = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'counting',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Types$Dashboard$CountingBucket$CountingBucket = F2(
	function (bucket, amount) {
		return {j2: amount, j9: bucket};
	});
var $author$project$LondoGQL$Object$CountingBucket$amount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'amount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$LondoGQL$Enum$Bucket$Below10 = 0;
var $author$project$LondoGQL$Enum$Bucket$Below100 = 1;
var $author$project$LondoGQL$Enum$Bucket$Below20 = 2;
var $author$project$LondoGQL$Enum$Bucket$Below30 = 3;
var $author$project$LondoGQL$Enum$Bucket$Below40 = 4;
var $author$project$LondoGQL$Enum$Bucket$Below50 = 5;
var $author$project$LondoGQL$Enum$Bucket$Below60 = 6;
var $author$project$LondoGQL$Enum$Bucket$Below70 = 7;
var $author$project$LondoGQL$Enum$Bucket$Below80 = 8;
var $author$project$LondoGQL$Enum$Bucket$Below90 = 9;
var $author$project$LondoGQL$Enum$Bucket$Exactly100 = 10;
var $author$project$LondoGQL$Enum$Bucket$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'Below10':
				return $elm$json$Json$Decode$succeed(0);
			case 'Below100':
				return $elm$json$Json$Decode$succeed(1);
			case 'Below20':
				return $elm$json$Json$Decode$succeed(2);
			case 'Below30':
				return $elm$json$Json$Decode$succeed(3);
			case 'Below40':
				return $elm$json$Json$Decode$succeed(4);
			case 'Below50':
				return $elm$json$Json$Decode$succeed(5);
			case 'Below60':
				return $elm$json$Json$Decode$succeed(6);
			case 'Below70':
				return $elm$json$Json$Decode$succeed(7);
			case 'Below80':
				return $elm$json$Json$Decode$succeed(8);
			case 'Below90':
				return $elm$json$Json$Decode$succeed(9);
			case 'Exactly100':
				return $elm$json$Json$Decode$succeed(10);
			default:
				return $elm$json$Json$Decode$fail('Invalid Bucket type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$LondoGQL$Object$CountingBucket$bucket = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Bucket.Bucket', 'bucket', _List_Nil, $author$project$LondoGQL$Enum$Bucket$decoder);
var $author$project$Types$Dashboard$CountingBucket$selection = A3($dillonkearns$elm_graphql$Graphql$SelectionSet$map2, $author$project$Types$Dashboard$CountingBucket$CountingBucket, $author$project$LondoGQL$Object$CountingBucket$bucket, $author$project$LondoGQL$Object$CountingBucket$amount);
var $author$project$LondoGQL$Object$Buckets$total = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'total',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Types$Dashboard$Buckets$selection = A3(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map2,
	$author$project$Types$Dashboard$Buckets$Buckets,
	$author$project$LondoGQL$Object$Buckets$total($author$project$Types$Dashboard$CountingBucket$selection),
	$author$project$LondoGQL$Object$Buckets$counting($author$project$Types$Dashboard$CountingBucket$selection));
var $author$project$Types$Dashboard$Tasks$Tasks = F2(
	function (total, counting) {
		return {dk: counting, jx: total};
	});
var $author$project$LondoGQL$Object$Tasks$counting = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'counting', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$LondoGQL$Object$Tasks$total = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'total', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Types$Dashboard$Tasks$selection = A3($dillonkearns$elm_graphql$Graphql$SelectionSet$map2, $author$project$Types$Dashboard$Tasks$Tasks, $author$project$LondoGQL$Object$Tasks$total, $author$project$LondoGQL$Object$Tasks$counting);
var $author$project$Types$Dashboard$WithoutSimulation$WithoutSimulation = F2(
	function (total, counting) {
		return {dk: counting, jx: total};
	});
var $author$project$LondoGQL$Object$WithoutSimulation$counting = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'counting', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$WithoutSimulation$total = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'total', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Types$Dashboard$WithoutSimulation$selection = A3(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map2,
	$author$project$Types$Dashboard$WithoutSimulation$WithoutSimulation,
	$author$project$LondoGQL$Object$WithoutSimulation$total($author$project$Math$Natural$selection),
	$author$project$LondoGQL$Object$WithoutSimulation$counting($author$project$Math$Natural$selection));
var $author$project$Types$Dashboard$WithSimulation$WithSimulation = F4(
	function (total, counting, simulatedTotal, simulatedCounting) {
		return {dk: counting, i3: simulatedCounting, i4: simulatedTotal, jx: total};
	});
var $author$project$LondoGQL$Object$WithSimulationBigDecimal$counting = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.BigDecimal',
	'counting',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).e9.fg);
var $author$project$LondoGQL$Object$WithSimulationBigDecimal$simulatedCounting = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.BigDecimal',
	'simulatedCounting',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).e9.fg);
var $author$project$LondoGQL$Object$WithSimulationBigDecimal$simulatedTotal = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.BigDecimal',
	'simulatedTotal',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).e9.fg);
var $author$project$LondoGQL$Object$WithSimulationBigDecimal$total = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.BigDecimal',
	'total',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).e9.fg);
var $author$project$Types$Dashboard$WithSimulation$selectionBigDecimal = A5($dillonkearns$elm_graphql$Graphql$SelectionSet$map4, $author$project$Types$Dashboard$WithSimulation$WithSimulation, $author$project$LondoGQL$Object$WithSimulationBigDecimal$total, $author$project$LondoGQL$Object$WithSimulationBigDecimal$counting, $author$project$LondoGQL$Object$WithSimulationBigDecimal$simulatedTotal, $author$project$LondoGQL$Object$WithSimulationBigDecimal$simulatedCounting);
var $author$project$LondoGQL$Object$WithSimulationNatural$counting = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'counting', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$WithSimulationNatural$simulatedCounting = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'simulatedCounting', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$WithSimulationNatural$simulatedTotal = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'simulatedTotal', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$WithSimulationNatural$total = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'total', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Types$Dashboard$WithSimulation$selectionNatural = A5(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map4,
	$author$project$Types$Dashboard$WithSimulation$WithSimulation,
	$author$project$LondoGQL$Object$WithSimulationNatural$total($author$project$Math$Natural$selection),
	$author$project$LondoGQL$Object$WithSimulationNatural$counting($author$project$Math$Natural$selection),
	$author$project$LondoGQL$Object$WithSimulationNatural$simulatedTotal($author$project$Math$Natural$selection),
	$author$project$LondoGQL$Object$WithSimulationNatural$simulatedCounting($author$project$Math$Natural$selection));
var $author$project$LondoGQL$Object$DashboardStatistics$tasks = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'tasks', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Types$Dashboard$Statistics$selection = A8(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map7,
	$author$project$Types$Dashboard$Statistics$Statistics,
	$author$project$LondoGQL$Object$DashboardStatistics$reached($author$project$Types$Dashboard$WithSimulation$selectionNatural),
	$author$project$LondoGQL$Object$DashboardStatistics$reachable($author$project$Types$Dashboard$WithoutSimulation$selection),
	$author$project$LondoGQL$Object$DashboardStatistics$absoluteMeans($author$project$Types$Dashboard$WithSimulation$selectionBigDecimal),
	$author$project$LondoGQL$Object$DashboardStatistics$relativeMeans($author$project$Types$Dashboard$WithSimulation$selectionBigDecimal),
	$author$project$LondoGQL$Object$DashboardStatistics$buckets($author$project$Types$Dashboard$Buckets$selection),
	$author$project$LondoGQL$Object$DashboardStatistics$tasks($author$project$Types$Dashboard$Tasks$selection),
	$author$project$LondoGQL$Object$DashboardStatistics$differenceTotalCounting);
var $author$project$Types$Dashboard$Analysis$statisticsSelection = $author$project$LondoGQL$Object$DashboardAnalysis$dashboardStatistics($author$project$Types$Dashboard$Statistics$selection);
var $author$project$Types$Dashboard$Analysis$selection = A4(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map3,
	$author$project$Types$Dashboard$Analysis$Analysis,
	$author$project$LondoGQL$Object$DashboardAnalysis$dashboard($author$project$Types$Dashboard$Dashboard$selection),
	$author$project$LondoGQL$Object$DashboardAnalysis$projectAnalyses($author$project$Types$Project$Analysis$selection),
	$author$project$Types$Dashboard$Analysis$statisticsSelection);
var $author$project$Types$Dashboard$Analysis$fetchWith = function (expect) {
	return $author$project$Types$Dashboard$Analysis$fetchWithSelection(
		{k2: expect, mG: $author$project$Types$Dashboard$Analysis$selection});
};
var $author$project$Pages$Statistics$Page$initial = F3(
	function (languages, errorLanguage, authorizedAccess) {
		return A3(
			$author$project$Pages$View$Tristate$createInitial,
			authorizedAccess.m,
			errorLanguage,
			{kA: $elm$core$Maybe$Nothing, am: authorizedAccess.am, cp: languages});
	});
var $cmditch$elm_bigint$BigInt$compareMagnitude = F4(
	function (x, y, xs, ys) {
		compareMagnitude:
		while (true) {
			var _v0 = _Utils_Tuple2(xs, ys);
			if (!_v0.a.b) {
				if (!_v0.b.b) {
					return A2($elm$core$Basics$compare, x, y);
				} else {
					return 0;
				}
			} else {
				if (!_v0.b.b) {
					return 2;
				} else {
					var _v1 = _v0.a;
					var x_ = _v1.a;
					var xss = _v1.b;
					var _v2 = _v0.b;
					var y_ = _v2.a;
					var yss = _v2.b;
					if (_Utils_eq(x_, y_)) {
						var $temp$x = x,
							$temp$y = y,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					} else {
						var $temp$x = x_,
							$temp$y = y_,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					}
				}
			}
		}
	});
var $cmditch$elm_bigint$BigInt$compare = F2(
	function (int1, int2) {
		var _v0 = _Utils_Tuple2(int1, int2);
		switch (_v0.a.$) {
			case 0:
				if (!_v0.b.$) {
					var mag1 = _v0.a.a;
					var mag2 = _v0.b.a;
					return A4($cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2);
				} else {
					return 2;
				}
			case 1:
				if (_v0.b.$ === 1) {
					var mag1 = _v0.a.a;
					var mag2 = _v0.b.a;
					return A4($cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag2, mag1);
				} else {
					return 0;
				}
			default:
				switch (_v0.b.$) {
					case 0:
						var _v1 = _v0.a;
						return 0;
					case 2:
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return 1;
					default:
						var _v4 = _v0.a;
						return 2;
				}
		}
	});
var $cmditch$elm_bigint$BigInt$gt = F2(
	function (x, y) {
		return A2($cmditch$elm_bigint$BigInt$compare, x, y) === 2;
	});
var $author$project$Math$Positive$fromInt = A2(
	$elm$core$Basics$composeR,
	$cmditch$elm_bigint$BigInt$fromInt,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$Just,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$maybe_extra$Maybe$Extra$filter(
				function (x) {
					return A2($cmditch$elm_bigint$BigInt$gt, x, $author$project$Math$Constants$zeroBigInt);
				}),
			$elm$core$Maybe$map($elm$core$Basics$identity))));
var $author$project$Pages$Statistics$Page$numberOfDecimalPlaces = A2(
	$elm$core$Maybe$withDefault,
	$author$project$Math$Positive$one,
	$author$project$Math$Positive$fromInt(6));
var $author$project$Pages$Statistics$Handler$init = function (flags) {
	return _Utils_Tuple2(
		A3(
			$author$project$Pages$Statistics$Page$initial,
			{ff: $author$project$Language$Language$default.gO, eg: $author$project$Language$Language$default.ix, eG: $author$project$Language$Language$default.eG, bS: $author$project$Language$Language$default.bS},
			$author$project$Language$Language$default.hc,
			flags.bm),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			A4($author$project$Types$Dashboard$Analysis$fetchWith, $author$project$Pages$Statistics$Page$GotFetchDashboardAnalysisResponse, flags.bm, flags.c, $author$project$Pages$Statistics$Page$numberOfDecimalPlaces)));
};
var $author$project$Pages$Statistics$Public$Page$GotFetchDashboardAnalysisResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$LondoGQL$Query$fetchPublicDashboardAnalysis = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'fetchPublicDashboardAnalysis',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeFetchDashboardAnalysisInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Types$Dashboard$Analysis$fetchPublicWith = F4(
	function (expect, configuration, dashboardId, numberOfDecimalPlaces) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			expect,
			A2(
				$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
				configuration.k8,
				A2(
					$author$project$LondoGQL$Query$fetchPublicDashboardAnalysis,
					{
						b: {
							c: $author$project$Types$Dashboard$Id$toGraphQLInput(dashboardId),
							ae: $author$project$Math$Positive$toGraphQLInput(numberOfDecimalPlaces)
						}
					},
					$author$project$Types$Dashboard$Analysis$selection)));
	});
var $author$project$Pages$Statistics$Public$Page$initial = F3(
	function (languages, errorLanguage, configuration) {
		return A3(
			$author$project$Pages$View$Tristate$createInitial,
			configuration,
			errorLanguage,
			{kA: $elm$core$Maybe$Nothing, cp: languages});
	});
var $author$project$Pages$Statistics$Public$Handler$init = function (flags) {
	return _Utils_Tuple2(
		A3(
			$author$project$Pages$Statistics$Public$Page$initial,
			{ff: $author$project$Language$Language$default.gO, eg: $author$project$Language$Language$default.ix, eG: $author$project$Language$Language$default.eG, bS: $author$project$Language$Language$default.bS},
			$author$project$Language$Language$default.hc,
			flags.m),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			A4($author$project$Types$Dashboard$Analysis$fetchPublicWith, $author$project$Pages$Statistics$Public$Page$GotFetchDashboardAnalysisResponse, flags.m, flags.c, $author$project$Pages$Statistics$Page$numberOfDecimalPlaces)));
};
var $author$project$Pages$Tasks$Tasks$Page$subInitial = function (authorizedAccess) {
	return A2($author$project$Pages$Util$ParentEditor$Page$defaultInitial, authorizedAccess.am, $author$project$Language$Language$default.bS);
};
var $author$project$Pages$Tasks$Page$initial = function (authorizedAccess) {
	return A3(
		$author$project$Pages$View$Tristate$createInitial,
		authorizedAccess.m,
		$author$project$Language$Language$default.hc,
		{
			eg: A2($author$project$Pages$Util$Parent$Page$initialWith, authorizedAccess.am, $author$project$Language$Language$default.ix),
			jn: $author$project$Pages$Tasks$Tasks$Page$subInitial(authorizedAccess)
		});
};
var $author$project$Pages$Tasks$Page$GotFetchResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$LondoGQL$InputObject$encodeProjectIdInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'uuid',
				$elm$core$Maybe$Just(
					A2(
						$author$project$LondoGQL$Scalar$unwrapEncoder,
						function ($) {
							return $.dj;
						},
						$author$project$LondoGQL$ScalarCodecs$codecs)(input____.o)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeFetchResolvedProjectInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'projectId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeProjectIdInput(input____.f)))
			]));
};
var $author$project$LondoGQL$Query$fetchResolvedProject = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'fetchResolvedProject',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeFetchResolvedProjectInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Types$Project$Resolved$Resolved = F2(
	function (project, tasks) {
		return {eg: project, jn: tasks};
	});
var $author$project$LondoGQL$Object$ResolvedProject$project = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'project', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$ResolvedProject$tasks = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'tasks',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Types$Project$Resolved$selection = A3(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map2,
	$author$project$Types$Project$Resolved$Resolved,
	$author$project$LondoGQL$Object$ResolvedProject$project($author$project$Types$Project$Project$selection),
	$author$project$LondoGQL$Object$ResolvedProject$tasks($author$project$Types$Task$Task$selection));
var $author$project$LondoGQL$InputObject$ProjectIdInput = function (uuid) {
	return {o: uuid};
};
var $author$project$Types$Project$Id$toGraphQLInput = A2($elm$core$Basics$composeR, $author$project$Types$Project$Id$uuid, $author$project$LondoGQL$InputObject$ProjectIdInput);
var $author$project$Types$Project$Resolved$fetchWith = F3(
	function (expect, authorizedAccess, projectId) {
		return A3(
			$author$project$Util$HttpUtil$queryWith,
			expect,
			authorizedAccess,
			A2(
				$author$project$LondoGQL$Query$fetchResolvedProject,
				{
					b: {
						f: $author$project$Types$Project$Id$toGraphQLInput(projectId)
					}
				},
				$author$project$Types$Project$Resolved$selection));
	});
var $author$project$Pages$Tasks$Handler$initialFetch = $author$project$Types$Project$Resolved$fetchWith($author$project$Pages$Tasks$Page$GotFetchResponse);
var $author$project$Pages$Tasks$Handler$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Tasks$Page$initial(flags.bm),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$View$Tristate$Logic,
			A2($author$project$Pages$Tasks$Handler$initialFetch, flags.bm, flags.f)));
};
var $author$project$Main$stepThrough = F3(
	function (ps, model, _v0) {
		var subModel = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					V: ps.V(subModel)
				}),
			A2($elm$core$Platform$Cmd$map, ps.hR, cmd));
	});
var $author$project$Main$ConfirmDeletion = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$ConfirmDeletionMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Main$ConfirmRecovery = function (a) {
	return {$: 13, a: a};
};
var $author$project$Main$ConfirmRecoveryMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Main$ConfirmRegistration = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$ConfirmRegistrationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$DashboardEntries = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$DashboardEntriesMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$Dashboards = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$DashboardsMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$Login = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$LoginMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$Overview = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$OverviewMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$Projects = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$ProjectsMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$PublicStatistics = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$PublicStatisticsMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Main$RequestRecovery = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$RequestRecoveryMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Main$RequestRegistration = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$RequestRegistrationMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$Settings = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$SettingsMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Main$Statistics = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$StatisticsMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$StepParameters = F2(
	function (page, message) {
		return {hR: message, V: page};
	});
var $author$project$Main$Tasks = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$TasksMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$steps = {
	gF: A2($author$project$Main$StepParameters, $author$project$Main$ConfirmDeletion, $author$project$Main$ConfirmDeletionMsg),
	fd: A2($author$project$Main$StepParameters, $author$project$Main$ConfirmRecovery, $author$project$Main$ConfirmRecoveryMsg),
	gG: A2($author$project$Main$StepParameters, $author$project$Main$ConfirmRegistration, $author$project$Main$ConfirmRegistrationMsg),
	gP: A2($author$project$Main$StepParameters, $author$project$Main$DashboardEntries, $author$project$Main$DashboardEntriesMsg),
	gS: A2($author$project$Main$StepParameters, $author$project$Main$Dashboards, $author$project$Main$DashboardsMsg),
	bH: A2($author$project$Main$StepParameters, $author$project$Main$Login, $author$project$Main$LoginMsg),
	id: A2($author$project$Main$StepParameters, $author$project$Main$Overview, $author$project$Main$OverviewMsg),
	eh: A2($author$project$Main$StepParameters, $author$project$Main$Projects, $author$project$Main$ProjectsMsg),
	fV: A2($author$project$Main$StepParameters, $author$project$Main$PublicStatistics, $author$project$Main$PublicStatisticsMsg),
	f_: A2($author$project$Main$StepParameters, $author$project$Main$RequestRecovery, $author$project$Main$RequestRecoveryMsg),
	iO: A2($author$project$Main$StepParameters, $author$project$Main$RequestRegistration, $author$project$Main$RequestRegistrationMsg),
	i0: A2($author$project$Main$StepParameters, $author$project$Main$Settings, $author$project$Main$SettingsMsg),
	eG: A2($author$project$Main$StepParameters, $author$project$Main$Statistics, $author$project$Main$StatisticsMsg),
	jn: A2($author$project$Main$StepParameters, $author$project$Main$Tasks, $author$project$Main$TasksMsg)
};
var $author$project$Main$followRoute = function (model) {
	var authorizedAccessWith = function (jwt) {
		return {m: model.m, am: jwt};
	};
	var _v0 = model.aZ;
	if (_v0.$ === 1) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{V: $author$project$Main$NotFound}),
			$elm$core$Platform$Cmd$none);
	} else {
		var entryRoute = _v0.a;
		var _v1 = _Utils_Tuple2(entryRoute, model.am);
		_v1$14:
		while (true) {
			switch (_v1.a.$) {
				case 0:
					var _v2 = _v1.a;
					return A3(
						$author$project$Main$stepThrough,
						$author$project$Main$steps.iO,
						model,
						$author$project$Pages$Registration$Request$Handler$init(
							{m: model.m}));
				case 1:
					var _v3 = _v1.a;
					var userIdentifier = _v3.a;
					var registrationJWT = _v3.b;
					return A3(
						$author$project$Main$stepThrough,
						$author$project$Main$steps.gG,
						model,
						$author$project$Pages$Registration$Confirm$Handler$init(
							{m: model.m, mo: registrationJWT, cO: userIdentifier}));
				case 2:
					var _v4 = _v1.a;
					return A3(
						$author$project$Main$stepThrough,
						$author$project$Main$steps.bH,
						model,
						$author$project$Pages$Login$Handler$init(
							{m: model.m}));
				case 3:
					if (!_v1.b.$) {
						var _v5 = _v1.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.id,
							model,
							$author$project$Pages$Overview$Handler$init(
								{m: model.m}));
					} else {
						break _v1$14;
					}
				case 4:
					if (!_v1.b.$) {
						var _v6 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eh,
							model,
							$author$project$Pages$Projects$Handler$init(
								{
									bm: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$14;
					}
				case 5:
					if (!_v1.b.$) {
						var projectId = _v1.a.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.jn,
							model,
							$author$project$Pages$Tasks$Handler$init(
								{
									bm: authorizedAccessWith(userJWT),
									f: projectId
								}));
					} else {
						break _v1$14;
					}
				case 6:
					if (!_v1.b.$) {
						var _v7 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.gS,
							model,
							$author$project$Pages$Dashboards$Handler$init(
								{
									bm: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$14;
					}
				case 7:
					if (!_v1.b.$) {
						var dashboardId = _v1.a.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.gP,
							model,
							$author$project$Pages$DashboardEntries$Handler$init(
								{
									bm: authorizedAccessWith(userJWT),
									c: dashboardId
								}));
					} else {
						break _v1$14;
					}
				case 8:
					if (!_v1.b.$) {
						var dashboardId = _v1.a.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eG,
							model,
							$author$project$Pages$Statistics$Handler$init(
								{
									bm: authorizedAccessWith(userJWT),
									c: dashboardId
								}));
					} else {
						break _v1$14;
					}
				case 9:
					var dashboardId = _v1.a.a;
					return A3(
						$author$project$Main$stepThrough,
						$author$project$Main$steps.fV,
						model,
						$author$project$Pages$Statistics$Public$Handler$init(
							{m: model.m, c: dashboardId}));
				case 10:
					if (!_v1.b.$) {
						var _v8 = _v1.a;
						var userJWT = _v1.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.i0,
							model,
							$author$project$Pages$Settings$Handler$init(
								{
									bm: authorizedAccessWith(userJWT)
								}));
					} else {
						break _v1$14;
					}
				case 11:
					var _v9 = _v1.a;
					var userIdentifier = _v9.a;
					var deletionJWT = _v9.b;
					return A3(
						$author$project$Main$stepThrough,
						$author$project$Main$steps.gF,
						model,
						$author$project$Pages$Deletion$Handler$init(
							{m: model.m, kK: deletionJWT, cO: userIdentifier}));
				case 12:
					var _v10 = _v1.a;
					return A3(
						$author$project$Main$stepThrough,
						$author$project$Main$steps.f_,
						model,
						$author$project$Pages$Recovery$Request$Handler$init(
							{m: model.m}));
				default:
					var _v11 = _v1.a;
					var userIdentifier = _v11.a;
					var recoveryJWT = _v11.b;
					return A3(
						$author$project$Main$stepThrough,
						$author$project$Main$steps.fd,
						model,
						$author$project$Pages$Recovery$Confirm$Handler$init(
							{m: model.m, mm: recoveryJWT, cO: userIdentifier}));
			}
		}
		return A3(
			$author$project$Main$stepThrough,
			$author$project$Main$steps.bH,
			model,
			$author$project$Pages$Login$Handler$init(
				{m: model.m}));
	}
};
var $arturopala$elm_monocle$Monocle$Lens$Lens = F2(
	function (get, set) {
		return {dy: get, f$: set};
	});
var $author$project$Main$lenses = {
	aZ: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.aZ;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{aZ: b});
			})),
	am: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.am;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{am: b});
			})),
	V: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.V;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{V: b});
			}))
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.iz;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.hk,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.iA,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.io,
					_Utils_ap(http, url.hr)),
				url.ik)));
};
var $author$project$Pages$DashboardEntries$Page$DashboardMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Util$Choice$Page$GotFetchElementsResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Util$Parent$Page$GotFetchResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Util$EditState$View = function (a) {
	return {$: 0, a: a};
};
var $author$project$Util$Editing$asView = function (element) {
	return {
		O: $author$project$Util$EditState$View(false),
		ic: element
	};
};
var $author$project$Pages$Util$PaginationSettings$initial = {kz: 1, cm: 25};
var $author$project$Pages$Util$Choice$Pagination$initial = {kl: $author$project$Pages$Util$PaginationSettings$initial, g9: $author$project$Pages$Util$PaginationSettings$initial};
var $author$project$Util$DictList$DictList = $elm$core$Basics$identity;
var $author$project$Util$DictList$orderingOf = function (_v0) {
	var ps = _v0;
	return ps.aL;
};
var $author$project$Util$DictList$toList = function (_v0) {
	var kvs = _v0;
	return kvs.g9;
};
var $author$project$Util$DictList$map = F2(
	function (f, dictList) {
		return {
			g9: A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(f),
				$author$project$Util$DictList$toList(dictList)),
			aL: $author$project$Util$DictList$orderingOf(dictList)
		};
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Pages$Util$Choice$Page$initialToMain = function (i) {
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (elements, choices) {
				return {
					kl: A2($author$project$Util$DictList$map, $author$project$Util$Editing$asView, choices),
					km: '',
					g9: A2($author$project$Util$DictList$map, $author$project$Util$Editing$asView, elements),
					kX: '',
					am: i.am,
					dL: i.dL,
					$8: $author$project$Pages$Util$Choice$Pagination$initial,
					eb: i.eb
				};
			}),
		i.g9,
		i.kl);
};
var $author$project$Pages$Util$Parent$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$map,
		function (parent) {
			return {
				am: i.am,
				dL: i.dL,
				me: $author$project$Util$Editing$asView(parent)
			};
		},
		i.me);
};
var $author$project$Pages$DashboardEntries$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$andThen,
		function (dashboard) {
			return A2(
				$elm$core$Maybe$map,
				function (entries) {
					return {ff: dashboard, fk: entries};
				},
				$author$project$Pages$Util$Choice$Page$initialToMain(i.fk));
		},
		$author$project$Pages$Util$Parent$Page$initialToMain(i.ff));
};
var $author$project$Pages$DashboardEntries$Page$lenses = {
	hx: {
		ff: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ff;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ff: b});
				})),
		fk: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.fk;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{fk: b});
				}))
	},
	hM: {
		ff: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ff;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ff: b});
				})),
		fk: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.fk;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{fk: b});
				}))
	}
};
var $author$project$Pages$View$Tristate$Error = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$View$Tristate$fold = F2(
	function (fs, t) {
		var _v0 = t.as;
		switch (_v0.$) {
			case 0:
				var initial = _v0.a;
				return fs.bM(initial);
			case 1:
				var main = _v0.a;
				return fs.bN(main);
			default:
				var errorState = _v0.a;
				return fs.bL(errorState);
		}
	});
var $author$project$Util$HttpUtil$errorToExplanation = function (error) {
	switch (error.$) {
		case 0:
			var string = error.a;
			return {kf: 'BadUrl: ' + string, ir: 'Check address. If the error persists, please contact an administrator.', a9: false, mX: true};
		case 1:
			return {kf: 'Timeout', ir: 'Try again later. If the error persists, please contact an administrator.', a9: false, mX: true};
		case 2:
			return {kf: 'Timeout', ir: 'Try again later. If the error persists, please contact an administrator.', a9: false, mX: true};
		case 3:
			var metadata = error.a;
			var message = error.b;
			return {
				kf: 'BadStatus: ' + ($elm$core$String$fromInt(metadata.f3) + (' - ' + message)),
				ir: (metadata.f3 === 401) ? 'Please log in again to continue.' : '',
				a9: metadata.f3 === 401,
				mX: true
			};
		default:
			var jsonError = error.a;
			return {
				kf: 'Bad payload: ' + $elm$json$Json$Decode$errorToString(jsonError),
				ir: '',
				a9: false,
				mX: true
			};
	}
};
var $author$project$Util$HttpUtil$graphQLErrorToExplanation = function (error) {
	if (!error.$) {
		var graphqlErrors = error.b;
		return {
			kf: 'Invalid data: ' + A2(
				$elm$core$String$join,
				',',
				A2(
					$elm$core$List$map,
					function ($) {
						return $.hR;
					},
					graphqlErrors)),
			ir: '',
			a9: false,
			mX: true
		};
	} else {
		var httpError = error.a;
		return $author$project$Util$HttpUtil$errorToExplanation(httpError);
	}
};
var $author$project$Pages$View$Tristate$toError = F2(
	function (model, error) {
		var errorExplanation = $author$project$Util$HttpUtil$graphQLErrorToExplanation(error);
		return A2(
			$author$project$Pages$View$Tristate$fold,
			{
				bL: function (errorState) {
					return A3(
						$author$project$Pages$View$Tristate$Model,
						model.m,
						model.z,
						$author$project$Pages$View$Tristate$Error(
							_Utils_update(
								errorState,
								{_: errorExplanation})));
				},
				bM: function (_v0) {
					return A3(
						$author$project$Pages$View$Tristate$Model,
						model.m,
						model.z,
						$author$project$Pages$View$Tristate$Error(
							{_: errorExplanation, ef: $elm$core$Maybe$Nothing}));
				},
				bN: function (main) {
					return A3(
						$author$project$Pages$View$Tristate$Model,
						model.m,
						model.z,
						$author$project$Pages$View$Tristate$Error(
							{
								_: errorExplanation,
								ef: $elm$core$Maybe$Just(main)
							}));
				}
			},
			model);
	});
var $elm_community$result_extra$Result$Extra$unpack = F3(
	function (errFunc, okFunc, result) {
		if (!result.$) {
			var ok = result.a;
			return okFunc(ok);
		} else {
			var err = result.a;
			return errFunc(err);
		}
	});
var $author$project$Pages$View$Tristate$asInitial = function (t) {
	var _v0 = t.as;
	if (!_v0.$) {
		var initial = _v0.a;
		return $elm$core$Maybe$Just(initial);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$View$Tristate$fromInitToMain = F2(
	function (_with, t) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			t,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$View$Tristate$Main,
				A2($author$project$Pages$View$Tristate$Model, t.m, t.z)),
			A2(
				$elm$core$Maybe$andThen,
				_with,
				$author$project$Pages$View$Tristate$asInitial(t)));
	});
var $arturopala$elm_monocle$Monocle$Optional$Optional = F2(
	function (getOption, set) {
		return {hn: getOption, f$: set};
	});
var $author$project$Pages$View$Tristate$asError = function (t) {
	var _v0 = t.as;
	if (_v0.$ === 2) {
		var errorState = _v0.a;
		return $elm$core$Maybe$Just(errorState._);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$View$Tristate$asMain = function (t) {
	var _v0 = t.as;
	if (_v0.$ === 1) {
		var main = _v0.a;
		return $elm$core$Maybe$Just(main);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$View$Tristate$lenses = {
	hb: A2(
		$arturopala$elm_monocle$Monocle$Optional$Optional,
		$author$project$Pages$View$Tristate$asError,
		F2(
			function (b, a) {
				var _v0 = a.as;
				if (_v0.$ === 2) {
					var errorState = _v0.a;
					return A3(
						$author$project$Pages$View$Tristate$Model,
						a.m,
						a.z,
						$author$project$Pages$View$Tristate$Error(
							_Utils_update(
								errorState,
								{_: b})));
				} else {
					return a;
				}
			})),
	hx: A2(
		$arturopala$elm_monocle$Monocle$Optional$Optional,
		$author$project$Pages$View$Tristate$asInitial,
		F2(
			function (b, a) {
				var _v1 = a.as;
				if (!_v1.$) {
					return A3(
						$author$project$Pages$View$Tristate$Model,
						a.m,
						a.z,
						$author$project$Pages$View$Tristate$Initial(b));
				} else {
					return a;
				}
			})),
	hM: A2(
		$arturopala$elm_monocle$Monocle$Optional$Optional,
		$author$project$Pages$View$Tristate$asMain,
		F2(
			function (b, a) {
				var _v2 = a.as;
				if (_v2.$ === 1) {
					return A3(
						$author$project$Pages$View$Tristate$Model,
						a.m,
						a.z,
						$author$project$Pages$View$Tristate$Main(b));
				} else {
					return a;
				}
			}))
};
var $author$project$Pages$View$TristateUtil$subModelWith = F2(
	function (ps, model) {
		return {
			m: model.m,
			z: model.z,
			as: A2(
				$author$project$Pages$View$Tristate$fold,
				{
					bL: function (es) {
						return $author$project$Pages$View$Tristate$Error(
							{
								_: es._,
								ef: A2($elm$core$Maybe$map, ps.f5, es.ef)
							});
					},
					bM: A2($elm$core$Basics$composeR, ps.je, $author$project$Pages$View$Tristate$Initial),
					bN: A2($elm$core$Basics$composeR, ps.f5, $author$project$Pages$View$Tristate$Main)
				},
				model)
		};
	});
var $author$project$Pages$View$TristateUtil$updateFromSubModel = F3(
	function (ps, msg, model) {
		var _v0 = A2(
			ps.jI,
			msg,
			A2(
				$author$project$Pages$View$TristateUtil$subModelWith,
				{je: ps.hz.dy, f5: ps.hN.dy},
				model));
		var subModel = _v0.a;
		var subCmd = _v0.b;
		var newCmd = A2($elm$core$Platform$Cmd$map, ps.js, subCmd);
		var newModel = function () {
			var _v1 = _Utils_Tuple2(model.as, subModel.as);
			_v1$3:
			while (true) {
				switch (_v1.b.$) {
					case 0:
						if (!_v1.a.$) {
							var i = _v1.a.a;
							var subInitial = _v1.b.a;
							return A2(
								$author$project$Pages$View$Tristate$fromInitToMain,
								ps.hl,
								A3(
									$author$project$Pages$View$Tristate$createInitial,
									model.m,
									model.z,
									A2(ps.hz.f$, subInitial, i)));
						} else {
							break _v1$3;
						}
					case 1:
						if (_v1.a.$ === 1) {
							var m = _v1.a.a;
							var subMain = _v1.b.a;
							return A3(
								$author$project$Pages$View$Tristate$createMain,
								model.m,
								model.z,
								A2(ps.hN.f$, subMain, m));
						} else {
							break _v1$3;
						}
					default:
						var subError = _v1.b.a;
						return {
							m: model.m,
							z: model.z,
							as: $author$project$Pages$View$Tristate$Error(
								{
									_: subError._,
									ef: $author$project$Pages$View$Tristate$lenses.hM.hn(model)
								})
						};
				}
			}
			return model;
		}();
		return _Utils_Tuple2(newModel, newCmd);
	});
var $author$project$Pages$Util$Parent$Page$GotDeleteResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Util$Parent$Page$GotSaveEditResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$LondoGQL$InputObject$encodeDeleteDashboardInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dashboardId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeDashboardIdInput(input____.c)))
			]));
};
var $author$project$LondoGQL$Mutation$deleteDashboard = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'deleteDashboard',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeDeleteDashboardInput)
			]),
		$elm$json$Json$Decode$bool);
};
var $dillonkearns$elm_graphql$Graphql$Http$Mutation = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$mutationRequest = F2(
	function (baseUrl, mutationSelectionSet) {
		return {
			b3: baseUrl,
			ds: $dillonkearns$elm_graphql$Graphql$Http$Mutation(mutationSelectionSet),
			k2: $dillonkearns$elm_graphql$Graphql$Document$decoder(mutationSelectionSet),
			D: _List_Nil,
			a4: $elm$core$Maybe$Nothing,
			a7: _List_Nil,
			K: $elm$core$Maybe$Nothing,
			bh: false
		};
	});
var $author$project$Util$HttpUtil$mutationWith = F2(
	function (expect, authorizedAccess) {
		return A2(
			$elm$core$Basics$composeR,
			$dillonkearns$elm_graphql$Graphql$Http$mutationRequest(authorizedAccess.m.k8),
			$author$project$Util$HttpUtil$sendWithJWT(
				{k2: expect, am: authorizedAccess.am}));
	});
var $author$project$Types$Dashboard$Dashboard$deleteWith = F3(
	function (expect, authorizedAccess, dashboardId) {
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect(dashboardId),
			authorizedAccess,
			$author$project$LondoGQL$Mutation$deleteDashboard(
				{
					b: {
						c: $author$project$Types$Dashboard$Id$toGraphQLInput(dashboardId)
					}
				}));
	});
var $author$project$Util$ValidatedInput$lenses = {
	jp: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.jp;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{jp: b});
			})),
	nc: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.nc;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{nc: b});
			}))
};
var $author$project$Types$Dashboard$Update$from = function (dashboard) {
	return {
		dq: dashboard.dq,
		bA: A2(
			$author$project$Util$ValidatedInput$lenses.jp.f$,
			dashboard.bA,
			A2($author$project$Util$ValidatedInput$lenses.nc.f$, dashboard.bA, $author$project$Util$ValidatedInput$nonEmptyString)),
		jN: dashboard.jN
	};
};
var $arturopala$elm_monocle$Monocle$Lens$modify = F2(
	function (lens, f) {
		var mf = function (a) {
			return function (b) {
				return A2(lens.f$, b, a);
			}(
				f(
					lens.dy(a)));
		};
		return mf;
	});
var $arturopala$elm_monocle$Monocle$Compose$lensWithOptional = F2(
	function (inner, outer) {
		var set = function (c) {
			return A2(
				$arturopala$elm_monocle$Monocle$Lens$modify,
				outer,
				inner.f$(c));
		};
		var getOption = A2($elm$core$Basics$composeR, outer.dy, inner.hn);
		return A2($arturopala$elm_monocle$Monocle$Optional$Optional, getOption, set);
	});
var $author$project$Util$EditState$setToggle = F2(
	function (value, editState) {
		if (!editState.$) {
			return $author$project$Util$EditState$View(value);
		} else {
			var e = editState;
			return e;
		}
	});
var $author$project$Util$EditState$Update = function (a) {
	return {$: 1, a: a};
};
var $author$project$Util$EditState$setUpdate = F2(
	function (update, editState) {
		if (editState.$ === 1) {
			return $author$project$Util$EditState$Update(update);
		} else {
			var e = editState;
			return e;
		}
	});
var $author$project$Util$EditState$toToggle = function (editState) {
	if (!editState.$) {
		var toggle = editState.a;
		return $elm$core$Maybe$Just(toggle);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Util$EditState$toUpdate = function (editState) {
	if (editState.$ === 1) {
		var update = editState.a;
		return $elm$core$Maybe$Just(update);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Util$EditState$lenses = {
	jt: A2($arturopala$elm_monocle$Monocle$Optional$Optional, $author$project$Util$EditState$toToggle, $author$project$Util$EditState$setToggle),
	m5: A2($arturopala$elm_monocle$Monocle$Optional$Optional, $author$project$Util$EditState$toUpdate, $author$project$Util$EditState$setUpdate)
};
var $author$project$Util$Editing$lenses = function () {
	var editState = A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.O;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{O: b});
			}));
	return {
		O: editState,
		ic: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ic;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ic: b});
				})),
		m5: A2($arturopala$elm_monocle$Monocle$Compose$lensWithOptional, $author$project$Util$EditState$lenses.m5, editState)
	};
}();
var $author$project$Util$Editing$extractUpdate = A2($arturopala$elm_monocle$Monocle$Compose$lensWithOptional, $author$project$Util$EditState$lenses.m5, $author$project$Util$Editing$lenses.O).hn;
var $author$project$Pages$View$Tristate$foldMain = F2(
	function (c, f) {
		return $author$project$Pages$View$Tristate$fold(
			{
				bL: $elm$core$Basics$always(c),
				bM: $elm$core$Basics$always(c),
				bN: f
			});
	});
var $author$project$Pages$Util$Parent$Page$lenses = {
	hx: {
		me: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.me;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{me: b});
				}))
	},
	hM: {
		me: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.me;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{me: b});
				}))
	}
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Pages$Util$Links$frontendPage = function (pathSteps) {
	return A2($elm$url$Url$Builder$absolute, pathSteps, _List_Nil);
};
var $author$project$Pages$Util$Links$loadFrontendPage = A2($elm$core$Basics$composeR, $author$project$Pages$Util$Links$frontendPage, $elm$browser$Browser$Navigation$load);
var $author$project$Pages$View$Tristate$mapInitial = F2(
	function (f, t) {
		return A2(
			$author$project$Pages$View$Tristate$fold,
			{
				bL: $elm$core$Basics$always(t),
				bM: A2(
					$elm$core$Basics$composeR,
					f,
					A2($author$project$Pages$View$Tristate$createInitial, t.m, t.z)),
				bN: $elm$core$Basics$always(t)
			},
			t);
	});
var $author$project$Pages$View$Tristate$mapMain = F2(
	function (f, t) {
		return A2(
			$author$project$Pages$View$Tristate$fold,
			{
				bL: $elm$core$Basics$always(t),
				bM: $elm$core$Basics$always(t),
				bN: A2(
					$elm$core$Basics$composeR,
					f,
					A2($author$project$Pages$View$Tristate$createMain, t.m, t.z))
			},
			t);
	});
var $author$project$Util$EditState$Delete = {$: 2};
var $author$project$Util$Editing$toDelete = $author$project$Util$Editing$lenses.O.f$($author$project$Util$EditState$Delete);
var $author$project$Util$Editing$toUpdate = F2(
	function (to, editing) {
		return A2(
			$author$project$Util$Editing$lenses.O.f$,
			$author$project$Util$EditState$Update(
				to(editing.ic)),
			editing);
	});
var $author$project$Util$Editing$toView = $author$project$Util$Editing$lenses.O.f$(
	$author$project$Util$EditState$View(false));
var $author$project$Util$EditState$unpack = F2(
	function (fs, editState) {
		switch (editState.$) {
			case 0:
				var showControls = editState.a;
				return fs.l4(showControls);
			case 1:
				var update = editState.a;
				return fs.l1(update);
			default:
				return fs.l0;
		}
	});
var $author$project$Util$Editing$toggleControls = function (editing) {
	return A3(
		$arturopala$elm_monocle$Monocle$Lens$modify,
		$author$project$Util$Editing$lenses.O,
		$author$project$Util$EditState$unpack(
			{
				l0: $author$project$Util$EditState$View(false),
				l1: function (_v0) {
					return $author$project$Util$EditState$View(false);
				},
				l4: A2($elm$core$Basics$composeR, $elm$core$Basics$not, $author$project$Util$EditState$View)
			}),
		editing);
};
var $author$project$Pages$Util$Parent$Handler$updateLogic = F3(
	function (ps, msg, model) {
		var toggleControls = _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2($arturopala$elm_monocle$Monocle$Lens$modify, $author$project$Pages$Util$Parent$Page$lenses.hM.me, $author$project$Util$Editing$toggleControls),
				model),
			$elm$core$Platform$Cmd$none);
		var saveEdit = _Utils_Tuple2(
			model,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$andThen,
					function (main) {
						return function (editing) {
							return A2(
								$elm$core$Maybe$andThen,
								A2(
									ps.aO,
									{m: model.m, am: main.am},
									ps.lg(editing.ic)),
								$author$project$Util$Editing$extractUpdate(editing));
						}(
							$author$project$Pages$Util$Parent$Page$lenses.hM.me.dy(main));
					},
					$author$project$Pages$View$Tristate$lenses.hM.hn(model))));
		var requestDelete = _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2($arturopala$elm_monocle$Monocle$Lens$modify, $author$project$Pages$Util$Parent$Page$lenses.hM.me, $author$project$Util$Editing$toDelete),
				model),
			$elm$core$Platform$Cmd$none);
		var gotSaveEditResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (parent) {
						return A2(
							$author$project$Pages$View$Tristate$mapMain,
							$author$project$Pages$Util$Parent$Page$lenses.hM.me.f$(
								$author$project$Util$Editing$asView(parent)),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotFetchResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (parent) {
						return A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Util$Parent$Page$lenses.hx.me.f$(
								$elm$core$Maybe$Just(parent)),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotDeleteResponse = function (result) {
			return A3(
				$elm_community$result_extra$Result$Extra$unpack,
				function (error) {
					return _Utils_Tuple2(
						A2($author$project$Pages$View$Tristate$toError, model, error),
						$elm$core$Platform$Cmd$none);
				},
				function (_v1) {
					return _Utils_Tuple2(
						model,
						$author$project$Pages$Util$Links$loadFrontendPage(
							ps.lP(0)));
				},
				result);
		};
		var exitEdit = _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2($arturopala$elm_monocle$Monocle$Lens$modify, $author$project$Pages$Util$Parent$Page$lenses.hM.me, $author$project$Util$Editing$toView),
				model),
			$elm$core$Platform$Cmd$none);
		var enterEdit = _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2(
					$arturopala$elm_monocle$Monocle$Lens$modify,
					$author$project$Pages$Util$Parent$Page$lenses.hM.me,
					$author$project$Util$Editing$toUpdate(ps.m3)),
				model),
			$elm$core$Platform$Cmd$none);
		var edit = function (update) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A2($arturopala$elm_monocle$Monocle$Compose$lensWithOptional, $author$project$Util$Editing$lenses.m5, $author$project$Pages$Util$Parent$Page$lenses.hM.me).f$(update),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var confirmDelete = _Utils_Tuple2(
			model,
			A3(
				$author$project$Pages$View$Tristate$foldMain,
				$elm$core$Platform$Cmd$none,
				function (main) {
					return A2(
						ps.Z,
						{m: model.m, am: main.am},
						ps.lg(main.me.ic));
				},
				model));
		var cancelDelete = _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				A2($arturopala$elm_monocle$Monocle$Lens$modify, $author$project$Pages$Util$Parent$Page$lenses.hM.me, $author$project$Util$Editing$toView),
				model),
			$elm$core$Platform$Cmd$none);
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return gotFetchResponse(result);
			case 1:
				var update = msg.a;
				return edit(update);
			case 2:
				return saveEdit;
			case 3:
				var result = msg.a;
				return gotSaveEditResponse(result);
			case 4:
				return enterEdit;
			case 5:
				return exitEdit;
			case 6:
				return requestDelete;
			case 7:
				return confirmDelete;
			case 8:
				return cancelDelete;
			case 9:
				var result = msg.a;
				return gotDeleteResponse(result);
			default:
				return toggleControls;
		}
	});
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent = {$: 1};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe = function (maybeValue) {
	if (!maybeValue.$) {
		var value = maybeValue.a;
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(value);
	} else {
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
	}
};
var $author$project$Types$Dashboard$Update$toGraphQLInput = F2(
	function (dashboardId, input) {
		return {
			c: $author$project$Types$Dashboard$Id$toGraphQLInput(dashboardId),
			cb: {
				dq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(input.dq),
				bA: input.bA.nc,
				jN: input.jN
			}
		};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum = F2(
	function (enumToString, value) {
		return $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue(
			enumToString(value));
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$null = $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$null);
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$optional = F2(
	function (optionalValue, toValue) {
		switch (optionalValue.$) {
			case 0:
				var value = optionalValue.a;
				return $elm$core$Maybe$Just(
					toValue(value));
			case 1:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$null);
		}
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$string = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$string(value));
};
var $author$project$LondoGQL$Enum$Visibility$toString = function (enum____) {
	if (!enum____) {
		return 'Private';
	} else {
		return 'Public';
	}
};
var $author$project$LondoGQL$InputObject$encodeDashboardUpdate = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'header',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.bA))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dq, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'visibility',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$LondoGQL$Enum$Visibility$toString, input____.jN)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeUpdateDashboardInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dashboardId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeDashboardIdInput(input____.c))),
				_Utils_Tuple2(
				'dashboardUpdate',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeDashboardUpdate(input____.cb)))
			]));
};
var $author$project$LondoGQL$Mutation$updateDashboard = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'updateDashboard',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeUpdateDashboardInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Types$Dashboard$Update$updateWith = F4(
	function (expect, authorizedAccess, dashboardId, update) {
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect,
			authorizedAccess,
			A2(
				$author$project$LondoGQL$Mutation$updateDashboard,
				{
					b: A2($author$project$Types$Dashboard$Update$toGraphQLInput, dashboardId, update)
				},
				$author$project$Types$Dashboard$Dashboard$selection));
	});
var $author$project$Pages$DashboardEntries$Dashboard$Handler$updateLogic = $author$project$Pages$Util$Parent$Handler$updateLogic(
	{
		Z: $author$project$Types$Dashboard$Dashboard$deleteWith(
			function (_v0) {
				return $author$project$Pages$Util$Parent$Page$GotDeleteResponse;
			}),
		lg: function ($) {
			return $.lf;
		},
		lP: $author$project$Addresses$Frontend$dashboards.gh,
		aO: F2(
			function (authorizedAccess, dashboardId) {
				return A2(
					$elm$core$Basics$composeR,
					A3($author$project$Types$Dashboard$Update$updateWith, $author$project$Pages$Util$Parent$Page$GotSaveEditResponse, authorizedAccess, dashboardId),
					$elm$core$Maybe$Just);
			}),
		m3: $author$project$Types$Dashboard$Update$from
	});
var $author$project$Pages$Util$Choice$Page$GotCreateResponse = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Util$Choice$Page$GotDeleteResponse = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Types$DashboardEntry$Id$Id = $elm$core$Basics$identity;
var $author$project$LondoGQL$InputObject$encodeDashboardEntryCreation = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'projectId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeProjectIdInput(input____.f)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeCreateDashboardEntryInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dashboardId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeDashboardIdInput(input____.c))),
				_Utils_Tuple2(
				'dashboardEntryCreation',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeDashboardEntryCreation(input____.ca)))
			]));
};
var $author$project$LondoGQL$Mutation$createDashboardEntry = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'createDashboardEntry',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeCreateDashboardEntryInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Types$DashboardEntry$Creation$toGraphQLInput = function (clientInput) {
	return {
		f: $author$project$Types$Project$Id$toGraphQLInput(clientInput.f)
	};
};
var $author$project$Types$DashboardEntry$Creation$createWith = F3(
	function (expect, authorizedAccess, creation) {
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect,
			authorizedAccess,
			A2(
				$author$project$LondoGQL$Mutation$createDashboardEntry,
				{
					b: {
						ca: $author$project$Types$DashboardEntry$Creation$toGraphQLInput(creation),
						c: $author$project$Types$Dashboard$Id$toGraphQLInput(creation.c)
					}
				},
				$author$project$Types$DashboardEntry$Entry$selection));
	});
var $author$project$Types$DashboardEntry$Creation$ClientInput = F2(
	function (dashboardId, projectId) {
		return {c: dashboardId, f: projectId};
	});
var $author$project$Types$DashboardEntry$Creation$default = $author$project$Types$DashboardEntry$Creation$ClientInput;
var $author$project$LondoGQL$InputObject$encodeDeleteDashboardEntryInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dashboardId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeDashboardIdInput(input____.c))),
				_Utils_Tuple2(
				'projectId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeProjectIdInput(input____.f)))
			]));
};
var $author$project$LondoGQL$Mutation$deleteDashboardEntry = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'deleteDashboardEntry',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeDeleteDashboardEntryInput)
			]),
		$elm$json$Json$Decode$bool);
};
var $author$project$Types$DashboardEntry$Id$unwrap = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Types$DashboardEntry$Entry$deleteWith = F3(
	function (expect, authorizedAccess, dashboardEntryId) {
		var unwrapped = $author$project$Types$DashboardEntry$Id$unwrap(dashboardEntryId);
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect(dashboardEntryId),
			authorizedAccess,
			$author$project$LondoGQL$Mutation$deleteDashboardEntry(
				{
					b: {
						c: $author$project$Types$Dashboard$Id$toGraphQLInput(unwrapped.c),
						f: $author$project$Types$Project$Id$toGraphQLInput(unwrapped.f)
					}
				}));
	});
var $author$project$Util$GraphQLUtil$uuidToString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Util$Ordering$with = F3(
	function (f, x, y) {
		return A2(
			$elm$core$Basics$compare,
			f(x),
			f(y));
	});
var $author$project$Types$Project$Id$ordering = $author$project$Util$Ordering$with(
	A2($elm$core$Basics$composeR, $author$project$Types$Project$Id$uuid, $author$project$Util$GraphQLUtil$uuidToString));
var $author$project$Util$Editing$asViewWithElement = function (element) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Util$Editing$lenses.ic.f$(element),
		A2(
			$arturopala$elm_monocle$Monocle$Lens$modify,
			$author$project$Util$Editing$lenses.O,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Util$EditState$unpack(
					{
						l0: true,
						l1: $elm$core$Basics$always(true),
						l4: $elm$core$Basics$identity
					}),
				$author$project$Util$EditState$View)));
};
var $author$project$Util$DictList$lenses = {
	g9: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		$author$project$Util$DictList$toList,
		F2(
			function (elements, _v0) {
				var ps = _v0;
				return {g9: elements, aL: ps.aL};
			}))
};
var $author$project$Util$DictList$remove = F2(
	function (key, dictList) {
		var ordering = $author$project$Util$DictList$orderingOf(dictList);
		var removeOrdered = function (list) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var _v1 = list.a;
				var k = _v1.a;
				var v = _v1.b;
				var rest = list.b;
				var _v2 = A2(ordering, key, k);
				switch (_v2) {
					case 0:
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(k, v),
							rest);
					case 1:
						return rest;
					default:
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(k, v),
							removeOrdered(rest));
				}
			}
		};
		return A3($arturopala$elm_monocle$Monocle$Lens$modify, $author$project$Util$DictList$lenses.g9, removeOrdered, dictList);
	});
var $author$project$Util$LensUtil$deleteAtId = F2(
	function (id, lens) {
		return A2(
			$arturopala$elm_monocle$Monocle$Lens$modify,
			lens,
			$author$project$Util$DictList$remove(id));
	});
var $author$project$Util$DictList$get = F2(
	function (key, _v0) {
		var ordering = _v0.aL;
		var elements = _v0.g9;
		var getOrdered = function (list) {
			getOrdered:
			while (true) {
				if (!list.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v2 = list.a;
					var k = _v2.a;
					var v = _v2.b;
					var rest = list.b;
					var _v3 = A2(ordering, key, k);
					switch (_v3) {
						case 0:
							return $elm$core$Maybe$Nothing;
						case 1:
							return $elm$core$Maybe$Just(v);
						default:
							var $temp$list = rest;
							list = $temp$list;
							continue getOrdered;
					}
				}
			}
		};
		return getOrdered(elements);
	});
var $author$project$Util$DictList$insert = F3(
	function (key, value, dictList) {
		var ordering = $author$project$Util$DictList$orderingOf(dictList);
		var insertOrdered = function (list) {
			if (!list.b) {
				return _List_fromArray(
					[
						_Utils_Tuple2(key, value)
					]);
			} else {
				var _v1 = list.a;
				var k = _v1.a;
				var v = _v1.b;
				var rest = list.b;
				var _v2 = A2(ordering, key, k);
				switch (_v2) {
					case 0:
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(key, value),
							list);
					case 1:
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(key, value),
							rest);
					default:
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(k, v),
							insertOrdered(rest));
				}
			}
		};
		return A3($arturopala$elm_monocle$Monocle$Lens$modify, $author$project$Util$DictList$lenses.g9, insertOrdered, dictList);
	});
var $author$project$Util$LensUtil$dictByKey = function (k) {
	return {
		hn: $author$project$Util$DictList$get(k),
		f$: $author$project$Util$DictList$insert(k)
	};
};
var $elm$core$List$sortWith = _List_sortWith;
var $elm_community$list_extra$List$Extra$stableSortWith = F2(
	function (pred, list) {
		var predWithIndex = F2(
			function (_v1, _v2) {
				var a1 = _v1.a;
				var i1 = _v1.b;
				var a2 = _v2.a;
				var i2 = _v2.b;
				var result = A2(pred, a1, a2);
				if (result === 1) {
					return A2($elm$core$Basics$compare, i1, i2);
				} else {
					return result;
				}
			});
		var listWithIndex = A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, a) {
					return _Utils_Tuple2(a, i);
				}),
			list);
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2($elm$core$List$sortWith, predWithIndex, listWithIndex));
	});
var $author$project$Util$DictList$fromList = F2(
	function (ordering, list) {
		return {
			g9: A2(
				$elm_community$list_extra$List$Extra$stableSortWith,
				F2(
					function (_v0, _v1) {
						var k1 = _v0.a;
						var k2 = _v1.a;
						return A2(ordering, k1, k2);
					}),
				list),
			aL: ordering
		};
	});
var $author$project$Util$DictList$fromListWithKey = F2(
	function (ordering, keyOf) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				function (v) {
					return _Utils_Tuple2(
						keyOf(v),
						v);
				}),
			$author$project$Util$DictList$fromList(ordering));
	});
var $author$project$Util$LensUtil$insertAtId = F2(
	function (id, lens) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Util$DictList$insert(id),
			$arturopala$elm_monocle$Monocle$Lens$modify(lens));
	});
var $arturopala$elm_monocle$Monocle$Lens$compose = F2(
	function (outer, inner) {
		var set = F2(
			function (c, a) {
				return function (b) {
					return A2(outer.f$, b, a);
				}(
					A2(
						inner.f$,
						c,
						outer.dy(a)));
			});
		return A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			A2($elm$core$Basics$composeR, outer.dy, inner.dy),
			set);
	});
var $arturopala$elm_monocle$Monocle$Compose$lensWithLens = F2(
	function (inner, outer) {
		return A2($arturopala$elm_monocle$Monocle$Lens$compose, outer, inner);
	});
var $author$project$Pages$Util$Choice$Page$lenses = {
	hx: {
		kl: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.kl;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{kl: b});
				})),
		g9: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.g9;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{g9: b});
				}))
	},
	hM: {
		kl: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.kl;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{kl: b});
				})),
		km: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.km;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{km: b});
				})),
		g9: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.g9;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{g9: b});
				})),
		kX: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.kX;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{kX: b});
				})),
		$8: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.$8;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{$8: b});
				}))
	}
};
var $author$project$Pages$Util$Choice$Pagination$lenses = {
	kl: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.kl;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{kl: b});
			})),
	g9: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.g9;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{g9: b});
			}))
};
var $arturopala$elm_monocle$Monocle$Optional$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var $arturopala$elm_monocle$Monocle$Optional$modifyOption = F2(
	function (opt, fx) {
		var mf = function (a) {
			return A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					fx,
					A2($arturopala$elm_monocle$Monocle$Optional$flip, opt.f$, a)),
				opt.hn(a));
		};
		return mf;
	});
var $arturopala$elm_monocle$Monocle$Optional$modify = F2(
	function (opt, fx) {
		var mf = function (a) {
			return A2(
				$elm$core$Maybe$withDefault,
				a,
				A3($arturopala$elm_monocle$Monocle$Optional$modifyOption, opt, fx, a));
		};
		return mf;
	});
var $author$project$Util$LensUtil$updateById = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$arturopala$elm_monocle$Monocle$Compose$lensWithOptional(
			$author$project$Util$LensUtil$dictByKey(id)),
		$arturopala$elm_monocle$Monocle$Optional$modify);
};
var $author$project$Pages$Util$Choice$Handler$mapElementStateById = function (elementId) {
	return A2(
		$elm$core$Basics$composeR,
		A2($author$project$Util$LensUtil$updateById, elementId, $author$project$Pages$Util$Choice$Page$lenses.hM.g9),
		$author$project$Pages$View$Tristate$mapMain);
};
var $arturopala$elm_monocle$Monocle$Optional$compose = F2(
	function (outer, inner) {
		var set = F2(
			function (c, a) {
				return A2(
					$elm$core$Maybe$withDefault,
					a,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							inner.f$(c),
							A2($arturopala$elm_monocle$Monocle$Optional$flip, outer.f$, a)),
						outer.hn(a)));
			});
		var getOption = function (a) {
			var _v0 = outer.hn(a);
			if (!_v0.$) {
				var x = _v0.a;
				return inner.hn(x);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		return A2($arturopala$elm_monocle$Monocle$Optional$Optional, getOption, set);
	});
var $arturopala$elm_monocle$Monocle$Compose$optionalWithOptional = F2(
	function (inner, outer) {
		return A2($arturopala$elm_monocle$Monocle$Optional$compose, outer, inner);
	});
var $author$project$Pages$Util$PaginationSettings$lenses = {
	kz: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.kz;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{kz: b});
			})),
	cm: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.cm;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{cm: b});
			}))
};
var $author$project$Pages$Util$PaginationSettings$setSearchStringAndReset = F2(
	function (ls, searchString) {
		return A2(
			$elm$core$Basics$composeR,
			ls.mF.f$(searchString),
			A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$PaginationSettings$lenses.kz, ls.mb).f$(1));
	});
var $author$project$Pages$Util$Choice$Handler$updateLogic = F3(
	function (ps, msg, model) {
		var updateCreation = function (elementCreationClientInput) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A3(
						$author$project$Util$LensUtil$updateById,
						ps.ki(elementCreationClientInput),
						$author$project$Pages$Util$Choice$Page$lenses.hM.kl,
						$author$project$Util$Editing$lenses.m5.f$(elementCreationClientInput)),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var toggleControls = function (elementId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$Choice$Handler$mapElementStateById, elementId, $author$project$Util$Editing$toggleControls, model),
				$elm$core$Platform$Cmd$none);
		};
		var toggleChoiceControls = function (choiceId) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A3($author$project$Util$LensUtil$updateById, choiceId, $author$project$Pages$Util$Choice$Page$lenses.hM.kl, $author$project$Util$Editing$toggleControls),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var setPagination = function (pagination) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					$author$project$Pages$Util$Choice$Page$lenses.hM.$8.f$(pagination),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var setElementsSearchString = function (string) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A2(
						$author$project$Pages$Util$PaginationSettings$setSearchStringAndReset,
						{
							mb: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$Choice$Pagination$lenses.g9, $author$project$Pages$Util$Choice$Page$lenses.hM.$8),
							mF: $author$project$Pages$Util$Choice$Page$lenses.hM.kX
						},
						string),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var setChoicesSearchString = function (string) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A2(
						$author$project$Pages$Util$PaginationSettings$setSearchStringAndReset,
						{
							mb: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$Choice$Pagination$lenses.kl, $author$project$Pages$Util$Choice$Page$lenses.hM.$8),
							mF: $author$project$Pages$Util$Choice$Page$lenses.hM.km
						},
						string),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var selectChoice = function (choice) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					function (main) {
						return A4(
							$author$project$Util$LensUtil$updateById,
							ps.lh(choice),
							$author$project$Pages$Util$Choice$Page$lenses.hM.kl,
							$author$project$Util$Editing$toUpdate(
								A2($elm_community$basics_extra$Basics$Extra$flip, ps.m0, main.eb)),
							main);
					},
					model),
				$elm$core$Platform$Cmd$none);
		};
		var saveEdit = function (elementUpdateClientInput) {
			return _Utils_Tuple2(
				model,
				A3(
					$author$project$Pages$View$Tristate$foldMain,
					$elm$core$Platform$Cmd$none,
					function (main) {
						return A3(
							ps.my,
							{m: model.m, am: main.am},
							main.eb,
							elementUpdateClientInput);
					},
					model));
		};
		var requestDelete = function (elementId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$Choice$Handler$mapElementStateById, elementId, $author$project$Util$Editing$toDelete, model),
				$elm$core$Platform$Cmd$none);
		};
		var gotSaveEditResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (element) {
						return A3(
							$author$project$Pages$Util$Choice$Handler$mapElementStateById,
							ps.li(element),
							$author$project$Util$Editing$asViewWithElement(element),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotFetchElementsResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (elements) {
						return A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Util$Choice$Page$lenses.hx.g9.f$(
								$elm$core$Maybe$Just(
									A3($author$project$Util$DictList$fromListWithKey, ps.kW, ps.li, elements))),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotFetchChoicesResponse = function (result) {
			return A3(
				$elm_community$result_extra$Result$Extra$unpack,
				function (error) {
					return _Utils_Tuple2(
						A2($author$project$Pages$View$Tristate$toError, model, error),
						$elm$core$Platform$Cmd$none);
				},
				function (choices) {
					return _Utils_Tuple2(
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							$author$project$Pages$Util$Choice$Page$lenses.hx.kl.f$(
								$elm$core$Maybe$Just(
									A3($author$project$Util$DictList$fromListWithKey, ps.kk, ps.lh, choices))),
							model),
						ps.mS(choices));
				},
				result);
		};
		var gotDeleteResponse = F2(
			function (elementId, result) {
				return _Utils_Tuple2(
					A3(
						$elm_community$result_extra$Result$Extra$unpack,
						$author$project$Pages$View$Tristate$toError(model),
						$elm$core$Basics$always(
							A2(
								$author$project$Pages$View$Tristate$mapMain,
								A2($author$project$Util$LensUtil$deleteAtId, elementId, $author$project$Pages$Util$Choice$Page$lenses.hM.g9),
								model)),
						result),
					$elm$core$Platform$Cmd$none);
			});
		var gotCreateResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (element) {
						return A2(
							$author$project$Pages$View$Tristate$mapMain,
							A2(
								$elm$core$Basics$composeR,
								A3(
									$author$project$Util$LensUtil$insertAtId,
									ps.li(element),
									$author$project$Pages$Util$Choice$Page$lenses.hM.g9,
									$author$project$Util$Editing$asView(element)),
								A3(
									$author$project$Util$LensUtil$updateById,
									ps.kj(element),
									$author$project$Pages$Util$Choice$Page$lenses.hM.kl,
									$author$project$Util$Editing$toView)),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var exitEdit = function (elementId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$Choice$Handler$mapElementStateById, elementId, $author$project$Util$Editing$toView, model),
				$elm$core$Platform$Cmd$none);
		};
		var enterEdit = function (elementId) {
			return _Utils_Tuple2(
				A3(
					$author$project$Pages$Util$Choice$Handler$mapElementStateById,
					elementId,
					$author$project$Util$Editing$toUpdate(ps.m3),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var edit = function (update) {
			return _Utils_Tuple2(
				A3(
					$author$project$Pages$Util$Choice$Handler$mapElementStateById,
					ps.lk(update),
					$author$project$Util$Editing$lenses.m5.f$(update),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var deselectChoice = function (choiceId) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A3($author$project$Util$LensUtil$updateById, choiceId, $author$project$Pages$Util$Choice$Page$lenses.hM.kl, $author$project$Util$Editing$toView),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var create = function (choiceId) {
			return _Utils_Tuple2(
				model,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$andThen,
						function (main) {
							return A2(
								$elm$core$Maybe$map,
								A2(
									ps.kx,
									{m: model.m, am: main.am},
									main.eb),
								A2(
									$arturopala$elm_monocle$Monocle$Compose$optionalWithOptional,
									$author$project$Util$Editing$lenses.m5,
									A2(
										$arturopala$elm_monocle$Monocle$Compose$lensWithOptional,
										$author$project$Util$LensUtil$dictByKey(choiceId),
										$author$project$Pages$Util$Choice$Page$lenses.hM.kl)).hn(main));
						},
						$author$project$Pages$View$Tristate$lenses.hM.hn(model))));
		};
		var confirmDelete = function (elementId) {
			return _Utils_Tuple2(
				model,
				A3(
					$author$project$Pages$View$Tristate$foldMain,
					$elm$core$Platform$Cmd$none,
					function (main) {
						return A3(
							ps.kI,
							{m: model.m, am: main.am},
							main.eb,
							elementId);
					},
					model));
		};
		var cancelDelete = function (elementId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$Choice$Handler$mapElementStateById, elementId, $author$project$Util$Editing$toView, model),
				$elm$core$Platform$Cmd$none);
		};
		switch (msg.$) {
			case 0:
				var update = msg.a;
				return edit(update);
			case 1:
				var update = msg.a;
				return saveEdit(update);
			case 2:
				var result = msg.a;
				return gotSaveEditResponse(result);
			case 3:
				var elementId = msg.a;
				return toggleControls(elementId);
			case 4:
				var elementId = msg.a;
				return enterEdit(elementId);
			case 5:
				var elementId = msg.a;
				return exitEdit(elementId);
			case 6:
				var elementId = msg.a;
				return requestDelete(elementId);
			case 7:
				var elementId = msg.a;
				return confirmDelete(elementId);
			case 8:
				var elementId = msg.a;
				return cancelDelete(elementId);
			case 9:
				var elementId = msg.a;
				var result = msg.b;
				return A2(gotDeleteResponse, elementId, result);
			case 10:
				var result = msg.a;
				return gotFetchElementsResponse(result);
			case 11:
				var result = msg.a;
				return gotFetchChoicesResponse(result);
			case 12:
				var choiceId = msg.a;
				return toggleChoiceControls(choiceId);
			case 13:
				var choice = msg.a;
				return selectChoice(choice);
			case 14:
				var choiceId = msg.a;
				return deselectChoice(choiceId);
			case 15:
				var choiceId = msg.a;
				return create(choiceId);
			case 16:
				var result = msg.a;
				return gotCreateResponse(result);
			case 17:
				var creation = msg.a;
				return updateCreation(creation);
			case 18:
				var pagination = msg.a;
				return setPagination(pagination);
			case 19:
				var string = msg.a;
				return setElementsSearchString(string);
			default:
				var string = msg.a;
				return setChoicesSearchString(string);
		}
	});
var $author$project$Pages$DashboardEntries$Entries$Handler$updateLogic = $author$project$Pages$Util$Choice$Handler$updateLogic(
	{
		ki: function ($) {
			return $.f;
		},
		kj: function ($) {
			return $.f;
		},
		kk: $author$project$Types$Project$Id$ordering,
		kx: F3(
			function (authorizedAccess, _v0, input) {
				return A3($author$project$Types$DashboardEntry$Creation$createWith, $author$project$Pages$Util$Choice$Page$GotCreateResponse, authorizedAccess, input);
			}),
		kI: F3(
			function (authorizedAccess, parentId, elementId) {
				return A3(
					$author$project$Types$DashboardEntry$Entry$deleteWith,
					function (_v1) {
						return $author$project$Pages$Util$Choice$Page$GotDeleteResponse(elementId);
					},
					authorizedAccess,
					{c: parentId, f: elementId});
			}),
		kW: $author$project$Types$Project$Id$ordering,
		lh: function ($) {
			return $.lf;
		},
		li: function ($) {
			return $.f;
		},
		lk: function ($) {
			return $.f;
		},
		my: F3(
			function (_v2, _v3, _v4) {
				return $elm$core$Platform$Cmd$none;
			}),
		mS: function (_v5) {
			return $elm$core$Platform$Cmd$none;
		},
		m0: F2(
			function (project, dashBoardId) {
				return A2($author$project$Types$DashboardEntry$Creation$default, dashBoardId, project.lf);
			}),
		m3: $elm$core$Basics$identity
	});
var $author$project$Pages$DashboardEntries$Handler$updateLogic = F2(
	function (msg, model) {
		var updateLogicEntries = $author$project$Pages$View$TristateUtil$updateFromSubModel(
			{hl: $author$project$Pages$DashboardEntries$Page$initialToMain, hz: $author$project$Pages$DashboardEntries$Page$lenses.hx.fk, hN: $author$project$Pages$DashboardEntries$Page$lenses.hM.fk, js: $author$project$Pages$DashboardEntries$Page$EntriesMsg, jI: $author$project$Pages$DashboardEntries$Entries$Handler$updateLogic});
		var updateLogicDashboard = $author$project$Pages$View$TristateUtil$updateFromSubModel(
			{hl: $author$project$Pages$DashboardEntries$Page$initialToMain, hz: $author$project$Pages$DashboardEntries$Page$lenses.hx.ff, hN: $author$project$Pages$DashboardEntries$Page$lenses.hM.ff, js: $author$project$Pages$DashboardEntries$Page$DashboardMsg, jI: $author$project$Pages$DashboardEntries$Dashboard$Handler$updateLogic});
		switch (msg.$) {
			case 2:
				var entriesMsg = msg.a;
				return A2(updateLogicEntries, entriesMsg, model);
			case 1:
				var mealMsg = msg.a;
				return A2(updateLogicDashboard, mealMsg, model);
			default:
				var result = msg.a;
				var newModel = A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (resolved) {
						return A2(
							updateLogicEntries,
							$author$project$Pages$Util$Choice$Page$GotFetchElementsResponse(
								$elm$core$Result$Ok(resolved.fk)),
							A2(
								updateLogicDashboard,
								$author$project$Pages$Util$Parent$Page$GotFetchResponse(
									$elm$core$Result$Ok(resolved.ff)),
								model).a).a;
					},
					result);
				return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
		}
	});
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $author$project$Pages$View$Tristate$updateWith = F3(
	function (update, msg, model) {
		if (msg.$ === 1) {
			return A2(
				$author$project$Pages$View$Tristate$fold,
				{
					bL: function (errorState) {
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_Utils_Tuple2(model, $elm$browser$Browser$Navigation$reload),
							function (main) {
								return _Utils_Tuple2(
									A3(
										$author$project$Pages$View$Tristate$Model,
										model.m,
										model.z,
										$author$project$Pages$View$Tristate$Main(main)),
									$elm$core$Platform$Cmd$none);
							},
							errorState.ef);
					},
					bM: function (_v1) {
						return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$reload);
					},
					bN: function (_v2) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				},
				model);
		} else {
			var message = msg.a;
			var _v3 = A2(update, message, model);
			var newModel = _v3.a;
			var cmd = _v3.b;
			return _Utils_Tuple2(
				newModel,
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$View$Tristate$Logic, cmd));
		}
	});
var $author$project$Pages$DashboardEntries$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$DashboardEntries$Handler$updateLogic);
var $author$project$Pages$Util$ParentEditor$Page$GotCreateResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$GotDeleteResponse = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Util$ParentEditor$Page$GotSaveEditResponse = function (a) {
	return {$: 5, a: a};
};
var $author$project$LondoGQL$InputObject$encodeDashboardCreation = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'header',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.bA))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dq, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'visibility',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$LondoGQL$Enum$Visibility$toString, input____.jN)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeCreateDashboardInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dashboardCreation',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeDashboardCreation(input____.b9)))
			]));
};
var $author$project$LondoGQL$Mutation$createDashboard = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'createDashboard',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeCreateDashboardInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Types$Dashboard$Creation$toGraphQLInput = function (input) {
	return {
		b9: {
			dq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(input.dq),
			bA: input.bA.nc,
			jN: input.jN
		}
	};
};
var $author$project$Types$Dashboard$Creation$createWith = F3(
	function (expect, authorizedAccess, creation) {
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect,
			authorizedAccess,
			A2(
				$author$project$LondoGQL$Mutation$createDashboard,
				{
					b: $author$project$Types$Dashboard$Creation$toGraphQLInput(creation)
				},
				$author$project$Types$Dashboard$Dashboard$selection));
	});
var $author$project$Types$Dashboard$Id$ordering = $author$project$Util$Ordering$with(
	A2($elm$core$Basics$composeR, $author$project$Types$Dashboard$Id$uuid, $author$project$Util$GraphQLUtil$uuidToString));
var $author$project$Pages$Util$ParentEditor$Pagination$initial = {mg: $author$project$Pages$Util$PaginationSettings$initial};
var $author$project$Pages$Util$ParentEditor$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$map,
		function (parents) {
			return {am: i.am, dL: i.dL, $8: $author$project$Pages$Util$ParentEditor$Pagination$initial, fQ: $elm$core$Maybe$Nothing, mg: parents, cD: ''};
		},
		i.mg);
};
var $author$project$Pages$Util$ParentEditor$Page$lenses = {
	hx: {
		mg: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.mg;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{mg: b});
				}))
	},
	hM: {
		$8: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.$8;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{$8: b});
				})),
		fQ: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.fQ;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{fQ: b});
				})),
		mg: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.mg;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{mg: b});
				})),
		cD: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.cD;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{cD: b});
				}))
	}
};
var $author$project$Pages$Util$ParentEditor$Pagination$lenses = {
	mg: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.mg;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{mg: b});
			}))
};
var $author$project$Pages$Util$ParentEditor$Handler$mapParentStateById = function (parentId) {
	return A2(
		$elm$core$Basics$composeR,
		A2($author$project$Util$LensUtil$updateById, parentId, $author$project$Pages$Util$ParentEditor$Page$lenses.hM.mg),
		$author$project$Pages$View$Tristate$mapMain);
};
var $author$project$Pages$Util$ParentEditor$Handler$updateLogic = F3(
	function (ps, msg, model) {
		var updateCreation = function (creation) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					$author$project$Pages$Util$ParentEditor$Page$lenses.hM.fQ.f$(creation),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var toggleControls = function (parentId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$ParentEditor$Handler$mapParentStateById, parentId, $author$project$Util$Editing$toggleControls, model),
				$elm$core$Platform$Cmd$none);
		};
		var setSearchString = function (string) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A2(
						$author$project$Pages$Util$PaginationSettings$setSearchStringAndReset,
						{
							mb: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$ParentEditor$Pagination$lenses.mg, $author$project$Pages$Util$ParentEditor$Page$lenses.hM.$8),
							mF: $author$project$Pages$Util$ParentEditor$Page$lenses.hM.cD
						},
						string),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var setPagination = function (pagination) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					$author$project$Pages$Util$ParentEditor$Page$lenses.hM.$8.f$(pagination),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var saveEdit = function (parentId) {
			return _Utils_Tuple2(
				model,
				A3(
					$author$project$Pages$View$Tristate$foldMain,
					$elm$core$Platform$Cmd$none,
					function (main) {
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$core$Platform$Cmd$none,
							A2(
								ps.aO,
								{m: model.m, am: main.am},
								parentId),
							A2(
								$elm$core$Maybe$andThen,
								$author$project$Util$Editing$extractUpdate,
								A2(
									$author$project$Util$DictList$get,
									parentId,
									$author$project$Pages$Util$ParentEditor$Page$lenses.hM.mg.dy(main))));
					},
					model));
		};
		var requestDelete = function (parentId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$ParentEditor$Handler$mapParentStateById, parentId, $author$project$Util$Editing$toDelete, model),
				$elm$core$Platform$Cmd$none);
		};
		var gotSaveEditResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (parent) {
						return A3(
							$author$project$Pages$Util$ParentEditor$Handler$mapParentStateById,
							ps.lj(parent),
							$author$project$Util$Editing$asViewWithElement(parent),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotFetchResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (parents) {
						return A2(
							$author$project$Pages$View$Tristate$fromInitToMain,
							$author$project$Pages$Util$ParentEditor$Page$initialToMain,
							A2(
								$author$project$Pages$View$Tristate$mapInitial,
								$author$project$Pages$Util$ParentEditor$Page$lenses.hx.mg.f$(
									$elm$core$Maybe$Just(
										A3(
											$author$project$Util$DictList$fromListWithKey,
											ps.mf,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.ic;
												},
												ps.lj),
											A2($elm$core$List$map, $author$project$Util$Editing$asView, parents)))),
								model));
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotDeleteResponse = F2(
			function (deletedId, result) {
				return _Utils_Tuple2(
					A3(
						$elm_community$result_extra$Result$Extra$unpack,
						$author$project$Pages$View$Tristate$toError(model),
						$elm$core$Basics$always(
							A2(
								$author$project$Pages$View$Tristate$mapMain,
								A2($author$project$Util$LensUtil$deleteAtId, deletedId, $author$project$Pages$Util$ParentEditor$Page$lenses.hM.mg),
								model)),
						result),
					$elm$core$Platform$Cmd$none);
			});
		var gotCreationResponseWith = F2(
			function (params, result) {
				return A3(
					$elm_community$result_extra$Result$Extra$unpack,
					function (error) {
						return _Utils_Tuple2(
							A2($author$project$Pages$View$Tristate$toError, model, error),
							$elm$core$Platform$Cmd$none);
					},
					function (parent) {
						var parentId = ps.lj(parent);
						var parentCreationHandling = params.iQ ? $author$project$Pages$Util$ParentEditor$Page$lenses.hM.fQ.f$($elm$core$Maybe$Nothing) : $elm$core$Basics$identity;
						return _Utils_Tuple2(
							A2(
								$author$project$Pages$View$Tristate$mapMain,
								A2(
									$elm$core$Basics$composeR,
									A3(
										$author$project$Util$LensUtil$insertAtId,
										parentId,
										$author$project$Pages$Util$ParentEditor$Page$lenses.hM.mg,
										$author$project$Util$Editing$asView(parent)),
									parentCreationHandling),
								model),
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$core$Platform$Cmd$none,
								$author$project$Pages$Util$Links$loadFrontendPage,
								ps.lQ(parentId)));
					},
					result);
			});
		var gotCreateResponse = gotCreationResponseWith(
			{iQ: true});
		var exitEdit = function (parentId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$ParentEditor$Handler$mapParentStateById, parentId, $author$project$Util$Editing$toView, model),
				$elm$core$Platform$Cmd$none);
		};
		var enterEdit = function (parentId) {
			return _Utils_Tuple2(
				A3(
					$author$project$Pages$Util$ParentEditor$Handler$mapParentStateById,
					parentId,
					$author$project$Util$Editing$toUpdate(ps.m3),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var edit = F2(
			function (parentId, update) {
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Util$ParentEditor$Handler$mapParentStateById,
						parentId,
						$author$project$Util$Editing$lenses.m5.f$(update),
						model),
					$elm$core$Platform$Cmd$none);
			});
		var create = _Utils_Tuple2(
			model,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$andThen,
					function (main) {
						return A2(
							$elm$core$Maybe$map,
							ps.br(
								{m: model.m, am: main.am}),
							main.fQ);
					},
					$author$project$Pages$View$Tristate$lenses.hM.hn(model))));
		var confirmDelete = function (parentId) {
			return _Utils_Tuple2(
				model,
				A3(
					$author$project$Pages$View$Tristate$foldMain,
					$elm$core$Platform$Cmd$none,
					function (main) {
						return A2(
							ps.Z,
							{m: model.m, am: main.am},
							parentId);
					},
					model));
		};
		var cancelDelete = function (parentId) {
			return _Utils_Tuple2(
				A3($author$project$Pages$Util$ParentEditor$Handler$mapParentStateById, parentId, $author$project$Util$Editing$toView, model),
				$elm$core$Platform$Cmd$none);
		};
		switch (msg.$) {
			case 0:
				var creation = msg.a;
				return updateCreation(creation);
			case 1:
				return create;
			case 2:
				var result = msg.a;
				return gotCreateResponse(result);
			case 3:
				var parentId = msg.a;
				var update = msg.b;
				return A2(edit, parentId, update);
			case 4:
				var parentId = msg.a;
				return saveEdit(parentId);
			case 5:
				var result = msg.a;
				return gotSaveEditResponse(result);
			case 6:
				var parentId = msg.a;
				return toggleControls(parentId);
			case 7:
				var parentId = msg.a;
				return enterEdit(parentId);
			case 8:
				var parentId = msg.a;
				return exitEdit(parentId);
			case 9:
				var parentId = msg.a;
				return requestDelete(parentId);
			case 10:
				var parentId = msg.a;
				return confirmDelete(parentId);
			case 11:
				var parentId = msg.a;
				return cancelDelete(parentId);
			case 12:
				var parentId = msg.a;
				var result = msg.b;
				return A2(gotDeleteResponse, parentId, result);
			case 13:
				var result = msg.a;
				return gotFetchResponse(result);
			case 14:
				var pagination = msg.a;
				return setPagination(pagination);
			default:
				var string = msg.a;
				return setSearchString(string);
		}
	});
var $author$project$Pages$Dashboards$Handler$updateLogic = $author$project$Pages$Util$ParentEditor$Handler$updateLogic(
	{
		br: $author$project$Types$Dashboard$Creation$createWith($author$project$Pages$Util$ParentEditor$Page$GotCreateResponse),
		Z: $author$project$Types$Dashboard$Dashboard$deleteWith($author$project$Pages$Util$ParentEditor$Page$GotDeleteResponse),
		lj: function ($) {
			return $.lf;
		},
		lQ: A2($elm$core$Basics$composeR, $author$project$Addresses$Frontend$dashboardEntries.gh, $elm$core$Maybe$Just),
		mf: $author$project$Types$Dashboard$Id$ordering,
		aO: $author$project$Types$Dashboard$Update$updateWith($author$project$Pages$Util$ParentEditor$Page$GotSaveEditResponse),
		m3: $author$project$Types$Dashboard$Update$from
	});
var $author$project$Pages$Dashboards$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Dashboards$Handler$updateLogic);
var $author$project$Pages$Deletion$Page$Confirmed = 1;
var $author$project$Pages$Deletion$Page$GotConfirmResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$LondoGQL$InputObject$encodeConfirmDeletionInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'deletionToken',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.cc)))
			]));
};
var $author$project$LondoGQL$Mutation$confirmDeletion = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'confirmDeletion',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeConfirmDeletionInput)
			]),
		$elm$json$Json$Decode$bool);
};
var $author$project$Types$User$User$confirmDeletionWith = F3(
	function (expect, configuration, deletionToken) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			expect,
			A2(
				$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
				configuration.k8,
				$author$project$LondoGQL$Mutation$confirmDeletion(
					{
						b: {cc: deletionToken}
					})));
	});
var $author$project$Ports$doDeleteToken = _Platform_outgoingPort(
	'doDeleteToken',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Pages$Deletion$Page$lenses = {
	hM: {
		lL: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lL;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lL: b});
				}))
	}
};
var $author$project$Pages$Deletion$Handler$updateLogic = F2(
	function (msg, model) {
		var gotConfirmResponse = function (result) {
			return A3(
				$elm_community$result_extra$Result$Extra$unpack,
				function (error) {
					return _Utils_Tuple2(
						A2($author$project$Pages$View$Tristate$toError, model, error),
						$elm$core$Platform$Cmd$none);
				},
				function (_v1) {
					return _Utils_Tuple2(
						A2(
							$author$project$Pages$View$Tristate$mapMain,
							$author$project$Pages$Deletion$Page$lenses.hM.lL.f$(1),
							model),
						$author$project$Ports$doDeleteToken(0));
				},
				result);
		};
		var confirm = _Utils_Tuple2(
			model,
			A3(
				$author$project$Pages$View$Tristate$foldMain,
				$elm$core$Platform$Cmd$none,
				function (main) {
					return A3($author$project$Types$User$User$confirmDeletionWith, $author$project$Pages$Deletion$Page$GotConfirmResponse, model.m, main.kK);
				},
				model));
		if (!msg.$) {
			return confirm;
		} else {
			var result = msg.a;
			return gotConfirmResponse(result);
		}
	});
var $author$project$Pages$Deletion$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Deletion$Handler$updateLogic);
var $author$project$Pages$Login$Page$GotResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Login$Page$lenses = {
	hM: {
		gM: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.gM;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{gM: b});
				}))
	}
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$bool(value));
};
var $author$project$LondoGQL$InputObject$encodeLoginInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nickname',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.R))),
				_Utils_Tuple2(
				'password',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.ec))),
				_Utils_Tuple2(
				'isValidityUnrestricted',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.cl)))
			]));
};
var $author$project$LondoGQL$Mutation$login = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'String',
		'login',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeLoginInput)
			]),
		$elm$json$Json$Decode$string);
};
var $author$project$Types$User$Login$loginWith = F3(
	function (expect, configuration, input) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			expect,
			A2(
				$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
				configuration.k8,
				$author$project$LondoGQL$Mutation$login(
					{b: input})));
	});
var $author$project$Ports$storeToken = _Platform_outgoingPort('storeToken', $elm$json$Json$Encode$string);
var $author$project$Pages$Login$Handler$updateLogic = F2(
	function (msg, model) {
		var setCredentials = function (credentials) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					$author$project$Pages$Login$Page$lenses.hM.gM.f$(credentials),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var login = _Utils_Tuple2(
			model,
			A3(
				$author$project$Pages$View$Tristate$foldMain,
				$elm$core$Platform$Cmd$none,
				function (main) {
					return A3($author$project$Types$User$Login$loginWith, $author$project$Pages$Login$Page$GotResponse, model.m, main.gM);
				},
				model));
		var gotResponse = function (remoteData) {
			return A3(
				$elm_community$result_extra$Result$Extra$unpack,
				function (error) {
					return _Utils_Tuple2(
						A2($author$project$Pages$View$Tristate$toError, model, error),
						$elm$core$Platform$Cmd$none);
				},
				function (token) {
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Ports$storeToken(token),
									$elm$browser$Browser$Navigation$load(
									$author$project$Pages$Util$Links$frontendPage(
										$author$project$Addresses$Frontend$overview.gh(0)))
								])));
				},
				remoteData);
		};
		switch (msg.$) {
			case 0:
				var credentials = msg.a;
				return setCredentials(credentials);
			case 1:
				return login;
			default:
				var remoteData = msg.a;
				return gotResponse(remoteData);
		}
	});
var $author$project$Pages$Login$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Login$Handler$updateLogic);
var $author$project$Pages$Overview$Handler$update = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$LondoGQL$InputObject$encodeCreateProjectInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.hV))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dq, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$LondoGQL$Mutation$createProject = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'createProject',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeCreateProjectInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Types$Project$Creation$toGraphQLInput = function (input) {
	return {
		dq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(input.dq),
		hV: input.hV.nc
	};
};
var $author$project$Types$Project$Creation$createWith = F3(
	function (expect, authorizedAccess, creation) {
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect,
			authorizedAccess,
			A2(
				$author$project$LondoGQL$Mutation$createProject,
				{
					b: $author$project$Types$Project$Creation$toGraphQLInput(creation)
				},
				$author$project$Types$Project$Project$selection));
	});
var $author$project$LondoGQL$InputObject$encodeDeleteProjectInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'projectId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeProjectIdInput(input____.f)))
			]));
};
var $author$project$LondoGQL$Mutation$deleteProject = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'deleteProject',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeDeleteProjectInput)
			]),
		$elm$json$Json$Decode$bool);
};
var $author$project$Types$Project$Project$deleteWith = F3(
	function (expect, authorizedAccess, projectId) {
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect(projectId),
			authorizedAccess,
			$author$project$LondoGQL$Mutation$deleteProject(
				{
					b: {
						f: $author$project$Types$Project$Id$toGraphQLInput(projectId)
					}
				}));
	});
var $author$project$Types$Project$Update$from = function (project) {
	return {
		dq: project.dq,
		hV: A2(
			$author$project$Util$ValidatedInput$lenses.jp.f$,
			project.hV,
			A2($author$project$Util$ValidatedInput$lenses.nc.f$, project.hV, $author$project$Util$ValidatedInput$nonEmptyString))
	};
};
var $author$project$Types$Project$Update$toGraphQLInput = F2(
	function (projectId, input) {
		return {
			dq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(input.dq),
			hV: input.hV.nc,
			f: $author$project$Types$Project$Id$toGraphQLInput(projectId)
		};
	});
var $author$project$LondoGQL$InputObject$encodeUpdateProjectInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'projectId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeProjectIdInput(input____.f))),
				_Utils_Tuple2(
				'name',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.hV))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dq, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$LondoGQL$Mutation$updateProject = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'updateProject',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeUpdateProjectInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Types$Project$Update$updateWith = F4(
	function (expect, authorizedAccess, projectId, update) {
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect,
			authorizedAccess,
			A2(
				$author$project$LondoGQL$Mutation$updateProject,
				{
					b: A2($author$project$Types$Project$Update$toGraphQLInput, projectId, update)
				},
				$author$project$Types$Project$Project$selection));
	});
var $author$project$Pages$Projects$Handler$updateLogic = $author$project$Pages$Util$ParentEditor$Handler$updateLogic(
	{
		br: $author$project$Types$Project$Creation$createWith($author$project$Pages$Util$ParentEditor$Page$GotCreateResponse),
		Z: $author$project$Types$Project$Project$deleteWith($author$project$Pages$Util$ParentEditor$Page$GotDeleteResponse),
		lj: function ($) {
			return $.lf;
		},
		lQ: A2($elm$core$Basics$composeR, $author$project$Addresses$Frontend$tasks.gh, $elm$core$Maybe$Just),
		mf: $author$project$Types$Project$Id$ordering,
		aO: $author$project$Types$Project$Update$updateWith($author$project$Pages$Util$ParentEditor$Page$GotSaveEditResponse),
		m3: $author$project$Types$Project$Update$from
	});
var $author$project$Pages$Projects$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Projects$Handler$updateLogic);
var $author$project$Pages$Recovery$Confirm$Page$Confirmed = 1;
var $author$project$Pages$Recovery$Confirm$Page$GotConfirmResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$LondoGQL$InputObject$encodeConfirmRecoveryInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'recoveryToken',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.cC))),
				_Utils_Tuple2(
				'password',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.ec)))
			]));
};
var $author$project$LondoGQL$Mutation$confirmRecovery = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'confirmRecovery',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeConfirmRecoveryInput)
			]),
		$elm$json$Json$Decode$bool);
};
var $author$project$Types$User$User$confirmRecoveryWith = F4(
	function (expect, configuration, recoveryToken, password) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			expect,
			A2(
				$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
				configuration.k8,
				$author$project$LondoGQL$Mutation$confirmRecovery(
					{
						b: {ec: password, cC: recoveryToken}
					})));
	});
var $author$project$Pages$Recovery$Confirm$Page$lenses = {
	hM: {
		lL: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lL;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lL: b});
				})),
		fR: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.fR;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{fR: b});
				}))
	}
};
var $author$project$Pages$Recovery$Confirm$Handler$updateLogic = F2(
	function (msg, model) {
		var setPasswordInput = function (passwordInput) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					$author$project$Pages$Recovery$Confirm$Page$lenses.hM.fR.f$(passwordInput),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var gotConfirmResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (_v1) {
						return A2(
							$author$project$Pages$View$Tristate$mapMain,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Pages$Recovery$Confirm$Page$lenses.hM.lL.f$(1),
								$author$project$Pages$Recovery$Confirm$Page$lenses.hM.fR.f$($author$project$Pages$Util$PasswordInput$initial)),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var confirm = _Utils_Tuple2(
			model,
			A3(
				$author$project$Pages$View$Tristate$foldMain,
				$elm$core$Platform$Cmd$none,
				function (main) {
					return A4($author$project$Types$User$User$confirmRecoveryWith, $author$project$Pages$Recovery$Confirm$Page$GotConfirmResponse, model.m, main.mm, main.fR.ih);
				},
				model));
		switch (msg.$) {
			case 0:
				var passwordInput = msg.a;
				return setPasswordInput(passwordInput);
			case 1:
				return confirm;
			default:
				var result = msg.a;
				return gotConfirmResponse(result);
		}
	});
var $author$project$Pages$Recovery$Confirm$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Recovery$Confirm$Handler$updateLogic);
var $author$project$Pages$Recovery$Request$Page$GotFindResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Recovery$Request$Page$GotRequestRecoveryResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Recovery$Request$Page$Requested = 2;
var $author$project$Pages$Recovery$Request$Page$Requesting = 1;
var $author$project$LondoGQL$InputObject$encodeFindUserInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'searchString',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.cD)))
			]));
};
var $author$project$LondoGQL$Query$findUser = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'findUser',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeFindUserInput)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Types$User$SearchResult$SearchResult = F2(
	function (id, nickname) {
		return {lf: id, R: nickname};
	});
var $author$project$LondoGQL$Object$FindUserResult$id = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'id', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$LondoGQL$Object$FindUserResult$nickname = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'nickname', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Types$User$SearchResult$selection = A3(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map2,
	$author$project$Types$User$SearchResult$SearchResult,
	$author$project$LondoGQL$Object$FindUserResult$id($author$project$Types$User$Id$selection),
	$author$project$LondoGQL$Object$FindUserResult$nickname);
var $author$project$Types$User$SearchResult$fetchWith = F3(
	function (expect, configuration, identifier) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			expect,
			A2(
				$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
				configuration.k8,
				A2(
					$author$project$LondoGQL$Query$findUser,
					{
						b: {cD: identifier}
					},
					$author$project$Types$User$SearchResult$selection)));
	});
var $author$project$Pages$Recovery$Request$Page$lenses = {
	hM: {
		lL: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lL;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lL: b});
				})),
		cD: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.cD;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{cD: b});
				})),
		na: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.na;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{na: b});
				}))
	}
};
var $author$project$LondoGQL$InputObject$encodeUserIdInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'uuid',
				$elm$core$Maybe$Just(
					A2(
						$author$project$LondoGQL$Scalar$unwrapEncoder,
						function ($) {
							return $.dj;
						},
						$author$project$LondoGQL$ScalarCodecs$codecs)(input____.o)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeRequestRecoveryInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'userId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeUserIdInput(input____.cN)))
			]));
};
var $author$project$LondoGQL$Mutation$requestRecovery = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'ScalarCodecs.Unit',
		'requestRecovery',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeRequestRecoveryInput)
			]),
		$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).fb.fg);
};
var $author$project$LondoGQL$InputObject$UserIdInput = function (uuid) {
	return {o: uuid};
};
var $author$project$Types$User$Id$uuid = function (_v0) {
	var u = _v0;
	return u;
};
var $author$project$Types$User$Id$toGraphQLInput = A2($elm$core$Basics$composeR, $author$project$Types$User$Id$uuid, $author$project$LondoGQL$InputObject$UserIdInput);
var $author$project$Types$User$User$requestRecoveryWith = F3(
	function (expect, configuration, userId) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			expect,
			A2(
				$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
				configuration.k8,
				$author$project$LondoGQL$Mutation$requestRecovery(
					{
						b: {
							cN: $author$project$Types$User$Id$toGraphQLInput(userId)
						}
					})));
	});
var $author$project$Pages$Recovery$Request$Handler$updateLogic = F2(
	function (msg, model) {
		var setSearchString = function (string) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Pages$Recovery$Request$Page$lenses.hM.cD.f$(string),
						$author$project$Pages$Recovery$Request$Page$lenses.hM.lL.f$(0)),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var requestRecovery = function (userId) {
			return _Utils_Tuple2(
				model,
				A3($author$project$Types$User$User$requestRecoveryWith, $author$project$Pages$Recovery$Request$Page$GotRequestRecoveryResponse, model.m, userId));
		};
		var gotRequestRecoveryResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (_v2) {
						return A2(
							$author$project$Pages$View$Tristate$mapMain,
							$author$project$Pages$Recovery$Request$Page$lenses.hM.lL.f$(2),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotFindResponse = function (result) {
			return A3(
				$elm_community$result_extra$Result$Extra$unpack,
				function (error) {
					return _Utils_Tuple2(
						A2($author$project$Pages$View$Tristate$toError, model, error),
						$elm$core$Platform$Cmd$none);
				},
				function (users) {
					if (users.b && (!users.b.b)) {
						var user = users.a;
						return requestRecovery(user.lf);
					} else {
						return _Utils_Tuple2(
							A2(
								$author$project$Pages$View$Tristate$mapMain,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Pages$Recovery$Request$Page$lenses.hM.na.f$(users),
									$author$project$Pages$Recovery$Request$Page$lenses.hM.lL.f$(1)),
								model),
							$elm$core$Platform$Cmd$none);
					}
				},
				result);
		};
		var find = _Utils_Tuple2(
			model,
			A3(
				$author$project$Pages$View$Tristate$foldMain,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.cD;
					},
					A2($author$project$Types$User$SearchResult$fetchWith, $author$project$Pages$Recovery$Request$Page$GotFindResponse, model.m)),
				model));
		switch (msg.$) {
			case 0:
				return find;
			case 1:
				var result = msg.a;
				return gotFindResponse(result);
			case 2:
				var string = msg.a;
				return setSearchString(string);
			case 3:
				var userId = msg.a;
				return requestRecovery(userId);
			default:
				var result = msg.a;
				return gotRequestRecoveryResponse(result);
		}
	});
var $author$project$Pages$Recovery$Request$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Recovery$Request$Handler$updateLogic);
var $author$project$Pages$Registration$Confirm$Page$Confirmed = 1;
var $author$project$Pages$Registration$Confirm$Page$lenses = {
	hM: {
		fc: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.fc;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{fc: b});
				})),
		lL: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lL;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lL: b});
				}))
	}
};
var $author$project$Pages$Registration$Confirm$Handler$gotResponse = F2(
	function (model, result) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (_v0) {
					return A2(
						$author$project$Pages$View$Tristate$mapMain,
						$author$project$Pages$Registration$Confirm$Page$lenses.hM.lL.f$(1),
						model);
				},
				result),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Registration$Confirm$Page$GotResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$LondoGQL$InputObject$encodeCreationComplement = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'displayName',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.du, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'password',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.ec)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeConfirmRegistrationInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'creationToken',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.b7))),
				_Utils_Tuple2(
				'creationComplement',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeCreationComplement(input____.b6)))
			]));
};
var $author$project$LondoGQL$Mutation$confirmRegistration = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'confirmRegistration',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeConfirmRegistrationInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Util$GraphQLUtil$unit = '()';
var $author$project$Pages$Registration$Confirm$Requests$confirmRegistration = F3(
	function (configuration, jwt, complement) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			$author$project$Pages$Registration$Confirm$Page$GotResponse,
			A2(
				$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
				configuration.k8,
				A2(
					$author$project$LondoGQL$Mutation$confirmRegistration,
					{
						b: {b6: complement, b7: jwt}
					},
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
						$elm$core$Basics$always($author$project$Util$GraphQLUtil$unit),
						$author$project$LondoGQL$Object$User$id($author$project$LondoGQL$Object$UserId$uuid)))));
	});
var $author$project$Pages$Registration$Confirm$Handler$request = function (model) {
	return _Utils_Tuple2(
		model,
		A3(
			$author$project$Pages$View$Tristate$foldMain,
			$elm$core$Platform$Cmd$none,
			function (main) {
				return A3(
					$author$project$Pages$Registration$Confirm$Requests$confirmRegistration,
					model.m,
					main.mo,
					{
						du: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(main.fc.du),
						ec: main.fc.fR.ih
					});
			},
			model));
};
var $author$project$Pages$Registration$Confirm$Handler$setComplementInput = F2(
	function (model, complementInput) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Registration$Confirm$Page$lenses.hM.fc.f$(complementInput),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Registration$Confirm$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var complementInput = msg.a;
				return A2($author$project$Pages$Registration$Confirm$Handler$setComplementInput, model, complementInput);
			case 1:
				return $author$project$Pages$Registration$Confirm$Handler$request(model);
			default:
				var result = msg.a;
				return A2($author$project$Pages$Registration$Confirm$Handler$gotResponse, model, result);
		}
	});
var $author$project$Pages$Registration$Confirm$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Registration$Confirm$Handler$updateLogic);
var $author$project$Pages$Registration$Request$Page$Confirmed = 1;
var $author$project$Pages$Registration$Request$Page$lenses = {
	hM: {
		aC: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.aC;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{aC: b});
				})),
		lL: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lL;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lL: b});
				})),
		R: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.R;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{R: b});
				}))
	}
};
var $author$project$Pages$Registration$Request$Handler$gotRequestResponse = F2(
	function (model, remoteResponse) {
		return _Utils_Tuple2(
			A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (_v0) {
					return A2(
						$author$project$Pages$View$Tristate$mapMain,
						$author$project$Pages$Registration$Request$Page$lenses.hM.lL.f$(1),
						model);
				},
				remoteResponse),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Registration$Request$Page$GotRequestResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$LondoGQL$InputObject$encodeUserIdentifier = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nickname',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.R))),
				_Utils_Tuple2(
				'email',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.aC)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeRequestRegistrationInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'userIdentifier',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeUserIdentifier(input____.cO)))
			]));
};
var $author$project$LondoGQL$Mutation$requestRegistration = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'ScalarCodecs.Unit',
		'requestRegistration',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeRequestRegistrationInput)
			]),
		$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).fb.fg);
};
var $author$project$Pages$Registration$Request$Requests$requestRegistration = F2(
	function (configuration, userIdentifier) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			$author$project$Pages$Registration$Request$Page$GotRequestResponse,
			A2(
				$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
				configuration.k8,
				$author$project$LondoGQL$Mutation$requestRegistration(
					{
						b: {cO: userIdentifier}
					})));
	});
var $author$project$Pages$Registration$Request$Handler$request = function (model) {
	return _Utils_Tuple2(
		model,
		A3(
			$author$project$Pages$View$Tristate$foldMain,
			$elm$core$Platform$Cmd$none,
			function (main) {
				return A2(
					$author$project$Pages$Registration$Request$Requests$requestRegistration,
					model.m,
					{aC: main.aC.nc, R: main.R.nc});
			},
			model));
};
var $author$project$Pages$Registration$Request$Handler$setEmail = F2(
	function (model, email) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Registration$Request$Page$lenses.hM.aC.f$(email),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Registration$Request$Handler$setNickname = F2(
	function (model, nickname) {
		return _Utils_Tuple2(
			A2(
				$author$project$Pages$View$Tristate$mapMain,
				$author$project$Pages$Registration$Request$Page$lenses.hM.R.f$(nickname),
				model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Registration$Request$Handler$updateLogic = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var nickname = msg.a;
				return A2($author$project$Pages$Registration$Request$Handler$setNickname, model, nickname);
			case 1:
				var email = msg.a;
				return A2($author$project$Pages$Registration$Request$Handler$setEmail, model, email);
			case 2:
				return $author$project$Pages$Registration$Request$Handler$request(model);
			default:
				var remoteResponse = msg.a;
				return A2($author$project$Pages$Registration$Request$Handler$gotRequestResponse, model, remoteResponse);
		}
	});
var $author$project$Pages$Registration$Request$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Registration$Request$Handler$updateLogic);
var $author$project$Types$User$PasswordUpdate$ClientInput = function (passwordInput) {
	return {fR: passwordInput};
};
var $author$project$Types$User$Update$ClientInput = function (displayName) {
	return {du: displayName};
};
var $author$project$Pages$Settings$Page$GotLogoutResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Settings$Page$GotRequestDeletionResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Settings$Page$GotUpdatePasswordResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Settings$Page$GotUpdateSettingsResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Settings$Page$RequestedDeletion = 1;
var $author$project$Pages$Settings$Page$Regular = 0;
var $author$project$Pages$Settings$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$map,
		function (user) {
			return {fc: $author$project$Pages$Util$ComplementInput$initial, am: i.am, dL: $author$project$Language$Language$default.eY, lL: 0, jK: user};
		},
		i.jK);
};
var $author$project$Pages$Settings$Page$lenses = {
	hx: {
		jK: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jK;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jK: b});
				}))
	},
	hM: {
		fc: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.fc;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{fc: b});
				})),
		lL: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.lL;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{lL: b});
				})),
		jK: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jK;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jK: b});
				}))
	}
};
var $author$project$Pages$Util$ComplementInput$lenses = {
	du: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.du;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{du: b});
			})),
	fR: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.fR;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{fR: b});
			}))
};
var $author$project$LondoGQL$Enum$LogoutMode$toString = function (enum____) {
	if (!enum____) {
		return 'AllSessions';
	} else {
		return 'ThisSession';
	}
};
var $author$project$LondoGQL$InputObject$encodeLogoutInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'logoutMode',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$LondoGQL$Enum$LogoutMode$toString, input____.cq)))
			]));
};
var $author$project$LondoGQL$Mutation$logout = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'logout',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeLogoutInput)
			]),
		$elm$json$Json$Decode$bool);
};
var $author$project$Types$User$User$logoutWith = F3(
	function (expect, authorizedAccess, logoutMode) {
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect,
			authorizedAccess,
			$author$project$LondoGQL$Mutation$logout(
				{
					b: {cq: logoutMode}
				}));
	});
var $author$project$LondoGQL$Mutation$requestDeletion = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Unit',
	'requestDeletion',
	_List_Nil,
	$author$project$LondoGQL$Scalar$unwrapCodecs($author$project$LondoGQL$ScalarCodecs$codecs).fb.fg);
var $author$project$Types$User$User$requestDeletionWith = F2(
	function (expect, authorizedAccess) {
		return A3($author$project$Util$HttpUtil$mutationWith, expect, authorizedAccess, $author$project$LondoGQL$Mutation$requestDeletion);
	});
var $author$project$Types$User$PasswordUpdate$toGraphQLInput = function (input) {
	return {ec: input.fR.ih};
};
var $author$project$LondoGQL$InputObject$encodeUpdatePasswordInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'password',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.ec)))
			]));
};
var $author$project$LondoGQL$Mutation$updatePassword = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'updatePassword',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeUpdatePasswordInput)
			]),
		$elm$json$Json$Decode$bool);
};
var $author$project$Types$User$PasswordUpdate$updateWith = F3(
	function (expect, authorizedAccess, update) {
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect,
			authorizedAccess,
			$author$project$LondoGQL$Mutation$updatePassword(
				{
					b: $author$project$Types$User$PasswordUpdate$toGraphQLInput(update)
				}));
	});
var $author$project$Types$User$Update$toGraphQLInput = function (input) {
	return {
		du: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(input.du)
	};
};
var $author$project$LondoGQL$InputObject$encodeUpdateUserInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'displayName',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.du, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$LondoGQL$Mutation$updateUser = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'updateUser',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeUpdateUserInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Types$User$Update$updateWith = F3(
	function (expect, authorizedAccess, update) {
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect,
			authorizedAccess,
			A2(
				$author$project$LondoGQL$Mutation$updateUser,
				{
					b: $author$project$Types$User$Update$toGraphQLInput(update)
				},
				$author$project$Types$User$User$selection));
	});
var $author$project$Pages$Settings$Handler$updateLogic = F2(
	function (msg, model) {
		var setComplementInput = function (complementInput) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					$author$project$Pages$Settings$Page$lenses.hM.fc.f$(complementInput),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var requestDeletion = _Utils_Tuple2(
			model,
			A3(
				$author$project$Pages$View$Tristate$foldMain,
				$elm$core$Platform$Cmd$none,
				function (main) {
					return A2(
						$author$project$Types$User$User$requestDeletionWith,
						$author$project$Pages$Settings$Page$GotRequestDeletionResponse,
						{m: model.m, am: main.am});
				},
				model));
		var passwordInputLens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$ComplementInput$lenses.fR, $author$project$Pages$Settings$Page$lenses.hM.fc);
		var updatePassword = _Utils_Tuple2(
			model,
			A3(
				$author$project$Pages$View$Tristate$foldMain,
				$elm$core$Platform$Cmd$none,
				function (main) {
					return A3(
						$author$project$Types$User$PasswordUpdate$updateWith,
						$author$project$Pages$Settings$Page$GotUpdatePasswordResponse,
						{m: model.m, am: main.am},
						$author$project$Types$User$PasswordUpdate$ClientInput(
							passwordInputLens.dy(main)));
				},
				model));
		var logout = function (logoutMode) {
			return _Utils_Tuple2(
				model,
				A3(
					$author$project$Pages$View$Tristate$foldMain,
					$elm$core$Platform$Cmd$none,
					function (main) {
						return A3(
							$author$project$Types$User$User$logoutWith,
							$author$project$Pages$Settings$Page$GotLogoutResponse,
							{m: model.m, am: main.am},
							logoutMode);
					},
					model));
		};
		var gotUpdatePasswordResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (isSuccess) {
						return isSuccess ? A2(
							$author$project$Pages$View$Tristate$mapMain,
							passwordInputLens.f$($author$project$Pages$Util$PasswordInput$initial),
							model) : model;
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotRequestDeletionResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (_v1) {
						return A2(
							$author$project$Pages$View$Tristate$mapMain,
							$author$project$Pages$Settings$Page$lenses.hM.lL.f$(1),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var gotLogoutResponse = function (result) {
			return A3(
				$elm_community$result_extra$Result$Extra$unpack,
				function (error) {
					return _Utils_Tuple2(
						A2($author$project$Pages$View$Tristate$toError, model, error),
						$elm$core$Platform$Cmd$none);
				},
				function (isSuccess) {
					return isSuccess ? _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Ports$doDeleteToken(0),
									$elm$browser$Browser$Navigation$load(
									$author$project$Pages$Util$Links$frontendPage(
										$author$project$Addresses$Frontend$login.gh(0)))
								]))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				},
				result);
		};
		var gotFetchUserResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (user) {
						return A2(
							$author$project$Pages$View$Tristate$fromInitToMain,
							$author$project$Pages$Settings$Page$initialToMain,
							A2(
								$author$project$Pages$View$Tristate$mapInitial,
								$author$project$Pages$Settings$Page$lenses.hx.jK.f$(
									$elm$core$Maybe$Just(user)),
								model));
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var displayNameLens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$ComplementInput$lenses.du, $author$project$Pages$Settings$Page$lenses.hM.fc);
		var gotUpdateSettingsResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (user) {
						return A2(
							$author$project$Pages$View$Tristate$mapMain,
							A2(
								$elm$core$Basics$composeR,
								displayNameLens.f$($elm$core$Maybe$Nothing),
								$author$project$Pages$Settings$Page$lenses.hM.jK.f$(user)),
							model);
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var updateSettings = _Utils_Tuple2(
			model,
			A3(
				$author$project$Pages$View$Tristate$foldMain,
				$elm$core$Platform$Cmd$none,
				function (main) {
					return A3(
						$author$project$Types$User$Update$updateWith,
						$author$project$Pages$Settings$Page$GotUpdateSettingsResponse,
						{m: model.m, am: main.am},
						$author$project$Types$User$Update$ClientInput(
							displayNameLens.dy(main)));
				},
				model));
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return gotFetchUserResponse(result);
			case 1:
				return updatePassword;
			case 2:
				var result = msg.a;
				return gotUpdatePasswordResponse(result);
			case 3:
				return updateSettings;
			case 4:
				var result = msg.a;
				return gotUpdateSettingsResponse(result);
			case 5:
				return requestDeletion;
			case 6:
				var result = msg.a;
				return gotRequestDeletionResponse(result);
			case 7:
				var complementInput = msg.a;
				return setComplementInput(complementInput);
			case 8:
				var logoutMode = msg.a;
				return logout(logoutMode);
			default:
				var result = msg.a;
				return gotLogoutResponse(result);
		}
	});
var $author$project$Pages$Settings$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Settings$Handler$updateLogic);
var $author$project$Pages$Statistics$Page$GotFetchUpdatedStatisticsResponse = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Pages$Statistics$Page$GotSaveEditTaskResponse = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Math$Natural$integerValue = function (_v0) {
	var _int = _v0;
	return _int;
};
var $cmditch$elm_bigint$BigInt$lt = F2(
	function (x, y) {
		return !A2($cmditch$elm_bigint$BigInt$compare, x, y);
	});
var $cmditch$elm_bigint$BigInt$gte = F2(
	function (x, y) {
		return !A2($cmditch$elm_bigint$BigInt$lt, x, y);
	});
var $cmditch$elm_bigint$BigInt$lte = F2(
	function (x, y) {
		return !A2($cmditch$elm_bigint$BigInt$gt, x, y);
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Util$ValidatedInput$partialInt = function (str) {
	var tailCorrect = A2(
		$elm$core$String$all,
		$elm$core$Char$isDigit,
		A2($elm$core$String$dropLeft, 1, str));
	var headCorrect = A2(
		$elm$core$List$all,
		function (c) {
			return (c === '-') || $elm$core$Char$isDigit(c);
		},
		A2(
			$elm$core$List$take,
			1,
			$elm$core$String$toList(str)));
	return headCorrect && tailCorrect;
};
var $author$project$Util$ValidatedInput$maybeBoundedBigInt = function (bounds) {
	return {
		ci: $elm$core$Maybe$Nothing,
		a6: function (str) {
			return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok($elm$core$Maybe$Nothing) : A2(
				$elm$core$Result$map,
				$elm$core$Maybe$Just,
				A2(
					$elm$core$Result$fromMaybe,
					'Error: Not an integer in the range between ' + ($cmditch$elm_bigint$BigInt$toString(bounds.lD) + (' and ' + $cmditch$elm_bigint$BigInt$toString(bounds.m9))),
					A2(
						$elm_community$maybe_extra$Maybe$Extra$filter,
						function (_int) {
							return A2($cmditch$elm_bigint$BigInt$gte, _int, bounds.lD) && A2($cmditch$elm_bigint$BigInt$lte, _int, bounds.m9);
						},
						$cmditch$elm_bigint$BigInt$fromIntString(str))));
		},
		bP: $author$project$Util$ValidatedInput$partialInt,
		jp: '',
		nc: $elm$core$Maybe$Nothing
	};
};
var $cmditch$elm_bigint$BigInt$negate = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return $cmditch$elm_bigint$BigInt$Zer;
		case 0:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Neg(mag);
		default:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Pos(mag);
	}
};
var $author$project$Util$ValidatedInput$set = F2(
	function (ps, input) {
		return A2(
			$author$project$Util$ValidatedInput$lenses.jp.f$,
			ps.eR(ps.nc),
			A2($author$project$Util$ValidatedInput$lenses.nc.f$, ps.nc, input));
	});
var $cmditch$elm_bigint$BigInt$sumLonger = F2(
	function (xs, ys) {
		var _v0 = _Utils_Tuple2(xs, ys);
		if (!_v0.a.b) {
			if (!_v0.b.b) {
				return _List_Nil;
			} else {
				return ys;
			}
		} else {
			if (!_v0.b.b) {
				return xs;
			} else {
				var _v1 = _v0.a;
				var x = _v1.a;
				var xs_ = _v1.b;
				var _v2 = _v0.b;
				var y = _v2.a;
				var ys_ = _v2.b;
				return A2(
					$elm$core$List$cons,
					x + y,
					A2($cmditch$elm_bigint$BigInt$sumLonger, xs_, ys_));
			}
		}
	});
var $cmditch$elm_bigint$BigInt$add = F2(
	function (a, b) {
		var magnitudeMaybeNegated = function (bigInt) {
			switch (bigInt.$) {
				case 2:
					return _List_Nil;
				case 1:
					var digits = bigInt.a;
					return A2($elm$core$List$map, $elm$core$Basics$negate, digits);
				default:
					var digits = bigInt.a;
					return digits;
			}
		};
		var mb = magnitudeMaybeNegated(b);
		var ma = magnitudeMaybeNegated(a);
		var added = A2($cmditch$elm_bigint$BigInt$sumLonger, ma, mb);
		return $cmditch$elm_bigint$BigInt$normalise(
			A2($cmditch$elm_bigint$BigInt$BigIntNotNormalised, 0, added));
	});
var $cmditch$elm_bigint$BigInt$sub = F2(
	function (a, b) {
		return A2(
			$cmditch$elm_bigint$BigInt$add,
			a,
			$cmditch$elm_bigint$BigInt$negate(b));
	});
var $author$project$Types$Simulation$Update$from = function (ps) {
	var maybeModifier = A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.cB;
		},
		ps.i5);
	return {
		cB: A2(
			$author$project$Util$ValidatedInput$set,
			{
				eR: A2($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $cmditch$elm_bigint$BigInt$toString),
				nc: maybeModifier
			},
			$author$project$Util$ValidatedInput$maybeBoundedBigInt(
				{
					lD: $cmditch$elm_bigint$BigInt$negate(
						$author$project$Math$Natural$integerValue(ps.iw.ai)),
					m9: function (p) {
						return A2(
							$cmditch$elm_bigint$BigInt$sub,
							$author$project$Math$Positive$integerValue(p.ah),
							$author$project$Math$Natural$integerValue(p.ai));
					}(ps.iw)
				}))
	};
};
var $elm_community$result_extra$Result$Extra$filter = F3(
	function (err, predicate, result) {
		var _v0 = A2($elm$core$Result$map, predicate, result);
		if (!_v0.$) {
			if (_v0.a) {
				return result;
			} else {
				return $elm$core$Result$Err(err);
			}
		} else {
			return result;
		}
	});
var $author$project$Math$Natural$fromString = A2(
	$elm$core$Basics$composeR,
	$cmditch$elm_bigint$BigInt$fromIntString,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Result$fromMaybe('Not a representation of a natural number'),
		A2(
			$elm$core$Basics$composeR,
			A2(
				$elm_community$result_extra$Result$Extra$filter,
				'Not a non-negative number',
				function (x) {
					return A2(
						$cmditch$elm_bigint$BigInt$gte,
						x,
						$cmditch$elm_bigint$BigInt$fromInt(0));
				}),
			$elm$core$Result$map($elm$core$Basics$identity))));
var $author$project$Math$Natural$min = F2(
	function (x, y) {
		return A2(
			$cmditch$elm_bigint$BigInt$lte,
			$author$project$Math$Natural$integerValue(x),
			$author$project$Math$Natural$integerValue(y)) ? x : y;
	});
var $author$project$Math$Natural$toString = A2($elm$core$Basics$composeR, $author$project$Math$Natural$integerValue, $cmditch$elm_bigint$BigInt$toString);
var $author$project$Util$ValidatedInput$boundedNaturalParser = function (n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Math$Natural$fromString,
		A2(
			$elm_community$result_extra$Result$Extra$filter,
			$elm$core$String$concat(
				_List_fromArray(
					[
						'The number is larger than the bound \'',
						$author$project$Math$Natural$toString(n),
						'\''
					])),
			function (k) {
				return _Utils_eq(
					A2($author$project$Math$Natural$min, k, n),
					k);
			}));
};
var $elm_community$result_extra$Result$Extra$isOk = function (x) {
	if (!x.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Util$ValidatedInput$naturalWithParser = function (parser) {
	return {
		ci: $author$project$Math$Natural$zero,
		a6: parser,
		bP: A2($elm$core$Basics$composeR, parser, $elm_community$result_extra$Result$Extra$isOk),
		jp: '0',
		nc: $author$project$Math$Natural$zero
	};
};
var $author$project$Util$ValidatedInput$boundedNatural = A2($elm$core$Basics$composeR, $author$project$Util$ValidatedInput$boundedNaturalParser, $author$project$Util$ValidatedInput$naturalWithParser);
var $author$project$Math$Natural$fromPositive = A2($elm$core$Basics$composeR, $author$project$Math$Positive$integerValue, $elm$core$Basics$identity);
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$core$String$any = _String_any;
var $elm$core$String$fromList = _String_fromList;
var $author$project$Math$Positive$fromString = A2(
	$elm$core$Basics$composeR,
	$cmditch$elm_bigint$BigInt$fromIntString,
	A2(
		$elm$core$Basics$composeR,
		$elm_community$maybe_extra$Maybe$Extra$filter(
			function (x) {
				return A2($cmditch$elm_bigint$BigInt$gt, x, $author$project$Math$Constants$zeroBigInt);
			}),
		$elm$core$Maybe$map($elm$core$Basics$identity)));
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Util$ValidatedInput$positive = function () {
	var one = $author$project$Math$Positive$one;
	var parsePositive = function (str) {
		return A2(
			$elm$core$Result$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$toList,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$fromList,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Math$Positive$fromString,
						$elm$core$Result$fromMaybe('Not a positive number')))),
			$elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(
				$author$project$Math$Positive$toString(one)) : ((A2($elm$core$String$all, $elm$core$Char$isDigit, str) && A2(
				$elm$core$String$any,
				$elm$core$Basics$neq('0'),
				str)) ? $elm$core$Result$Ok(str) : $elm$core$Result$Err('The string does not represent a natural number')));
	};
	return {
		ci: one,
		a6: parsePositive,
		bP: A2(
			$elm$core$Basics$composeR,
			parsePositive,
			A2($elm$core$Basics$composeR, $elm$core$Result$toMaybe, $elm_community$maybe_extra$Maybe$Extra$isJust)),
		jp: '1',
		nc: one
	};
}();
var $author$project$Types$Progress$Input$from = function (progress) {
	return {
		ah: A2(
			$author$project$Util$ValidatedInput$lenses.jp.f$,
			$author$project$Math$Positive$toString(progress.ah),
			A2($author$project$Util$ValidatedInput$lenses.nc.f$, progress.ah, $author$project$Util$ValidatedInput$positive)),
		ai: A2(
			$author$project$Util$ValidatedInput$lenses.jp.f$,
			$author$project$Math$Natural$toString(progress.ai),
			A2(
				$author$project$Util$ValidatedInput$lenses.nc.f$,
				progress.ai,
				$author$project$Util$ValidatedInput$boundedNatural(
					$author$project$Math$Natural$fromPositive(progress.ah))))
	};
};
var $author$project$Types$Task$Update$from = function (task) {
	return {
		dk: task.dk,
		hV: A2(
			$author$project$Util$ValidatedInput$lenses.jp.f$,
			task.hV,
			A2($author$project$Util$ValidatedInput$lenses.nc.f$, task.hV, $author$project$Util$ValidatedInput$nonEmptyString)),
		cA: $author$project$Types$Progress$Input$from(task.iw),
		jl: task.jl,
		jF: task.jF
	};
};
var $author$project$Types$Task$TaskWithSimulation$from = function (resolved) {
	return {
		i5: $author$project$Types$Simulation$Update$from(
			{iw: resolved.eM.iw, i5: resolved.i5}),
		ak: $author$project$Types$Task$Update$from(resolved.eM)
	};
};
var $author$project$Pages$Statistics$Page$Counting = 1;
var $author$project$Pages$Statistics$Pagination$initial = {eh: $author$project$Pages$Util$PaginationSettings$initial};
var $author$project$Types$Task$Id$uuid = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Types$Task$Id$ordering = $author$project$Util$Ordering$with(
	A2($elm$core$Basics$composeR, $author$project$Types$Task$Id$uuid, $author$project$Util$GraphQLUtil$uuidToString));
var $author$project$Pages$Statistics$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$map,
		function (dashboardAnalysis) {
			return {
				ff: dashboardAnalysis.ff,
				kC: dashboardAnalysis.kC,
				am: i.am,
				cp: i.cp,
				$8: $author$project$Pages$Statistics$Pagination$initial,
				eh: A3(
					$author$project$Util$DictList$fromListWithKey,
					$author$project$Types$Project$Id$ordering,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.eg;
						},
						function ($) {
							return $.lf;
						}),
					A2(
						$elm$core$List$map,
						function (resolvedProject) {
							return {
								eg: resolvedProject.eg,
								jn: A3(
									$author$project$Util$DictList$fromListWithKey,
									$author$project$Types$Task$Id$ordering,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.ic;
										},
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.eM;
											},
											function ($) {
												return $.lf;
											})),
									A2($elm$core$List$map, $author$project$Util$Editing$asView, resolvedProject.jn))
							};
						},
						dashboardAnalysis.mj)),
				cD: '',
				nh: 1
			};
		},
		i.kA);
};
var $author$project$Pages$Statistics$Page$lenses = {
	hx: {
		kA: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.kA;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{kA: b});
				}))
	},
	hM: {
		ff: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ff;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ff: b});
				})),
		kC: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.kC;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{kC: b});
				})),
		$8: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.$8;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{$8: b});
				})),
		eh: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.eh;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{eh: b});
				})),
		cD: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.cD;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{cD: b});
				})),
		nh: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.nh;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{nh: b});
				}))
	}
};
var $author$project$Pages$Statistics$Pagination$lenses = {
	eh: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.eh;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{eh: b});
			}))
};
var $author$project$Pages$Statistics$EditingResolvedProject$lenses = {
	eg: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.eg;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{eg: b});
			})),
	jn: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.jn;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{jn: b});
			}))
};
var $author$project$Pages$Statistics$Handler$updateTaskById = F2(
	function (projectId, taskId) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Util$LensUtil$updateById, taskId, $author$project$Pages$Statistics$EditingResolvedProject$lenses.jn),
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Util$LensUtil$updateById, projectId, $author$project$Pages$Statistics$Page$lenses.hM.eh),
				$author$project$Pages$View$Tristate$mapMain));
	});
var $author$project$LondoGQL$InputObject$SimulationInput = function (reachedModifier) {
	return {cB: reachedModifier};
};
var $author$project$Util$GraphQLUtil$bigIntToGraphQL = A2($elm$core$Basics$composeR, $cmditch$elm_bigint$BigInt$toString, $elm$core$Basics$identity);
var $author$project$Types$Simulation$Update$toGraphQLInput = function (input) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeR, $author$project$Util$GraphQLUtil$bigIntToGraphQL, $author$project$LondoGQL$InputObject$SimulationInput),
		input.cB.nc);
};
var $author$project$LondoGQL$InputObject$TaskIdInput = function (uuid) {
	return {o: uuid};
};
var $author$project$Types$Task$Id$toGraphQLInput = A2($elm$core$Basics$composeR, $author$project$Types$Task$Id$uuid, $author$project$LondoGQL$InputObject$TaskIdInput);
var $author$project$LondoGQL$InputObject$NaturalInput = function (nonNegative) {
	return {cv: nonNegative};
};
var $author$project$Math$Natural$toGraphQLInput = A2(
	$elm$core$Basics$composeR,
	$author$project$Math$Natural$toString,
	A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$LondoGQL$InputObject$NaturalInput));
var $author$project$Types$Progress$Input$toGraphQLInput = function (clientInput) {
	return {
		ah: $author$project$Math$Positive$toGraphQLInput(clientInput.ah.nc),
		ai: $author$project$Math$Natural$toGraphQLInput(clientInput.ai.nc)
	};
};
var $author$project$Types$Task$Update$toGraphQLInput = function (clientInput) {
	return {
		dk: clientInput.dk,
		hV: clientInput.hV.nc,
		cA: $author$project$Types$Progress$Input$toGraphQLInput(clientInput.cA),
		jl: clientInput.jl,
		jF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(clientInput.jF)
	};
};
var $author$project$LondoGQL$InputObject$encodeSimulationInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'reachedModifier',
				$elm$core$Maybe$Just(
					A2(
						$author$project$LondoGQL$Scalar$unwrapEncoder,
						function ($) {
							return $.fa;
						},
						$author$project$LondoGQL$ScalarCodecs$codecs)(input____.cB)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeTaskIdInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'uuid',
				$elm$core$Maybe$Just(
					A2(
						$author$project$LondoGQL$Scalar$unwrapEncoder,
						function ($) {
							return $.dj;
						},
						$author$project$LondoGQL$ScalarCodecs$codecs)(input____.o)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeNaturalInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nonNegative',
				$elm$core$Maybe$Just(
					A2(
						$author$project$LondoGQL$Scalar$unwrapEncoder,
						function ($) {
							return $.fa;
						},
						$author$project$LondoGQL$ScalarCodecs$codecs)(input____.cv)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeProgressUpdate = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'reached',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeNaturalInput(input____.ai))),
				_Utils_Tuple2(
				'reachable',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodePositiveInput(input____.ah)))
			]));
};
var $author$project$LondoGQL$Enum$TaskKind$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'Discrete';
		case 1:
			return 'Fraction';
		default:
			return 'Percent';
	}
};
var $author$project$LondoGQL$InputObject$encodeTaskUpdate = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.hV))),
				_Utils_Tuple2(
				'taskKind',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$LondoGQL$Enum$TaskKind$toString, input____.jl))),
				_Utils_Tuple2(
				'unit',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'counting',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.dk))),
				_Utils_Tuple2(
				'progressUpdate',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeProgressUpdate(input____.cA)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeUpdateTaskWithSimulationInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dashboardId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeDashboardIdInput(input____.c))),
				_Utils_Tuple2(
				'taskId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeTaskIdInput(input____.C))),
				_Utils_Tuple2(
				'taskUpdate',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeTaskUpdate(input____.ak))),
				_Utils_Tuple2(
				'simulation',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i5, $author$project$LondoGQL$InputObject$encodeSimulationInput)),
				_Utils_Tuple2(
				'numberOfTotalTasks',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bK, $author$project$LondoGQL$InputObject$encodePositiveInput)),
				_Utils_Tuple2(
				'numberOfCountingTasks',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bJ, $author$project$LondoGQL$InputObject$encodePositiveInput)),
				_Utils_Tuple2(
				'numberOfDecimalPlaces',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodePositiveInput(input____.ae)))
			]));
};
var $author$project$LondoGQL$Mutation$updateTaskWithSimulation = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'updateTaskWithSimulation',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeUpdateTaskWithSimulationInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Types$Task$TaskWithSimulation$updateWith = F4(
	function (expect, authorizedAccess, complement, update) {
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect,
			authorizedAccess,
			A2(
				$author$project$LondoGQL$Mutation$updateTaskWithSimulation,
				{
					b: {
						c: $author$project$Types$Dashboard$Id$toGraphQLInput(complement.c),
						bJ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
							A2($elm$core$Maybe$map, $author$project$Math$Positive$toGraphQLInput, complement.bJ)),
						ae: $author$project$Math$Positive$toGraphQLInput(complement.ae),
						bK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
							A2($elm$core$Maybe$map, $author$project$Math$Positive$toGraphQLInput, complement.bK)),
						i5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
							$author$project$Types$Simulation$Update$toGraphQLInput(update.i5)),
						C: $author$project$Types$Task$Id$toGraphQLInput(complement.C),
						ak: $author$project$Types$Task$Update$toGraphQLInput(update.ak)
					}
				},
				$author$project$Types$Task$Analysis$selection));
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Util$DictList$values = A2(
	$elm$core$Basics$composeR,
	$author$project$Util$DictList$toList,
	$elm$core$List$map($elm$core$Tuple$second));
var $author$project$Pages$Statistics$Handler$updateLogic = F2(
	function (msg, model) {
		var toggleControls = F2(
			function (projectId, taskId) {
				return _Utils_Tuple2(
					A4($author$project$Pages$Statistics$Handler$updateTaskById, projectId, taskId, $author$project$Util$Editing$toggleControls, model),
					$elm$core$Platform$Cmd$none);
			});
		var setViewType = function (viewType) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					$author$project$Pages$Statistics$Page$lenses.hM.nh.f$(viewType),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var setSearchString = function (string) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A2(
						$author$project$Pages$Util$PaginationSettings$setSearchStringAndReset,
						{
							mb: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Statistics$Pagination$lenses.eh, $author$project$Pages$Statistics$Page$lenses.hM.$8),
							mF: $author$project$Pages$Statistics$Page$lenses.hM.cD
						},
						string),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var setProjectsPagination = function (paginationSettings) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Statistics$Pagination$lenses.eh, $author$project$Pages$Statistics$Page$lenses.hM.$8).f$(paginationSettings),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var saveEditTask = F2(
			function (projectId, taskId) {
				return _Utils_Tuple2(
					model,
					A3(
						$author$project$Pages$View$Tristate$foldMain,
						$elm$core$Platform$Cmd$none,
						function (main) {
							var numberOf = function (filter) {
								return $author$project$Math$Positive$fromInt(
									$elm$core$List$length(
										A2(
											$elm$core$List$concatMap,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.jn;
												},
												A2($elm$core$Basics$composeR, $author$project$Util$DictList$values, filter)),
											$author$project$Util$DictList$values(
												$author$project$Pages$Statistics$Page$lenses.hM.eh.dy(main)))));
							};
							var numberOfCountingTasks = numberOf(
								$elm$core$List$filter(
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.ic;
										},
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.eM;
											},
											function ($) {
												return $.dk;
											}))));
							var numberOfTotalTasks = numberOf($elm$core$Basics$identity);
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$core$Platform$Cmd$none,
								A3(
									$author$project$Types$Task$TaskWithSimulation$updateWith,
									$author$project$Pages$Statistics$Page$GotSaveEditTaskResponse(projectId),
									{m: model.m, am: main.am},
									{c: main.ff.lf, bJ: numberOfCountingTasks, ae: $author$project$Pages$Statistics$Page$numberOfDecimalPlaces, bK: numberOfTotalTasks, C: taskId}),
								A2(
									$elm$core$Maybe$andThen,
									$author$project$Util$Editing$extractUpdate,
									A2(
										$elm$core$Maybe$andThen,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.jn;
											},
											$author$project$Util$DictList$get(taskId)),
										A2(
											$author$project$Util$DictList$get,
											projectId,
											$author$project$Pages$Statistics$Page$lenses.hM.eh.dy(main)))));
						},
						model));
			});
		var gotSaveEditTaskResponse = F2(
			function (projectId, result) {
				return A3(
					$elm_community$result_extra$Result$Extra$unpack,
					function (error) {
						return _Utils_Tuple2(
							A2($author$project$Pages$View$Tristate$toError, model, error),
							$elm$core$Platform$Cmd$none);
					},
					function (resolvedTask) {
						return _Utils_Tuple2(
							model,
							A3(
								$author$project$Pages$View$Tristate$foldMain,
								$elm$core$Platform$Cmd$none,
								function (main) {
									return A4(
										$author$project$Types$Dashboard$Analysis$fetchWithSelection,
										{
											k2: A2($author$project$Pages$Statistics$Page$GotFetchUpdatedStatisticsResponse, projectId, resolvedTask),
											mG: $author$project$Types$Dashboard$Analysis$statisticsSelection
										},
										{m: model.m, am: main.am},
										main.ff.lf,
										$author$project$Pages$Statistics$Page$numberOfDecimalPlaces);
								},
								model));
					},
					result);
			});
		var gotFetchUpdatedStatisticsResponse = F3(
			function (projectId, taskAnalysis, result) {
				return _Utils_Tuple2(
					A3(
						$elm_community$result_extra$Result$Extra$unpack,
						$author$project$Pages$View$Tristate$toError(model),
						function (dashboardStatistics) {
							return A2(
								$author$project$Pages$View$Tristate$mapMain,
								$author$project$Pages$Statistics$Page$lenses.hM.kC.f$(dashboardStatistics),
								A4(
									$author$project$Pages$Statistics$Handler$updateTaskById,
									projectId,
									taskAnalysis.eM.lf,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Util$Editing$asViewWithElement(
											{hw: taskAnalysis.hw, i5: taskAnalysis.i5, eM: taskAnalysis.eM}),
										$author$project$Util$Editing$toggleControls),
									model));
						},
						result),
					$elm$core$Platform$Cmd$none);
			});
		var gotFetchDashboardAnalysisResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (dashboardAnalysis) {
						return A2(
							$author$project$Pages$View$Tristate$fromInitToMain,
							$author$project$Pages$Statistics$Page$initialToMain,
							A2(
								$author$project$Pages$View$Tristate$mapInitial,
								$author$project$Pages$Statistics$Page$lenses.hx.kA.f$(
									$elm$core$Maybe$Just(dashboardAnalysis)),
								model));
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		var exitEditTask = F2(
			function (projectId, taskId) {
				return _Utils_Tuple2(
					A4($author$project$Pages$Statistics$Handler$updateTaskById, projectId, taskId, $author$project$Util$Editing$toView, model),
					$elm$core$Platform$Cmd$none);
			});
		var enterEditTask = F2(
			function (projectId, taskId) {
				return _Utils_Tuple2(
					A4(
						$author$project$Pages$Statistics$Handler$updateTaskById,
						projectId,
						taskId,
						$author$project$Util$Editing$toUpdate($author$project$Types$Task$TaskWithSimulation$from),
						model),
					$elm$core$Platform$Cmd$none);
			});
		var editTask = F3(
			function (projectId, taskId, taskUpdate) {
				return _Utils_Tuple2(
					A4(
						$author$project$Pages$Statistics$Handler$updateTaskById,
						projectId,
						taskId,
						$author$project$Util$Editing$lenses.m5.f$(taskUpdate),
						model),
					$elm$core$Platform$Cmd$none);
			});
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return gotFetchDashboardAnalysisResponse(result);
			case 1:
				var projectId = msg.a;
				var taskId = msg.b;
				var taskUpdate = msg.c;
				return A3(editTask, projectId, taskId, taskUpdate);
			case 2:
				var projectId = msg.a;
				var taskId = msg.b;
				return A2(saveEditTask, projectId, taskId);
			case 3:
				var projectId = msg.a;
				var result = msg.b;
				return A2(gotSaveEditTaskResponse, projectId, result);
			case 4:
				var projectId = msg.a;
				var taskAnalysis = msg.b;
				var result = msg.c;
				return A3(gotFetchUpdatedStatisticsResponse, projectId, taskAnalysis, result);
			case 5:
				var projectId = msg.a;
				var taskId = msg.b;
				return A2(toggleControls, projectId, taskId);
			case 6:
				var projectId = msg.a;
				var taskId = msg.b;
				return A2(enterEditTask, projectId, taskId);
			case 7:
				var projectId = msg.a;
				var taskId = msg.b;
				return A2(exitEditTask, projectId, taskId);
			case 8:
				var pagination = msg.a;
				return setProjectsPagination(pagination);
			case 9:
				var string = msg.a;
				return setSearchString(string);
			default:
				var viewType = msg.a;
				return setViewType(viewType);
		}
	});
var $author$project$Pages$Statistics$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Statistics$Handler$updateLogic);
var $author$project$Pages$Statistics$Public$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$map,
		function (dashboardAnalysis) {
			return {
				ff: dashboardAnalysis.ff,
				kC: dashboardAnalysis.kC,
				cp: i.cp,
				$8: $author$project$Pages$Statistics$Pagination$initial,
				eh: A3(
					$author$project$Util$DictList$fromListWithKey,
					$author$project$Types$Project$Id$ordering,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.eg;
						},
						function ($) {
							return $.lf;
						}),
					dashboardAnalysis.mj),
				cD: '',
				nh: 1
			};
		},
		i.kA);
};
var $author$project$Pages$Statistics$Public$Page$lenses = {
	hx: {
		kA: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.kA;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{kA: b});
				}))
	},
	hM: {
		ff: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.ff;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{ff: b});
				})),
		kC: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.kC;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{kC: b});
				})),
		$8: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.$8;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{$8: b});
				})),
		eh: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.eh;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{eh: b});
				})),
		cD: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.cD;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{cD: b});
				})),
		nh: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.nh;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{nh: b});
				}))
	}
};
var $author$project$Pages$Statistics$Public$Handler$updateLogic = F2(
	function (msg, model) {
		var setViewType = function (viewType) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					$author$project$Pages$Statistics$Public$Page$lenses.hM.nh.f$(viewType),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var setSearchString = function (string) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A2(
						$author$project$Pages$Util$PaginationSettings$setSearchStringAndReset,
						{
							mb: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Statistics$Pagination$lenses.eh, $author$project$Pages$Statistics$Public$Page$lenses.hM.$8),
							mF: $author$project$Pages$Statistics$Public$Page$lenses.hM.cD
						},
						string),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var setProjectsPagination = function (paginationSettings) {
			return _Utils_Tuple2(
				A2(
					$author$project$Pages$View$Tristate$mapMain,
					A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Statistics$Pagination$lenses.eh, $author$project$Pages$Statistics$Public$Page$lenses.hM.$8).f$(paginationSettings),
					model),
				$elm$core$Platform$Cmd$none);
		};
		var gotFetchDashboardAnalysisResponse = function (result) {
			return _Utils_Tuple2(
				A3(
					$elm_community$result_extra$Result$Extra$unpack,
					$author$project$Pages$View$Tristate$toError(model),
					function (dashboardAnalysis) {
						return A2(
							$author$project$Pages$View$Tristate$fromInitToMain,
							$author$project$Pages$Statistics$Public$Page$initialToMain,
							A2(
								$author$project$Pages$View$Tristate$mapInitial,
								$author$project$Pages$Statistics$Public$Page$lenses.hx.kA.f$(
									$elm$core$Maybe$Just(dashboardAnalysis)),
								model));
					},
					result),
				$elm$core$Platform$Cmd$none);
		};
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return gotFetchDashboardAnalysisResponse(result);
			case 1:
				var pagination = msg.a;
				return setProjectsPagination(pagination);
			case 2:
				var string = msg.a;
				return setSearchString(string);
			default:
				var viewType = msg.a;
				return setViewType(viewType);
		}
	});
var $author$project$Pages$Statistics$Public$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Statistics$Public$Handler$updateLogic);
var $author$project$Pages$Tasks$Page$ProjectMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Tasks$Page$TasksMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Tasks$Page$initialToMain = function (i) {
	return A2(
		$elm$core$Maybe$andThen,
		function (project) {
			return A2(
				$elm$core$Maybe$map,
				function (tasks) {
					return {eg: project, jn: tasks};
				},
				$author$project$Pages$Util$ParentEditor$Page$initialToMain(i.jn));
		},
		$author$project$Pages$Util$Parent$Page$initialToMain(i.eg));
};
var $author$project$Pages$Tasks$Page$lenses = {
	hx: {
		eg: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.eg;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{eg: b});
				})),
		jn: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jn;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jn: b});
				}))
	},
	hM: {
		eg: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.eg;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{eg: b});
				})),
		jn: A2(
			$arturopala$elm_monocle$Monocle$Lens$Lens,
			function ($) {
				return $.jn;
			},
			F2(
				function (b, a) {
					return _Utils_update(
						a,
						{jn: b});
				}))
	}
};
var $author$project$Pages$Tasks$Project$Handler$updateLogic = $author$project$Pages$Util$Parent$Handler$updateLogic(
	{
		Z: $author$project$Types$Project$Project$deleteWith(
			function (_v0) {
				return $author$project$Pages$Util$Parent$Page$GotDeleteResponse;
			}),
		lg: function ($) {
			return $.lf;
		},
		lP: $author$project$Addresses$Frontend$projects.gh,
		aO: F2(
			function (authorizedAccess, projectId) {
				return A2(
					$elm$core$Basics$composeR,
					A3($author$project$Types$Project$Update$updateWith, $author$project$Pages$Util$Parent$Page$GotSaveEditResponse, authorizedAccess, projectId),
					$elm$core$Maybe$Just);
			}),
		m3: $author$project$Types$Project$Update$from
	});
var $author$project$LondoGQL$InputObject$encodeProgressInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'reached',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeNaturalInput(input____.ai))),
				_Utils_Tuple2(
				'reachable',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodePositiveInput(input____.ah)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeTaskCreation = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.hV))),
				_Utils_Tuple2(
				'taskKind',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$LondoGQL$Enum$TaskKind$toString, input____.jl))),
				_Utils_Tuple2(
				'unit',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'progress',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeProgressInput(input____.iw))),
				_Utils_Tuple2(
				'counting',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.dk)))
			]));
};
var $author$project$LondoGQL$InputObject$encodeCreateTaskInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'projectId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeProjectIdInput(input____.f))),
				_Utils_Tuple2(
				'taskCreation',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeTaskCreation(input____.cH)))
			]));
};
var $author$project$LondoGQL$Mutation$createTask = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'createTask',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeCreateTaskInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Types$Task$Creation$toGraphQLInput = function (clientInput) {
	return {
		dk: clientInput.dk,
		hV: clientInput.hV.nc,
		iw: $author$project$Types$Progress$Input$toGraphQLInput(clientInput.iw),
		jl: clientInput.jl,
		jF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(clientInput.jF)
	};
};
var $author$project$Types$Task$Creation$createWith = F3(
	function (expect, authorizedAccess, creation) {
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect,
			authorizedAccess,
			A2(
				$author$project$LondoGQL$Mutation$createTask,
				{
					b: {
						f: $author$project$Types$Project$Id$toGraphQLInput(creation.f),
						cH: $author$project$Types$Task$Creation$toGraphQLInput(creation)
					}
				},
				$author$project$Types$Task$Task$selection));
	});
var $author$project$LondoGQL$InputObject$encodeDeleteTaskInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'taskId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeTaskIdInput(input____.C)))
			]));
};
var $author$project$LondoGQL$Mutation$deleteTask = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'deleteTask',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeDeleteTaskInput)
			]),
		$elm$json$Json$Decode$bool);
};
var $author$project$Types$Task$Task$deleteWith = F3(
	function (expect, authorizedAccess, taskId) {
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect(taskId),
			authorizedAccess,
			$author$project$LondoGQL$Mutation$deleteTask(
				{
					b: {
						C: $author$project$Types$Task$Id$toGraphQLInput(taskId)
					}
				}));
	});
var $author$project$LondoGQL$InputObject$encodeUpdateTaskInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'taskId',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeTaskIdInput(input____.C))),
				_Utils_Tuple2(
				'taskUpdate',
				$elm$core$Maybe$Just(
					$author$project$LondoGQL$InputObject$encodeTaskUpdate(input____.ak)))
			]));
};
var $author$project$LondoGQL$Mutation$updateTask = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'updateTask',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.b, $author$project$LondoGQL$InputObject$encodeUpdateTaskInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Types$Task$Update$updateWith = F4(
	function (expect, authorizedAccess, taskId, update) {
		return A3(
			$author$project$Util$HttpUtil$mutationWith,
			expect,
			authorizedAccess,
			A2(
				$author$project$LondoGQL$Mutation$updateTask,
				{
					b: {
						C: $author$project$Types$Task$Id$toGraphQLInput(taskId),
						ak: $author$project$Types$Task$Update$toGraphQLInput(update)
					}
				},
				$author$project$Types$Task$Task$selection));
	});
var $author$project$Pages$Tasks$Tasks$Handler$updateLogic = $author$project$Pages$Util$ParentEditor$Handler$updateLogic(
	{
		br: $author$project$Types$Task$Creation$createWith($author$project$Pages$Util$ParentEditor$Page$GotCreateResponse),
		Z: $author$project$Types$Task$Task$deleteWith($author$project$Pages$Util$ParentEditor$Page$GotDeleteResponse),
		lj: function ($) {
			return $.lf;
		},
		lQ: function (_v0) {
			return $elm$core$Maybe$Nothing;
		},
		mf: $author$project$Types$Task$Id$ordering,
		aO: $author$project$Types$Task$Update$updateWith($author$project$Pages$Util$ParentEditor$Page$GotSaveEditResponse),
		m3: $author$project$Types$Task$Update$from
	});
var $author$project$Pages$Tasks$Handler$updateLogic = F2(
	function (msg, model) {
		var updateLogicTasks = $author$project$Pages$View$TristateUtil$updateFromSubModel(
			{hl: $author$project$Pages$Tasks$Page$initialToMain, hz: $author$project$Pages$Tasks$Page$lenses.hx.jn, hN: $author$project$Pages$Tasks$Page$lenses.hM.jn, js: $author$project$Pages$Tasks$Page$TasksMsg, jI: $author$project$Pages$Tasks$Tasks$Handler$updateLogic});
		var updateLogicProject = $author$project$Pages$View$TristateUtil$updateFromSubModel(
			{hl: $author$project$Pages$Tasks$Page$initialToMain, hz: $author$project$Pages$Tasks$Page$lenses.hx.eg, hN: $author$project$Pages$Tasks$Page$lenses.hM.eg, js: $author$project$Pages$Tasks$Page$ProjectMsg, jI: $author$project$Pages$Tasks$Project$Handler$updateLogic});
		var gotFetchResponse = function (result) {
			var newModel = A3(
				$elm_community$result_extra$Result$Extra$unpack,
				$author$project$Pages$View$Tristate$toError(model),
				function (resolved) {
					return A2(
						$author$project$Pages$View$Tristate$fromInitToMain,
						$author$project$Pages$Tasks$Page$initialToMain,
						A2(
							$author$project$Pages$View$Tristate$mapInitial,
							A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$ParentEditor$Page$lenses.hx.mg, $author$project$Pages$Tasks$Page$lenses.hx.jn).f$(
								$elm$core$Maybe$Just(
									A3(
										$author$project$Util$DictList$fromListWithKey,
										$author$project$Types$Task$Id$ordering,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.ic;
											},
											function ($) {
												return $.lf;
											}),
										A2($elm$core$List$map, $author$project$Util$Editing$asView, resolved.jn)))),
							A2(
								updateLogicProject,
								$author$project$Pages$Util$Parent$Page$GotFetchResponse(
									$elm$core$Result$Ok(resolved.eg)),
								model).a));
				},
				result);
			return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
		};
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return gotFetchResponse(result);
			case 1:
				var projectMsg = msg.a;
				return A2(updateLogicProject, projectMsg, model);
			default:
				var tasksMsg = msg.a;
				return A2(updateLogicTasks, tasksMsg, model);
		}
	});
var $author$project$Pages$Tasks$Handler$update = $author$project$Pages$View$Tristate$updateWith($author$project$Pages$Tasks$Handler$updateLogic);
var $author$project$Main$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.V);
		_v0$18:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var urlRequest = _v0.a.a;
					if (!urlRequest.$) {
						var url = urlRequest.a;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.fz,
								$elm$url$Url$toString(url)));
					} else {
						var href = urlRequest.a;
						return _Utils_Tuple2(
							model,
							$elm$browser$Browser$Navigation$load(href));
					}
				case 1:
					var url = _v0.a.a;
					return $author$project$Main$followRoute(
						A2(
							$author$project$Main$lenses.aZ.f$,
							$author$project$Main$parsePage(url),
							model));
				case 2:
					var token = _v0.a.a;
					return $author$project$Main$followRoute(
						A2(
							$author$project$Main$lenses.am.f$,
							A2(
								$elm_community$maybe_extra$Maybe$Extra$filter,
								A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
								$elm$core$Maybe$Just(token)),
							model));
				case 3:
					return _Utils_Tuple2(
						A2($author$project$Main$lenses.am.f$, $elm$core$Maybe$Nothing, model),
						$elm$core$Platform$Cmd$none);
				case 4:
					if (!_v0.b.$) {
						var requestRegistrationMsg = _v0.a.a;
						var requestRegistration = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.iO,
							model,
							A2($author$project$Pages$Registration$Request$Handler$update, requestRegistrationMsg, requestRegistration));
					} else {
						break _v0$18;
					}
				case 5:
					if (_v0.b.$ === 1) {
						var confirmRegistrationMsg = _v0.a.a;
						var confirmRegistration = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.gG,
							model,
							A2($author$project$Pages$Registration$Confirm$Handler$update, confirmRegistrationMsg, confirmRegistration));
					} else {
						break _v0$18;
					}
				case 6:
					if (_v0.b.$ === 2) {
						var loginMsg = _v0.a.a;
						var login = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.bH,
							model,
							A2($author$project$Pages$Login$Handler$update, loginMsg, login));
					} else {
						break _v0$18;
					}
				case 7:
					if (_v0.b.$ === 3) {
						var overviewMsg = _v0.a.a;
						var overview = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.id,
							model,
							A2($author$project$Pages$Overview$Handler$update, overviewMsg, overview));
					} else {
						break _v0$18;
					}
				case 8:
					if (_v0.b.$ === 4) {
						var projectsMsg = _v0.a.a;
						var projects = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eh,
							model,
							A2($author$project$Pages$Projects$Handler$update, projectsMsg, projects));
					} else {
						break _v0$18;
					}
				case 9:
					if (_v0.b.$ === 5) {
						var tasksMsg = _v0.a.a;
						var tasks = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.jn,
							model,
							A2($author$project$Pages$Tasks$Handler$update, tasksMsg, tasks));
					} else {
						break _v0$18;
					}
				case 10:
					if (_v0.b.$ === 6) {
						var dashboardsMsg = _v0.a.a;
						var dashboards = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.gS,
							model,
							A2($author$project$Pages$Dashboards$Handler$update, dashboardsMsg, dashboards));
					} else {
						break _v0$18;
					}
				case 11:
					if (_v0.b.$ === 7) {
						var dashboardEntriesMsg = _v0.a.a;
						var dashboardEntries = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.gP,
							model,
							A2($author$project$Pages$DashboardEntries$Handler$update, dashboardEntriesMsg, dashboardEntries));
					} else {
						break _v0$18;
					}
				case 12:
					if (_v0.b.$ === 8) {
						var statisticsMsg = _v0.a.a;
						var statistics = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.eG,
							model,
							A2($author$project$Pages$Statistics$Handler$update, statisticsMsg, statistics));
					} else {
						break _v0$18;
					}
				case 13:
					if (_v0.b.$ === 9) {
						var publicStatisticsMsg = _v0.a.a;
						var publicStatistics = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.fV,
							model,
							A2($author$project$Pages$Statistics$Public$Handler$update, publicStatisticsMsg, publicStatistics));
					} else {
						break _v0$18;
					}
				case 14:
					if (_v0.b.$ === 10) {
						var settingsMsg = _v0.a.a;
						var settings = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.i0,
							model,
							A2($author$project$Pages$Settings$Handler$update, settingsMsg, settings));
					} else {
						break _v0$18;
					}
				case 15:
					if (_v0.b.$ === 11) {
						var confirmDeletionMsg = _v0.a.a;
						var confirmDeletion = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.gF,
							model,
							A2($author$project$Pages$Deletion$Handler$update, confirmDeletionMsg, confirmDeletion));
					} else {
						break _v0$18;
					}
				case 16:
					if (_v0.b.$ === 12) {
						var requestRecoveryMsg = _v0.a.a;
						var requestRecovery = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.f_,
							model,
							A2($author$project$Pages$Recovery$Request$Handler$update, requestRecoveryMsg, requestRecovery));
					} else {
						break _v0$18;
					}
				default:
					if (_v0.b.$ === 13) {
						var confirmRecoveryMsg = _v0.a.a;
						var confirmRecovery = _v0.b.a;
						return A3(
							$author$project$Main$stepThrough,
							$author$project$Main$steps.fd,
							model,
							A2($author$project$Pages$Recovery$Confirm$Handler$update, confirmRecoveryMsg, confirmRecovery));
					} else {
						break _v0$18;
					}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Pages$View$Tristate$HandleError = {$: 1};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$Pages$Util$Style$classes = {
	bi: $elm$html$Html$Attributes$class('add'),
	jX: $elm$html$Html$Attributes$class('add-element'),
	j_: $elm$html$Html$Attributes$class('add-view'),
	dc: {
		bi: $elm$html$Html$Attributes$class('add-button'),
		X: $elm$html$Html$Attributes$class('cancel-button'),
		kn: $elm$html$Html$Attributes$class('clear-button '),
		gD: $elm$html$Html$Attributes$class('confirm-button'),
		Z: $elm$html$Html$Attributes$class('delete-button'),
		aB: $elm$html$Html$Attributes$class('edit-button'),
		kR: $elm$html$Html$Attributes$class('editor-button'),
		hb: $elm$html$Html$Attributes$class('error-button'),
		lG: $elm$html$Html$Attributes$class('menu-button'),
		lR: $elm$html$Html$Attributes$class('navigation-button'),
		lS: $elm$html$Html$Attributes$class('new-element-button'),
		id: $elm$html$Html$Attributes$class('overview-button'),
		ma: $elm$html$Html$Attributes$class('pager-button'),
		i_: $elm$html$Html$Attributes$class('select-button')
	},
	kl: $elm$html$Html$Attributes$class('choices'),
	gH: $elm$html$Html$Attributes$class('controls'),
	kB: $elm$html$Html$Attributes$class('dashboard-edit-table'),
	kN: $elm$html$Html$Attributes$class('disabled'),
	g7: $elm$html$Html$Attributes$class('edit-line'),
	bs: $elm$html$Html$Attributes$class('editable'),
	kQ: $elm$html$Html$Attributes$class('editing'),
	kU: $elm$html$Html$Attributes$class('element-edit-table'),
	g9: $elm$html$Html$Attributes$class('elements'),
	kY: $elm$html$Html$Attributes$class('elements-with-controls-table'),
	kZ: $elm$html$Html$Attributes$class('ellipsis'),
	lo: $elm$html$Html$Attributes$class('info'),
	h8: $elm$html$Html$Attributes$class('number-cell'),
	dU: $elm$html$Html$Attributes$class('number-half-cell'),
	h9: $elm$html$Html$Attributes$class('number-label'),
	$8: $elm$html$Html$Attributes$class('pagination'),
	mk: $elm$html$Html$Attributes$class('project-edit-table'),
	mD: $elm$html$Html$Attributes$class('search-area'),
	cE: $elm$html$Html$Attributes$class('statistics-line'),
	mY: $elm$html$Html$Attributes$class('table-header'),
	m$: $elm$html$Html$Attributes$class('task-edit-table'),
	jt: $elm$html$Html$Attributes$class('toggle')
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Pages$Util$Style$ids = {
	ge: $elm$html$Html$Attributes$id('account-deletion'),
	gf: $elm$html$Html$Attributes$id('account-recovery'),
	jW: $elm$html$Html$Attributes$id('add-dashboard-view'),
	jY: $elm$html$Html$Attributes$id('add-project-view'),
	jZ: $elm$html$Html$Attributes$id('add-task-view'),
	gG: $elm$html$Html$Attributes$id('confirm-registration'),
	$7: $elm$html$Html$Attributes$id('dashboard-entry-editor'),
	hb: $elm$html$Html$Attributes$id('error'),
	bH: $elm$html$Html$Attributes$id('login'),
	lR: $elm$html$Html$Attributes$id('navigation'),
	id: $elm$html$Html$Attributes$id('overview'),
	mp: $elm$html$Html$Attributes$id('registration-request-sent'),
	iO: $elm$html$Html$Attributes$id('request-registration'),
	mE: $elm$html$Html$Attributes$id('search-field'),
	i0: $elm$html$Html$Attributes$id('settings'),
	eG: $elm$html$Html$Attributes$id('statistics'),
	bS: $elm$html$Html$Attributes$id('task-editor')
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $perzanko$elm_loading$Loading$On = 0;
var $perzanko$elm_loading$Loading$Spinner = 1;
var $perzanko$elm_loading$Loading$defaultConfig = {gz: '', gB: '#74b4c9', i6: 30, i9: 1};
var $elm$html$Html$div = _VirtualDom_node('div');
var $robinheghan$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {bp: charsProcessed, bz: hash, ba: seed, bQ: shift};
	});
var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
var $robinheghan$murmur3$Murmur3$c2 = 461845907;
var $robinheghan$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $robinheghan$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $robinheghan$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.bz)) ? (data.ba ^ A2(
		$robinheghan$murmur3$Murmur3$multiplyBy,
		$robinheghan$murmur3$Murmur3$c2,
		A2(
			$robinheghan$murmur3$Murmur3$rotlBy,
			15,
			A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, data.bz)))) : data.ba;
	var h0 = acc ^ data.bp;
	var h1 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $robinheghan$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$robinheghan$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$robinheghan$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$robinheghan$murmur3$Murmur3$multiplyBy,
					$robinheghan$murmur3$Murmur3$c2,
					A2(
						$robinheghan$murmur3$Murmur3$rotlBy,
						15,
						A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $robinheghan$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.bz | ((255 & $elm$core$Char$toCode(c)) << data.bQ);
		var _v0 = data.bQ;
		if (_v0 === 24) {
			return {
				bp: data.bp + 1,
				bz: 0,
				ba: A2($robinheghan$murmur3$Murmur3$mix, data.ba, res),
				bQ: 0
			};
		} else {
			return {bp: data.bp + 1, bz: res, ba: data.ba, bQ: data.bQ + 8};
		}
	});
var $robinheghan$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $robinheghan$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$robinheghan$murmur3$Murmur3$hashFold,
				A4($robinheghan$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$initialSeed = 15739;
var $elm$core$Basics$modBy = _Basics_modBy;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($robinheghan$murmur3$Murmur3$hashString, $rtfeldman$elm_css$Hash$initialSeed, str)));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				return styles;
			} else {
				return A3(
					$elm$core$Dict$insert,
					cssTemplate,
					$rtfeldman$elm_css$Hash$fromString(cssTemplate),
					styles);
			}
		} else {
			return styles;
		}
	});
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string(classname));
			} else {
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string('_unstyled'));
			}
		} else {
			return val;
		}
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', classname);
			} else {
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', '_unstyled');
			}
		} else {
			return val;
		}
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin = '\u0007';
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration = F3(
	function (template, classname, declaration) {
		return declaration + ('\n' + A3($elm$core$String$replace, $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, classname, template));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return A3($elm$core$Dict$foldl, $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration, '', dict);
};
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = F2(
	function (maybeNonce, styles) {
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			'span',
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'display: none;'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'elm-css-style-wrapper')
				]),
			_List_fromArray(
				[
					A3(
					$elm$virtual_dom$VirtualDom$node,
					'style',
					function () {
						if (!maybeNonce.$) {
							var nonce = maybeNonce.a;
							return _List_fromArray(
								[
									A2($elm$virtual_dom$VirtualDom$attribute, 'nonce', nonce)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					$elm$core$List$singleton(
						$elm$virtual_dom$VirtualDom$text(
							$rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))))
				]));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F4(
	function (maybeNonce, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, styles);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F3(
	function (maybeNonce, allStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, allStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F4(
	function (maybeNonce, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, maybeNonce, styles, keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F5(
	function (maybeNonce, ns, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, maybeNonce, styles, keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F5(
	function (maybeNonce, ns, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, styles);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyle, $elm$core$Maybe$Nothing, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, $elm$core$Maybe$Nothing, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Property = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			gc: 0,
			gs: 0,
			bw: 0,
			H: 0,
			s: 0,
			bE: 0,
			aG: 0,
			bF: 0,
			bG: 0,
			a2: 0,
			a3: 0,
			an: 0,
			aK: numericValue,
			bV: 0,
			bX: unitLabel,
			cM: units,
			nc: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$Preprocess$WithKeyframes = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.nc);
	});
var $rtfeldman$elm_css$Css$animationName = function (arg) {
	return ((arg.nc === 'none') || ((arg.nc === 'inherit') || ((arg.nc === 'unset') || (arg.nc === 'initial')))) ? A2($rtfeldman$elm_css$Css$prop1, 'animation-name', arg) : $rtfeldman$elm_css$Css$Preprocess$WithKeyframes(arg.nc);
};
var $rtfeldman$elm_css$Css$auto = {j$: 0, d: 0, bw: 0, dH: 0, lu: 0, bE: 0, aG: 0, an: 0, bO: 0, ag: 0, eL: 0, bW: 0, S: 0, nc: 'auto'};
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.nc);
};
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.kE) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.hV, record.kE, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{kE: decl, hV: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactDeclarations = function (declarations) {
	var _v0 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v0.a;
	var compactedDeclarations = _v0.b;
	return A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
};
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.gx;
	var imports = _v0.hv;
	var namespaces = _v0.hW;
	var declarations = _v0.kF;
	return {
		gx: charset,
		kF: $rtfeldman$elm_css$Css$Structure$compactDeclarations(declarations),
		hv: imports,
		hW: namespaces
	};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$String$mapJoinHelp = F4(
	function (map, sep, strs, result) {
		mapJoinHelp:
		while (true) {
			if (!strs.b) {
				return result;
			} else {
				if (!strs.b.b) {
					var first = strs.a;
					return result + (map(first) + '');
				} else {
					var first = strs.a;
					var rest = strs.b;
					var $temp$map = map,
						$temp$sep = sep,
						$temp$strs = rest,
						$temp$result = result + (map(first) + (sep + ''));
					map = $temp$map;
					sep = $temp$sep;
					strs = $temp$strs;
					result = $temp$result;
					continue mapJoinHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$Css$String$mapJoin = F3(
	function (map, sep, strs) {
		return A4($rtfeldman$elm_css$Css$String$mapJoinHelp, map, sep, strs, '');
	});
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.hg + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.nc)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, ' and ', expressions);
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
		'\n',
		mediaQueries);
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		function (_v0) {
			var prop = _v0;
			return prop + ';';
		},
		'',
		properties);
};
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors);
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return $rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator) + (' ' + $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement));
	return A2(
		$elm$core$String$append,
		A2($elm$core$String$join, ' ', segments),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = function (_v0) {
	var firstSelector = _v0.a;
	var otherSelectors = _v0.b;
	var properties = _v0.c;
	var selectorStr = A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
		',',
		A2($elm$core$List$cons, firstSelector, otherSelectors));
	return selectorStr + ('{' + ($rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties) + '}'));
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, ', ', mediaQueries);
			var blocks = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, '\n', styleBlocks);
			return '@media ' + (query + ('{' + (blocks + '}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.hV;
			var declaration = decl.a.kE;
			return '@keyframes ' + (name + ('{' + (declaration + '}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.gx;
	var imports = _v0.hv;
	var namespaces = _v0.hW;
	var declarations = _v0.kF;
	return $rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$importToString, '\n', imports) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, '\n', namespaces) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, '\n', declarations) + '')));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$PageRule(properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{kE: str, hV: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$PageRule(properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.gx;
	var imports = _v0.hv;
	var namespaces = _v0.hW;
	var snippets = _v0.i8;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {gx: charset, kF: declarations, hv: imports, hW: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {gx: $elm$core$Maybe$Nothing, hv: _List_Nil, hW: _List_Nil, i8: snippets};
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$templateSelector = $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$ClassSelector($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin)
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate = function (styles) {
	if (!styles.b) {
		return '';
	} else {
		var otherwise = styles;
		return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$VirtualDom$Styled$makeSnippet, styles, $rtfeldman$elm_css$VirtualDom$Styled$templateSelector)
					])));
	}
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
	var classProperty = A2($elm$virtual_dom$VirtualDom$attribute, '', '');
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, true, cssTemplate);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $rtfeldman$elm_css$Css$flexEnd = $rtfeldman$elm_css$Css$prop1('flex-end');
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		bj: 1,
		e7: 0,
		gB: 0,
		fq: 0,
		fZ: 0,
		nc: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				bj: alpha / 255,
				e7: blue,
				gB: 0,
				fq: green,
				fZ: red,
				nc: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$Internal$printKeyframeSelector = function (_v0) {
	var percentage = _v0.a;
	var properties = _v0.b;
	var propertiesStr = A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		function (_v1) {
			var prop = _v1;
			return prop + ';';
		},
		'',
		properties);
	var percentageStr = $elm$core$String$fromInt(percentage) + '%';
	return percentageStr + ('{' + (propertiesStr + '}'));
};
var $rtfeldman$elm_css$Css$Internal$compileKeyframes = function (tuples) {
	return A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Internal$printKeyframeSelector, '', tuples);
};
var $rtfeldman$elm_css$Css$Animations$keyframes = function (tuples) {
	return $elm$core$List$isEmpty(tuples) ? {fA: 0, fL: 0, nc: 'none'} : {
		fA: 0,
		fL: 0,
		nc: $rtfeldman$elm_css$Css$Internal$compileKeyframes(tuples)
	};
};
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.nc + (' ' + argB.nc));
	});
var $rtfeldman$elm_css$Css$margin2 = $rtfeldman$elm_css$Css$prop2('margin');
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $rtfeldman$elm_css$Css$Internal$Property = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Animations$property = F2(
	function (key, value) {
		return key + (':' + value);
	});
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $rtfeldman$elm_css$Css$relative = {cy: 0, nc: 'relative'};
var $rtfeldman$elm_css$Css$spaceBetween = $rtfeldman$elm_css$Css$prop1('space-between');
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $perzanko$elm_loading$Loading$Bars$view = function (config) {
	var withSpeed = function (x) {
		return $elm$core$String$fromFloat(x / config.i9);
	};
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.i6)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.i6)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto),
			A2($rtfeldman$elm_css$Css$property, 'display', 'flex'),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexEnd)
		]);
	var childStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.i6 / 3.5)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.i6 / 3.5)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex(config.gB)),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-duration',
			withSpeed(1.5) + 's'),
			A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
			A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'ease-in-out'),
			$rtfeldman$elm_css$Css$animationName(
			$rtfeldman$elm_css$Css$Animations$keyframes(
				_List_fromArray(
					[
						_Utils_Tuple2(
						0,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Animations$property,
								'height',
								$elm$core$String$fromFloat(config.i6 / 3.5) + 'px'),
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0)')
							])),
						_Utils_Tuple2(
						50,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Animations$property,
								'height',
								$elm$core$String$fromFloat(config.i6) + 'px'),
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0)')
							])),
						_Utils_Tuple2(
						100,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Animations$property,
								'height',
								$elm$core$String$fromFloat(config.i6 / 3.5) + 'px'),
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0)')
							]))
					])))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.gz)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(1) + 's')
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.5) + 's')
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.0000001) + 's')
								])))
					]),
				_List_Nil)
			]));
};
var $rtfeldman$elm_css$Css$block = {fi: 0, nc: 'block'};
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $perzanko$elm_loading$Loading$BouncingBalls$view = function (config) {
	var withSpeed = function (x) {
		return $elm$core$String$fromFloat(x / config.i9);
	};
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.i6)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.i6)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto),
			A2($rtfeldman$elm_css$Css$property, 'display', 'flex'),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]);
	var childStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.i6 / 3.5)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.i6 / 3.5)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex(config.gB)),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-duration',
			withSpeed(0.6) + 's'),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-delay',
			withSpeed(0.1) + 's'),
			A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'linear'),
			A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
			$rtfeldman$elm_css$Css$animationName(
			$rtfeldman$elm_css$Css$Animations$keyframes(
				_List_fromArray(
					[
						_Utils_Tuple2(
						0,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0) translateZ(0) translate(0,0)')
							])),
						_Utils_Tuple2(
						50,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Animations$property,
								'transform',
								'translate3d(0,0,0) translateZ(0) translate(0,' + ($elm$core$String$fromFloat(config.i6 / 3.5) + 'px)'))
							])),
						_Utils_Tuple2(
						100,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0) translateZ(0) translate(0,0)')
							]))
					])))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.gz)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.1) + 's')
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.2) + 's')
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							childStyle,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$property,
									'animation-delay',
									withSpeed(0.3) + 's')
								])))
					]),
				_List_Nil)
			]));
};
var $rtfeldman$elm_css$Css$absolute = {cy: 0, nc: 'absolute'};
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		a3: 0,
		an: 0,
		l_: 0,
		dV: 0,
		aK: val,
		bX: '',
		cM: 0,
		nc: $elm$core$String$fromFloat(val)
	};
};
var $rtfeldman$elm_css$Css$opacity = $rtfeldman$elm_css$Css$prop1('opacity');
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $perzanko$elm_loading$Loading$Circle$view = function (config) {
	var withSpeed = function (x) {
		return $elm$core$String$fromFloat(x / config.i9);
	};
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.i6)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.i6 * 0.95)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto)
		]);
	var childStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.i6 - (2 * (config.i6 * 0.17)))),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.i6 - (2 * (config.i6 * 0.17)))),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(0)),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-duration',
			withSpeed(1.33) + 's'),
			A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'cubic-bezier(.51,.92,.24,1.15)'),
			A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
			$rtfeldman$elm_css$Css$animationName(
			$rtfeldman$elm_css$Css$Animations$keyframes(
				_List_fromArray(
					[
						_Utils_Tuple2(
						0,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0) rotate(0deg)')
							])),
						_Utils_Tuple2(
						100,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate3d(0,0,0) rotate(720deg)')
							]))
					])))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.gz)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$elm$core$List$concat(
							_List_fromArray(
								[
									childStyle,
									_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$property,
										'border',
										$elm$core$String$fromFloat(config.i6 * 0.17) + ('px ' + (config.gB + ' solid'))),
										$rtfeldman$elm_css$Css$opacity(
										$rtfeldman$elm_css$Css$num(0.25))
									])
								])))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$elm$core$List$concat(
							_List_fromArray(
								[
									childStyle,
									_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$property,
										'border',
										$elm$core$String$fromFloat(config.i6 * 0.17) + 'px transparent solid'),
										A2(
										$rtfeldman$elm_css$Css$property,
										'border-top',
										$elm$core$String$fromFloat(config.i6 * 0.17) + ('px ' + (config.gB + ' solid'))),
										$rtfeldman$elm_css$Css$opacity(
										$rtfeldman$elm_css$Css$num(0.8))
									])
								])))
					]),
				_List_Nil)
			]));
};
var $perzanko$elm_loading$Loading$DoubleBounce$view = function (config) {
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.i6)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.i6)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto)
		]);
	var innerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex(config.gB)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.6)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$animationName(
			$rtfeldman$elm_css$Css$Animations$keyframes(
				_List_fromArray(
					[
						_Utils_Tuple2(
						0,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
							])),
						_Utils_Tuple2(
						50,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1.0)')
							])),
						_Utils_Tuple2(
						100,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
							]))
					]))),
			A2(
			$rtfeldman$elm_css$Css$property,
			'animation-duration',
			$elm$core$String$fromFloat(2 / config.i9) + 's'),
			A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'ease-in-out'),
			A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite')
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.gz)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(innerStyle)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$elm$core$List$concat(
							_List_fromArray(
								[
									innerStyle,
									_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$property,
										'animation-delay',
										'-' + ($elm$core$String$fromFloat(1 / config.i9) + 's'))
									])
								])))
					]),
				_List_Nil)
			]));
};
var $rtfeldman$elm_css$Css$Structure$PseudoElement = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$pseudoElement = function (element) {
	return $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement(element);
};
var $rtfeldman$elm_css$Css$after = $rtfeldman$elm_css$Css$pseudoElement('after');
var $rtfeldman$elm_css$Css$before = $rtfeldman$elm_css$Css$pseudoElement('before');
var $rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.nc + (' ' + (argB.nc + (' ' + argC.nc))));
	});
var $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3('border');
var $rtfeldman$elm_css$Css$Animations$opacity = function (_v0) {
	var value = _v0.nc;
	return 'opacity:' + value;
};
var $rtfeldman$elm_css$Css$solid = {M: 0, bb: 0, nc: 'solid'};
var $perzanko$elm_loading$Loading$Sonar$view = function (config) {
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.i6)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.i6)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$before(
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$property, 'content', '\' \''),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$pct(50)),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(config.i6 / 3)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(config.i6 / 3)),
					A2(
					$rtfeldman$elm_css$Css$property,
					'top',
					'calc(50% - ' + ($elm$core$String$fromFloat(config.i6 / 6) + 'px)')),
					A2(
					$rtfeldman$elm_css$Css$property,
					'left',
					'calc(50% - ' + ($elm$core$String$fromFloat(config.i6 / 6) + 'px)')),
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex(config.gB)),
					A2(
					$rtfeldman$elm_css$Css$property,
					'animation-duration',
					$elm$core$String$fromFloat(3 / config.i9) + 's'),
					A2($rtfeldman$elm_css$Css$property, 'animation-timing-funtion', 'linear'),
					A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
					$rtfeldman$elm_css$Css$animationName(
					$rtfeldman$elm_css$Css$Animations$keyframes(
						_List_fromArray(
							[
								_Utils_Tuple2(
								0,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(1))
									])),
								_Utils_Tuple2(
								15,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(1)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.5)')
									])),
								_Utils_Tuple2(
								60,
								_List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(4)'),
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0))
									])),
								_Utils_Tuple2(
								90,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(3)')
									])),
								_Utils_Tuple2(
								95,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(1))
									])),
								_Utils_Tuple2(
								100,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(1)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1)')
									]))
							])))
				])),
			$rtfeldman$elm_css$Css$after(
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$property, 'content', '\' \''),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$pct(50)),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(config.i6 / 3)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(config.i6 / 3)),
					A2(
					$rtfeldman$elm_css$Css$property,
					'top',
					'calc(50% - ' + ($elm$core$String$fromFloat(config.i6 / 6) + 'px)')),
					A2(
					$rtfeldman$elm_css$Css$property,
					'left',
					'calc(50% - ' + ($elm$core$String$fromFloat(config.i6 / 6) + 'px)')),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$rtfeldman$elm_css$Css$hex(config.gB)),
					$rtfeldman$elm_css$Css$opacity(
					$rtfeldman$elm_css$Css$num(0)),
					A2(
					$rtfeldman$elm_css$Css$property,
					'animation-duration',
					$elm$core$String$fromFloat(3 / config.i9) + 's'),
					A2($rtfeldman$elm_css$Css$property, 'animation-timing-funtion', 'linear'),
					A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
					$rtfeldman$elm_css$Css$animationName(
					$rtfeldman$elm_css$Css$Animations$keyframes(
						_List_fromArray(
							[
								_Utils_Tuple2(
								0,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1)')
									])),
								_Utils_Tuple2(
								30,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0)),
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1)')
									])),
								_Utils_Tuple2(
								60,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0.3))
									])),
								_Utils_Tuple2(
								90,
								_List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(3)')
									])),
								_Utils_Tuple2(
								100,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$Animations$opacity(
										$rtfeldman$elm_css$Css$num(0))
									]))
							])))
				]))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.gz)
			]),
		_List_Nil);
};
var $perzanko$elm_loading$Loading$Spinner$view = function (config) {
	var outerStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(config.i6)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(config.i6)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$auto)
		]);
	var childs = A2($elm$core$List$range, 1, 12);
	var childStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100))
		]);
	var calcAnimationDelay = function (x) {
		return (x === 1) ? '0s' : ($elm$core$String$fromFloat(-((1.1 - (x / 10)) / config.i9)) + 's');
	};
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(outerStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$class(config.gz)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
					]),
				A2(
					$elm$core$List$map,
					function (x) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$pct(100)),
											$rtfeldman$elm_css$Css$height(
											$rtfeldman$elm_css$Css$pct(100)),
											$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
											$rtfeldman$elm_css$Css$left(
											$rtfeldman$elm_css$Css$px(0)),
											$rtfeldman$elm_css$Css$top(
											$rtfeldman$elm_css$Css$px(0)),
											A2(
											$rtfeldman$elm_css$Css$property,
											'transform',
											'rotate(' + ($elm$core$String$fromInt((30 * x) - 30) + 'deg)')),
											$rtfeldman$elm_css$Css$before(
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Css$property,
													'animation-delay',
													calcAnimationDelay(x)),
													A2($rtfeldman$elm_css$Css$property, 'content', '\' \''),
													$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
													A2(
													$rtfeldman$elm_css$Css$margin2,
													$rtfeldman$elm_css$Css$px(0),
													$rtfeldman$elm_css$Css$auto),
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$pct(15)),
													$rtfeldman$elm_css$Css$height(
													$rtfeldman$elm_css$Css$pct(15)),
													$rtfeldman$elm_css$Css$backgroundColor(
													$rtfeldman$elm_css$Css$hex(config.gB)),
													$rtfeldman$elm_css$Css$borderRadius(
													$rtfeldman$elm_css$Css$pct(100)),
													A2(
													$rtfeldman$elm_css$Css$property,
													'animation-duration',
													$elm$core$String$fromFloat(1.2 / config.i9) + 's'),
													A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
													A2($rtfeldman$elm_css$Css$property, 'animation-fill-mode', 'both'),
													$rtfeldman$elm_css$Css$animationName(
													$rtfeldman$elm_css$Css$Animations$keyframes(
														_List_fromArray(
															[
																_Utils_Tuple2(
																0,
																_List_fromArray(
																	[
																		A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
																	])),
																_Utils_Tuple2(
																40,
																_List_fromArray(
																	[
																		A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(1.0)')
																	])),
																_Utils_Tuple2(
																80,
																_List_fromArray(
																	[
																		A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
																	])),
																_Utils_Tuple2(
																100,
																_List_fromArray(
																	[
																		A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'scale(0.0)')
																	]))
															])))
												]))
										]))
								]),
							_List_Nil);
					},
					childs))
			]));
};
var $perzanko$elm_loading$Loading$render = F3(
	function (loaderType, config, loadingState) {
		var loader = function () {
			switch (loaderType) {
				case 0:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$DoubleBounce$view(config));
				case 1:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$Spinner$view(config));
				case 2:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$BouncingBalls$view(config));
				case 3:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$Bars$view(config));
				case 4:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$Circle$view(config));
				default:
					return $rtfeldman$elm_css$Html$Styled$toUnstyled(
						$perzanko$elm_loading$Loading$Sonar$view(config));
			}
		}();
		if (!loadingState) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading')
					]),
				_List_fromArray(
					[loader]));
		} else {
			return $elm$html$Html$text(' ');
		}
	});
var $author$project$Pages$Util$Links$loadingSymbol = A3($perzanko$elm_loading$Loading$render, 1, $perzanko$elm_loading$Loading$defaultConfig, 0);
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$Attrs = function (a) {
	return {$: 4, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Button$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Internal$Button$Attrs(attrs_);
};
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var size = modifier.a;
				return _Utils_update(
					options,
					{
						i6: $elm$core$Maybe$Just(size)
					});
			case 1:
				var coloring = modifier.a;
				return _Utils_update(
					options,
					{
						ax: $elm$core$Maybe$Just(coloring)
					});
			case 2:
				return _Utils_update(
					options,
					{c9: true});
			case 3:
				var val = modifier.a;
				return _Utils_update(
					options,
					{kN: val});
			default:
				var attrs = modifier.a;
				return _Utils_update(
					options,
					{
						b1: _Utils_ap(options.b1, attrs)
					});
		}
	});
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$defaultOptions = {b1: _List_Nil, c9: false, ax: $elm$core$Maybe$Nothing, kN: false, i6: $elm$core$Maybe$Nothing};
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass = function (role) {
	switch (role) {
		case 0:
			return 'primary';
		case 1:
			return 'secondary';
		case 2:
			return 'success';
		case 3:
			return 'info';
		case 4:
			return 'warning';
		case 5:
			return 'danger';
		case 6:
			return 'dark';
		case 7:
			return 'light';
		default:
			return 'link';
	}
};
var $rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption = function (size) {
	switch (size) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('sm');
		case 2:
			return $elm$core$Maybe$Just('md');
		case 3:
			return $elm$core$Maybe$Just('lg');
		default:
			return $elm$core$Maybe$Just('xl');
	}
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Internal$Button$applyModifier, $rundis$elm_bootstrap$Bootstrap$Internal$Button$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('btn', true),
						_Utils_Tuple2('btn-block', options.c9),
						_Utils_Tuple2('disabled', options.kN)
					])),
				$elm$html$Html$Attributes$disabled(options.kN)
			]),
		_Utils_ap(
			function () {
				var _v0 = A2($elm$core$Maybe$andThen, $rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption, options.i6);
				if (!_v0.$) {
					var s = _v0.a;
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn-' + s)
						]);
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					var _v1 = options.ax;
					if (!_v1.$) {
						if (!_v1.a.$) {
							var role = _v1.a.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									'btn-' + $rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass(role))
								]);
						} else {
							var role = _v1.a.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									'btn-outline-' + $rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass(role))
								]);
						}
					} else {
						return _List_Nil;
					}
				}(),
				options.b1)));
};
var $rundis$elm_bootstrap$Bootstrap$Button$linkButton = F2(
	function (options, children) {
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
				$rundis$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes(options)),
			children);
	});
var $author$project$Pages$Util$Links$linkButton = function (params) {
	return A2(
		$rundis$elm_bootstrap$Bootstrap$Button$linkButton,
		_List_fromArray(
			[
				$rundis$elm_bootstrap$Bootstrap$Button$attrs(
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$href(params.jJ),
					params.b1))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(params.hI)
			]));
};
var $author$project$Pages$Util$Links$toLoginButtonWith = function (params) {
	return $author$project$Pages$Util$Links$linkButton(
		{
			b1: params.b1,
			hI: params.gr,
			jJ: $author$project$Pages$Util$Links$frontendPage(
				$author$project$Addresses$Frontend$login.gh(0))
		});
};
var $author$project$Pages$View$Tristate$view = F2(
	function (ps, t) {
		var _v0 = t.as;
		switch (_v0.$) {
			case 0:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$main_,
						_List_Nil,
						_List_fromArray(
							[$author$project$Pages$Util$Links$loadingSymbol]))
					]);
			case 1:
				var main = _v0.a;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Pages$View$Tristate$Logic),
					ps.ng(main));
			default:
				var errorState = _v0.a;
				var suggestionBlock = $elm$core$String$isEmpty(errorState._.ir) ? _List_Nil : _List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(t.z.jj)
							])),
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(errorState._.ir)
							]))
					]);
				var retryBlock = A2(
					$elm$core$List$filter,
					$elm$core$Basics$always(errorState._.mX),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Pages$View$Tristate$HandleError),
									$author$project$Pages$Util$Style$classes.dc.hb
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(t.z.iR)
								]))
						]));
				var redirectBlock = A2(
					$elm$core$List$filter,
					$elm$core$Basics$always(ps.mL),
					_List_fromArray(
						[
							$author$project$Pages$Util$Links$toLoginButtonWith(
							{
								b1: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.dc.lR]),
								gr: t.z.bH
							})
						]));
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$main_,
						_List_fromArray(
							[$author$project$Pages$Util$Style$ids.hb]),
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(t.z.hd)
												])),
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(errorState._.kf)
												]))
										])),
									A2($elm$html$Html$p, _List_Nil, suggestionBlock)
								]),
							_Utils_ap(retryBlock, redirectBlock)))
					]);
		}
	});
var $author$project$Pages$Util$Choice$Page$RequestDelete = function (a) {
	return {$: 6, a: a};
};
var $elm$html$Html$th = _VirtualDom_node('th');
var $author$project$Pages$DashboardEntries$Entries$View$headerColumns = function (language) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$th,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(language.gR)
				])),
			A2(
			$elm$html$Html$th,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(language.gQ)
				]))
		]);
};
var $author$project$Pages$Util$NavigationUtil$projectEditorLinkButton = F2(
	function (projectId, editorLabel) {
		return $author$project$Pages$Util$Links$linkButton(
			{
				b1: _List_fromArray(
					[$author$project$Pages$Util$Style$classes.dc.kR]),
				hI: editorLabel,
				jJ: $author$project$Pages$Util$Links$frontendPage(
					$author$project$Addresses$Frontend$tasks.gh(projectId))
			});
	});
var $author$project$Pages$Projects$View$projectInfoColumns = function (project) {
	return _List_fromArray(
		[
			{
			b1: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.bs]),
			e8: _List_fromArray(
				[
					$elm$html$Html$text(project.hV)
				])
		},
			{
			b1: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.bs]),
			e8: _List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, '', project.dq))
				])
		}
		]);
};
var $author$project$Pages$DashboardEntries$Entries$View$projectInfoFromMap = F2(
	function (projects, projectId) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ic;
				},
				$author$project$Pages$Projects$View$projectInfoColumns),
			A2($author$project$Util$DictList$get, projectId, projects));
	});
var $author$project$Pages$Util$Choice$Page$SetElementsSearchString = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Util$Choice$Page$SetPagination = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Util$Choice$Page$CancelDelete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Util$Choice$Page$ConfirmDelete = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Util$Choice$Page$ToggleControls = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$td = _VirtualDom_node('td');
var $icidasset$elm_material_icons$Material$Icons$Types$Inherit = {$: 1};
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $icidasset$elm_material_icons$Material$Icons$Internal$f = $elm$svg$Svg$Attributes$fill;
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$core$Basics$round = _Basics_round;
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $icidasset$elm_material_icons$Material$Icons$Internal$icon = F4(
	function (attributes, nodes, size, coloring) {
		var sizeAsString = $elm$core$String$fromInt(size);
		return A2(
			$elm$svg$Svg$svg,
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$height(sizeAsString),
						$elm$svg$Svg$Attributes$width(sizeAsString)
					])),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							function () {
							if (!coloring.$) {
								var color = coloring.a;
								return $elm$svg$Svg$Attributes$fill(
									$avh4$elm_color$Color$toCssString(color));
							} else {
								return $elm$svg$Svg$Attributes$fill('currentColor');
							}
						}()
						]),
					nodes)
				]));
	});
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $icidasset$elm_material_icons$Material$Icons$Internal$p = $elm$svg$Svg$path;
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $icidasset$elm_material_icons$Material$Icons$Internal$v = $elm$svg$Svg$Attributes$viewBox;
var $icidasset$elm_material_icons$Material$Icons$list = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z')
				]),
			_List_Nil)
		]));
var $author$project$Pages$Util$HtmlUtil$menuIcon = A2($icidasset$elm_material_icons$Material$Icons$list, 20, $icidasset$elm_material_icons$Material$Icons$Types$Inherit);
var $author$project$Pages$Util$HtmlUtil$toggleControlsCell = function (msg) {
	return A2(
		$elm$html$Html$td,
		_List_fromArray(
			[
				$author$project$Pages$Util$Style$classes.jt,
				$elm$html$Html$Events$onClick(msg)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.dc.lG]),
				_List_fromArray(
					[$author$project$Pages$Util$HtmlUtil$menuIcon]))
			]));
};
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Pages$Util$HtmlUtil$withExtraAttributes = F2(
	function (extra, column) {
		return A2(
			$elm$html$Html$td,
			_Utils_ap(column.b1, extra),
			column.e8);
	});
var $author$project$Pages$Util$Choice$View$elementLineWith = F2(
	function (ps, element) {
		var toggleCommand = $author$project$Pages$Util$Choice$Page$ToggleControls(
			ps.li(element));
		var info = ps.lo(element);
		var displayColumns = info.fi;
		var infoCells = A2(
			$elm$core$List$map,
			$author$project$Pages$Util$HtmlUtil$withExtraAttributes(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(toggleCommand)
					])),
			displayColumns);
		var infoRow = A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.kQ]),
			_Utils_ap(
				infoCells,
				_List_fromArray(
					[
						$author$project$Pages$Util$HtmlUtil$toggleControlsCell(toggleCommand)
					])));
		var controlsRow = A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.gH]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(
							$elm$core$List$length(displayColumns))
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$p, _List_Nil, info.gH)
						]))
				]));
		return A2(
			$elm$core$List$cons,
			infoRow,
			ps.i1 ? _List_fromArray(
				[controlsRow]) : _List_Nil);
	});
var $author$project$Pages$Util$Choice$View$deleteElementLine = function (ps) {
	return $author$project$Pages$Util$Choice$View$elementLineWith(
		{
			li: ps.li,
			lo: function (element) {
				return {
					gH: function () {
						var elementId = ps.li(element);
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.gH]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$author$project$Pages$Util$Style$classes.dc.Z,
												$elm$html$Html$Events$onClick(
												$author$project$Pages$Util$Choice$Page$ConfirmDelete(elementId))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(ps.ku)
											]))
									])),
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.gH]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$author$project$Pages$Util$Style$classes.dc.gD,
												$elm$html$Html$Events$onClick(
												$author$project$Pages$Util$Choice$Page$CancelDelete(elementId))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(ps.kd)
											]))
									]))
							]);
					}(),
					fi: ps.lo(element)
				};
			},
			i1: true
		});
};
var $author$project$Pages$Util$Choice$Page$ExitEdit = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Util$Choice$Page$SaveEdit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Util$MaybeUtil$defined = $elm$core$Maybe$Just;
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $elm_community$html_extra$Html$Events$Extra$onEnter = function (onEnterAction) {
	return A2(
		$elm$html$Html$Events$on,
		'keyup',
		A2(
			$elm$json$Json$Decode$andThen,
			function (keyCode) {
				return (keyCode === 13) ? $elm$json$Json$Decode$succeed(onEnterAction) : $elm$json$Json$Decode$fail(
					$elm$core$String$fromInt(keyCode));
			},
			$elm$html$Html$Events$keyCode));
};
var $Gizra$elm_keyboard_event$Keyboard$Event$KeyboardEvent = F7(
	function (altKey, ctrlKey, key, keyCode, metaKey, repeat, shiftKey) {
		return {j1: altKey, ky: ctrlKey, fz: key, lv: keyCode, lH: metaKey, mr: repeat, mK: shiftKey};
	});
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKey = $elm$json$Json$Decode$maybe(
	A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			return $elm$core$String$isEmpty(key) ? $elm$json$Json$Decode$fail('empty key') : $elm$json$Json$Decode$succeed(key);
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero = A2(
	$elm$json$Json$Decode$andThen,
	function (code) {
		return (!code) ? $elm$json$Json$Decode$fail('code was zero') : $elm$json$Json$Decode$succeed(code);
	},
	$elm$json$Json$Decode$int);
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyCode = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$field, 'keyCode', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			A2($elm$json$Json$Decode$field, 'which', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			A2($elm$json$Json$Decode$field, 'charCode', $Gizra$elm_keyboard_event$Keyboard$Event$decodeNonZero),
			$elm$json$Json$Decode$succeed(0)
		]));
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$A = {$: 0};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Add = {$: 85};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Alt = {$: 32};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ambiguous = function (a) {
	return {$: 89, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$B = {$: 1};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Backspace = {$: 38};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$C = {$: 2};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$CapsLock = {$: 34};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$ChromeSearch = {$: 59};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Command = {$: 58};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ctrl = function (a) {
	return {$: 31, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$D = {$: 3};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Decimal = {$: 87};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Delete = {$: 39};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Divide = {$: 88};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Down = {$: 29};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$E = {$: 4};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Eight = {$: 52};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$End = {$: 42};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Enter = {$: 37};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Escape = {$: 36};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F = {$: 5};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F1 = {$: 62};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F10 = {$: 71};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F11 = {$: 72};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F12 = {$: 73};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F2 = {$: 63};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F3 = {$: 64};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F4 = {$: 65};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F5 = {$: 66};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F6 = {$: 67};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F7 = {$: 68};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F8 = {$: 69};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$F9 = {$: 70};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Five = {$: 49};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Four = {$: 48};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$G = {$: 6};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$H = {$: 7};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Home = {$: 43};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$I = {$: 8};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Insert = {$: 54};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$J = {$: 9};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$K = {$: 10};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$L = {$: 11};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Left = {$: 26};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$M = {$: 12};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Multiply = {$: 84};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$N = {$: 13};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Nine = {$: 53};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumLock = {$: 60};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadEight = {$: 82};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFive = {$: 79};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFour = {$: 78};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadNine = {$: 83};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadOne = {$: 75};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSeven = {$: 81};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSix = {$: 80};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadThree = {$: 77};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadTwo = {$: 76};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadZero = {$: 74};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$O = {$: 14};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$One = {$: 45};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$P = {$: 15};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageDown = {$: 41};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageUp = {$: 40};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PauseBreak = {$: 56};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$PrintScreen = {$: 55};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Q = {$: 16};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$R = {$: 17};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Right = {$: 27};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$S = {$: 18};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$ScrollLock = {$: 61};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Seven = {$: 51};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Shift = function (a) {
	return {$: 30, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Six = {$: 50};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Spacebar = {$: 35};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Subtract = {$: 86};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$T = {$: 19};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Tab = {$: 33};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Three = {$: 47};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Two = {$: 46};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$U = {$: 20};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Unknown = function (a) {
	return {$: 90, a: a};
};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Up = {$: 28};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$V = {$: 21};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$W = {$: 22};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Windows = {$: 57};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$X = {$: 23};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Y = {$: 24};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Z = {$: 25};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$Zero = {$: 44};
var $SwiftsNamesake$proper_keyboard$Keyboard$Key$fromCode = function (keyCode) {
	switch (keyCode) {
		case 8:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Backspace;
		case 9:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Tab;
		case 13:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Enter;
		case 16:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Shift($elm$core$Maybe$Nothing);
		case 17:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ctrl($elm$core$Maybe$Nothing);
		case 18:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Alt;
		case 19:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PauseBreak;
		case 20:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$CapsLock;
		case 27:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Escape;
		case 32:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Spacebar;
		case 33:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageUp;
		case 34:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PageDown;
		case 35:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$End;
		case 36:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Home;
		case 37:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Left;
		case 38:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Up;
		case 39:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Right;
		case 40:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Down;
		case 44:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$PrintScreen;
		case 45:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Insert;
		case 46:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Delete;
		case 48:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Zero;
		case 49:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$One;
		case 50:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Two;
		case 51:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Three;
		case 52:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Four;
		case 53:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Five;
		case 54:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Six;
		case 55:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Seven;
		case 56:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Eight;
		case 57:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Nine;
		case 65:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$A;
		case 66:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$B;
		case 67:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$C;
		case 68:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$D;
		case 69:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$E;
		case 70:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F;
		case 71:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$G;
		case 72:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$H;
		case 73:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$I;
		case 74:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$J;
		case 75:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$K;
		case 76:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$L;
		case 77:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$M;
		case 78:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$N;
		case 79:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$O;
		case 80:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$P;
		case 81:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Q;
		case 82:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$R;
		case 83:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$S;
		case 84:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$T;
		case 85:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$U;
		case 86:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$V;
		case 87:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$W;
		case 88:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$X;
		case 89:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Y;
		case 90:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Z;
		case 91:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Ambiguous(
				_List_fromArray(
					[$SwiftsNamesake$proper_keyboard$Keyboard$Key$Windows, $SwiftsNamesake$proper_keyboard$Keyboard$Key$Command, $SwiftsNamesake$proper_keyboard$Keyboard$Key$ChromeSearch]));
		case 96:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadZero;
		case 97:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadOne;
		case 98:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadTwo;
		case 99:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadThree;
		case 100:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFour;
		case 101:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadFive;
		case 102:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSix;
		case 103:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadSeven;
		case 104:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadEight;
		case 105:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumpadNine;
		case 106:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Multiply;
		case 107:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Add;
		case 109:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Subtract;
		case 110:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Decimal;
		case 111:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Divide;
		case 112:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F1;
		case 113:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F2;
		case 114:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F3;
		case 115:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F4;
		case 116:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F5;
		case 117:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F6;
		case 118:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F7;
		case 119:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F8;
		case 120:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F9;
		case 121:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F10;
		case 122:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F11;
		case 123:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$F12;
		case 144:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$NumLock;
		case 145:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$ScrollLock;
		default:
			return $SwiftsNamesake$proper_keyboard$Keyboard$Key$Unknown(keyCode);
	}
};
var $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyboardEvent = A8(
	$elm$json$Json$Decode$map7,
	$Gizra$elm_keyboard_event$Keyboard$Event$KeyboardEvent,
	A2($elm$json$Json$Decode$field, 'altKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
	$Gizra$elm_keyboard_event$Keyboard$Event$decodeKey,
	A2($elm$json$Json$Decode$map, $SwiftsNamesake$proper_keyboard$Keyboard$Key$fromCode, $Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyCode),
	A2($elm$json$Json$Decode$field, 'metaKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool));
var $Gizra$elm_keyboard_event$Keyboard$Event$considerKeyboardEvent = function (func) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (event) {
			var _v0 = func(event);
			if (!_v0.$) {
				var msg = _v0.a;
				return $elm$json$Json$Decode$succeed(msg);
			} else {
				return $elm$json$Json$Decode$fail('Ignoring keyboard event');
			}
		},
		$Gizra$elm_keyboard_event$Keyboard$Event$decodeKeyboardEvent);
};
var $author$project$Pages$Util$HtmlUtil$mkEscapeEventMsg = F2(
	function (msg, keyboardEvent) {
		return A2(
			$elm_community$maybe_extra$Maybe$Extra$filter,
			$elm$core$Basics$always(
				_Utils_eq(keyboardEvent.lv, $SwiftsNamesake$proper_keyboard$Keyboard$Key$Escape)),
			$elm$core$Maybe$Just(msg));
	});
var $author$project$Pages$Util$HtmlUtil$onEscape = A2(
	$elm$core$Basics$composeR,
	$author$project$Pages$Util$HtmlUtil$mkEscapeEventMsg,
	A2(
		$elm$core$Basics$composeR,
		$Gizra$elm_keyboard_event$Keyboard$Event$considerKeyboardEvent,
		$elm$html$Html$Events$on('keydown')));
var $author$project$Util$MaybeUtil$optional = function (isDefined) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$Just,
		$elm_community$maybe_extra$Maybe$Extra$filter(
			$elm$core$Basics$always(isDefined)));
};
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Pages$Util$Choice$View$editElementLine = F3(
	function (ps, element, elementUpdateClientInput) {
		var validInput = ps.lr(elementUpdateClientInput);
		var saveMsg = $author$project$Pages$Util$Choice$Page$SaveEdit(elementUpdateClientInput);
		var elementId = ps.li(element);
		var editCells = A2(ps.aB, element, elementUpdateClientInput);
		var cancelMsg = $author$project$Pages$Util$Choice$Page$ExitEdit(elementId);
		var cells = _Utils_ap(
			A2(
				$elm$core$List$map,
				$author$project$Pages$Util$HtmlUtil$withExtraAttributes(
					$elm_community$maybe_extra$Maybe$Extra$values(
						_List_fromArray(
							[
								A2(
								$author$project$Util$MaybeUtil$optional,
								validInput,
								$elm_community$html_extra$Html$Events$Extra$onEnter(saveMsg)),
								$author$project$Util$MaybeUtil$defined(
								$author$project$Pages$Util$HtmlUtil$onEscape(cancelMsg))
							]))),
				editCells),
			_List_fromArray(
				[
					$author$project$Pages$Util$HtmlUtil$toggleControlsCell(
					$author$project$Pages$Util$Choice$Page$ToggleControls(elementId))
				]));
		var editRow = A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.g7]),
			cells);
		var controlsRow = A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(
							$elm$core$List$length(editCells))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							$elm_community$maybe_extra$Maybe$Extra$values(
								_List_fromArray(
									[
										$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.dc.gD),
										$author$project$Util$MaybeUtil$defined(
										$elm$html$Html$Attributes$disabled(!validInput)),
										A2(
										$author$project$Util$MaybeUtil$optional,
										validInput,
										$elm$html$Html$Events$onClick(saveMsg))
									])),
							_List_fromArray(
								[
									$elm$html$Html$text(ps.mA)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Pages$Util$Style$classes.dc.X,
									$elm$html$Html$Events$onClick(cancelMsg)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(ps.kd)
								]))
						]))
				]));
		return _List_fromArray(
			[editRow, controlsRow]);
	});
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $jschomay$elm_bounded_number$Number$Bounded$value = function (_v0) {
	var n = _v0.aJ;
	return n;
};
var $jschomay$elm_paginate$Paginate$Custom$page = F2(
	function (sliceFn, _v0) {
		var itemsPerPage_ = _v0.dK;
		var currentPage_ = _v0.x;
		var items = _v0.lt;
		var from = ($jschomay$elm_bounded_number$Number$Bounded$value(currentPage_) - 1) * itemsPerPage_;
		var to = from + itemsPerPage_;
		return A3(sliceFn, from, to, items);
	});
var $jschomay$elm_paginate$Paginate$page = $jschomay$elm_paginate$Paginate$Custom$page(
	F2(
		function (from, to) {
			return A2(
				$elm$core$Basics$composeR,
				$elm$core$List$drop(from),
				$elm$core$List$take(to - from));
		}));
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $jschomay$elm_paginate$Paginate$Custom$accumulateWindowGroups = F2(
	function (page_, windows) {
		if (!windows.b) {
			return _List_fromArray(
				[
					_Utils_Tuple2(page_, _List_Nil)
				]);
		} else {
			var currentWindow = windows.a;
			var remainingWindows = windows.b;
			var prevPage = function () {
				var _v1 = $elm$core$List$head(currentWindow.b);
				if (!_v1.$) {
					var prevPage_ = _v1.a;
					return prevPage_;
				} else {
					return currentWindow.a;
				}
			}();
			return ((page_ - prevPage) > 1) ? A2(
				$elm$core$List$cons,
				_Utils_Tuple2(page_, _List_Nil),
				windows) : A2(
				$elm$core$List$cons,
				A2(
					$elm$core$Tuple$mapSecond,
					function (list) {
						return A2($elm$core$List$cons, page_, list);
					},
					currentWindow),
				remainingWindows);
		}
	});
var $jschomay$elm_paginate$Paginate$Custom$groupWindows = function (pages) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var x = _v0.a;
			var xs = _v0.b;
			return A2($elm$core$List$cons, x, xs);
		},
		$elm$core$List$reverse(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond($elm$core$List$reverse),
				A3($elm$core$List$foldl, $jschomay$elm_paginate$Paginate$Custom$accumulateWindowGroups, _List_Nil, pages))));
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $jschomay$elm_bounded_number$Number$Bounded$maxBound = function (_v0) {
	var max = _v0.ao;
	return max;
};
var $jschomay$elm_bounded_number$Number$Bounded$minBound = function (_v0) {
	var min = _v0.ap;
	return min;
};
var $jschomay$elm_bounded_number$Number$Bounded$Bounded = $elm$core$Basics$identity;
var $jschomay$elm_bounded_number$Number$Bounded$set = F2(
	function (n, _v0) {
		var min = _v0.ap;
		var max = _v0.ao;
		return {
			ao: max,
			ap: min,
			aJ: A3($elm$core$Basics$clamp, min, max, n)
		};
	});
var $jschomay$elm_paginate$Paginate$Custom$elidedPager = F2(
	function (options, _v0) {
		var currentPage_ = _v0.x;
		var rightWindow = (options.l8 <= 0) ? _List_Nil : A2(
			$elm$core$List$range,
			$jschomay$elm_bounded_number$Number$Bounded$value(
				A2(
					$jschomay$elm_bounded_number$Number$Bounded$set,
					$jschomay$elm_bounded_number$Number$Bounded$maxBound(currentPage_) - (options.l8 - 1),
					currentPage_)),
			$jschomay$elm_bounded_number$Number$Bounded$maxBound(currentPage_));
		var leftWindow = (options.l8 <= 0) ? _List_Nil : A2(
			$elm$core$List$range,
			$jschomay$elm_bounded_number$Number$Bounded$minBound(currentPage_),
			$jschomay$elm_bounded_number$Number$Bounded$value(
				A2(
					$jschomay$elm_bounded_number$Number$Bounded$set,
					$jschomay$elm_bounded_number$Number$Bounded$minBound(currentPage_) + (options.l8 - 1),
					currentPage_)));
		var currentPageNumber = $jschomay$elm_bounded_number$Number$Bounded$value(currentPage_);
		var innerWindow = A2(
			$elm$core$List$range,
			A3(
				$elm$core$Basics$clamp,
				$jschomay$elm_bounded_number$Number$Bounded$minBound(currentPage_),
				currentPageNumber,
				currentPageNumber - options.lq),
			A3(
				$elm$core$Basics$clamp,
				currentPageNumber,
				$jschomay$elm_bounded_number$Number$Bounded$maxBound(currentPage_),
				currentPageNumber + options.lq));
		return $elm$core$List$concat(
			A2(
				$elm$core$List$intersperse,
				_List_fromArray(
					[options.k7]),
				A2(
					$elm$core$List$map,
					$elm$core$List$map(
						function (i) {
							return A2(
								options.l9,
								i,
								_Utils_eq(i, currentPageNumber));
						}),
					$jschomay$elm_paginate$Paginate$Custom$groupWindows(
						$elm$core$Set$toList(
							$elm$core$Set$fromList(
								_Utils_ap(
									leftWindow,
									_Utils_ap(innerWindow, rightWindow))))))));
	});
var $jschomay$elm_paginate$Paginate$elidedPager = $jschomay$elm_paginate$Paginate$Custom$elidedPager;
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $jschomay$elm_paginate$Paginate$Custom$totalPages = function (_v0) {
	var currentPage_ = _v0.x;
	return $jschomay$elm_bounded_number$Number$Bounded$maxBound(currentPage_);
};
var $jschomay$elm_paginate$Paginate$totalPages = $jschomay$elm_paginate$Paginate$Custom$totalPages;
var $author$project$Pages$Util$ViewUtil$pagerButtons = function (ps) {
	var pagerButton = F2(
		function (pageNum, isCurrentPage) {
			return A2(
				$elm$html$Html$button,
				$elm_community$maybe_extra$Maybe$Extra$values(
					_List_fromArray(
						[
							$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.dc.ma),
							$author$project$Util$MaybeUtil$defined(
							$elm$html$Html$Events$onClick(
								ps.hT(pageNum))),
							A2(
							$author$project$Util$MaybeUtil$optional,
							isCurrentPage,
							$elm$html$Html$Attributes$disabled(true))
						])),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(pageNum))
					]));
		});
	var cells = A2(
		$elm$core$List$filter,
		$elm$core$Basics$always(
			$jschomay$elm_paginate$Paginate$totalPages(ps.g9) > 1),
		A2(
			$elm$core$List$map,
			function (elt) {
				return A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[elt]));
			},
			A2(
				$jschomay$elm_paginate$Paginate$elidedPager,
				{
					k7: A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$author$project$Pages$Util$Style$classes.kZ,
								$author$project$Pages$Util$Style$classes.dc.ma,
								$elm$html$Html$Attributes$disabled(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('...')
							])),
					lq: 5,
					l8: 1,
					l9: pagerButton
				},
				ps.g9)));
	return A2(
		$elm$html$Html$table,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tbody,
				_List_Nil,
				_List_fromArray(
					[
						A2($elm$html$Html$tr, _List_Nil, cells)
					]))
			]));
};
var $jschomay$elm_paginate$Paginate$Custom$Paginated = $elm$core$Basics$identity;
var $jschomay$elm_bounded_number$Number$Bounded$between = F2(
	function (a, b) {
		return (_Utils_cmp(a, b) < 0) ? {ao: b, ap: a, aJ: a} : {ao: a, ap: b, aJ: b};
	});
var $jschomay$elm_paginate$Paginate$Custom$init = F3(
	function (lengthFn, itemsPerPage_, items) {
		var max = (!lengthFn(items)) ? 1 : $elm$core$Basics$ceiling(
			lengthFn(items) / A2($elm$core$Basics$max, 1, itemsPerPage_));
		return {
			x: A2($jschomay$elm_bounded_number$Number$Bounded$between, 1, max),
			lt: items,
			dK: A2($elm$core$Basics$max, 1, itemsPerPage_)
		};
	});
var $jschomay$elm_paginate$Paginate$fromList = F2(
	function (a, b) {
		return A3($jschomay$elm_paginate$Paginate$Custom$init, $elm$core$List$length, a, b);
	});
var $jschomay$elm_paginate$Paginate$Custom$goTo = F2(
	function (i, _v0) {
		var p = _v0;
		return _Utils_update(
			p,
			{
				x: A2($jschomay$elm_bounded_number$Number$Bounded$set, i, p.x)
			});
	});
var $jschomay$elm_paginate$Paginate$goTo = $jschomay$elm_paginate$Paginate$Custom$goTo;
var $author$project$Pages$Util$ViewUtil$paginate = F2(
	function (ps, model) {
		return A2(
			$elm$core$Basics$composeR,
			$jschomay$elm_paginate$Paginate$fromList(
				A2($elm$core$Basics$composeR, ps.$8, $author$project$Pages$Util$PaginationSettings$lenses.cm.dy)(model)),
			$jschomay$elm_paginate$Paginate$goTo(
				A3($elm$core$Basics$composeR, ps.$8, $author$project$Pages$Util$PaginationSettings$lenses.kz.dy, model)));
	});
var $elm_community$list_extra$List$Extra$andThen = $elm$core$List$concatMap;
var $elm_community$list_extra$List$Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$isSubsequenceOf = F2(
	function (subseq, list) {
		isSubsequenceOf:
		while (true) {
			var _v0 = _Utils_Tuple2(subseq, list);
			if (!_v0.a.b) {
				return true;
			} else {
				if (!_v0.b.b) {
					return false;
				} else {
					var _v1 = _v0.a;
					var x = _v1.a;
					var xs = _v1.b;
					var _v2 = _v0.b;
					var y = _v2.a;
					var ys = _v2.b;
					if (_Utils_eq(x, y)) {
						var $temp$subseq = xs,
							$temp$list = ys;
						subseq = $temp$subseq;
						list = $temp$list;
						continue isSubsequenceOf;
					} else {
						var $temp$subseq = subseq,
							$temp$list = ys;
						subseq = $temp$subseq;
						list = $temp$list;
						continue isSubsequenceOf;
					}
				}
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 1) {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$Util$SearchUtil$searchByInitials = function (ps) {
	return A2(
		$elm_community$list_extra$List$Extra$isSubsequenceOf,
		$elm$core$String$toList(
			$elm$core$String$toLower(ps.dr)),
		A2(
			$elm_community$list_extra$List$Extra$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$toList,
				A2(
					$elm$core$Basics$composeR,
					$elm_community$list_extra$List$Extra$dropWhile(
						A2($elm$core$Basics$composeR, $elm$core$Char$isAlpha, $elm$core$Basics$not)),
					A2($elm$core$Basics$composeR, $elm$core$List$head, $elm_community$maybe_extra$Maybe$Extra$toList))),
			A2(
				$elm$core$List$concatMap,
				$elm$core$String$split('-'),
				A2(
					$elm$core$String$split,
					' ',
					$elm$core$String$toLower(ps.cZ)))));
};
var $author$project$Util$SearchUtil$searchByWords = function (ps) {
	return A2(
		$elm$core$List$all,
		A2(
			$elm_community$basics_extra$Basics$Extra$flip,
			$elm$core$String$contains,
			$elm$core$String$toLower(ps.cZ)),
		A2(
			$elm$core$String$split,
			' ',
			$elm$core$String$toLower(ps.dr)));
};
var $author$project$Util$SearchUtil$search = F2(
	function (desired, actual) {
		var searchParameters = {cZ: actual, dr: desired};
		return A2(
			$elm$core$List$any,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$author$project$Util$SearchUtil$searchByWords(searchParameters),
					$author$project$Util$SearchUtil$searchByInitials(searchParameters)
				]));
	});
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$core$Char$fromCode = _Char_fromCode;
var $author$project$Pages$Util$Links$special = A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar);
var $author$project$Pages$Util$Links$lookingGlass = $author$project$Pages$Util$Links$special(128269);
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Pages$Util$HtmlUtil$searchAreaWith = function (ps) {
	var searchField = 'search-field';
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[$author$project$Pages$Util$Style$classes.mD]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for(searchField)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text($author$project$Pages$Util$Links$lookingGlass)
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('search'),
						$author$project$Pages$Util$Style$ids.mE,
						$elm$html$Html$Events$onInput(ps.hT),
						$elm$html$Html$Attributes$value(ps.cD),
						$elm$html$Html$Attributes$id(searchField)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$author$project$Pages$Util$Style$classes.dc.kn,
						$elm$html$Html$Attributes$type_('reset'),
						$elm$html$Html$Events$onClick(
						ps.hT('')),
						$elm$html$Html$Attributes$disabled(
						$elm$core$String$isEmpty(ps.cD))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(ps.ko)
					]))
			]));
};
var $elm$html$Html$section = _VirtualDom_node('section');
var $elm$core$List$sortBy = _List_sortBy;
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $author$project$Util$Editing$unpack = F2(
	function (fs, editing) {
		return A2(
			$author$project$Util$EditState$unpack,
			{
				l0: fs.l0(editing.ic),
				l1: fs.l1(editing.ic),
				l4: fs.l4(editing.ic)
			},
			editing.O);
	});
var $author$project$Pages$Util$PaginationSettings$updateCurrentPage = F3(
	function (ps, model, currentPage) {
		return A2(
			A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$PaginationSettings$lenses.kz, ps.lt).f$,
			currentPage,
			ps.$8.dy(model));
	});
var $author$project$Pages$Util$Choice$View$viewElementLine = F3(
	function (ps, element, showControls) {
		return A2(
			$author$project$Pages$Util$Choice$View$elementLineWith,
			{li: ps.li, lo: ps.lo, i1: showControls},
			element);
	});
var $author$project$Pages$Util$Choice$View$viewElements = F2(
	function (ps, main) {
		var viewElementState = $author$project$Util$Editing$unpack(
			{
				l0: $author$project$Pages$Util$Choice$View$deleteElementLine(
					{
						kd: ps.kd,
						ku: ps.ku,
						li: ps.li,
						lo: A2(
							$elm$core$Basics$composeR,
							ps.lo,
							function ($) {
								return $.fi;
							})
					}),
				l1: $author$project$Pages$Util$Choice$View$editElementLine(
					{kd: ps.kd, aB: ps.aB, li: ps.li, lr: ps.lr, mA: ps.mA}),
				l4: $author$project$Pages$Util$Choice$View$viewElementLine(
					{li: ps.li, lo: ps.lo})
			});
		var extractedName = A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.ic;
			},
			A2(
				$elm$core$Basics$composeR,
				ps.kj,
				A2(
					$elm$core$Basics$composeR,
					A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Util$DictList$get, main.kl),
					A2(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.ic;
							},
							ps.lN)))));
		var paginatedElements = A3(
			$author$project$Pages$Util$ViewUtil$paginate,
			{
				$8: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$Choice$Pagination$lenses.g9, $author$project$Pages$Util$Choice$Page$lenses.hM.$8).dy
			},
			main,
			A2(
				$elm$core$List$sortBy,
				A2($elm$core$Basics$composeR, extractedName, $elm$core$String$toLower),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						extractedName,
						$author$project$Util$SearchUtil$search(main.kX)),
					$author$project$Util$DictList$values(main.g9))));
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.kl]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(ps.bA)
						])),
					$author$project$Pages$Util$HtmlUtil$searchAreaWith(
					{ko: ps.gA, hT: $author$project$Pages$Util$Choice$Page$SetElementsSearchString, cD: main.kX}),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.kY, $author$project$Pages$Util$Style$classes.kU]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.mY]),
									_Utils_ap(
										ps.kV,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$th,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.jt]),
												_List_Nil)
											])))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							A2(
								$elm$core$List$concatMap,
								viewElementState,
								$jschomay$elm_paginate$Paginate$page(paginatedElements)))
						])),
					A2(
					$elm$html$Html$nav,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.$8]),
					_List_fromArray(
						[
							$author$project$Pages$Util$ViewUtil$pagerButtons(
							{
								g9: paginatedElements,
								hT: A2(
									$elm$core$Basics$composeR,
									A2(
										$author$project$Pages$Util$PaginationSettings$updateCurrentPage,
										{lt: $author$project$Pages$Util$Choice$Pagination$lenses.g9, $8: $author$project$Pages$Util$Choice$Page$lenses.hM.$8},
										main),
									$author$project$Pages$Util$Choice$Page$SetPagination)
							})
						]))
				]));
	});
var $author$project$Pages$DashboardEntries$Entries$View$viewEntries = function (main) {
	return A2(
		$author$project$Pages$Util$Choice$View$viewElements,
		{
			kd: main.dL.X,
			kj: function ($) {
				return $.f;
			},
			gA: main.dL.aw,
			ku: main.dL.ay,
			aB: F2(
				function (_v0, _v1) {
					return _List_Nil;
				}),
			kV: $author$project$Pages$DashboardEntries$Entries$View$headerColumns(main.dL),
			bA: main.dL.gP,
			li: function ($) {
				return $.f;
			},
			lo: function (entry) {
				return {
					gH: _List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Pages$Util$Style$classes.dc.Z,
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Util$Choice$Page$RequestDelete(entry.f))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(main.dL.Z)
								])),
							A2($author$project$Pages$Util$NavigationUtil$projectEditorLinkButton, entry.f, main.dL.bS)
						]),
					fi: A2($author$project$Pages$DashboardEntries$Entries$View$projectInfoFromMap, main.kl, entry.f)
				};
			},
			lr: $elm$core$Basics$always(true),
			lN: function ($) {
				return $.hV;
			},
			mA: main.dL.aO
		},
		main);
};
var $author$project$Pages$Util$Parent$Page$CancelDelete = {$: 8};
var $author$project$Pages$Util$Parent$Page$ConfirmDelete = {$: 7};
var $author$project$Pages$Util$Parent$Page$Edit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Util$Parent$Page$EnterEdit = {$: 4};
var $author$project$Pages$Util$Parent$Page$ExitEdit = {$: 5};
var $author$project$Pages$Util$Parent$Page$RequestDelete = {$: 6};
var $author$project$Pages$Util$Parent$Page$SaveEdit = {$: 2};
var $author$project$Pages$Util$Parent$Page$ToggleControls = {$: 10};
var $author$project$Pages$Dashboards$View$dashboardInfoColumns = function (dashboard) {
	return _List_fromArray(
		[
			{
			b1: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.bs]),
			e8: _List_fromArray(
				[
					$elm$html$Html$text(dashboard.bA)
				])
		},
			{
			b1: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.bs]),
			e8: _List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, '', dashboard.dq))
				])
		},
			{
			b1: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.bs]),
			e8: _List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$LondoGQL$Enum$Visibility$toString(dashboard.jN))
				])
		}
		]);
};
var $author$project$Pages$Util$ParentEditor$View$lineWith = F2(
	function (ps, parent) {
		var row = ps.mx(parent);
		var displayColumns = A2(
			$elm$core$List$map,
			$author$project$Pages$Util$HtmlUtil$withExtraAttributes(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(ps.jv)
					])),
			row.fi);
		var infoRow = A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.kQ]),
			_Utils_ap(
				displayColumns,
				_List_fromArray(
					[
						$author$project$Pages$Util$HtmlUtil$toggleControlsCell(ps.jv)
					])));
		var controlsRow = A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.gH]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(
							$elm$core$List$length(displayColumns))
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$p, _List_Nil, row.gH)
						]))
				]));
		return A2(
			$elm$core$List$cons,
			infoRow,
			ps.i1 ? _List_fromArray(
				[controlsRow]) : _List_Nil);
	});
var $author$project$Pages$Dashboards$View$dashboardLineWith = function (ps) {
	return $author$project$Pages$Util$ParentEditor$View$lineWith(
		{
			mx: function (dashboard) {
				return {
					gH: ps.gH,
					fi: $author$project$Pages$Dashboards$View$dashboardInfoColumns(dashboard)
				};
			},
			i1: ps.i1,
			jv: ps.jv
		});
};
var $author$project$Pages$Util$ParentEditor$View$controlsRowWith = function (ps) {
	return A2(
		$elm$html$Html$tr,
		_List_fromArray(
			[$author$project$Pages$Util$Style$classes.gH]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$colspan(ps.kp)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								$elm_community$maybe_extra$Maybe$Extra$values(
									_List_fromArray(
										[
											$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.dc.gD),
											$author$project$Util$MaybeUtil$defined(
											$elm$html$Html$Attributes$disabled(!ps.nb)),
											A2(
											$author$project$Util$MaybeUtil$optional,
											ps.nb,
											$elm$html$Html$Events$onClick(ps.gD.hT))
										])),
								_List_fromArray(
									[
										$elm$html$Html$text(ps.gD.hV)
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.dc.X,
										$elm$html$Html$Events$onClick(ps.X.hT)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(ps.X.hV)
									]))
							]))
					]))
			]));
};
var $abadi199$elm_input_extra$Dropdown$onChange = F2(
	function (emptyItem, tagger) {
		var textToMaybe = function (string) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nc;
						},
						$elm$core$Basics$eq(string)),
					emptyItem)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
		};
		return A2(
			$elm$html$Html$Events$on,
			'change',
			A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeR, textToMaybe, tagger),
				$elm$html$Html$Events$targetValue));
	});
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $abadi199$elm_input_extra$Dropdown$dropdown = F3(
	function (options, attributes, currentValue) {
		var itemsWithEmptyItems = function () {
			var _v1 = options.k_;
			if (!_v1.$) {
				var emptyItem = _v1.a;
				return A2($elm$core$List$cons, emptyItem, options.lt);
			} else {
				return options.lt;
			}
		}();
		var isSelected = function (value) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$eq(value),
					currentValue));
		};
		var toOption = function (_v0) {
			var value = _v0.nc;
			var text = _v0.jp;
			var enabled = _v0.k$;
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(value),
						$elm$html$Html$Attributes$selected(
						isSelected(value)),
						$elm$html$Html$Attributes$disabled(!enabled)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(text)
					]));
		};
		return A2(
			$elm$html$Html$select,
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						A2($abadi199$elm_input_extra$Dropdown$onChange, options.k_, options.l$)
					])),
			A2($elm$core$List$map, toOption, itemsWithEmptyItems));
	});
var $author$project$LondoGQL$Enum$Visibility$fromString = function (enumString____) {
	switch (enumString____) {
		case 'Private':
			return $elm$core$Maybe$Just(0);
		case 'Public':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Util$ValidatedInput$isValid = function (fromInput) {
	var _v0 = fromInput.a6(fromInput.jp);
	if (!_v0.$) {
		var v = _v0.a;
		return _Utils_eq(v, fromInput.nc);
	} else {
		return false;
	}
};
var $author$project$Util$ValidatedInput$setWithLens = F3(
	function (lens, txt, model) {
		var validatedInput = lens.dy(model);
		var possiblyValid = ($elm$core$String$isEmpty(txt) || validatedInput.bP(txt)) ? A2($author$project$Util$ValidatedInput$lenses.jp.f$, txt, validatedInput) : validatedInput;
		var _v0 = validatedInput.a6(txt);
		if (!_v0.$) {
			var v = _v0.a;
			return A3(
				$elm_community$basics_extra$Basics$Extra$flip,
				lens.f$,
				model,
				A2($author$project$Util$ValidatedInput$lenses.nc.f$, v, possiblyValid));
		} else {
			return A2(lens.f$, possiblyValid, model);
		}
	});
var $author$project$Util$ValidatedInput$lift = function (lens) {
	return A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		A2(
			$elm$core$Basics$composeR,
			lens.dy,
			function ($) {
				return $.jp;
			}),
		$author$project$Util$ValidatedInput$setWithLens(lens));
};
var $author$project$LondoGQL$Enum$Visibility$list = _List_fromArray(
	[0, 1]);
var $author$project$Pages$Dashboards$View$editDashboardLineWith = F2(
	function (handling, editedValue) {
		var visibilityToItem = function (visibility) {
			var stringValue = $author$project$LondoGQL$Enum$Visibility$toString(visibility);
			return {k$: true, jp: stringValue, nc: stringValue};
		};
		var validInput = A2(
			$elm$core$List$all,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$author$project$Util$ValidatedInput$isValid(
					handling.k9.dy(editedValue))
				]));
		var validatedSaveAction = A2(
			$author$project$Util$MaybeUtil$optional,
			validInput,
			$elm_community$html_extra$Html$Events$Extra$onEnter(handling.mz));
		var infoColumns = _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.bs]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						$elm_community$maybe_extra$Maybe$Extra$values(
							_List_fromArray(
								[
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Attributes$value(
										handling.k9.dy(editedValue).jp)),
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeR,
											A2(
												$elm_community$basics_extra$Basics$Extra$flip,
												$author$project$Util$ValidatedInput$lift(handling.k9).f$,
												editedValue),
											handling.m8))),
									$author$project$Util$MaybeUtil$defined(
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.kb)),
									validatedSaveAction
								])),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.bs]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						$elm_community$maybe_extra$Maybe$Extra$values(
							_List_fromArray(
								[
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Attributes$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											handling.kL.dy(editedValue)))),
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeR,
											A2(
												$elm_community$basics_extra$Basics$Extra$flip,
												A2(
													$elm$core$Basics$composeR,
													$elm$core$Maybe$Just,
													A2(
														$elm$core$Basics$composeR,
														$elm_community$maybe_extra$Maybe$Extra$filter(
															A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
														handling.kL.f$)),
												editedValue),
											handling.m8))),
									$author$project$Util$MaybeUtil$defined(
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.kb)),
									validatedSaveAction
								])),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.bs]),
				_List_fromArray(
					[
						A3(
						$abadi199$elm_input_extra$Dropdown$dropdown,
						{
							k_: $elm$core$Maybe$Nothing,
							lt: A2($elm$core$List$map, visibilityToItem, $author$project$LondoGQL$Enum$Visibility$list),
							l$: A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$andThen($author$project$LondoGQL$Enum$Visibility$fromString),
								A2(
									$elm$core$Basics$composeR,
									A2(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										editedValue,
										A2($elm_community$basics_extra$Basics$Extra$flip, handling.ni.f$, editedValue)),
									handling.m8))
						},
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$LondoGQL$Enum$Visibility$toString(
								handling.ni.dy(editedValue))))
					]))
			]);
		var controlsRow = $author$project$Pages$Util$ParentEditor$View$controlsRowWith(
			{
				X: {hT: handling.kb, hV: handling.kc},
				kp: $elm$core$List$length(infoColumns),
				gD: {hT: handling.mz, hV: handling.kv},
				nb: validInput
			});
		var commandToggle = A2(
			$elm$core$List$map,
			$author$project$Pages$Util$HtmlUtil$toggleControlsCell,
			$elm_community$maybe_extra$Maybe$Extra$toList(handling.m4));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				handling.mw,
				_Utils_ap(infoColumns, commandToggle)),
				controlsRow
			]);
	});
var $author$project$Types$Dashboard$Update$lenses = {
	dq: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.dq;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{dq: b});
			})),
	bA: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.bA;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{bA: b});
			})),
	jN: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.jN;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{jN: b});
			}))
};
var $author$project$Pages$Util$ParentEditor$View$tableHeaderWith = function (ps) {
	return A2(
		$elm$html$Html$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.mY, ps.mT]),
				_Utils_ap(
					ps.kr,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$th,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.jt]),
							_List_Nil)
						])))
			]));
};
var $author$project$Pages$Dashboards$View$tableHeader = function (language) {
	return $author$project$Pages$Util$ParentEditor$View$tableHeaderWith(
		{
			kr: _List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(language.bA)
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(language.dq)
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(language.jN)
						]))
				]),
			mT: $author$project$Pages$Util$Style$classes.kB
		});
};
var $author$project$Pages$Util$Parent$View$viewMain = F2(
	function (ps, main) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.kY]),
			A2(
				$elm$core$List$cons,
				ps.mY(main.dL),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$author$project$Util$Editing$unpack,
							{l0: ps.l0, l1: ps.l1, l4: ps.l4},
							main.me))
					])));
	});
var $author$project$Pages$DashboardEntries$Dashboard$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$Parent$View$viewMain,
		{
			l0: $author$project$Pages$Dashboards$View$dashboardLineWith(
				{
					gH: _List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.dc.Z,
											$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$ConfirmDelete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(main.dL.ay)
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.dc.gD,
											$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$CancelDelete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(main.dL.X)
										]))
								]))
						]),
					i1: true,
					jv: $author$project$Pages$Util$Parent$Page$ToggleControls
				}),
			l1: $elm$core$Basics$always(
				$author$project$Pages$Dashboards$View$editDashboardLineWith(
					{
						kb: $author$project$Pages$Util$Parent$Page$ExitEdit,
						kc: main.dL.X,
						kv: main.dL.aO,
						kL: $author$project$Types$Dashboard$Update$lenses.dq,
						k9: $author$project$Types$Dashboard$Update$lenses.bA,
						mw: _List_Nil,
						mz: $author$project$Pages$Util$Parent$Page$SaveEdit,
						m4: $elm$core$Maybe$Just($author$project$Pages$Util$Parent$Page$ToggleControls),
						m8: $author$project$Pages$Util$Parent$Page$Edit,
						ni: $author$project$Types$Dashboard$Update$lenses.jN
					})),
			l4: F2(
				function (dashboard, showControls) {
					return A2(
						$author$project$Pages$Dashboards$View$dashboardLineWith,
						{
							gH: _List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.dc.aB,
											$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$EnterEdit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(main.dL.aB)
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.dc.Z,
											$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$RequestDelete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(main.dL.Z)
										]))
								]),
							i1: showControls,
							jv: $author$project$Pages$Util$Parent$Page$ToggleControls
						},
						dashboard);
				}),
			mY: $author$project$Pages$Dashboards$View$tableHeader
		},
		main);
};
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$Pages$Util$ViewUtil$navigationBarWith = function (ps) {
	return A2(
		$elm$html$Html$nav,
		_List_fromArray(
			[$author$project$Pages$Util$Style$ids.lR]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (page) {
										return A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													ps.ie(page)
												]));
									},
									ps.hX))
							]))
					]))
			]));
};
var $author$project$Pages$Util$ViewUtil$Dashboards = 1;
var $author$project$Pages$Util$ViewUtil$Projects = 0;
var $author$project$Pages$Util$ViewUtil$UserSettings = 2;
var $author$project$Pages$Util$ViewUtil$navigationPages = _List_fromArray(
	[0, 1, 2]);
var $author$project$Pages$Util$ViewUtil$addressSuffix = function (page) {
	var parts = function () {
		switch (page) {
			case 0:
				return $author$project$Addresses$Frontend$projects.gh(0);
			case 1:
				return $author$project$Addresses$Frontend$dashboards.gh(0);
			case 2:
				return $author$project$Addresses$Frontend$settings.gh(0);
			case 3:
				return $author$project$Addresses$Frontend$login.gh(0);
			default:
				return $author$project$Addresses$Frontend$overview.gh(0);
		}
	}();
	return $elm$core$String$concat(parts);
};
var $author$project$Pages$Util$ViewUtil$nameOf = function (page) {
	switch (page) {
		case 0:
			return 'Projects';
		case 1:
			return 'Dashboards';
		case 2:
			return 'Settings';
		case 3:
			return 'Login';
		default:
			return 'Overview';
	}
};
var $author$project$Pages$Util$ViewUtil$navigationLink = function (ps) {
	return A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[ps.V]),
		_List_Nil);
};
var $author$project$Pages$Util$ViewUtil$navigationToPageButtonWith = function (ps) {
	var navigationAttributes = _List_fromArray(
		[$author$project$Pages$Util$Style$classes.dc.lR]);
	var isDisabled = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		false,
		function (current) {
			return _Utils_eq(current, ps.V);
		},
		ps.kz);
	return isDisabled ? A2(
		$elm$html$Html$p,
		A2($elm$core$List$cons, $author$project$Pages$Util$Style$classes.kN, navigationAttributes),
		_List_fromArray(
			[
				$elm$html$Html$text(
				ps.fH(ps.V))
			])) : $author$project$Pages$Util$Links$linkButton(
		{
			b1: navigationAttributes,
			hI: ps.fH(ps.V),
			jJ: $author$project$Pages$Util$ViewUtil$navigationLink(
				{
					V: ps.gi(ps.V)
				})
		});
};
var $author$project$Pages$Util$ViewUtil$navigationToPageButton = function (ps) {
	return $author$project$Pages$Util$ViewUtil$navigationToPageButtonWith(
		{gi: $author$project$Pages$Util$ViewUtil$addressSuffix, kz: ps.kz, fH: $author$project$Pages$Util$ViewUtil$nameOf, V: ps.V});
};
var $author$project$Pages$Util$ViewUtil$navigationBar = function (ps) {
	return $author$project$Pages$Util$ViewUtil$navigationBarWith(
		{
			hX: $author$project$Pages$Util$ViewUtil$navigationPages,
			ie: function (page) {
				return $author$project$Pages$Util$ViewUtil$navigationToPageButton(
					{kz: ps.kz, V: page});
			}
		});
};
var $author$project$Pages$Util$ViewUtil$viewMainWith = F2(
	function (ps, html) {
		var navigation = A2(
			$elm$core$List$filter,
			$elm$core$Basics$always(ps.mM),
			_List_fromArray(
				[
					$author$project$Pages$Util$ViewUtil$navigationBar(
					{kz: ps.kz})
				]));
		return _List_fromArray(
			[
				A2($elm$html$Html$header, _List_Nil, navigation),
				A2(
				$elm$html$Html$main_,
				_List_fromArray(
					[ps.lf]),
				html)
			]);
	});
var $author$project$Pages$Util$Choice$Page$Create = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Util$Choice$Page$DeselectChoice = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Util$Choice$Page$SelectChoice = function (a) {
	return {$: 13, a: a};
};
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $elm_community$basics_extra$Basics$Extra$uncurry = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2(f, a, b);
	});
var $author$project$Util$DictList$any = function (p) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Util$DictList$toList,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$list_extra$List$Extra$find(
				$elm_community$basics_extra$Basics$Extra$uncurry(p)),
			$elm_community$maybe_extra$Maybe$Extra$isJust));
};
var $author$project$Util$DictListUtil$existsValue = function (p) {
	return $author$project$Util$DictList$any(
		$elm$core$Basics$always(p));
};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Util$Choice$Page$SetChoicesSearchString = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Util$Choice$Page$ToggleChoiceControls = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Util$Choice$View$editElementCreation = F3(
	function (ps, choice, creation) {
		var rowWithControls = A2(ps.kT, choice, creation);
		var controlsRow = A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.gH]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(
							$elm$core$List$length(rowWithControls.fi))
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$p, _List_Nil, rowWithControls.gH)
						]))
				]));
		var choiceId = ps.lh(choice);
		var toggleMsg = $author$project$Pages$Util$Choice$Page$ToggleChoiceControls(choiceId);
		var creationRow = A2(
			$elm$html$Html$tr,
			_List_Nil,
			_Utils_ap(
				A2(
					$elm$core$List$map,
					$author$project$Pages$Util$HtmlUtil$withExtraAttributes(_List_Nil),
					rowWithControls.fi),
				_List_fromArray(
					[
						$author$project$Pages$Util$HtmlUtil$toggleControlsCell(toggleMsg)
					])));
		return _List_fromArray(
			[creationRow, controlsRow]);
	});
var $author$project$Pages$Util$Choice$View$viewChoiceLine = F3(
	function (ps, choice, showControls) {
		var toggleCommand = $author$project$Pages$Util$Choice$Page$ToggleChoiceControls(
			ps.lh(choice));
		var rowWithControls = ps.gy(choice);
		var columns = A2(
			$elm$core$List$map,
			$author$project$Pages$Util$HtmlUtil$withExtraAttributes(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(toggleCommand)
					])),
			rowWithControls.fi);
		var controlsRow = A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.gH]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$colspan(
							$elm$core$List$length(columns))
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$p, _List_Nil, rowWithControls.gH)
						]))
				]));
		var infoRow = A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.kQ]),
			_Utils_ap(
				columns,
				_List_fromArray(
					[
						$author$project$Pages$Util$HtmlUtil$toggleControlsCell(toggleCommand)
					])));
		return A2(
			$elm$core$List$cons,
			infoRow,
			showControls ? _List_fromArray(
				[controlsRow]) : _List_Nil);
	});
var $author$project$Pages$Util$Choice$View$viewChoices = F2(
	function (ps, main) {
		var paginatedChoices = A3(
			$author$project$Pages$Util$ViewUtil$paginate,
			{
				$8: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$Choice$Pagination$lenses.kl, $author$project$Pages$Util$Choice$Page$lenses.hM.$8).dy
			},
			main,
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ic;
					},
					ps.mO),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ic;
						},
						ps.lF(main.km)),
					$author$project$Util$DictList$values(main.kl))));
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.jX]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(ps.bA)
						])),
					$author$project$Pages$Util$HtmlUtil$searchAreaWith(
					{ko: ps.gA, hT: $author$project$Pages$Util$Choice$Page$SetChoicesSearchString, cD: main.km}),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.kY]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[$author$project$Pages$Util$Style$classes.mY]),
									_Utils_ap(
										ps.kh,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$th,
												_List_fromArray(
													[$author$project$Pages$Util$Style$classes.jt]),
												_List_Nil)
											])))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							A2(
								$elm$core$List$concatMap,
								$author$project$Util$Editing$unpack(
									{
										l0: $elm$core$Basics$always(_List_Nil),
										l1: $author$project$Pages$Util$Choice$View$editElementCreation(
											{kT: ps.kT, lh: ps.lh}),
										l4: $author$project$Pages$Util$Choice$View$viewChoiceLine(
											{gy: ps.ne, lh: ps.lh})
									}),
								$jschomay$elm_paginate$Paginate$page(paginatedChoices)))
						])),
					A2(
					$elm$html$Html$nav,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.$8]),
					_List_fromArray(
						[
							$author$project$Pages$Util$ViewUtil$pagerButtons(
							{
								g9: paginatedChoices,
								hT: A2(
									$elm$core$Basics$composeR,
									A2(
										$author$project$Pages$Util$PaginationSettings$updateCurrentPage,
										{lt: $author$project$Pages$Util$Choice$Pagination$lenses.kl, $8: $author$project$Pages$Util$Choice$Page$lenses.hM.$8},
										main),
									$author$project$Pages$Util$Choice$Page$SetPagination)
							})
						]))
				]));
	});
var $author$project$Pages$DashboardEntries$Entries$View$viewProjects = function (main) {
	return A2(
		$author$project$Pages$Util$Choice$View$viewChoices,
		{
			kh: $author$project$Pages$DashboardEntries$Entries$View$headerColumns(main.dL),
			gA: main.dL.aw,
			kT: F2(
				function (project, creation) {
					var validInput = $elm_community$maybe_extra$Maybe$Extra$isNothing(
						A2($author$project$Util$DictList$get, creation.f, main.g9));
					var confirmName = A2(
						$author$project$Util$DictListUtil$existsValue,
						function (choice) {
							return _Utils_eq(choice.ic.f, creation.f);
						},
						main.g9) ? main.dL.gg : main.dL.bi;
					var cancelMsg = $author$project$Pages$Util$Choice$Page$DeselectChoice(project.lf);
					var addMsg = $author$project$Pages$Util$Choice$Page$Create(project.lf);
					return {
						gH: _List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								$elm_community$maybe_extra$Maybe$Extra$values(
									_List_fromArray(
										[
											$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.dc.gD),
											$author$project$Util$MaybeUtil$defined(
											$elm$html$Html$Attributes$disabled(!validInput)),
											A2(
											$author$project$Util$MaybeUtil$optional,
											validInput,
											$elm$html$Html$Events$onClick(addMsg))
										])),
								_List_fromArray(
									[
										$elm$html$Html$text(confirmName)
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.dc.X,
										$elm$html$Html$Events$onClick(cancelMsg)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(main.dL.X)
									]))
							]),
						fi: $author$project$Pages$Projects$View$projectInfoColumns(project)
					};
				}),
			bA: main.dL.eh,
			lh: function ($) {
				return $.lf;
			},
			lF: F2(
				function (string, project) {
					return A2($author$project$Util$SearchUtil$search, string, project.hV) || A2(
						$author$project$Util$SearchUtil$search,
						string,
						A2($elm$core$Maybe$withDefault, '', project.dq));
				}),
			mO: function ($) {
				return $.hV;
			},
			ne: function (project) {
				return {
					gH: _List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Pages$Util$Style$classes.dc.i_,
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Util$Choice$Page$SelectChoice(project))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(main.dL.i_)
								])),
							A2($author$project$Pages$Util$NavigationUtil$projectEditorLinkButton, project.lf, main.dL.bS)
						]),
					fi: $author$project$Pages$Projects$View$projectInfoColumns(project)
				};
			}
		},
		main);
};
var $author$project$Pages$DashboardEntries$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{kz: $elm$core$Maybe$Nothing, lf: $author$project$Pages$Util$Style$ids.$7, mM: true},
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$DashboardEntries$Page$DashboardMsg,
				$author$project$Pages$DashboardEntries$Dashboard$View$viewMain(main.ff)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$DashboardEntries$Page$EntriesMsg,
				$author$project$Pages$DashboardEntries$Entries$View$viewEntries(main.fk)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$DashboardEntries$Page$EntriesMsg,
				$author$project$Pages$DashboardEntries$Entries$View$viewProjects(main.fk))
			]));
};
var $author$project$Pages$DashboardEntries$View$view = $author$project$Pages$View$Tristate$view(
	{mL: true, ng: $author$project$Pages$DashboardEntries$View$viewMain});
var $author$project$Pages$Util$ParentEditor$Page$SetPagination = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$SetSearchString = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$UpdateCreation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$Create = {$: 1};
var $author$project$Types$Dashboard$Creation$lenses = {
	dq: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.dq;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{dq: b});
			})),
	bA: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.bA;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{bA: b});
			})),
	jN: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.jN;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{jN: b});
			}))
};
var $author$project$Pages$Dashboards$View$createDashboardLine = function (language) {
	return $author$project$Pages$Dashboards$View$editDashboardLineWith(
		{
			kb: $author$project$Pages$Util$ParentEditor$Page$UpdateCreation($elm$core$Maybe$Nothing),
			kc: language.X,
			kv: language.bi,
			kL: $author$project$Types$Dashboard$Creation$lenses.dq,
			k9: $author$project$Types$Dashboard$Creation$lenses.bA,
			mw: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.g7]),
			mz: $author$project$Pages$Util$ParentEditor$Page$Create,
			m4: $elm$core$Maybe$Nothing,
			m8: A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Pages$Util$ParentEditor$Page$UpdateCreation),
			ni: $author$project$Types$Dashboard$Creation$lenses.jN
		});
};
var $author$project$Types$Dashboard$Creation$default = {dq: $elm$core$Maybe$Nothing, bA: $author$project$Util$ValidatedInput$nonEmptyString, jN: 0};
var $author$project$Pages$Util$ParentEditor$Page$CancelDelete = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$ConfirmDelete = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$ToggleControls = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Dashboards$View$deleteDashboardLine = F2(
	function (language, dashboard) {
		return A2(
			$author$project$Pages$Dashboards$View$dashboardLineWith,
			{
				gH: _List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$author$project$Pages$Util$Style$classes.dc.Z,
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Util$ParentEditor$Page$ConfirmDelete(dashboard.lf))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(language.ay)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$author$project$Pages$Util$Style$classes.dc.gD,
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Util$ParentEditor$Page$CancelDelete(dashboard.lf))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(language.X)
							]))
					]),
				i1: true,
				jv: $author$project$Pages$Util$ParentEditor$Page$ToggleControls(dashboard.lf)
			},
			dashboard);
	});
var $author$project$Pages$Util$ParentEditor$Page$Edit = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Util$ParentEditor$Page$ExitEdit = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$SaveEdit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Dashboards$View$updateDashboardLine = F3(
	function (language, dashboardId, dashboardUpdateClientInput) {
		return A2(
			$author$project$Pages$Dashboards$View$editDashboardLineWith,
			{
				kb: $author$project$Pages$Util$ParentEditor$Page$ExitEdit(dashboardId),
				kc: language.X,
				kv: language.aO,
				kL: $author$project$Types$Dashboard$Update$lenses.dq,
				k9: $author$project$Types$Dashboard$Update$lenses.bA,
				mw: _List_fromArray(
					[$author$project$Pages$Util$Style$classes.g7]),
				mz: $author$project$Pages$Util$ParentEditor$Page$SaveEdit(dashboardId),
				m4: $elm$core$Maybe$Just(
					$author$project$Pages$Util$ParentEditor$Page$ToggleControls(dashboardId)),
				m8: $author$project$Pages$Util$ParentEditor$Page$Edit(dashboardId),
				ni: $author$project$Types$Dashboard$Update$lenses.jN
			},
			dashboardUpdateClientInput);
	});
var $author$project$Pages$Util$ParentEditor$Page$EnterEdit = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Util$ParentEditor$Page$RequestDelete = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Dashboards$View$viewDashboardLine = F3(
	function (language, dashboard, showControls) {
		return A2(
			$author$project$Pages$Dashboards$View$dashboardLineWith,
			{
				gH: _List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$author$project$Pages$Util$Style$classes.dc.aB,
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Util$ParentEditor$Page$EnterEdit(dashboard.lf))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(language.aB)
							])),
						$author$project$Pages$Util$Links$linkButton(
						{
							b1: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.dc.kR]),
							hI: language.$7,
							jJ: $author$project$Pages$Util$Links$frontendPage(
								$author$project$Addresses$Frontend$dashboardEntries.gh(dashboard.lf))
						}),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$author$project$Pages$Util$Style$classes.dc.Z,
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Util$ParentEditor$Page$RequestDelete(dashboard.lf))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(language.Z)
							])),
						$author$project$Pages$Util$Links$linkButton(
						{
							b1: _List_fromArray(
								[$author$project$Pages$Util$Style$classes.dc.lR]),
							hI: 'Statistics',
							jJ: $author$project$Pages$Util$Links$frontendPage(
								$author$project$Addresses$Frontend$statistics.gh(dashboard.lf))
						})
					]),
				i1: showControls,
				jv: $author$project$Pages$Util$ParentEditor$Page$ToggleControls(dashboard.lf)
			},
			dashboard);
	});
var $author$project$Pages$Util$ParentEditor$View$creationButton = function (ps) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$author$project$Pages$Util$Style$classes.dc.lS,
				$elm$html$Html$Events$onClick(
				ps.jG(
					$elm$core$Maybe$Just(ps.gU)))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(ps.lw)
			]));
};
var $author$project$Util$DictList$filter = F2(
	function (p, dictList) {
		return A3(
			$arturopala$elm_monocle$Monocle$Lens$modify,
			$author$project$Util$DictList$lenses.g9,
			$elm$core$List$filter(
				$elm_community$basics_extra$Basics$Extra$uncurry(p)),
			dictList);
	});
var $author$project$Pages$Util$ParentEditor$View$viewParentsWith = F3(
	function (ps, language, main) {
		return A2(
			$author$project$Pages$Util$ViewUtil$viewMainWith,
			{kz: ps.kz, lf: ps.mU, mM: ps.mM},
			function () {
				var viewParents = A3(
					$author$project$Pages$Util$ViewUtil$paginate,
					{
						$8: A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$ParentEditor$Pagination$lenses.mg, $author$project$Pages$Util$ParentEditor$Page$lenses.hM.$8).dy
					},
					main,
					ps.mN(
						$author$project$Util$DictList$values(
							A2(
								$author$project$Util$DictList$filter,
								F2(
									function (_v1, v) {
										return A2(ps.lF, main.cD, v.ic);
									}),
								main.mg))));
				var viewParent = $author$project$Util$Editing$unpack(
					{
						l0: ps.kJ(language),
						l1: ps.m7(language),
						l4: ps.nf(language)
					});
				var _v0 = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_Utils_Tuple2(
						_List_fromArray(
							[
								$author$project$Pages$Util$ParentEditor$View$creationButton(
								{
									gU: ps.br.kH,
									lw: ps.br.lw(language),
									jG: ps.br.m5
								})
							]),
						_List_Nil),
					A2(
						$elm$core$Basics$composeR,
						ps.br.ll(language),
						$elm$core$Tuple$pair(_List_Nil)),
					main.fQ);
				var button = _v0.a;
				var creationLine = _v0.b;
				return _Utils_ap(
					button,
					_List_fromArray(
						[
							$author$project$Pages$Util$HtmlUtil$searchAreaWith(
							{ko: ps.gA, hT: ps.mJ, cD: main.cD}),
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.kY]),
							A2(
								$elm$core$List$cons,
								ps.mY,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tbody,
										_List_Nil,
										_Utils_ap(
											creationLine,
											A2(
												$elm$core$List$concatMap,
												viewParent,
												$jschomay$elm_paginate$Paginate$page(viewParents))))
									]))),
							A2(
							$elm$html$Html$nav,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.$8]),
							_List_fromArray(
								[
									$author$project$Pages$Util$ViewUtil$pagerButtons(
									{
										g9: viewParents,
										hT: A2(
											$elm$core$Basics$composeR,
											A2(
												$author$project$Pages$Util$PaginationSettings$updateCurrentPage,
												{lt: $author$project$Pages$Util$ParentEditor$Pagination$lenses.mg, $8: $author$project$Pages$Util$ParentEditor$Page$lenses.hM.$8},
												main),
											ps.mI)
									})
								]))
						]));
			}());
	});
var $author$project$Pages$Dashboards$View$viewMain = function (main) {
	return A3(
		$author$project$Pages$Util$ParentEditor$View$viewParentsWith,
		{
			gA: main.dL.aw,
			br: {
				kH: $author$project$Types$Dashboard$Creation$default,
				ll: $author$project$Pages$Dashboards$View$createDashboardLine,
				lw: function ($) {
					return $.hY;
				},
				m5: $author$project$Pages$Util$ParentEditor$Page$UpdateCreation
			},
			kz: $elm$core$Maybe$Just(1),
			kJ: $author$project$Pages$Dashboards$View$deleteDashboardLine,
			lF: F2(
				function (string, dashboard) {
					return A2($author$project$Util$SearchUtil$search, string, dashboard.bA) || A2(
						$author$project$Util$SearchUtil$search,
						string,
						A2($elm$core$Maybe$withDefault, '', dashboard.dq));
				}),
			mI: $author$project$Pages$Util$ParentEditor$Page$SetPagination,
			mJ: $author$project$Pages$Util$ParentEditor$Page$SetSearchString,
			mM: true,
			mN: $elm$core$List$sortBy(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ic;
					},
					function ($) {
						return $.bA;
					})),
			mU: $author$project$Pages$Util$Style$ids.jW,
			mY: $author$project$Pages$Dashboards$View$tableHeader(main.dL),
			m7: F2(
				function (language, dashboard) {
					return A2($author$project$Pages$Dashboards$View$updateDashboardLine, language, dashboard.lf);
				}),
			nf: $author$project$Pages$Dashboards$View$viewDashboardLine
		},
		main.dL,
		main);
};
var $author$project$Pages$Dashboards$View$view = $author$project$Pages$View$Tristate$view(
	{mL: true, ng: $author$project$Pages$Dashboards$View$viewMain});
var $author$project$Pages$Deletion$Page$Confirm = {$: 0};
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Pages$Util$Links$toLoginButton = function (params) {
	return $author$project$Pages$Util$Links$toLoginButtonWith(
		{
			b1: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.dc.lR]),
			gr: params.gr
		});
};
var $author$project$Pages$Deletion$View$viewChecking = function (main) {
	var nickname = 'nickname';
	var email = 'email';
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(main.dL.gF)
				])),
			A2(
			$elm$html$Html$form,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(nickname)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(main.dL.R)
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$disabled(true),
							$elm$html$Html$Attributes$value(main.cO.R)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(email)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(main.dL.aC)
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$disabled(true),
							$elm$html$Html$Attributes$value(main.cO.aC)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Pages$Deletion$Page$Confirm),
							$author$project$Pages$Util$Style$classes.dc.Z,
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(main.dL.Z)
						])),
					$author$project$Pages$Util$Links$toLoginButton(
					{gr: main.dL.X})
				]))
		]);
};
var $author$project$Pages$Deletion$View$viewConfirmed = function (language) {
	return _List_fromArray(
		[
			$elm$html$Html$text(language.gY),
			$author$project$Pages$Util$Links$toLoginButton(
			{gr: language.aa})
		]);
};
var $author$project$Pages$Deletion$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{kz: $elm$core$Maybe$Nothing, lf: $author$project$Pages$Util$Style$ids.ge, mM: false},
		function () {
			var _v0 = main.lL;
			if (!_v0) {
				return $author$project$Pages$Deletion$View$viewChecking(main);
			} else {
				return $author$project$Pages$Deletion$View$viewConfirmed(main.dL);
			}
		}());
};
var $author$project$Pages$Deletion$View$view = $author$project$Pages$View$Tristate$view(
	{mL: true, ng: $author$project$Pages$Deletion$View$viewMain});
var $author$project$Pages$Login$Page$Login = {$: 1};
var $author$project$Pages$Login$Page$SetCredentials = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$Types$User$Login$lenses = {
	cl: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.cl;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{cl: b});
			})),
	R: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.R;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{R: b});
			})),
	ec: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.ec;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{ec: b});
			}))
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Pages$Login$View$viewMain = function (main) {
	var username = 'username';
	var password = 'password';
	var keepLoggedIn = 'keep-logged-in';
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[$author$project$Pages$Util$Style$ids.bH]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(main.dL.eQ)
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Events$onSubmit($author$project$Pages$Login$Page$Login)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for(username)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(main.dL.R)
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$autocomplete(true),
									$elm$html$Html$Attributes$value(
									$author$project$Types$User$Login$lenses.R.dy(main.gM)),
									$elm$html$Html$Events$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Pages$Login$Page$SetCredentials,
										A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Types$User$Login$lenses.R.f$, main.gM))),
									$author$project$Pages$Util$Style$classes.bs,
									$elm$html$Html$Attributes$id(username),
									$elm$html$Html$Attributes$type_('text')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for(password)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(main.dL.ec)
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('password'),
									$elm$html$Html$Attributes$autocomplete(true),
									$elm$html$Html$Events$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Pages$Login$Page$SetCredentials,
										A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Types$User$Login$lenses.ec.f$, main.gM))),
									$author$project$Pages$Util$Style$classes.bs,
									$elm$html$Html$Attributes$id(password)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for(keepLoggedIn)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(main.dL.hE)
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$Login$Page$SetCredentials(
										A3($arturopala$elm_monocle$Monocle$Lens$modify, $author$project$Types$User$Login$lenses.cl, $elm$core$Basics$not, main.gM))),
									$author$project$Pages$Util$Style$classes.bs,
									$elm$html$Html$Attributes$id(keepLoggedIn)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Pages$Util$Style$classes.dc.gD,
									$elm$html$Html$Attributes$type_('submit')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(main.dL.bH)
								])),
							$author$project$Pages$Util$Links$linkButton(
							{
								b1: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.dc.lR]),
								hI: main.dL.gK,
								jJ: $author$project$Pages$Util$Links$frontendPage(
									$author$project$Addresses$Frontend$requestRegistration.gh(0))
							}),
							$author$project$Pages$Util$Links$linkButton(
							{
								b1: _List_fromArray(
									[$author$project$Pages$Util$Style$classes.dc.lR]),
								hI: main.dL.iE,
								jJ: $author$project$Pages$Util$Links$frontendPage(
									$author$project$Addresses$Frontend$requestRecovery.gh(0))
							})
						]))
				]))
		]);
};
var $author$project$Pages$Login$View$view = $author$project$Pages$View$Tristate$view(
	{mL: false, ng: $author$project$Pages$Login$View$viewMain});
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$menu = _VirtualDom_node('menu');
var $author$project$Pages$Overview$View$viewMain = function (main) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[$author$project$Pages$Util$Style$ids.id]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$menu,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$Util$Links$linkButton(
									{
										b1: _List_fromArray(
											[$author$project$Pages$Util$Style$classes.dc.id]),
										hI: main.dL.eh,
										jJ: $author$project$Pages$Util$Links$frontendPage(
											$author$project$Addresses$Frontend$projects.gh(0))
									})
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$Util$Links$linkButton(
									{
										b1: _List_fromArray(
											[$author$project$Pages$Util$Style$classes.dc.id]),
										hI: main.dL.gS,
										jJ: $author$project$Pages$Util$Links$frontendPage(
											$author$project$Addresses$Frontend$dashboards.gh(0))
									})
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$Util$Links$linkButton(
									{
										b1: _List_fromArray(
											[$author$project$Pages$Util$Style$classes.dc.id]),
										hI: main.dL.i0,
										jJ: $author$project$Pages$Util$Links$frontendPage(
											$author$project$Addresses$Frontend$settings.gh(0))
									})
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Overview$View$view = $author$project$Pages$View$Tristate$view(
	{mL: true, ng: $author$project$Pages$Overview$View$viewMain});
var $author$project$Pages$Projects$View$editProjectLineWith = F2(
	function (handling, editedValue) {
		var validInput = A2(
			$elm$core$List$all,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$author$project$Util$ValidatedInput$isValid(
					handling.ct.dy(editedValue))
				]));
		var validatedSaveAction = A2(
			$author$project$Util$MaybeUtil$optional,
			validInput,
			$elm_community$html_extra$Html$Events$Extra$onEnter(handling.mz));
		var infoColumns = _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.bs]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						$elm_community$maybe_extra$Maybe$Extra$values(
							_List_fromArray(
								[
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Attributes$value(
										handling.ct.dy(editedValue).jp)),
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeR,
											A2(
												$elm_community$basics_extra$Basics$Extra$flip,
												$author$project$Util$ValidatedInput$lift(handling.ct).f$,
												editedValue),
											handling.m8))),
									$author$project$Util$MaybeUtil$defined(
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.kb)),
									validatedSaveAction
								])),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.bs]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						$elm_community$maybe_extra$Maybe$Extra$values(
							_List_fromArray(
								[
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Attributes$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											handling.kL.dy(editedValue)))),
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeR,
											A2(
												$elm_community$basics_extra$Basics$Extra$flip,
												A2(
													$elm$core$Basics$composeR,
													$elm$core$Maybe$Just,
													A2(
														$elm$core$Basics$composeR,
														$elm_community$maybe_extra$Maybe$Extra$filter(
															A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
														handling.kL.f$)),
												editedValue),
											handling.m8))),
									$author$project$Util$MaybeUtil$defined(
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.kb)),
									validatedSaveAction
								])),
						_List_Nil)
					]))
			]);
		var controlsRow = $author$project$Pages$Util$ParentEditor$View$controlsRowWith(
			{
				X: {hT: handling.kb, hV: handling.kc},
				kp: $elm$core$List$length(infoColumns),
				gD: {hT: handling.mz, hV: handling.kv},
				nb: validInput
			});
		var commandToggle = A2(
			$elm$core$List$map,
			$author$project$Pages$Util$HtmlUtil$toggleControlsCell,
			$elm_community$maybe_extra$Maybe$Extra$toList(handling.m4));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				handling.mw,
				_Utils_ap(infoColumns, commandToggle)),
				controlsRow
			]);
	});
var $author$project$Types$Project$Creation$lenses = {
	dq: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.dq;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{dq: b});
			})),
	hV: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.hV;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{hV: b});
			}))
};
var $author$project$Pages$Projects$View$createProjectLine = function (language) {
	return $author$project$Pages$Projects$View$editProjectLineWith(
		{
			kb: $author$project$Pages$Util$ParentEditor$Page$UpdateCreation($elm$core$Maybe$Nothing),
			kc: language.X,
			kv: language.bi,
			kL: $author$project$Types$Project$Creation$lenses.dq,
			ct: $author$project$Types$Project$Creation$lenses.hV,
			mw: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.g7]),
			mz: $author$project$Pages$Util$ParentEditor$Page$Create,
			m4: $elm$core$Maybe$Nothing,
			m8: A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Pages$Util$ParentEditor$Page$UpdateCreation)
		});
};
var $author$project$Types$Project$Creation$default = {dq: $elm$core$Maybe$Nothing, hV: $author$project$Util$ValidatedInput$nonEmptyString};
var $author$project$Pages$Projects$View$projectLineWith = function (ps) {
	return $author$project$Pages$Util$ParentEditor$View$lineWith(
		{
			mx: function (project) {
				return {
					gH: ps.gH,
					fi: $author$project$Pages$Projects$View$projectInfoColumns(project)
				};
			},
			i1: ps.i1,
			jv: ps.jv
		});
};
var $author$project$Pages$Projects$View$deleteProjectLine = F2(
	function (language, project) {
		return A2(
			$author$project$Pages$Projects$View$projectLineWith,
			{
				gH: _List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.dc.Z,
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Util$ParentEditor$Page$ConfirmDelete(project.lf))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(language.ay)
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.dc.gD,
										$elm$html$Html$Events$onClick(
										$author$project$Pages$Util$ParentEditor$Page$CancelDelete(project.lf))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(language.X)
									]))
							]))
					]),
				i1: true,
				jv: $author$project$Pages$Util$ParentEditor$Page$ToggleControls(project.lf)
			},
			project);
	});
var $author$project$Pages$Projects$View$tableHeader = function (language) {
	return $author$project$Pages$Util$ParentEditor$View$tableHeaderWith(
		{
			kr: _List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(language.hV)
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(language.dq)
						]))
				]),
			mT: $author$project$Pages$Util$Style$classes.mk
		});
};
var $author$project$Types$Project$Update$lenses = {
	dq: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.dq;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{dq: b});
			})),
	hV: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.hV;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{hV: b});
			}))
};
var $author$project$Pages$Projects$View$updateProjectLine = F3(
	function (language, projectId, projectUpdateClientInput) {
		return A2(
			$author$project$Pages$Projects$View$editProjectLineWith,
			{
				kb: $author$project$Pages$Util$ParentEditor$Page$ExitEdit(projectId),
				kc: language.X,
				kv: language.aO,
				kL: $author$project$Types$Project$Update$lenses.dq,
				ct: $author$project$Types$Project$Update$lenses.hV,
				mw: _List_fromArray(
					[$author$project$Pages$Util$Style$classes.g7]),
				mz: $author$project$Pages$Util$ParentEditor$Page$SaveEdit(projectId),
				m4: $elm$core$Maybe$Just(
					$author$project$Pages$Util$ParentEditor$Page$ToggleControls(projectId)),
				m8: $author$project$Pages$Util$ParentEditor$Page$Edit(projectId)
			},
			projectUpdateClientInput);
	});
var $author$project$Pages$Projects$View$viewProjectLine = F3(
	function (language, project, showControls) {
		return A2(
			$author$project$Pages$Projects$View$projectLineWith,
			{
				gH: _List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$author$project$Pages$Util$Style$classes.dc.aB,
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Util$ParentEditor$Page$EnterEdit(project.lf))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(language.aB)
							])),
						A2($author$project$Pages$Util$NavigationUtil$projectEditorLinkButton, project.lf, language.bS),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$author$project$Pages$Util$Style$classes.dc.Z,
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Util$ParentEditor$Page$RequestDelete(project.lf))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(language.Z)
							]))
					]),
				i1: showControls,
				jv: $author$project$Pages$Util$ParentEditor$Page$ToggleControls(project.lf)
			},
			project);
	});
var $author$project$Pages$Projects$View$viewMain = function (main) {
	return A3(
		$author$project$Pages$Util$ParentEditor$View$viewParentsWith,
		{
			gA: main.dL.aw,
			br: {
				kH: $author$project$Types$Project$Creation$default,
				ll: $author$project$Pages$Projects$View$createProjectLine,
				lw: function ($) {
					return $.h0;
				},
				m5: $author$project$Pages$Util$ParentEditor$Page$UpdateCreation
			},
			kz: $elm$core$Maybe$Just(0),
			kJ: $author$project$Pages$Projects$View$deleteProjectLine,
			lF: F2(
				function (string, project) {
					return A2($author$project$Util$SearchUtil$search, string, project.hV) || A2(
						$author$project$Util$SearchUtil$search,
						string,
						A2($elm$core$Maybe$withDefault, '', project.dq));
				}),
			mI: $author$project$Pages$Util$ParentEditor$Page$SetPagination,
			mJ: $author$project$Pages$Util$ParentEditor$Page$SetSearchString,
			mM: true,
			mN: $elm$core$List$sortBy(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ic;
					},
					function ($) {
						return $.hV;
					})),
			mU: $author$project$Pages$Util$Style$ids.jY,
			mY: $author$project$Pages$Projects$View$tableHeader(main.dL),
			m7: F2(
				function (language, project) {
					return A2($author$project$Pages$Projects$View$updateProjectLine, language, project.lf);
				}),
			nf: $author$project$Pages$Projects$View$viewProjectLine
		},
		main.dL,
		main);
};
var $author$project$Pages$Projects$View$view = $author$project$Pages$View$Tristate$view(
	{mL: true, ng: $author$project$Pages$Projects$View$viewMain});
var $author$project$Pages$Recovery$Confirm$View$viewConfirmed = function (language) {
	return _List_fromArray(
		[
			$elm$html$Html$text(language.ji),
			$author$project$Pages$Util$Links$toLoginButton(
			{gr: language.aa})
		]);
};
var $author$project$Pages$Recovery$Confirm$Page$Confirm = {$: 1};
var $author$project$Pages$Recovery$Confirm$Page$SetPasswordInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Util$PasswordInput$isValidPassword = function (complementInput) {
	return _Utils_eq(complementInput.ih, complementInput.ii);
};
var $author$project$Pages$Util$PasswordInput$lenses = {
	ih: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.ih;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{ih: b});
			})),
	ii: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.ii;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{ii: b});
			}))
};
var $author$project$Pages$Recovery$Confirm$View$viewResetting = function (main) {
	var password2 = 'password2';
	var password1 = 'password1';
	var isValidPassword = $author$project$Pages$Util$PasswordInput$isValidPassword(main.fR);
	var enterAction = A2(
		$author$project$Util$MaybeUtil$optional,
		isValidPassword,
		$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$Pages$Recovery$Confirm$Page$Confirm));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(main.dL.gf)
				])),
			A2(
			$elm$html$Html$form,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(password1)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(main.dL.dS)
						])),
					A2(
					$elm$html$Html$input,
					$elm_community$maybe_extra$Maybe$Extra$values(
						_List_fromArray(
							[
								$author$project$Util$MaybeUtil$defined(
								$elm$html$Html$Events$onInput(
									A2(
										$elm$core$Basics$composeR,
										A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Pages$Util$PasswordInput$lenses.ih.f$, main.fR),
										$author$project$Pages$Recovery$Confirm$Page$SetPasswordInput))),
								$author$project$Util$MaybeUtil$defined(
								$elm$html$Html$Attributes$type_('password')),
								$author$project$Util$MaybeUtil$defined(
								$elm$html$Html$Attributes$value(
									$author$project$Pages$Util$PasswordInput$lenses.ih.dy(main.fR))),
								$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.bs),
								enterAction,
								$author$project$Util$MaybeUtil$defined(
								$elm$html$Html$Attributes$id(password1))
							])),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(password2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(main.dL.dT)
						])),
					A2(
					$elm$html$Html$input,
					$elm_community$maybe_extra$Maybe$Extra$values(
						_List_fromArray(
							[
								$author$project$Util$MaybeUtil$defined(
								$elm$html$Html$Events$onInput(
									A2(
										$elm$core$Basics$composeR,
										A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Pages$Util$PasswordInput$lenses.ii.f$, main.fR),
										$author$project$Pages$Recovery$Confirm$Page$SetPasswordInput))),
								$author$project$Util$MaybeUtil$defined(
								$elm$html$Html$Attributes$type_('password')),
								$author$project$Util$MaybeUtil$defined(
								$elm$html$Html$Attributes$value(
									$author$project$Pages$Util$PasswordInput$lenses.ii.dy(main.fR))),
								$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.bs),
								enterAction,
								$author$project$Util$MaybeUtil$defined(
								$elm$html$Html$Attributes$id(password2))
							])),
					_List_Nil),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Pages$Recovery$Confirm$Page$Confirm),
							$author$project$Pages$Util$Style$classes.dc.gD,
							$elm$html$Html$Attributes$disabled(!isValidPassword),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(main.dL.eV)
						]))
				]))
		]);
};
var $author$project$Pages$Recovery$Confirm$View$viewMain = function (model) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{kz: $elm$core$Maybe$Nothing, lf: $author$project$Pages$Util$Style$ids.gf, mM: false},
		function () {
			var _v0 = model.lL;
			if (!_v0) {
				return $author$project$Pages$Recovery$Confirm$View$viewResetting(model);
			} else {
				return $author$project$Pages$Recovery$Confirm$View$viewConfirmed(model.dL);
			}
		}());
};
var $author$project$Pages$Recovery$Confirm$View$view = $author$project$Pages$View$Tristate$view(
	{mL: true, ng: $author$project$Pages$Recovery$Confirm$View$viewMain});
var $author$project$Pages$Recovery$Request$Page$Find = {$: 0};
var $author$project$Pages$Recovery$Request$Page$SetSearchString = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $author$project$Pages$Recovery$Request$View$searchComponents = function (main) {
	var isValid = !$elm$core$String$isEmpty(main.cD);
	var identifier = 'identifier';
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(main.dL.iF)
				])),
			A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Events$onSubmit($author$project$Pages$Recovery$Request$Page$Find)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(identifier)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(main.dL.hu)
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput($author$project$Pages$Recovery$Request$Page$SetSearchString),
							$author$project$Pages$Util$Style$classes.bs,
							$elm$html$Html$Attributes$value(main.cD),
							$elm$html$Html$Attributes$id(identifier),
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$required(true)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$author$project$Pages$Util$Style$classes.dc.gD,
							$elm$html$Html$Attributes$disabled(!isValid),
							$elm$html$Html$Attributes$type_('submit')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(main.dL.hi)
						]))
				]))
		]);
};
var $author$project$Pages$Recovery$Request$View$viewInitial = $author$project$Pages$Recovery$Request$View$searchComponents;
var $author$project$Pages$Recovery$Request$View$viewRequested = function (language) {
	return _List_fromArray(
		[
			$elm$html$Html$text(language.iP),
			$author$project$Pages$Util$Links$toLoginButton(
			{gr: language.aa})
		]);
};
var $author$project$Pages$Recovery$Request$Page$RequestRecovery = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Recovery$Request$View$viewRequesting = function (main) {
	var message = $elm$core$List$isEmpty(main.na) ? function ($) {
		return $.h5;
	} : function ($) {
		return $.hU;
	};
	var chooseUser = function (user) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Pages$Recovery$Request$Page$RequestRecovery(user.lf)),
					$author$project$Pages$Util$Style$classes.dc.lR
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(user.R)
				]));
	};
	var remainder = _List_fromArray(
		[
			A2(
			$elm$html$Html$section,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							message(main.dL))
						])),
				A2($elm$core$List$map, chooseUser, main.na)))
		]);
	return _Utils_ap(
		$author$project$Pages$Recovery$Request$View$searchComponents(main),
		remainder);
};
var $author$project$Pages$Recovery$Request$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{kz: $elm$core$Maybe$Nothing, lf: $author$project$Pages$Util$Style$ids.gf, mM: false},
		function () {
			var _v0 = main.lL;
			switch (_v0) {
				case 0:
					return $author$project$Pages$Recovery$Request$View$viewInitial(main);
				case 1:
					return $author$project$Pages$Recovery$Request$View$viewRequesting(main);
				default:
					return $author$project$Pages$Recovery$Request$View$viewRequested(main.dL);
			}
		}());
};
var $author$project$Pages$Recovery$Request$View$view = $author$project$Pages$View$Tristate$view(
	{mL: true, ng: $author$project$Pages$Recovery$Request$View$viewMain});
var $author$project$Pages$Registration$Confirm$View$viewConfirmed = function (language) {
	return _List_fromArray(
		[
			$elm$html$Html$text(language.jh),
			$author$project$Pages$Util$Links$toLoginButton(
			{gr: language.aa})
		]);
};
var $author$project$Pages$Registration$Confirm$Page$Request = {$: 1};
var $author$project$Pages$Registration$Confirm$Page$SetComplementInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Registration$Confirm$View$viewEditing = function (main) {
	var password2Lens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$PasswordInput$lenses.ii, $author$project$Pages$Util$ComplementInput$lenses.fR);
	var password1Lens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$PasswordInput$lenses.ih, $author$project$Pages$Util$ComplementInput$lenses.fR);
	var isValid = $author$project$Pages$Util$PasswordInput$isValidPassword(main.fc.fR);
	var enterAction = A2(
		$author$project$Util$MaybeUtil$optional,
		isValid,
		$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$Pages$Registration$Confirm$Page$Request));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[$author$project$Pages$Util$Style$classes.lo]),
			_List_fromArray(
				[
					$elm$html$Html$text(main.dL.bA)
				])),
			A2(
			$elm$html$Html$table,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(main.dL.R)
										])),
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(main.cO.R)
										]))
								])),
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(main.dL.aC)
										])),
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(main.cO.aC)
										]))
								])),
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(main.dL.du)
										])),
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											$elm_community$maybe_extra$Maybe$Extra$values(
												_List_fromArray(
													[
														$author$project$Util$MaybeUtil$defined(
														$elm$html$Html$Events$onInput(
															A2(
																$elm$core$Basics$composeR,
																$elm$core$Maybe$Just,
																A2(
																	$elm$core$Basics$composeR,
																	$elm_community$maybe_extra$Maybe$Extra$filter(
																		A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
																	A2(
																		$elm$core$Basics$composeR,
																		A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Pages$Util$ComplementInput$lenses.du.f$, main.fc),
																		$author$project$Pages$Registration$Confirm$Page$SetComplementInput))))),
														$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.bs),
														enterAction
													])),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(main.dL.ec)
										])),
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											$elm_community$maybe_extra$Maybe$Extra$values(
												_List_fromArray(
													[
														$author$project$Util$MaybeUtil$defined(
														$elm$html$Html$Events$onInput(
															A2(
																$elm$core$Basics$composeR,
																A2($elm_community$basics_extra$Basics$Extra$flip, password1Lens.f$, main.fc),
																$author$project$Pages$Registration$Confirm$Page$SetComplementInput))),
														$author$project$Util$MaybeUtil$defined(
														$elm$html$Html$Attributes$value(
															password1Lens.dy(main.fc))),
														$author$project$Util$MaybeUtil$defined(
														$elm$html$Html$Attributes$type_('password')),
														$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.bs),
														enterAction
													])),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(main.dL.ij)
										])),
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											$elm_community$maybe_extra$Maybe$Extra$values(
												_List_fromArray(
													[
														$author$project$Util$MaybeUtil$defined(
														$elm$html$Html$Events$onInput(
															A2(
																$elm$core$Basics$composeR,
																A2($elm_community$basics_extra$Basics$Extra$flip, password2Lens.f$, main.fc),
																$author$project$Pages$Registration$Confirm$Page$SetComplementInput))),
														$author$project$Util$MaybeUtil$defined(
														$elm$html$Html$Attributes$value(
															password2Lens.dy(main.fc))),
														$author$project$Util$MaybeUtil$defined(
														$elm$html$Html$Attributes$type_('password')),
														$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.bs),
														enterAction
													])),
											_List_Nil)
										]))
								]))
						]))
				])),
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick($author$project$Pages$Registration$Confirm$Page$Request),
					$author$project$Pages$Util$Style$classes.dc.gD,
					$elm$html$Html$Attributes$disabled(!isValid)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(main.dL.gD)
				]))
		]);
};
var $author$project$Pages$Registration$Confirm$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{kz: $elm$core$Maybe$Nothing, lf: $author$project$Pages$Util$Style$ids.gG, mM: false},
		function () {
			var _v0 = main.lL;
			if (!_v0) {
				return $author$project$Pages$Registration$Confirm$View$viewEditing(main);
			} else {
				return $author$project$Pages$Registration$Confirm$View$viewConfirmed(main.dL);
			}
		}());
};
var $author$project$Pages$Registration$Confirm$View$view = $author$project$Pages$View$Tristate$view(
	{mL: true, ng: $author$project$Pages$Registration$Confirm$View$viewMain});
var $author$project$Pages$Registration$Request$View$viewConfirmed = function (language) {
	return _List_fromArray(
		[
			$elm$html$Html$text(language.iI),
			$author$project$Pages$Util$Links$toLoginButton(
			{gr: language.aa})
		]);
};
var $author$project$Pages$Registration$Request$Page$Request = {$: 2};
var $author$project$Pages$Registration$Request$Page$SetEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Registration$Request$Page$SetNickname = function (a) {
	return {$: 0, a: a};
};
var $author$project$Util$LensUtil$identityLens = A2($arturopala$elm_monocle$Monocle$Lens$Lens, $elm$core$Basics$identity, $elm$core$Basics$always);
var $author$project$Pages$Registration$Request$View$viewEditing = function (main) {
	var nickname = 'nickname';
	var isValid = $author$project$Util$ValidatedInput$isValid(main.R) && $author$project$Util$ValidatedInput$isValid(main.aC);
	var enterAction = A2(
		$author$project$Util$MaybeUtil$optional,
		isValid,
		$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$Pages$Registration$Request$Page$Request));
	var email = 'email';
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(main.dL.bA)
				])),
			A2(
			$elm$html$Html$form,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(nickname)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(main.dL.R)
						])),
					A2(
					$elm$html$Html$input,
					$elm_community$maybe_extra$Maybe$Extra$values(
						_List_fromArray(
							[
								$author$project$Util$MaybeUtil$defined(
								$elm$html$Html$Events$onInput(
									A2(
										$elm$core$Basics$composeR,
										A2(
											$elm_community$basics_extra$Basics$Extra$flip,
											$author$project$Util$ValidatedInput$lift($author$project$Util$LensUtil$identityLens).f$,
											main.R),
										$author$project$Pages$Registration$Request$Page$SetNickname))),
								$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.bs),
								enterAction,
								$author$project$Util$MaybeUtil$defined(
								$elm$html$Html$Attributes$type_('text')),
								$author$project$Util$MaybeUtil$defined(
								$elm$html$Html$Attributes$id(nickname))
							])),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(email)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(main.dL.aC)
						])),
					A2(
					$elm$html$Html$input,
					$elm_community$maybe_extra$Maybe$Extra$values(
						_List_fromArray(
							[
								$author$project$Util$MaybeUtil$defined(
								$elm$html$Html$Events$onInput(
									A2(
										$elm$core$Basics$composeR,
										A2(
											$elm_community$basics_extra$Basics$Extra$flip,
											$author$project$Util$ValidatedInput$lift($author$project$Util$LensUtil$identityLens).f$,
											main.aC),
										$author$project$Pages$Registration$Request$Page$SetEmail))),
								$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.bs),
								enterAction,
								$author$project$Util$MaybeUtil$defined(
								$elm$html$Html$Attributes$type_('email')),
								$author$project$Util$MaybeUtil$defined(
								$elm$html$Html$Attributes$id(email))
							])),
					_List_Nil),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Pages$Registration$Request$Page$Request),
							$author$project$Pages$Util$Style$classes.dc.gD,
							$elm$html$Html$Attributes$disabled(!isValid),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(main.dL.iG)
						]))
				]))
		]);
};
var $author$project$Pages$Registration$Request$View$viewMain = function (main) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[$author$project$Pages$Util$Style$ids.iO]),
			function () {
				var _v0 = main.lL;
				if (!_v0) {
					return $author$project$Pages$Registration$Request$View$viewEditing(main);
				} else {
					return $author$project$Pages$Registration$Request$View$viewConfirmed(main.dL);
				}
			}())
		]);
};
var $author$project$Pages$Registration$Request$View$view = $author$project$Pages$View$Tristate$view(
	{mL: true, ng: $author$project$Pages$Registration$Request$View$viewMain});
var $author$project$LondoGQL$Enum$LogoutMode$AllSessions = 0;
var $author$project$Pages$Settings$Page$Logout = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Settings$Page$RequestDeletion = {$: 5};
var $author$project$Pages$Settings$Page$SetComplementInput = function (a) {
	return {$: 7, a: a};
};
var $author$project$LondoGQL$Enum$LogoutMode$ThisSession = 1;
var $author$project$Pages$Settings$Page$UpdatePassword = {$: 1};
var $author$project$Pages$Settings$Page$UpdateSettings = {$: 3};
var $author$project$Pages$Settings$View$viewRegular = F2(
	function (language, main) {
		var password2Lens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$PasswordInput$lenses.ii, $author$project$Pages$Util$ComplementInput$lenses.fR);
		var password2 = 'password2';
		var password1Lens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Pages$Util$PasswordInput$lenses.ih, $author$project$Pages$Util$ComplementInput$lenses.fR);
		var password1 = 'password1';
		var newDisplayName = 'new-display-name';
		var isValidPassword = $author$project$Pages$Util$PasswordInput$isValidPassword(main.fc.fR);
		var enterPasswordAction = A2(
			$author$project$Util$MaybeUtil$optional,
			isValidPassword,
			$elm_community$html_extra$Html$Events$Extra$onEnter($author$project$Pages$Settings$Page$UpdatePassword));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(language.eY)
					])),
				A2(
				$elm$html$Html$section,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$form,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(language.R)
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$disabled(true),
										$elm$html$Html$Attributes$value(main.jK.R)
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(language.aC)
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$disabled(true),
										$elm$html$Html$Attributes$value(main.jK.aC)
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(language.du)
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$disabled(true),
										$elm$html$Html$Attributes$value(
										A2($elm$core$Maybe$withDefault, '', main.jK.du))
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(language.gv)
							])),
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Events$onSubmit($author$project$Pages$Settings$Page$UpdateSettings)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for(newDisplayName)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(language.h_)
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$id(newDisplayName),
										$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Maybe$Just,
											A2(
												$elm$core$Basics$composeR,
												$elm_community$maybe_extra$Maybe$Extra$filter(
													A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
												A2(
													$elm$core$Basics$composeR,
													A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Pages$Util$ComplementInput$lenses.du.f$, main.fc),
													$author$project$Pages$Settings$Page$SetComplementInput)))),
										$elm$html$Html$Attributes$value(
										A2($elm$core$Maybe$withDefault, '', main.fc.du)),
										$author$project$Pages$Util$Style$classes.bs
									]),
								_List_Nil),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Pages$Settings$Page$UpdateSettings),
										$author$project$Pages$Util$Style$classes.dc.gD,
										$elm$html$Html$Attributes$type_('submit')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(language.jH)
									]))
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(language.gu)
							])),
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Events$onSubmit($author$project$Pages$Settings$Page$UpdatePassword)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for(password1)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(language.dS)
									])),
								A2(
								$elm$html$Html$input,
								$elm_community$maybe_extra$Maybe$Extra$values(
									_List_fromArray(
										[
											$author$project$Util$MaybeUtil$defined(
											$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeR,
													A2($elm_community$basics_extra$Basics$Extra$flip, password1Lens.f$, main.fc),
													$author$project$Pages$Settings$Page$SetComplementInput))),
											$author$project$Util$MaybeUtil$defined(
											$elm$html$Html$Attributes$type_('password')),
											$author$project$Util$MaybeUtil$defined(
											$elm$html$Html$Attributes$value(
												password1Lens.dy(main.fc))),
											$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.bs),
											enterPasswordAction,
											$author$project$Util$MaybeUtil$defined(
											$elm$html$Html$Attributes$id(password1))
										])),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for(password2)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(language.dT)
									])),
								A2(
								$elm$html$Html$input,
								$elm_community$maybe_extra$Maybe$Extra$values(
									_List_fromArray(
										[
											$author$project$Util$MaybeUtil$defined(
											$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeR,
													A2($elm_community$basics_extra$Basics$Extra$flip, password2Lens.f$, main.fc),
													$author$project$Pages$Settings$Page$SetComplementInput))),
											$author$project$Util$MaybeUtil$defined(
											$elm$html$Html$Attributes$type_('password')),
											$author$project$Util$MaybeUtil$defined(
											$elm$html$Html$Attributes$value(
												password2Lens.dy(main.fc))),
											$author$project$Util$MaybeUtil$defined($author$project$Pages$Util$Style$classes.bs),
											enterPasswordAction,
											$author$project$Util$MaybeUtil$defined(
											$elm$html$Html$Attributes$id(password2))
										])),
								_List_Nil),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Pages$Settings$Page$UpdatePassword),
										$author$project$Pages$Util$Style$classes.dc.gD,
										$elm$html$Html$Attributes$disabled(!isValidPassword),
										$elm$html$Html$Attributes$type_('submit')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(language.eV)
									]))
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(language.gN)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Pages$Settings$Page$RequestDeletion),
								$author$project$Pages$Util$Style$classes.dc.Z
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(language.gW)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Settings$Page$Logout(1)),
								$author$project$Pages$Util$Style$classes.dc.aB
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(language.hL)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Settings$Page$Logout(0)),
								$author$project$Pages$Util$Style$classes.dc.aB
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(language.hK)
							]))
					]))
			]);
	});
var $author$project$Pages$Settings$View$viewRequestedDeletion = function (language) {
	return _List_fromArray(
		[
			$elm$html$Html$text(language.gX)
		]);
};
var $author$project$Pages$Settings$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{
			kz: $elm$core$Maybe$Just(2),
			lf: $author$project$Pages$Util$Style$ids.i0,
			mM: true
		},
		function () {
			var _v0 = main.lL;
			if (!_v0) {
				return A2($author$project$Pages$Settings$View$viewRegular, main.dL, main);
			} else {
				return $author$project$Pages$Settings$View$viewRequestedDeletion(main.dL);
			}
		}());
};
var $author$project$Pages$Settings$View$view = $author$project$Pages$View$Tristate$view(
	{mL: true, ng: $author$project$Pages$Settings$View$viewMain});
var $author$project$Pages$Statistics$Public$Page$SetSearchString = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Statistics$Public$Page$SetViewType = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Statistics$Page$Total = 0;
var $author$project$Pages$Statistics$View$bigDecimalToString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Pages$Statistics$View$orderedBuckets = _List_fromArray(
	[0, 2, 3, 4, 5, 6, 7, 8, 9, 1, 10]);
var $author$project$Pages$Statistics$View$prettyPrintBucket = function (bucket) {
	switch (bucket) {
		case 0:
			return '0% - 10%';
		case 2:
			return '10% - 20%';
		case 3:
			return '20% - 30%';
		case 4:
			return '30% - 40%';
		case 5:
			return '40% - 50%';
		case 6:
			return '50% - 60%';
		case 7:
			return '60% - 70%';
		case 8:
			return '70% - 80%';
		case 9:
			return '80% - 90%';
		case 1:
			return '90% - 100%';
		default:
			return '100%';
	}
};
var $author$project$Pages$Statistics$View$prettyBuckets = A2($elm$core$List$map, $author$project$Pages$Statistics$View$prettyPrintBucket, $author$project$Pages$Statistics$View$orderedBuckets);
var $author$project$Pages$Statistics$View$viewDashboardStatisticsWith = F3(
	function (ps, statisticsLanguage, statistics) {
		var reachable = $elm$html$Html$text(
			$author$project$Math$Natural$toString(
				ps.ah(statistics.ah)));
		var bucketValues = A2(
			$elm$core$List$map,
			function (bucket) {
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					0,
					function ($) {
						return $.j2;
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (cb) {
							return _Utils_eq(cb.j9, bucket);
						},
						ps.db(statistics.db)));
			},
			$author$project$Pages$Statistics$View$orderedBuckets);
		var bucketHeader = A2(
			$elm$core$List$map,
			function (bucket) {
				return A2(
					$elm$html$Html$th,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.h9]),
					_List_fromArray(
						[
							$elm$html$Html$text(bucket)
						]));
			},
			$author$project$Pages$Statistics$View$prettyBuckets);
		var bucketCells = A2(
			$elm$core$List$map,
			function (n) {
				return A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.h8]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(n))
						]));
			},
			bucketValues);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.kY]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												ps.fr(statisticsLanguage))
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												ps.ft(statisticsLanguage))
											]))
									]))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.kQ, $author$project$Pages$Util$Style$classes.cE]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(statisticsLanguage.iD)
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Math$Natural$toString(
													ps.fW(statistics.ai)))
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Math$Natural$toString(
													ps.fX(statistics.ai)))
											]))
									])),
								A2(
								$elm$html$Html$tr,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.kQ, $author$project$Pages$Util$Style$classes.cE]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(statisticsLanguage.iC)
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[reachable])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[reachable]))
									])),
								A2(
								$elm$html$Html$tr,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.kQ, $author$project$Pages$Util$Style$classes.cE]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(statisticsLanguage.hP)
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Pages$Statistics$View$bigDecimalToString(
													ps.fC(statistics.gd)))
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Pages$Statistics$View$bigDecimalToString(
													ps.fD(statistics.gd)))
											]))
									])),
								A2(
								$elm$html$Html$tr,
								_List_fromArray(
									[$author$project$Pages$Util$Style$classes.kQ, $author$project$Pages$Util$Style$classes.cE]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(statisticsLanguage.hQ)
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Pages$Statistics$View$bigDecimalToString(
													ps.fE(statistics.iJ)))
											])),
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Pages$Statistics$View$bigDecimalToString(
													ps.fF(statistics.iJ)))
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.kY]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$th,
										_List_fromArray(
											[$author$project$Pages$Util$Style$classes.h9]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												ps.fs(statisticsLanguage))
											])),
									bucketHeader))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$td,
										_List_fromArray(
											[$author$project$Pages$Util$Style$classes.h8]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(
													ps.e4(statistics.jn)))
											])),
									bucketCells))
							]))
					]))
			]);
	});
var $author$project$Pages$Statistics$View$viewTypeButtonWith = function (ps) {
	var extraStyling = _Utils_eq(ps.fe, ps.dx) ? _List_fromArray(
		[$author$project$Pages$Util$Style$classes.kN]) : _List_Nil;
	return A2(
		$elm$html$Html$button,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					ps.f0(ps.dx)),
					$author$project$Pages$Util$Style$classes.dc.lR
				]),
			extraStyling),
		_List_fromArray(
			[
				$elm$html$Html$text(ps.lw)
			]));
};
var $author$project$Pages$Statistics$View$viewDashboardStatistics = F6(
	function (setViewType, statisticsLanguage, dashboardLanguage, viewType, dashboard, statistics) {
		return A2(
			$elm$html$Html$section,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.kY]),
					_List_fromArray(
						[
							$author$project$Pages$Dashboards$View$tableHeader(dashboardLanguage),
							A2(
							$elm$html$Html$tr,
							_List_fromArray(
								[$author$project$Pages$Util$Style$classes.cE]),
							A2(
								$elm$core$List$map,
								$author$project$Pages$Util$HtmlUtil$withExtraAttributes(_List_Nil),
								$author$project$Pages$Dashboards$View$dashboardInfoColumns(dashboard)))
						])),
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(statisticsLanguage.eG)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Statistics$View$viewTypeButtonWith(
							{fe: viewType, dx: 0, lw: statisticsLanguage.jx, f0: setViewType}),
							$author$project$Pages$Statistics$View$viewTypeButtonWith(
							{fe: viewType, dx: 1, lw: statisticsLanguage.dk, f0: setViewType})
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.kY]),
					A2(
						function () {
							if (!viewType) {
								return $author$project$Pages$Statistics$View$viewDashboardStatisticsWith(
									{
										e4: function ($) {
											return $.jx;
										},
										db: function ($) {
											return $.jx;
										},
										fr: function ($) {
											return $.jx;
										},
										fs: function ($) {
											return $.jy;
										},
										ft: function ($) {
											return $.i4;
										},
										fC: function ($) {
											return $.jx;
										},
										fD: function ($) {
											return $.i4;
										},
										fE: function ($) {
											return $.jx;
										},
										fF: function ($) {
											return $.i4;
										},
										ah: function ($) {
											return $.jx;
										},
										fW: function ($) {
											return $.jx;
										},
										fX: function ($) {
											return $.i4;
										}
									});
							} else {
								return $author$project$Pages$Statistics$View$viewDashboardStatisticsWith(
									{
										e4: function ($) {
											return $.dk;
										},
										db: function ($) {
											return $.dk;
										},
										fr: function ($) {
											return $.dk;
										},
										fs: function ($) {
											return $.gJ;
										},
										ft: function ($) {
											return $.i3;
										},
										fC: function ($) {
											return $.dk;
										},
										fD: function ($) {
											return $.i3;
										},
										fE: function ($) {
											return $.dk;
										},
										fF: function ($) {
											return $.i3;
										},
										ah: function ($) {
											return $.dk;
										},
										fW: function ($) {
											return $.dk;
										},
										fX: function ($) {
											return $.i3;
										}
									});
							}
						}(),
						statisticsLanguage,
						statistics))
				]));
	});
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Types$Progress$Progress$isComplete = function (progress) {
	return _Utils_eq(
		$author$project$Math$Natural$integerValue(progress.ai),
		$author$project$Math$Positive$integerValue(progress.ah));
};
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $author$project$Pages$Statistics$View$taskInfoHeaderColumns = F3(
	function (viewType, taskEditorLanguage, statisticsLanguage) {
		var deltaColumns = function () {
			if (!viewType) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(statisticsLanguage.g0)
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(statisticsLanguage.g_)
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(statisticsLanguage.g2)
							]))
					]);
			} else {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(statisticsLanguage.g$)
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(statisticsLanguage.gZ)
							])),
						A2(
						$elm$html$Html$th,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(statisticsLanguage.g1)
							]))
					]);
			}
		}();
		return _Utils_ap(
			_List_fromArray(
				[
					A2($elm$html$Html$th, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(taskEditorLanguage.jm)
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(taskEditorLanguage.jl)
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(taskEditorLanguage.iw)
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(statisticsLanguage.i5)
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(taskEditorLanguage.jF)
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(taskEditorLanguage.dk)
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(statisticsLanguage.hO)
						]))
				]),
			deltaColumns);
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm_community$list_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $author$project$Types$Progress$Progress$percentParts = function (progress) {
	var reachedString = $author$project$Math$Natural$toString(progress.ai);
	var reachedStringLength = $elm$core$String$length(reachedString);
	var numberOfDecimalPlaces = $elm$core$String$length(
		A2(
			$elm$core$String$dropLeft,
			3,
			$author$project$Math$Positive$toString(progress.ah)));
	if (numberOfDecimalPlaces <= 0) {
		return {kD: $elm$core$Maybe$Nothing, jO: reachedString};
	} else {
		var _v0 = A2(
			$elm_community$list_extra$List$Extra$splitAt,
			reachedStringLength - numberOfDecimalPlaces,
			$elm$core$String$toList(reachedString));
		var before = _v0.a;
		var after = _v0.b;
		return {
			kD: $elm$core$Maybe$Just(
				$elm$core$String$fromList(after)),
			jO: $elm$core$String$fromList(before)
		};
	}
};
var $author$project$Types$Progress$Progress$displayPercentage = function (progress) {
	return A2(
		$elm$core$String$join,
		'.',
		$elm_community$maybe_extra$Maybe$Extra$values(
			function (parts) {
				return _List_fromArray(
					[
						$elm$core$Maybe$Just(parts.jO),
						parts.kD
					]);
			}(
				$author$project$Types$Progress$Progress$percentParts(progress))));
};
var $author$project$Pages$Tasks$Tasks$View$displayProgress = F2(
	function (progress, taskKind) {
		switch (taskKind) {
			case 0:
				return A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(
							$author$project$Types$Progress$Progress$isComplete(progress)),
							$elm$html$Html$Attributes$disabled(true)
						]),
					_List_Nil);
			case 2:
				return $elm$html$Html$text(
					A3(
						$elm_community$basics_extra$Basics$Extra$flip,
						$elm$core$Basics$append,
						'%',
						$author$project$Types$Progress$Progress$displayPercentage(progress)));
			default:
				return $elm$html$Html$text(
					A2(
						$elm$core$String$join,
						'/',
						_List_fromArray(
							[
								$author$project$Math$Natural$toString(progress.ai),
								$author$project$Math$Positive$toString(progress.ah)
							])));
		}
	});
var $author$project$Pages$Statistics$View$taskInfoColumns = F3(
	function (index, viewType, taskAnalysis) {
		var selector = function () {
			if (!viewType) {
				return function ($) {
					return $.jx;
				};
			} else {
				return function ($) {
					return $.dk;
				};
			}
		}();
		var mean = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.hO;
				},
				$author$project$Pages$Statistics$View$bigDecimalToString),
			taskAnalysis.hw);
		var afterSimulation = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			$author$project$Pages$Statistics$View$bigDecimalToString,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					selector,
					function ($) {
						return $.i5;
					}),
				taskAnalysis.hw));
		var afterOne = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			A2(
				$elm$core$Basics$composeR,
				selector,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.l5;
					},
					$author$project$Pages$Statistics$View$bigDecimalToString)),
			taskAnalysis.hw);
		var afterCompletion = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			A2(
				$elm$core$Basics$composeR,
				selector,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ks;
					},
					$author$project$Pages$Statistics$View$bigDecimalToString)),
			taskAnalysis.hw);
		var extraColumns = _List_fromArray(
			[
				{
				b1: _List_fromArray(
					[$author$project$Pages$Util$Style$classes.bs]),
				e8: _List_fromArray(
					[
						$elm$html$Html$text(afterOne)
					])
			},
				{
				b1: _List_fromArray(
					[$author$project$Pages$Util$Style$classes.bs]),
				e8: _List_fromArray(
					[
						$elm$html$Html$text(afterCompletion)
					])
			},
				{
				b1: _List_fromArray(
					[$author$project$Pages$Util$Style$classes.bs]),
				e8: _List_fromArray(
					[
						$elm$html$Html$text(afterSimulation)
					])
			}
			]);
		return _Utils_ap(
			_List_fromArray(
				[
					{
					b1: _List_fromArray(
						[$author$project$Pages$Util$Style$classes.bs]),
					e8: _List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(index))
						])
				},
					{
					b1: _List_fromArray(
						[$author$project$Pages$Util$Style$classes.bs]),
					e8: _List_fromArray(
						[
							$elm$html$Html$text(taskAnalysis.eM.hV)
						])
				},
					{
					b1: _List_fromArray(
						[$author$project$Pages$Util$Style$classes.bs]),
					e8: _List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$LondoGQL$Enum$TaskKind$toString(taskAnalysis.eM.jl))
						])
				},
					{
					b1: _List_fromArray(
						[$author$project$Pages$Util$Style$classes.bs]),
					e8: _List_fromArray(
						[
							A2($author$project$Pages$Tasks$Tasks$View$displayProgress, taskAnalysis.eM.iw, taskAnalysis.eM.jl)
						])
				},
					{
					b1: _List_fromArray(
						[$author$project$Pages$Util$Style$classes.bs]),
					e8: _List_fromArray(
						[
							$elm$html$Html$text(
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								'',
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.cB;
									},
									$cmditch$elm_bigint$BigInt$toString),
								taskAnalysis.i5))
						])
				},
					{
					b1: _List_fromArray(
						[$author$project$Pages$Util$Style$classes.bs]),
					e8: _List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '', taskAnalysis.eM.jF))
						])
				},
					{
					b1: _List_Nil,
					e8: _List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$checked(taskAnalysis.eM.dk),
									$elm$html$Html$Attributes$disabled(true)
								]),
							_List_Nil)
						])
				},
					{
					b1: _List_fromArray(
						[$author$project$Pages$Util$Style$classes.bs]),
					e8: _List_fromArray(
						[
							$elm$html$Html$text(mean)
						])
				}
				]),
			extraColumns);
	});
var $author$project$Pages$Statistics$Public$View$viewTask = F3(
	function (index, viewType, taskAnalysis) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.kQ]),
				A2(
					$elm$core$List$map,
					$author$project$Pages$Util$HtmlUtil$withExtraAttributes(_List_Nil),
					A3($author$project$Pages$Statistics$View$taskInfoColumns, index, viewType, taskAnalysis)))
			]);
	});
var $author$project$Pages$Statistics$Public$View$viewResolvedProject = F5(
	function (viewType, taskEditorLanguage, statisticsLanguage, searchString, projectAnalysis) {
		var project = projectAnalysis.eg;
		var projectName = _Utils_ap(
			project.hV,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function (description) {
					return ' (' + (description + ')');
				},
				project.dq));
		var headerColumns = A3($author$project$Pages$Statistics$View$taskInfoHeaderColumns, viewType, taskEditorLanguage, statisticsLanguage);
		var display = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$sortBy(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.eM;
					},
					function ($) {
						return $.hV;
					})),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$indexedMap(
					function (index) {
						return A2($author$project$Pages$Statistics$Public$View$viewTask, index + 1, viewType);
					}),
				$elm$core$List$concat));
		var _v0 = A2(
			$elm$core$List$partition,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.eM;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.iw;
					},
					$author$project$Types$Progress$Progress$isComplete)),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.eM;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.hV;
						},
						$author$project$Util$SearchUtil$search(searchString))),
				projectAnalysis.jn));
		var finished = _v0.a;
		var unfinished = _v0.b;
		var separator = A2(
			$elm$core$List$any,
			$elm$core$List$isEmpty,
			_List_fromArray(
				[finished, unfinished])) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$colspan(
								$elm$core$List$length(headerColumns) + 1)
							]),
						_List_fromArray(
							[
								A2($elm$html$Html$hr, _List_Nil, _List_Nil)
							]))
					]))
			]);
		return A2(
			$elm$html$Html$section,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(projectName)
						])),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.kY]),
						_List_fromArray(
							[
								$author$project$Pages$Util$ParentEditor$View$tableHeaderWith(
								{kr: headerColumns, mT: $author$project$Pages$Util$Style$classes.m$}),
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								$elm$core$List$concat(
									_List_fromArray(
										[
											display(unfinished),
											separator,
											display(finished)
										])))
							]))
					])));
	});
var $author$project$Pages$Statistics$Public$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{kz: $elm$core$Maybe$Nothing, lf: $author$project$Pages$Util$Style$ids.eG, mM: true},
		A2(
			$elm$core$List$cons,
			A6($author$project$Pages$Statistics$View$viewDashboardStatistics, $author$project$Pages$Statistics$Public$Page$SetViewType, main.cp.eG, main.cp.ff, main.nh, main.ff, main.kC),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Util$HtmlUtil$searchAreaWith(
							{ko: main.cp.bS.aw, hT: $author$project$Pages$Statistics$Public$Page$SetSearchString, cD: main.cD})
						])),
				A2(
					$elm$core$List$map,
					A4($author$project$Pages$Statistics$Public$View$viewResolvedProject, main.nh, main.cp.bS, main.cp.eG, main.cD),
					$author$project$Util$DictList$values(main.eh)))));
};
var $author$project$Pages$Statistics$Public$View$view = $author$project$Pages$View$Tristate$view(
	{mL: true, ng: $author$project$Pages$Statistics$Public$View$viewMain});
var $author$project$Pages$Statistics$Page$SetSearchString = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Statistics$Page$SetViewType = function (a) {
	return {$: 10, a: a};
};
var $the_sett$lazy_list$Seq$Cons = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $the_sett$lazy_list$Seq$cons = F2(
	function (a, list) {
		return A2(
			$the_sett$lazy_list$Seq$Cons,
			a,
			function (_v0) {
				return list;
			});
	});
var $the_sett$lazy_list$Seq$Nil = {$: 0};
var $the_sett$lazy_list$Seq$empty = $the_sett$lazy_list$Seq$Nil;
var $the_sett$lazy_list$Seq$fromList = A2($elm$core$List$foldr, $the_sett$lazy_list$Seq$cons, $the_sett$lazy_list$Seq$empty);
var $author$project$Pages$Statistics$Page$EditTask = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Pages$Statistics$Page$ExitEditTask = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Statistics$Page$SaveEditTask = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Statistics$Page$ToggleControls = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $the_sett$lazy_list$Seq$append = F2(
	function (list1, list2) {
		if (!list1.$) {
			return list2;
		} else {
			var first = list1.a;
			var rest = list1.b;
			return A2(
				$the_sett$lazy_list$Seq$Cons,
				first,
				function (_v1) {
					return A2(
						$the_sett$lazy_list$Seq$append,
						rest(0),
						list2);
				});
		}
	});
var $author$project$Math$Natural$one = $author$project$Math$Constants$oneBigInt;
var $author$project$Types$Progress$Progress$booleanToggle = function (progress) {
	var reached = $author$project$Types$Progress$Progress$isComplete(progress) ? $author$project$Math$Natural$zero : $author$project$Math$Natural$one;
	return A2($author$project$Types$Progress$Progress$Progress, $author$project$Math$Positive$one, reached);
};
var $author$project$Types$Progress$Input$progressOf = function (input) {
	return A2($author$project$Types$Progress$Progress$Progress, input.ah.nc, input.ai.nc);
};
var $author$project$Types$Progress$Input$lenses = {
	iw: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		$author$project$Types$Progress$Input$progressOf,
		A2($elm$core$Basics$composeR, $author$project$Types$Progress$Input$from, $elm$core$Basics$always)),
	ah: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.ah;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{ah: b});
			})),
	ai: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.ai;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{ai: b});
			}))
};
var $author$project$Math$Constants$oneHundredBigInt = $cmditch$elm_bigint$BigInt$fromInt(100);
var $author$project$Math$Positive$oneHundred = $author$project$Math$Constants$oneHundredBigInt;
var $author$project$Pages$Tasks$Tasks$View$splitPercent = F2(
	function (whole, decimal) {
		var adjustedDecimal = $elm$core$String$isEmpty(decimal) ? '0' : decimal;
		return {
			ah: _Utils_ap(
				$author$project$Math$Positive$toString($author$project$Math$Positive$oneHundred),
				A2(
					$elm$core$String$repeat,
					$elm$core$String$length(adjustedDecimal),
					'0')),
			ai: _Utils_ap(whole, adjustedDecimal)
		};
	});
var $author$project$Util$ValidatedInput$updateBound = F2(
	function (n, input) {
		var currentValue = input.nc;
		return A2(
			$author$project$Util$ValidatedInput$lenses.jp.f$,
			$author$project$Math$Natural$toString(currentValue),
			A2(
				$author$project$Util$ValidatedInput$lenses.nc.f$,
				currentValue,
				$author$project$Util$ValidatedInput$naturalWithParser(
					$author$project$Util$ValidatedInput$boundedNaturalParser(n))));
	});
var $author$project$Pages$Tasks$Tasks$View$editProgress = F3(
	function (ps, taskKind, editedValue) {
		var reachedLens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Types$Progress$Input$lenses.ai, ps.mi);
		var reachableLens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Types$Progress$Input$lenses.ah, ps.mi);
		var progressValueLens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Types$Progress$Input$lenses.iw, ps.mi);
		switch (taskKind) {
			case 0:
				return _List_fromArray(
					[
						{
						b1: _List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$checked(
								$author$project$Types$Progress$Progress$isComplete(
									progressValueLens.dy(editedValue))),
								$elm$html$Html$Events$onClick(
								ps.m8(
									A3($arturopala$elm_monocle$Monocle$Lens$modify, progressValueLens, $author$project$Types$Progress$Progress$booleanToggle, editedValue)))
							]),
						e8: _List_Nil,
						aU: $elm$html$Html$input
					}
					]);
			case 2:
				var percentageParts = $author$project$Types$Progress$Progress$percentParts(
					progressValueLens.dy(editedValue));
				var whole = percentageParts.jO;
				var decimal = A2($elm$core$Maybe$withDefault, '0', percentageParts.kD);
				return _List_fromArray(
					[
						{
						b1: _List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								function (str) {
									var fullInput = A2($author$project$Pages$Tasks$Tasks$View$splitPercent, str, decimal);
									return ps.m8(
										A2(
											$author$project$Util$ValidatedInput$lift(reachedLens).f$,
											fullInput.ai,
											A2(
												$author$project$Util$ValidatedInput$lift(reachableLens).f$,
												fullInput.ah,
												editedValue)));
								}),
								$elm$html$Html$Attributes$value(percentageParts.jO),
								$author$project$Pages$Util$Style$classes.h8,
								$author$project$Pages$Util$Style$classes.dU
							]),
						e8: _List_Nil,
						aU: $elm$html$Html$input
					},
						{
						b1: _List_Nil,
						e8: _List_Nil,
						aU: F2(
							function (_v1, _v2) {
								return $elm$html$Html$text('.');
							})
					},
						{
						b1: _List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								function (str) {
									var fullInput = A2($author$project$Pages$Tasks$Tasks$View$splitPercent, whole, str);
									return ps.m8(
										A2(
											$author$project$Util$ValidatedInput$lift(reachedLens).f$,
											fullInput.ai,
											function (ev) {
												return A3(
													$arturopala$elm_monocle$Monocle$Lens$modify,
													reachedLens,
													$author$project$Util$ValidatedInput$updateBound(
														$author$project$Math$Natural$fromPositive(
															reachableLens.dy(ev).nc)),
													ev);
											}(
												A2(
													$author$project$Util$ValidatedInput$lift(reachableLens).f$,
													fullInput.ah,
													editedValue))));
								}),
								$elm$html$Html$Attributes$value(decimal),
								$author$project$Pages$Util$Style$classes.h8,
								$author$project$Pages$Util$Style$classes.dU
							]),
						e8: _List_Nil,
						aU: $elm$html$Html$input
					}
					]);
			default:
				return _List_fromArray(
					[
						{
						b1: _List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2(
									$elm$core$Basics$composeL,
									ps.m8,
									A2(
										$elm_community$basics_extra$Basics$Extra$flip,
										$author$project$Util$ValidatedInput$lift(reachedLens).f$,
										editedValue))),
								$elm$html$Html$Attributes$value(
								reachedLens.dy(editedValue).jp),
								$author$project$Pages$Util$Style$classes.h8,
								$author$project$Pages$Util$Style$classes.dU
							]),
						e8: _List_Nil,
						aU: $elm$html$Html$input
					},
						{
						b1: _List_Nil,
						e8: _List_Nil,
						aU: F2(
							function (_v3, _v4) {
								return $elm$html$Html$text('/');
							})
					},
						{
						b1: _List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										ps.m8,
										function (ev) {
											return A3(
												$arturopala$elm_monocle$Monocle$Lens$modify,
												reachedLens,
												$author$project$Util$ValidatedInput$updateBound(
													$author$project$Math$Natural$fromPositive(
														reachableLens.dy(ev).nc)),
												ev);
										}),
									A2(
										$elm_community$basics_extra$Basics$Extra$flip,
										$author$project$Util$ValidatedInput$lift(reachableLens).f$,
										editedValue))),
								$elm$html$Html$Attributes$value(
								$author$project$Math$Positive$toString(
									reachableLens.dy(editedValue).nc)),
								$author$project$Pages$Util$Style$classes.h8,
								$author$project$Pages$Util$Style$classes.dU
							]),
						e8: _List_Nil,
						aU: $elm$html$Html$input
					}
					]);
		}
	});
var $author$project$Types$Simulation$Update$lenses = {
	cB: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.cB;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{cB: b});
			}))
};
var $author$project$Types$Task$TaskWithSimulation$lenses = {
	i5: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.i5;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{i5: b});
			})),
	ak: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.ak;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{ak: b});
			}))
};
var $author$project$Types$Task$Update$lenses = {
	dk: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.dk;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{dk: b});
			})),
	hV: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.hV;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{hV: b});
			})),
	cA: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.cA;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{cA: b});
			})),
	jl: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.jl;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{jl: b});
			})),
	jF: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.jF;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{jF: b});
			}))
};
var $the_sett$lazy_list$Seq$map2 = F3(
	function (f, list1, list2) {
		if (!list1.$) {
			return $the_sett$lazy_list$Seq$Nil;
		} else {
			var first1 = list1.a;
			var rest1 = list1.b;
			if (!list2.$) {
				return $the_sett$lazy_list$Seq$Nil;
			} else {
				var first2 = list2.a;
				var rest2 = list2.b;
				return A2(
					$the_sett$lazy_list$Seq$Cons,
					A2(f, first1, first2),
					function (_v2) {
						return A3(
							$the_sett$lazy_list$Seq$map2,
							f,
							rest1(0),
							rest2(0));
					});
			}
		}
	});
var $the_sett$lazy_list$Seq$repeat = function (a) {
	return A2(
		$the_sett$lazy_list$Seq$Cons,
		a,
		function (_v0) {
			return $the_sett$lazy_list$Seq$repeat(a);
		});
};
var $the_sett$lazy_list$Seq$toList = function (list) {
	var helper = F2(
		function (coll, acc) {
			helper:
			while (true) {
				if (!coll.$) {
					return $elm$core$List$reverse(acc);
				} else {
					var first = coll.a;
					var rest = coll.b;
					var $temp$coll = rest(0),
						$temp$acc = A2($elm$core$List$cons, first, acc);
					coll = $temp$coll;
					acc = $temp$acc;
					continue helper;
				}
			}
		});
	return A2(helper, list, _List_Nil);
};
var $author$project$Pages$Util$HtmlUtil$withAttributes = F2(
	function (extra, structure) {
		return A2(
			structure.aU,
			_Utils_ap(extra, structure.b1),
			structure.e8);
	});
var $author$project$Pages$Statistics$View$updateTask = F6(
	function (ps, index, language, projectId, task, update) {
		var updateMsg = A2($author$project$Pages$Statistics$Page$EditTask, projectId, task.lf);
		var saveMsg = A2($author$project$Pages$Statistics$Page$SaveEditTask, projectId, task.lf);
		var reachedModifierLens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Types$Simulation$Update$lenses.cB, $author$project$Types$Task$TaskWithSimulation$lenses.i5);
		var validSimulation = $author$project$Util$ValidatedInput$isValid(
			reachedModifierLens.dy(update));
		var progressUpdateLens = A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Types$Task$Update$lenses.cA, $author$project$Types$Task$TaskWithSimulation$lenses.ak);
		var validReachable = $author$project$Util$ValidatedInput$isValid(
			progressUpdateLens.dy(update).ah);
		var validReached = $author$project$Util$ValidatedInput$isValid(
			progressUpdateLens.dy(update).ai);
		var validInput = validReached && (validReachable && validSimulation);
		var validatedSaveAction = A2(
			$author$project$Util$MaybeUtil$optional,
			validInput,
			$elm_community$html_extra$Html$Events$Extra$onEnter(
				A2($author$project$Pages$Statistics$Page$SaveEditTask, projectId, task.lf)));
		var cancelMsg = A2($author$project$Pages$Statistics$Page$ExitEditTask, projectId, task.lf);
		var nonEmptyColumns = $the_sett$lazy_list$Seq$fromList(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.bs]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(index))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.bs]),
					_List_fromArray(
						[
							$elm$html$Html$text(task.hV)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$LondoGQL$Enum$TaskKind$toString(task.jl))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Util$HtmlUtil$withAttributes(
							$elm_community$maybe_extra$Maybe$Extra$values(
								_List_fromArray(
									[
										$author$project$Util$MaybeUtil$defined(
										$author$project$Pages$Util$HtmlUtil$onEscape(cancelMsg)),
										validatedSaveAction
									]))),
						A3(
							$author$project$Pages$Tasks$Tasks$View$editProgress,
							{mi: progressUpdateLens, m8: updateMsg},
							A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Types$Task$Update$lenses.jl, $author$project$Types$Task$TaskWithSimulation$lenses.ak).dy(update),
							update))),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.bs]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							$elm_community$maybe_extra$Maybe$Extra$values(
								_List_fromArray(
									[
										$author$project$Util$MaybeUtil$defined(
										$elm$html$Html$Attributes$value(
											reachedModifierLens.dy(update).jp)),
										$author$project$Util$MaybeUtil$defined(
										$elm$html$Html$Events$onInput(
											A2(
												$elm$core$Basics$composeR,
												A2(
													$elm_community$basics_extra$Basics$Extra$flip,
													$author$project$Util$ValidatedInput$lift(reachedModifierLens).f$,
													update),
												updateMsg))),
										$author$project$Util$MaybeUtil$defined(
										$author$project$Pages$Util$HtmlUtil$onEscape(cancelMsg)),
										validatedSaveAction
									])),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.bs]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '', task.jF))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$checked(
									A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Types$Task$Update$lenses.dk, $author$project$Types$Task$TaskWithSimulation$lenses.ak).dy(update)),
									$elm$html$Html$Events$onClick(
									updateMsg(
										A3(
											$arturopala$elm_monocle$Monocle$Lens$modify,
											A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Types$Task$Update$lenses.dk, $author$project$Types$Task$TaskWithSimulation$lenses.ak),
											$elm$core$Basics$not,
											update))),
									$elm_community$html_extra$Html$Events$Extra$onEnter(saveMsg),
									$author$project$Pages$Util$HtmlUtil$onEscape(cancelMsg)
								]),
							_List_Nil)
						]))
				]));
		var infoColumns = $the_sett$lazy_list$Seq$toList(
			A3(
				$the_sett$lazy_list$Seq$map2,
				F2(
					function (_v0, element) {
						return element;
					}),
				ps.$9,
				A2(
					$the_sett$lazy_list$Seq$append,
					nonEmptyColumns,
					$the_sett$lazy_list$Seq$repeat(
						A2($elm$html$Html$td, _List_Nil, _List_Nil)))));
		var controlsRow = $author$project$Pages$Util$ParentEditor$View$controlsRowWith(
			{
				X: {hT: cancelMsg, hV: language.X},
				kp: $elm$core$List$length(infoColumns),
				gD: {hT: saveMsg, hV: language.aO},
				nb: validInput
			});
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.g7]),
				_Utils_ap(
					infoColumns,
					_List_fromArray(
						[
							$author$project$Pages$Util$HtmlUtil$toggleControlsCell(
							A2($author$project$Pages$Statistics$Page$ToggleControls, projectId, task.lf))
						]))),
				controlsRow
			]);
	});
var $author$project$Pages$Statistics$Page$EnterEditTask = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Statistics$View$viewTask = F6(
	function (index, viewType, projectId, language, resolvedTask, showControls) {
		return A2(
			$author$project$Pages$Util$ParentEditor$View$lineWith,
			{
				mx: function (t) {
					return {
						gH: _List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$author$project$Pages$Util$Style$classes.dc.aB,
										$elm$html$Html$Events$onClick(
										A2($author$project$Pages$Statistics$Page$EnterEditTask, projectId, t.eM.lf))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(language.aB)
									]))
							]),
						fi: A3($author$project$Pages$Statistics$View$taskInfoColumns, index, viewType, t)
					};
				},
				i1: showControls,
				jv: A2($author$project$Pages$Statistics$Page$ToggleControls, projectId, resolvedTask.eM.lf)
			},
			resolvedTask);
	});
var $author$project$Pages$Statistics$View$viewResolvedProject = F5(
	function (viewType, taskEditorLanguage, statisticsLanguage, searchString, resolvedProject) {
		var tasks = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ic;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.eM;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.hV;
						},
						$author$project$Util$SearchUtil$search(searchString)))),
			$author$project$Util$DictList$values(resolvedProject.jn));
		var project = resolvedProject.eg;
		var projectName = _Utils_ap(
			project.hV,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function (description) {
					return ' (' + (description + ')');
				},
				project.dq));
		var headerColumns = A3($author$project$Pages$Statistics$View$taskInfoHeaderColumns, viewType, taskEditorLanguage, statisticsLanguage);
		var plainHeaders = $the_sett$lazy_list$Seq$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Basics$always(0),
				headerColumns));
		var display = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$sortBy(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ic;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.eM;
						},
						function ($) {
							return $.hV;
						}))),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$indexedMap(
					function (index) {
						var position = index + 1;
						return $author$project$Util$Editing$unpack(
							{
								l0: function (_v1) {
									return _List_Nil;
								},
								l1: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.eM;
									},
									A4(
										$author$project$Pages$Statistics$View$updateTask,
										{$9: plainHeaders},
										position,
										taskEditorLanguage,
										project.lf)),
								l4: A4($author$project$Pages$Statistics$View$viewTask, position, viewType, project.lf, taskEditorLanguage)
							});
					}),
				$elm$core$List$concat));
		var _v0 = A2(
			$elm$core$List$partition,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ic;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.eM;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.iw;
						},
						$author$project$Types$Progress$Progress$isComplete))),
			tasks);
		var finished = _v0.a;
		var unfinished = _v0.b;
		var separator = A2(
			$elm$core$List$any,
			$elm$core$List$isEmpty,
			_List_fromArray(
				[finished, unfinished])) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$colspan(
								$elm$core$List$length(headerColumns) + 1)
							]),
						_List_fromArray(
							[
								A2($elm$html$Html$hr, _List_Nil, _List_Nil)
							]))
					]))
			]);
		return A2(
			$elm$html$Html$section,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(projectName)
						])),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[$author$project$Pages$Util$Style$classes.kY]),
						_List_fromArray(
							[
								$author$project$Pages$Util$ParentEditor$View$tableHeaderWith(
								{kr: headerColumns, mT: $author$project$Pages$Util$Style$classes.m$}),
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								$elm$core$List$concat(
									_List_fromArray(
										[
											display(unfinished),
											separator,
											display(finished)
										])))
							]))
					])));
	});
var $author$project$Pages$Statistics$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{kz: $elm$core$Maybe$Nothing, lf: $author$project$Pages$Util$Style$ids.eG, mM: true},
		A2(
			$elm$core$List$cons,
			A6($author$project$Pages$Statistics$View$viewDashboardStatistics, $author$project$Pages$Statistics$Page$SetViewType, main.cp.eG, main.cp.ff, main.nh, main.ff, main.kC),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Util$HtmlUtil$searchAreaWith(
							{ko: main.cp.bS.aw, hT: $author$project$Pages$Statistics$Page$SetSearchString, cD: main.cD})
						])),
				A2(
					$elm$core$List$map,
					A4($author$project$Pages$Statistics$View$viewResolvedProject, main.nh, main.cp.bS, main.cp.eG, main.cD),
					$author$project$Util$DictList$values(main.eh)))));
};
var $author$project$Pages$Statistics$View$view = $author$project$Pages$View$Tristate$view(
	{mL: true, ng: $author$project$Pages$Statistics$View$viewMain});
var $author$project$Pages$Tasks$Project$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$Parent$View$viewMain,
		{
			l0: $author$project$Pages$Projects$View$projectLineWith(
				{
					gH: _List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Pages$Util$Style$classes.dc.Z,
									$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$ConfirmDelete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(main.dL.ay)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Pages$Util$Style$classes.dc.gD,
									$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$CancelDelete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(main.dL.X)
								]))
						]),
					i1: true,
					jv: $author$project$Pages$Util$Parent$Page$ToggleControls
				}),
			l1: $elm$core$Basics$always(
				$author$project$Pages$Projects$View$editProjectLineWith(
					{
						kb: $author$project$Pages$Util$Parent$Page$ExitEdit,
						kc: main.dL.X,
						kv: main.dL.aO,
						kL: $author$project$Types$Project$Update$lenses.dq,
						ct: $author$project$Types$Project$Update$lenses.hV,
						mw: _List_Nil,
						mz: $author$project$Pages$Util$Parent$Page$SaveEdit,
						m4: $elm$core$Maybe$Just($author$project$Pages$Util$Parent$Page$ToggleControls),
						m8: $author$project$Pages$Util$Parent$Page$Edit
					})),
			l4: F2(
				function (project, showControls) {
					return A2(
						$author$project$Pages$Projects$View$projectLineWith,
						{
							gH: _List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.dc.aB,
											$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$EnterEdit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(main.dL.aB)
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Pages$Util$Style$classes.dc.Z,
											$elm$html$Html$Events$onClick($author$project$Pages$Util$Parent$Page$RequestDelete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(main.dL.Z)
										]))
								]),
							i1: showControls,
							jv: $author$project$Pages$Util$Parent$Page$ToggleControls
						},
						project);
				}),
			mY: $author$project$Pages$Projects$View$tableHeader
		},
		main);
};
var $author$project$Math$Constants$oneThousandBigInt = $cmditch$elm_bigint$BigInt$fromInt(1000);
var $author$project$Math$Positive$oneThousand = $author$project$Math$Constants$oneThousandBigInt;
var $author$project$Types$Progress$Progress$default = function (taskKind) {
	switch (taskKind) {
		case 0:
			return {ah: $author$project$Math$Positive$one, ai: $author$project$Math$Natural$zero};
		case 2:
			return {ah: $author$project$Math$Positive$oneThousand, ai: $author$project$Math$Natural$zero};
		default:
			return {ah: $author$project$Math$Positive$oneHundred, ai: $author$project$Math$Natural$zero};
	}
};
var $author$project$LondoGQL$Enum$TaskKind$fromString = function (enumString____) {
	switch (enumString____) {
		case 'Discrete':
			return $elm$core$Maybe$Just(0);
		case 'Fraction':
			return $elm$core$Maybe$Just(1);
		case 'Percent':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$LondoGQL$Enum$TaskKind$list = _List_fromArray(
	[0, 1, 2]);
var $author$project$Pages$Tasks$Tasks$View$editTaskLineWith = F2(
	function (handling, editedValue) {
		var validInput = A2(
			$elm$core$List$all,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$author$project$Util$ValidatedInput$isValid(
					handling.ct.dy(editedValue)),
					$author$project$Util$ValidatedInput$isValid(
					handling.mi.dy(editedValue).ah),
					$author$project$Util$ValidatedInput$isValid(
					handling.mi.dy(editedValue).ai)
				]));
		var validatedSaveAction = A2(
			$author$project$Util$MaybeUtil$optional,
			validInput,
			$elm_community$html_extra$Html$Events$Extra$onEnter(handling.mz));
		var taskKindToItem = function (taskKind) {
			var stringValue = $author$project$LondoGQL$Enum$TaskKind$toString(taskKind);
			return {k$: true, jp: stringValue, nc: stringValue};
		};
		var infoColumns = _List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.bs]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						$elm_community$maybe_extra$Maybe$Extra$values(
							_List_fromArray(
								[
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Attributes$value(
										handling.ct.dy(editedValue).jp)),
									$author$project$Util$MaybeUtil$defined(
									$elm$html$Html$Events$onInput(
										A2(
											$elm$core$Basics$composeL,
											handling.m8,
											A2(
												$elm_community$basics_extra$Basics$Extra$flip,
												$author$project$Util$ValidatedInput$lift(handling.ct).f$,
												editedValue)))),
									$author$project$Util$MaybeUtil$defined(
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.kb)),
									validatedSaveAction
								])),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$abadi199$elm_input_extra$Dropdown$dropdown,
						{
							k_: $elm$core$Maybe$Nothing,
							lt: A2($elm$core$List$map, taskKindToItem, $author$project$LondoGQL$Enum$TaskKind$list),
							l$: A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$andThen($author$project$LondoGQL$Enum$TaskKind$fromString),
								A2(
									$elm$core$Basics$composeR,
									A2(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										editedValue,
										A2($elm_community$basics_extra$Basics$Extra$flip, handling.bT.f$, editedValue)),
									A2(
										$elm$core$Basics$composeR,
										function (ev) {
											return A2(
												A2($arturopala$elm_monocle$Monocle$Compose$lensWithLens, $author$project$Types$Progress$Input$lenses.iw, handling.mi).f$,
												$author$project$Types$Progress$Progress$default(
													handling.bT.dy(ev)),
												ev);
										},
										handling.m8)))
						},
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$LondoGQL$Enum$TaskKind$toString(
								handling.bT.dy(editedValue))))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$author$project$Pages$Util$HtmlUtil$withAttributes(
						$elm_community$maybe_extra$Maybe$Extra$values(
							_List_fromArray(
								[
									$author$project$Util$MaybeUtil$defined(
									$author$project$Pages$Util$HtmlUtil$onEscape(handling.kb)),
									validatedSaveAction
								]))),
					A3(
						$author$project$Pages$Tasks$Tasks$View$editProgress,
						{mi: handling.mi, m8: handling.m8},
						handling.bT.dy(editedValue),
						editedValue))),
				A2(
				$elm$html$Html$td,
				_List_fromArray(
					[$author$project$Pages$Util$Style$classes.bs]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									handling.eT.dy(editedValue))),
								$elm$html$Html$Events$onInput(
								A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											handling.m8,
											A2($elm_community$basics_extra$Basics$Extra$flip, handling.eT.f$, editedValue)),
										$elm_community$maybe_extra$Maybe$Extra$filter(
											A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not))),
									$elm$core$Maybe$Just)),
								$elm_community$html_extra$Html$Events$Extra$onEnter(handling.mz),
								$author$project$Pages$Util$HtmlUtil$onEscape(handling.kb)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$checked(
								handling.dl.dy(editedValue)),
								$elm$html$Html$Events$onClick(
								handling.m8(
									A3($arturopala$elm_monocle$Monocle$Lens$modify, handling.dl, $elm$core$Basics$not, editedValue))),
								$elm_community$html_extra$Html$Events$Extra$onEnter(handling.mz),
								$author$project$Pages$Util$HtmlUtil$onEscape(handling.kb)
							]),
						_List_Nil)
					]))
			]);
		var controlsRow = $author$project$Pages$Util$ParentEditor$View$controlsRowWith(
			{
				X: {hT: handling.kb, hV: handling.kc},
				kp: $elm$core$List$length(infoColumns),
				gD: {hT: handling.mz, hV: handling.kv},
				nb: validInput
			});
		var commandToggle = A2(
			$elm$core$List$map,
			$author$project$Pages$Util$HtmlUtil$toggleControlsCell,
			$elm_community$maybe_extra$Maybe$Extra$toList(handling.m4));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				handling.mw,
				_Utils_ap(infoColumns, commandToggle)),
				controlsRow
			]);
	});
var $author$project$Types$Task$Creation$lenses = {
	dk: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.dk;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{dk: b});
			})),
	hV: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.hV;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{hV: b});
			})),
	iw: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.iw;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{iw: b});
			})),
	jl: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.jl;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{jl: b});
			})),
	jF: A2(
		$arturopala$elm_monocle$Monocle$Lens$Lens,
		function ($) {
			return $.jF;
		},
		F2(
			function (b, a) {
				return _Utils_update(
					a,
					{jF: b});
			}))
};
var $author$project$Pages$Tasks$Tasks$View$createTaskLine = function (language) {
	return $author$project$Pages$Tasks$Tasks$View$editTaskLineWith(
		{
			kb: $author$project$Pages$Util$ParentEditor$Page$UpdateCreation($elm$core$Maybe$Nothing),
			kc: language.X,
			kv: language.h3,
			dl: $author$project$Types$Task$Creation$lenses.dk,
			ct: $author$project$Types$Task$Creation$lenses.hV,
			mi: $author$project$Types$Task$Creation$lenses.iw,
			mw: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.g7]),
			mz: $author$project$Pages$Util$ParentEditor$Page$Create,
			bT: $author$project$Types$Task$Creation$lenses.jl,
			m4: $elm$core$Maybe$Nothing,
			eT: $author$project$Types$Task$Creation$lenses.jF,
			m8: A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Pages$Util$ParentEditor$Page$UpdateCreation)
		});
};
var $author$project$Types$Progress$Input$default = function (taskKind) {
	var max = function () {
		switch (taskKind) {
			case 0:
				return $author$project$Math$Positive$one;
			case 2:
				return $author$project$Math$Positive$oneThousand;
			default:
				return $author$project$Math$Positive$oneHundred;
		}
	}();
	return {
		ah: A2(
			$author$project$Util$ValidatedInput$set,
			{eR: $author$project$Math$Positive$toString, nc: max},
			$author$project$Util$ValidatedInput$positive),
		ai: A2(
			$author$project$Util$ValidatedInput$set,
			{eR: $author$project$Math$Natural$toString, nc: $author$project$Math$Natural$zero},
			$author$project$Util$ValidatedInput$boundedNatural(
				$author$project$Math$Natural$fromPositive(max)))
	};
};
var $author$project$Types$Task$Creation$default = function (projectId) {
	var defaultTaskKind = 1;
	return {
		dk: true,
		hV: $author$project$Util$ValidatedInput$nonEmptyString,
		iw: $author$project$Types$Progress$Input$default(defaultTaskKind),
		f: projectId,
		jl: defaultTaskKind,
		jF: $elm$core$Maybe$Nothing
	};
};
var $author$project$Pages$Tasks$Tasks$View$taskInfoColumns = function (task) {
	return _List_fromArray(
		[
			{
			b1: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.bs]),
			e8: _List_fromArray(
				[
					$elm$html$Html$text(task.hV)
				])
		},
			{
			b1: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.bs]),
			e8: _List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$LondoGQL$Enum$TaskKind$toString(task.jl))
				])
		},
			{
			b1: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.bs]),
			e8: _List_fromArray(
				[
					A2($author$project$Pages$Tasks$Tasks$View$displayProgress, task.iw, task.jl)
				])
		},
			{
			b1: _List_fromArray(
				[$author$project$Pages$Util$Style$classes.bs]),
			e8: _List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, '', task.jF))
				])
		},
			{
			b1: _List_Nil,
			e8: _List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(task.dk),
							$elm$html$Html$Attributes$disabled(true)
						]),
					_List_Nil)
				])
		}
		]);
};
var $author$project$Pages$Tasks$Tasks$View$taskLineWith = function (ps) {
	return $author$project$Pages$Util$ParentEditor$View$lineWith(
		{
			mx: function (task) {
				return {
					gH: ps.gH,
					fi: $author$project$Pages$Tasks$Tasks$View$taskInfoColumns(task)
				};
			},
			i1: ps.i1,
			jv: ps.jv
		});
};
var $author$project$Pages$Tasks$Tasks$View$deleteTaskLine = F2(
	function (language, task) {
		return A2(
			$author$project$Pages$Tasks$Tasks$View$taskLineWith,
			{
				gH: _List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$author$project$Pages$Util$Style$classes.dc.Z,
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Util$ParentEditor$Page$ConfirmDelete(task.lf))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(language.ay)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$author$project$Pages$Util$Style$classes.dc.gD,
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Util$ParentEditor$Page$CancelDelete(task.lf))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(language.X)
							]))
					]),
				i1: true,
				jv: $author$project$Pages$Util$ParentEditor$Page$ToggleControls(task.lf)
			},
			task);
	});
var $author$project$Pages$Tasks$Tasks$View$tableHeader = function (language) {
	return $author$project$Pages$Util$ParentEditor$View$tableHeaderWith(
		{
			kr: _List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(language.jm)
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(language.jl)
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(language.iw)
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(language.jF)
						])),
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(language.dk)
						]))
				]),
			mT: $author$project$Pages$Util$Style$classes.m$
		});
};
var $author$project$Pages$Tasks$Tasks$View$updateTaskLine = F3(
	function (language, taskId, update) {
		return A2(
			$author$project$Pages$Tasks$Tasks$View$editTaskLineWith,
			{
				kb: $author$project$Pages$Util$ParentEditor$Page$ExitEdit(taskId),
				kc: language.X,
				kv: language.aO,
				dl: $author$project$Types$Task$Update$lenses.dk,
				ct: $author$project$Types$Task$Update$lenses.hV,
				mi: $author$project$Types$Task$Update$lenses.cA,
				mw: _List_fromArray(
					[$author$project$Pages$Util$Style$classes.g7]),
				mz: $author$project$Pages$Util$ParentEditor$Page$SaveEdit(taskId),
				bT: A2(
					$arturopala$elm_monocle$Monocle$Lens$Lens,
					function (_v0) {
						return 1;
					},
					F2(
						function (_v1, a) {
							return a;
						})),
				m4: $elm$core$Maybe$Just(
					$author$project$Pages$Util$ParentEditor$Page$ToggleControls(taskId)),
				eT: $author$project$Types$Task$Update$lenses.jF,
				m8: $author$project$Pages$Util$ParentEditor$Page$Edit(taskId)
			},
			update);
	});
var $author$project$Pages$Tasks$Tasks$View$viewTaskLine = F3(
	function (language, task, showControls) {
		return A2(
			$author$project$Pages$Tasks$Tasks$View$taskLineWith,
			{
				gH: _List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$author$project$Pages$Util$Style$classes.dc.aB,
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Util$ParentEditor$Page$EnterEdit(task.lf))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(language.aB)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$author$project$Pages$Util$Style$classes.dc.Z,
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Util$ParentEditor$Page$RequestDelete(task.lf))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(language.Z)
							]))
					]),
				i1: showControls,
				jv: $author$project$Pages$Util$ParentEditor$Page$ToggleControls(task.lf)
			},
			task);
	});
var $author$project$Pages$Tasks$Tasks$View$viewSubMain = F2(
	function (projectId, subMain) {
		return A3(
			$author$project$Pages$Util$ParentEditor$View$viewParentsWith,
			{
				gA: subMain.dL.aw,
				br: {
					kH: $author$project$Types$Task$Creation$default(projectId),
					ll: $author$project$Pages$Tasks$Tasks$View$createTaskLine,
					lw: function ($) {
						return $.h3;
					},
					m5: $author$project$Pages$Util$ParentEditor$Page$UpdateCreation
				},
				kz: $elm$core$Maybe$Nothing,
				kJ: $author$project$Pages$Tasks$Tasks$View$deleteTaskLine,
				lF: F2(
					function (string, task) {
						return A2($author$project$Util$SearchUtil$search, string, task.hV);
					}),
				mI: $author$project$Pages$Util$ParentEditor$Page$SetPagination,
				mJ: $author$project$Pages$Util$ParentEditor$Page$SetSearchString,
				mM: false,
				mN: $elm$core$List$sortBy(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ic;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.hV;
							},
							$elm$core$String$toLower))),
				mU: $author$project$Pages$Util$Style$ids.jZ,
				mY: $author$project$Pages$Tasks$Tasks$View$tableHeader(subMain.dL),
				m7: F2(
					function (language, task) {
						return A2($author$project$Pages$Tasks$Tasks$View$updateTaskLine, language, task.lf);
					}),
				nf: function (language) {
					return $author$project$Pages$Tasks$Tasks$View$viewTaskLine(language);
				}
			},
			subMain.dL,
			subMain);
	});
var $author$project$Pages$Tasks$View$viewMain = function (main) {
	return A2(
		$author$project$Pages$Util$ViewUtil$viewMainWith,
		{kz: $elm$core$Maybe$Nothing, lf: $author$project$Pages$Util$Style$ids.bS, mM: true},
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Tasks$Page$ProjectMsg,
					$author$project$Pages$Tasks$Project$View$viewMain(main.eg)),
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[$author$project$Pages$Util$Style$classes.g9]),
					_List_fromArray(
						[
							$elm$html$Html$text(main.jn.dL.jn)
						]))
				]),
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Pages$Tasks$Page$TasksMsg),
				A2($author$project$Pages$Tasks$Tasks$View$viewSubMain, main.eg.me.ic.lf, main.jn))));
};
var $author$project$Pages$Tasks$View$view = $author$project$Pages$View$Tristate$view(
	{mL: true, ng: $author$project$Pages$Tasks$View$viewMain});
var $author$project$Main$view = function (model) {
	var _v0 = model.V;
	switch (_v0.$) {
		case 0:
			var requestRegistration = _v0.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Main$RequestRegistrationMsg),
				$author$project$Pages$Registration$Request$View$view(requestRegistration));
		case 1:
			var confirmRegistration = _v0.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Main$ConfirmRegistrationMsg),
				$author$project$Pages$Registration$Confirm$View$view(confirmRegistration));
		case 2:
			var login = _v0.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Main$LoginMsg),
				$author$project$Pages$Login$View$view(login));
		case 3:
			var overview = _v0.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Main$OverviewMsg),
				$author$project$Pages$Overview$View$view(overview));
		case 4:
			var projects = _v0.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Main$ProjectsMsg),
				$author$project$Pages$Projects$View$view(projects));
		case 5:
			var tasks = _v0.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Main$TasksMsg),
				$author$project$Pages$Tasks$View$view(tasks));
		case 6:
			var dashboards = _v0.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Main$DashboardsMsg),
				$author$project$Pages$Dashboards$View$view(dashboards));
		case 7:
			var dashboardEntries = _v0.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Main$DashboardEntriesMsg),
				$author$project$Pages$DashboardEntries$View$view(dashboardEntries));
		case 8:
			var statistics = _v0.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Main$StatisticsMsg),
				$author$project$Pages$Statistics$View$view(statistics));
		case 9:
			var publicStatistics = _v0.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Main$PublicStatisticsMsg),
				$author$project$Pages$Statistics$Public$View$view(publicStatistics));
		case 10:
			var settings = _v0.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Main$SettingsMsg),
				$author$project$Pages$Settings$View$view(settings));
		case 11:
			var confirmDeletion = _v0.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Main$ConfirmDeletionMsg),
				$author$project$Pages$Deletion$View$view(confirmDeletion));
		case 12:
			var requestRecovery = _v0.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Main$RequestRecoveryMsg),
				$author$project$Pages$Recovery$Request$View$view(requestRecovery));
		case 13:
			var confirmRecovery = _v0.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Main$ConfirmRecoveryMsg),
				$author$project$Pages$Recovery$Confirm$View$view(confirmRecovery));
		default:
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$main_,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(model.dL.h7)
						]))
				]);
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{
		lp: $author$project$Main$init,
		l2: $author$project$Main$ChangedUrl,
		l3: $author$project$Main$ClickedLink,
		mW: $author$project$Main$subscriptions,
		m5: $author$project$Main$update,
		nd: function (model) {
			return {
				j7: $author$project$Main$view(model),
				eQ: $author$project$Main$titleFor(model)
			};
		}
	});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (graphQLEndpoint) {
			return $elm$json$Json$Decode$succeed(
				{k8: graphQLEndpoint});
		},
		A2($elm$json$Json$Decode$field, 'graphQLEndpoint', $elm$json$Json$Decode$string)))(0)}});}(this));